export const translationSchema = {
  'auth-app': {
    greeting: 'auth-app.greeting',
  },
  'access-denied': {
    errorMessage: 'access-denied.errorMessage',
    title: 'access-denied.title',
    message: 'access-denied.message',
    back: 'access-denied.back',
  },
  auth: {
    signup: 'auth.signup',
    signupButton: 'auth.signupButton',
    registerQuestion: 'auth.registerQuestion',
    emailConfirmation: {
      success: 'auth.emailConfirmation.success',
      error: 'auth.emailConfirmation.error',
    },
    confirmEmailCheck: 'auth.confirmEmailCheck',
    passwordRecovery: {
      title: 'auth.passwordRecovery.title',
      newPassword: 'auth.passwordRecovery.newPassword',
      newPasswordConfirmation: 'auth.passwordRecovery.newPasswordConfirmation',
      changePassword: 'auth.passwordRecovery.changePassword',
      error: {
        minLength9: 'auth.passwordRecovery.error.minLength9',
        requiredNewPasswordConfirmation: 'auth.passwordRecovery.error.requiredNewPasswordConfirmation',
        passwordConfirmationMatchError: 'auth.passwordRecovery.error.passwordConfirmationMatchError',
        customPattern: 'auth.passwordRecovery.error.customPattern',
      },
      messages: {
        success: 'auth.passwordRecovery.messages.success',
        successfulIfValid: 'auth.passwordRecovery.messages.successfulIfValid',
      },
    },
    passwordRecoveryRequest: {
      title: 'auth.passwordRecoveryRequest.title',
      description: 'auth.passwordRecoveryRequest.description',
      mainCredential: 'auth.passwordRecoveryRequest.mainCredential',
      recovery: 'auth.passwordRecoveryRequest.recovery',
      messages: {
        success: 'auth.passwordRecoveryRequest.messages.success',
        error: {
          '504': 'auth.passwordRecoveryRequest.messages.error.504',
          undefined: 'auth.passwordRecoveryRequest.messages.error.undefined',
        },
      },
      error: {
        requiredMainCredential: 'auth.passwordRecoveryRequest.error.requiredMainCredential',
      },
    },
    companySuperAdmin: 'auth.companySuperAdmin',
    utils: {
      back: 'auth.utils.back',
      cancel: 'auth.utils.cancel',
      requiredLegend: 'auth.utils.requiredLegend',
    },
    user: {
      new: 'auth.user.new',
      edit: 'auth.user.edit',
    },
    username: 'auth.username',
    ipAddress: 'auth.ipAddress',
    operatingSystem: 'auth.operatingSystem',
    browser: 'auth.browser',
    email: 'auth.email',
    phoneNumber: 'auth.phoneNumber',
    oldPassword: 'auth.oldPassword',
    password: 'auth.password',
    passwordConfirmation: 'auth.passwordConfirmation',
    passwordExample: 'auth.passwordExample',
    changePassword: 'auth.changePassword',
    login: 'auth.login',
    'login-details': 'auth.login-details',
    users: 'auth.users',
    rights: 'auth.rights',
    activeRight: 'auth.activeRight',
    rightName: 'auth.rightName',
    description: 'auth.description',
    companyType: 'auth.companyType',
    edit: 'auth.edit',
    language: 'auth.language',
    cancel: 'auth.cancel',
    save: 'auth.save',
    name: 'auth.name',
    add: 'auth.add',
    delete: 'auth.delete',
    search: 'auth.search',
    selectAll: 'auth.selectAll',
    authenticationLog: 'auth.authenticationLog',
    loginDate: 'auth.loginDate',
    yes: 'auth.yes',
    no: 'auth.no',
    error: {
      'bad-credentials': 'auth.error.bad-credentials',
    },
    warnings: {
      emailNullReference: 'auth.warnings.emailNullReference',
    },
    errors: {
      '504': 'auth.errors.504',
      minLength5: 'auth.errors.minLength5',
      maxLength50: 'auth.errors.maxLength50',
      requiredName: 'auth.errors.requiredName',
      pattern: 'auth.errors.pattern',
      requiredEmail: 'auth.errors.requiredEmail',
      requiredPhoneNumber: 'auth.errors.requiredPhoneNumber',
      requiredPassword: 'auth.errors.requiredPassword',
      requiredPasswordConfirmation: 'auth.errors.requiredPasswordConfirmation',
      requiredOldPassword: 'auth.errors.requiredOldPassword',
      requiredNewPassword: 'auth.errors.requiredNewPassword',
      requiredNewPasswordConfirmation: 'auth.errors.requiredNewPasswordConfirmation',
      passwordConfirmationMatchError: 'auth.errors.passwordConfirmationMatchError',
      hasWhitespacePassword: 'auth.errors.hasWhitespacePassword',
      invalid_token: 'auth.errors.invalid_token',
      requiredConfirmEmail: 'auth.errors.requiredConfirmEmail',
      customPatternUsername: 'auth.errors.customPatternUsername',
      minlengthPassword: 'auth.errors.minlengthPassword',
      minlengthOldPassword: 'auth.errors.minlengthOldPassword',
      minlengthPasswordConfirmation: 'auth.errors.minlengthPasswordConfirmation',
      maxlengthPassword: 'auth.errors.maxlengthPassword',
      maxlengthOldPassword: 'auth.errors.maxlengthOldPassword',
      maxlengthPasswordConfirmation: 'auth.errors.maxlengthPasswordConfirmation',
      requiredConfirmCheckbox: 'auth.errors.requiredConfirmCheckbox',
      name: {
        minlength: 'auth.errors.name.minlength',
        required: 'auth.errors.name.required',
      },
      oldPassword: {
        'old-password-match': 'auth.errors.oldPassword.old-password-match',
      },
      password: {
        required: 'auth.errors.password.required',
        requiredNewPassword: 'auth.errors.password.requiredNewPassword',
        requiredConfirmPassword: 'auth.errors.password.requiredConfirmPassword',
      },
      passwordConfirmation: {
        requiredPasswordConfirmation: 'auth.errors.passwordConfirmation.requiredPasswordConfirmation',
        passwordConfirmationMatchError: 'auth.errors.passwordConfirmation.passwordConfirmationMatchError',
      },
      emailEmail: 'auth.errors.emailEmail',
      email: {
        pattern: 'auth.errors.email.pattern',
        required: 'auth.errors.email.required',
      },
      customPatternEmail: 'auth.errors.customPatternEmail',
      'Bad credentials': 'auth.errors.Bad credentials',
      'expired-user': 'auth.errors.expired-user',
      'disabled-user': 'auth.errors.disabled-user',
      undefined: 'auth.errors.undefined',
    },
    activeTo: 'auth.activeTo',
    indefinitely: 'auth.indefinitely',
    itemsSelected: 'auth.itemsSelected',
    activeOpts: {
      active: 'auth.activeOpts.active',
      inactive: 'auth.activeOpts.inactive',
      all: 'auth.activeOpts.all',
    },
    role: {
      isPlatform: 'auth.role.isPlatform',
      newRole: 'auth.role.newRole',
      descriptionPlaceholder: 'auth.role.descriptionPlaceholder',
      confirmDeletion: 'auth.role.confirmDeletion',
      editRole: 'auth.role.editRole',
      cloneRole: 'auth.role.cloneRole',
      assigned: 'auth.role.assigned',
      otherRights: 'auth.role.otherRights',
      configuration: {
        errors: {
          requiredName: 'auth.role.configuration.errors.requiredNamed',
        },
      },
    },
    validatePhoneNumber: 'auth.validatePhoneNumber',
    validationCode: 'auth.validationCode',
    sendSmsValidation: 'auth.sendSmsValidation',
    validateCode: 'auth.validateCode',
    invalidCode: 'auth.invalidCode',
    invalidPhoneNumber: 'auth.invalidPhoneNumber',
    'password-recovery-request-link': 'auth.password-recovery-request-link',
    'resend-email-confirmation': {
      button: 'auth.resend-email-confirmation.button',
      success: 'auth.resend-email-confirmation.success',
      error: 'auth.resend-email-confirmation.error',
    },
    profileInfoChanged: 'auth.profileInfoChanged',
    menu: {
      profile: 'auth.menu.profile',
      users: 'auth.menu.users',
      authLogs: 'auth.menu.authLogs',
      notifications: 'auth.menu.notifications',
      notificationSettings: 'auth.menu.notificationSettings',
      notificationEvents: 'auth.menu.notificationEvents',
      sentNotifications: 'auth.menu.sentNotifications',
      jobs: 'auth.menu.jobs',
      importDefinitions: 'auth.menu.importDefinitions',
      importExecutions: 'auth.menu.importExecutions',
      exceptions: 'auth.menu.exceptions',
      feedbackManagement: 'auth.menu.feedbackManagement',
      reports: 'auth.menu.reports',
      dashboard: 'auth.menu.dashboard',
      workflows: 'auth.menu.workflows',
      platformManagement: 'auth.menu.platformManagement',
      platformManagementCompanies: 'auth.menu.platformManagementCompanies',
      platformManagementSubscriptions: 'auth.menu.platformManagementSubscriptions',
      platformManagementInvoices: 'auth.menu.platformManagementInvoices',
      ownedAuthLogs: 'auth.menu.ownedAuthLogs',
    },
  },
  company: {
    suggestions: {
      addLogoAsset: 'company.suggestions.addLogoAsset',
      addCompanyContact: 'company.suggestions.addCompanyContact',
    },
    companyType: {
      customer: 'company.companyType.customer',
      forwarder: 'company.companyType.forwarder',
      service_provider: 'company.companyType.service_provider',
      customer_with_fleet: 'company.companyType.customer_with_fleet',
    },
    address: {
      newTitle: 'company.address.newTitle',
      mainAddress: 'company.address.mainAddress',
      detailTitle: 'company.address.detailTitle',
      list: {
        add: 'company.address.list.add',
      },
      error: {
        noAddressSelected: 'company.address.error.noAddressSelected',
      },
    },
    type: {
      forwarder: 'company.type.forwarder',
      service_provider: 'company.type.service_provider',
      customer: 'company.type.customer',
    },
    utils: {
      requiredLegend: 'company.utils.requiredLegend',
      save: 'company.utils.save',
      cancel: 'company.utils.cancel',
      next: 'company.utils.next',
      requiredLabel: 'company.utils.requiredLabel',
      edit: 'company.utils.edit',
      close: 'company.utils.close',
      select: 'company.utils.select',
      search: 'company.utils.search',
      upload: 'company.utils.upload',
      singleUpload: 'company.utils.singleUpload',
      deleteConfirmationTitle: 'company.utils.deleteConfirmationTitle',
      deleteConfirmationMessage: 'company.utils.deleteConfirmationMessage',
      invalidateEmployeeConfirmationMessage: 'company.utils.invalidateEmployeeConfirmationMessage',
      yes: 'company.utils.yes',
      no: 'company.utils.no',
      all: 'company.utils.all',
      'boolean-select-item': {
        true: 'company.utils.boolean-select-item.true',
        false: 'company.utils.boolean-select-item.false',
        null: 'company.utils.boolean-select-item.null',
      },
    },
    error: {
      alreadyExistingAddressOfType: 'company.error.alreadyExistingAddressOfType',
      noContactsWithEmail: 'company.error.noContactsWithEmail',
    },
    contact: {
      list: {
        add: 'company.contact.list.add',
        ownerCompanyName: 'company.contact.list.ownerCompanyName',
        companyName: 'company.contact.list.companyName',
        phoneNumber: 'company.contact.list.phoneNumber',
        email: 'company.contact.list.email',
        contactName: 'company.contact.list.contactName',
        contactCountry: 'company.contact.list.contactCountry',
        visibilityType: 'company.contact.list.visibilityType',
        contactMethod: 'company.contact.list.contactMethod',
        receivesRequests: 'company.contact.list.receivesRequests',
        visibilityTypes: {
          PUBLIC: 'company.contact.list.visibilityTypes.PUBLIC',
          CUSTOMER: 'company.contact.list.visibilityTypes.CUSTOMER',
          SERVICE_PROVIDER: 'company.contact.list.visibilityTypes.SERVICE_PROVIDER',
          BOTH: 'company.contact.list.visibilityTypes.BOTH',
          NONE: 'company.contact.list.visibilityTypes.NONE',
          null: 'company.contact.list.visibilityTypes.null',
        },
        contactMethods: {
          EMAIL: 'company.contact.list.contactMethods.EMAIL',
          TEL: 'company.contact.list.contactMethods.TEL',
          VISIT: 'company.contact.list.contactMethods.VISIT',
          null: 'company.contact.list.contactMethods.null',
        },
        search: 'company.contact.list.search',
        contactIsNotOwned: 'company.contact.list.contactIsNotOwned',
        companyIsSuperAdmin: 'company.contact.list.companyIsSuperAdmin',
      },
      new: 'company.contact.new',
      detail: 'company.contact.detail',
      close: 'company.contact.close',
      save: 'company.contact.save',
      unsubscribe: 'company.contact.unsubscribe',
      confirmEmailUnsubscribe: 'company.contact.confirmEmailUnsubscribe',
      unsubscribeSuccess: 'company.contact.unsubscribeSuccess',
    },
    employee: {
      new: {
        title: 'company.employee.new.title',
      },
      edit: {
        title: 'company.employee.edit.title',
      },
      common: {
        userDTO: {
          userName: 'company.employee.common.userDTO.userName',
          password: 'company.employee.common.userDTO.password',
        },
        personDTO: {
          name: 'company.employee.common.personDTO.name',
          idSeries: 'company.employee.common.personDTO.idSeries',
          idNumber: 'company.employee.common.personDTO.idNumber',
          cnp: 'company.employee.common.personDTO.cnp',
          address: 'company.employee.common.personDTO.address',
          county: 'company.employee.common.personDTO.county',
          country: 'company.employee.common.personDTO.country',
          person: 'company.employee.common.personDTO.person',
          selectUser: 'company.employee.common.personDTO.selectUser',
          addPerson: 'company.employee.common.personDTO.addPerson',
        },
        email: 'company.employee.common.email',
        phoneNumber: 'company.employee.common.phoneNumber',
        departmentName: 'company.employee.common.departmentName',
        selectDepartment: 'company.employee.common.selectDepartment',
        newDepartment: 'company.employee.common.newDepartment',
        validFrom: 'company.employee.common.validFrom',
        validTo: 'company.employee.common.validTo',
        wizard: {
          employeeStep: 'company.employee.common.wizard.employeeStep',
          userStep: 'company.employee.common.wizard.userStep',
        },
      },
      role: {
        roleSavedSuccess: 'company.employee.role.roleSavedSuccess',
      },
      error: {
        requireduserName: 'company.employee.error.requireduserName',
        requiredpassword: 'company.employee.error.requiredpassword',
        requiredname: 'company.employee.error.requiredname',
        patternEmail: 'company.employee.error.patternEmail',
        requiredcounty: 'company.employee.error.requiredcounty',
        requiredValidFrom: 'company.employee.error.requiredValidFrom',
        requiredValidTo: 'company.employee.error.requiredValidTo',
        requiredPerson: 'company.employee.error.requiredPerson',
      },
      list: {
        add: 'company.employee.list.add',
        pid: 'company.employee.list.pid',
        name: 'company.employee.list.name',
        country: 'company.employee.list.country',
        county: 'company.employee.list.county',
        expired: 'company.employee.list.expired',
        active: 'company.employee.list.active',
        undefinedValidTo: 'company.employee.list.undefinedValidTo',
        phoneNumber: 'company.employee.list.phoneNumber',
        validFrom: 'company.employee.list.validFrom',
        validTo: 'company.employee.list.validTo',
        hasUser: 'company.employee.list.hasUser',
        hasUserStatus: {
          false: 'company.employee.list.hasUserStatus.false',
        },
        search: 'company.employee.list.search',
      },
    },
    creditCard: {
      card: 'company.creditCard.card',
      cardNumber: 'company.creditCard.cardNumber',
      expirationDate: 'company.creditCard.expirationDate',
      cardOwner: 'company.creditCard.cardOwner',
      expirationDateFormat: 'company.creditCard.expirationDateFormat',
      error: {
        invalidCardNumber: 'company.creditCard.error.invalidCardNumber',
        invalidExpirationDate: 'company.creditCard.error.invalidExpirationDate',
        requiredCardNumber: 'company.creditCard.error.requiredCardNumber',
        requiredExpirationDate: 'company.creditCard.error.requiredExpirationDate',
        requiredName: 'company.creditCard.error.requiredName',
      },
    },
    myCompany: {
      title: 'company.myCompany.title',
      details: 'company.myCompany.details',
      remainingCredit: 'company.myCompany.remainingCredit',
      subscriptionValidFrom: 'company.myCompany.subscriptionValidFrom',
      subscriptionRenewedAt: 'company.myCompany.subscriptionRenewedAt',
      firstSubscriptionDate: 'company.myCompany.firstSubscriptionDate',
    },
    businessProfile: {
      publicTitle: 'company.businessProfile.publicTitle',
      partnerTitle: 'company.businessProfile.partnerTitle',
      myProfileTitle: 'company.businessProfile.myProfileTitle',
      companyTabHeader: 'company.businessProfile.companyTabHeader',
      bankAccountTabHeader: 'company.businessProfile.bankAccountTabHeader',
      subscriptionTypeTabHeader: 'company.businessProfile.subscriptionTypeTabHeader',
      cardTabHeader: 'company.businessProfile.cardTabHeader',
      list: {
        companyName: 'company.businessProfile.list.companyName',
        uniqueIdentificationNumber: 'company.businessProfile.list.uniqueIdentificationNumber',
        vat: 'company.businessProfile.list.vat',
        PARTNER: 'company.businessProfile.list.PARTNER',
        PUBLIC: 'company.businessProfile.list.PUBLIC',
        industryTypesValue: 'company.businessProfile.list.industryTypesValue',
        mainPhoneNumber: 'company.businessProfile.list.mainPhoneNumber',
        mainEmailAddress: 'company.businessProfile.list.mainEmailAddress',
        city: 'company.businessProfile.list.city',
        country: 'company.businessProfile.list.country',
        account: 'company.businessProfile.list.account',
        typeValue: 'company.businessProfile.list.typeValue',
        search: 'company.businessProfile.list.search',
        delete: 'company.businessProfile.list.delete',
        businessProfileType: 'company.businessProfile.list.businessProfileType',
        platformMember: 'company.businessProfile.list.platformMember',
        sendInvitationEmail: 'company.businessProfile.list.sendInvitationEmail',
        contactList: 'company.businessProfile.list.contactList',
        onCompanyAddress: 'company.businessProfile.list.onCompanyAddress',
        addCompany: 'company.businessProfile.list.addCompany',
      },
      partners: {
        selectPartner: 'company.businessProfile.partners.selectPartner',
      },
    },
    bankAccount: {
      title: 'company.bankAccount.title',
      iban: 'company.bankAccount.iban',
      swiftCode: 'company.bankAccount.swiftCode',
      currencyCode: 'company.bankAccount.currencyCode',
      bankName: 'company.bankAccount.bankName',
      status: 'company.bankAccount.status',
      type: 'company.bankAccount.type',
      statusEnum: {
        Active: 'company.bankAccount.statusEnum.Active',
        Closed: 'company.bankAccount.statusEnum.Closed',
        Suspended: 'company.bankAccount.statusEnum.Suspended',
      },
      typeEnum: {
        Normal: 'company.bankAccount.typeEnum.Normal',
        Primary: 'company.bankAccount.typeEnum.Primary',
        VAT: 'company.bankAccount.typeEnum.VAT',
      },
      saveNew: 'company.bankAccount.saveNew',
      updateExisting: 'company.bankAccount.updateExisting',
      addNew: 'company.bankAccount.addNew',
      error: {
        requiredIban: 'company.bankAccount.error.requiredIban',
        requiredCurrencyCode: 'company.bankAccount.error.requiredCurrencyCode',
        requiredBankName: 'company.bankAccount.error.requiredBankName',
        requiredStatus: 'company.bankAccount.error.requiredStatus',
        requiredType: 'company.bankAccount.error.requiredType',
        bankAccountOwnershipError: 'company.bankAccount.error.bankAccountOwnershipError',
      },
      lastModifiedAt: 'company.bankAccount.lastModifiedAt',
      lastModifiedBy: 'company.bankAccount.lastModifiedBy',
    },
    menu: {
      companyProfile: 'company.menu.companyProfile',
      employees: 'company.menu.employees',
      addresses: 'company.menu.addresses',
      contacts: 'company.menu.contacts',
      bankAccounts: 'company.menu.bankAccounts',
      termsAndConditions: 'company.menu.termsAndConditions',
      allCompanies: 'company.menu.allCompanies',
      partners: 'company.menu.partners',
      companies: 'company.menu.companies',
      details: 'company.menu.details',
      roleConfiguration: 'company.menu.roleConfiguration',
      userActionTracking: 'company.menu.userActionTracking',
      bankAccountAudit: 'company.menu.bankAccountAudit',
    },
    'le-terms-and-conditions': {
      title: 'company.le-terms-and-conditions.title',
      'general-terms-and-conditions-title': {
        SERVICE_PROVIDER_OFFER_REQ:
          'company.le-terms-and-conditions.general-terms-and-conditions-title.SERVICE_PROVIDER_OFFER_REQ',
        CUSTOMER_OFFER_REQ: 'company.le-terms-and-conditions.general-terms-and-conditions-title.CUSTOMER_OFFER_REQ',
      },
      preview: 'company.le-terms-and-conditions.preview',
      types: {
        SERVICE_PROVIDER_OFFER_REQ: 'company.le-terms-and-conditions.types.SERVICE_PROVIDER_OFFER_REQ',
        CUSTOMER_OFFER_REQ: 'company.le-terms-and-conditions.types.CUSTOMER_OFFER_REQ',
      },
      add: {
        versions: 'company.le-terms-and-conditions.add.versions',
        version: 'company.le-terms-and-conditions.add.version',
        'active-version': 'company.le-terms-and-conditions.add.active-version',
        'valid-from': 'company.le-terms-and-conditions.add.valid-from',
        'valid-to': 'company.le-terms-and-conditions.add.valid-to',
        availability: 'company.le-terms-and-conditions.add.availability',
        'time-undefined': 'company.le-terms-and-conditions.add.time-undefined',
        'new-major-version': 'company.le-terms-and-conditions.add.new-major-version',
        'new-major-version-button': 'company.le-terms-and-conditions.add.new-major-version-button',
        errors: {
          requiredValidFrom: 'company.le-terms-and-conditions.add.errors.requiredValidFrom',
          requiredTemplate: 'company.le-terms-and-conditions.add.errors.requiredTemplate',
        },
        'for-other': {
          SERVICE_PROVIDER_OFFER_REQ: 'company.le-terms-and-conditions.add.for-other.SERVICE_PROVIDER_OFFER_REQ',
          CUSTOMER_OFFER_REQ: 'company.le-terms-and-conditions.add.for-other.CUSTOMER_OFFER_REQ',
        },
        tooltip: {
          SERVICE_PROVIDER_OFFER_REQ: 'company.le-terms-and-conditions.add.tooltip.SERVICE_PROVIDER_OFFER_REQ',
          CUSTOMER_OFFER_REQ: 'company.le-terms-and-conditions.add.tooltip.CUSTOMER_OFFER_REQ',
        },
      },
      dashboard: {
        customers: 'company.le-terms-and-conditions.dashboard.customers',
        vendors: 'company.le-terms-and-conditions.dashboard.vendors',
      },
    },
    companyDetails: {
      createServiceProvider: 'company.companyDetails.createServiceProvider',
      invoiceSeriesPrefix: 'company.companyDetails.invoiceSeriesPrefix',
      companyTabTitle: 'company.companyDetails.companyTabTitle',
      companyTabHeader: 'company.companyDetails.companyTabHeader',
      companyFormSubTitle: 'company.companyDetails.companyFormSubTitle',
      existingCompanyError: 'company.companyDetails.existingCompanyError',
      invoice: {
        logo: 'company.companyDetails.invoice.logo',
      },
    },
    'subscription-type': {
      'list-title': 'company.subscription-type.list-title',
      'add-title': 'company.subscription-type.add-title',
      'new-actions': 'company.subscription-type.new-actions',
      add: 'company.subscription-type.add',
      companies: 'company.subscription-type.companies',
      private: 'company.subscription-type.private',
      'select-company-type': 'company.subscription-type.select-company-type',
      subscription: {
        legalEntity: 'company.subscription-type.subscription.legalEntity',
        detail: 'company.subscription-type.subscription.detail',
        list: {
          title: 'company.subscription-type.subscription.list.title',
        },
      },
      actions: {
        'offer-request': 'company.subscription-type.actions.offer-request',
        info: 'company.subscription-type.actions.info',
        monthlyIncludedAmount: 'company.subscription-type.actions.monthlyIncludedAmount',
        actionCost: 'company.subscription-type.actions.actionCost',
        creditStart: 'company.subscription-type.actions.creditStart',
        CREATE_OFFER: 'company.subscription-type.actions.CREATE_OFFER',
        credits: 'company.subscription-type.actions.credits',
        pricePerExtraCredit: 'company.subscription-type.actions.pricePerExtraCredit',
        SEND_ORDER: 'company.subscription-type.actions.SEND_ORDER',
        RECEIVE_ORDER: 'company.subscription-type.actions.RECEIVE_ORDER',
      },
      errors: {
        requiredtypeName: 'company.subscription-type.errors.requiredtypeName',
        requiredsubscriptionPrice: 'company.subscription-type.errors.requiredsubscriptionPrice',
        requiredsubscriptionCurrency: 'company.subscription-type.errors.requiredsubscriptionCurrency',
        requiredcompanyType: 'company.subscription-type.errors.requiredcompanyType',
        requiredCreditStart: 'company.subscription-type.errors.requiredCreditStart',
        requiredPricePerExtraCredit: 'company.subscription-type.errors.requiredPricePerExtraCredit',
      },
      inputs: {
        creditStart: 'company.subscription-type.inputs.creditStart',
        private: 'company.subscription-type.inputs.private',
        subscriptionCurrency: 'company.subscription-type.inputs.subscriptionCurrency',
        subscriptionPrice: 'company.subscription-type.inputs.subscriptionPrice',
        legalEntity: 'company.subscription-type.inputs.legalEntity',
        typeName: 'company.subscription-type.inputs.typeName',
        companyType: 'company.subscription-type.inputs.companyType',
        subscriptionDetails: 'company.subscription-type.inputs.subscriptionDetails',
        pricePerExtraCredit: 'company.subscription-type.inputs.pricePerExtraCredit',
      },
      companyTypes: {
        customer: 'company.subscription-type.companyTypes.customer',
        service_provider: 'company.subscription-type.companyTypes.service_provider',
        forwarder: 'company.subscription-type.companyTypes.forwarder',
        customer_with_fleet: 'company.subscription-type.companyTypes.customer_with_fleet',
      },
      'actions-list': {
        detailTitle: 'company.subscription-type.actions-list.detailTitle',
        addTitle: 'company.subscription-type.actions-list.addTitle',
        list: {
          adminTitle: 'company.subscription-type.actions-list.list.adminTitle',
          title: 'company.subscription-type.actions-list.list.title',
          name: 'company.subscription-type.actions-list.list.name',
          cost: 'company.subscription-type.actions-list.list.cost',
          validFrom: 'company.subscription-type.actions-list.list.validFrom',
          validTo: 'company.subscription-type.actions-list.list.validTo',
          search: 'company.subscription-type.actions-list.list.search',
          subscriptionTypeName: 'company.subscription-type.actions-list.list.subscriptionTypeName',
          subscriptionTypeModule: 'company.subscription-type.actions-list.list.subscriptionTypeModule',
          monthlyIncludedAmount: 'company.subscription-type.actions-list.list.monthlyIncludedAmount',
        },
        inputs: {
          actionName: 'company.subscription-type.actions-list.inputs.actionName',
          validFrom: 'company.subscription-type.actions-list.inputs.validFrom',
          validTo: 'company.subscription-type.actions-list.inputs.validTo',
          actionCost: 'company.subscription-type.actions-list.inputs.actionCost',
          monthlyIncludedAmount: 'company.subscription-type.actions-list.inputs.monthlyIncludedAmount',
        },
        errors: {
          requiredcost: 'company.subscription-type.actions-list.errors.requiredcost',
          requiredactionName: 'company.subscription-type.actions-list.errors.requiredactionName',
        },
      },
    },
  },
  'crm-app': {
    suggestions: {
      salesNotFound: 'crm-app.suggestions.salesNotFound',
      missingEmployee: 'crm-app.suggestions.missingEmployee',
      missingServicesForOpportunity: 'crm-app.suggestions.missingServicesForOpportunity',
      editActivitySuggestion: 'crm-app.suggestions.editActivitySuggestion',
      editOpportunitySuggestion: 'crm-app.suggestions.editOpportunitySuggestion',
      companyNotServiceProvider: 'crm-app.suggestions.companyNotServiceProvider',
      addContact: 'crm-app.suggestions.addContact',
    },
    menu: {
      language: 'crm-app.menu.language',
      title: 'crm-app.menu.title',
      customer: 'crm-app.menu.customer',
      opportunity: 'crm-app.menu.opportunity',
      activity: 'crm-app.menu.activity',
      sales: 'crm-app.menu.sales',
      credit: 'crm-app.menu.credit',
      address: 'crm-app.menu.address',
      customerDetail: 'crm-app.menu.customerDetail',
      customerProfile: 'crm-app.menu.customerProfile',
      customerAddress: 'crm-app.menu.customerAddress',
      customerContacts: 'crm-app.menu.customerContacts',
      customerActivity: 'crm-app.menu.customerActivity',
      customerOpportunity: 'crm-app.menu.customerOpportunity',
      customerCredit: 'crm-app.menu.customerCredit',
      customerAttachments: 'crm-app.menu.customerAttachments',
      opportunityDetail: 'crm-app.menu.opportunityDetail',
      opportunityAddress: 'crm-app.menu.opportunityAddress',
      opportunityActivity: 'crm-app.menu.opportunityActivity',
      opportunityContacts: 'crm-app.menu.opportunityContacts',
      opportunityVersion: 'crm-app.menu.opportunityVersion',
      opportunityAccount: 'crm-app.menu.opportunityAccount',
      activityDetail: 'crm-app.menu.activityDetail',
      activityAddress: 'crm-app.menu.activityAddress',
      activityContacts: 'crm-app.menu.activityContacts',
    },
    selectItems: {
      reasonWonLostValues: 'crm-app.selectItems.reasonWonLostValues',
      industryTypeValue: 'crm-app.selectItems.industryTypeValue',
      globalAccountTypes: 'crm-app.selectItems.globalAccountTypes',
      needs: 'crm-app.selectItems.needs',
      salesChannels: 'crm-app.selectItems.salesChannels',
      revenueBrands: 'crm-app.selectItems.revenueBrands',
      gpBrands: 'crm-app.selectItems.gpBrands',
      serviceTypeValue: 'crm-app.selectItems.serviceTypeValue',
      trafficChannelTypeValue: 'crm-app.selectItems.trafficChannelTypeValue',
      shipmentType: 'crm-app.selectItems.shipmentType',
      incotermValue: 'crm-app.selectItems.incotermValue',
      volumeUnitValue: 'crm-app.selectItems.volumeUnitValue',
      weightUnitValue: 'crm-app.selectItems.weightUnitValue',
      contactTypeValue: 'crm-app.selectItems.contactTypeValue',
      buyingRoleValue: 'crm-app.selectItems.buyingRoleValue',
      jobTitleValue: 'crm-app.selectItems.jobTitleValue',
      activityType: 'crm-app.selectItems.activityType',
      activityObjective: 'crm-app.selectItems.activityObjective',
      activityPurpose: 'crm-app.selectItems.activityPurpose',
      activityOutcome: 'crm-app.selectItems.activityOutcome',
      callFrequency: 'crm-app.selectItems.callFrequency',
      vehicleType: 'crm-app.selectItems.vehicleType',
      offerRefuseReason: 'crm-app.selectItems.offerRefuseReason',
      invoiceOperationType: 'crm-app.selectItems.invoiceOperationType',
      documentType: 'crm-app.selectItems.documentType',
      activeUserType: 'crm-app.selectItems.activeUserType',
    },
    legalEntity: {
      add: 'crm-app.legalEntity.add',
      title: 'crm-app.legalEntity.title',
      error: {
        DuplicateCompanyName: 'crm-app.legalEntity.error.DuplicateCompanyName',
        DuplicateUniqueID: 'crm-app.legalEntity.error.DuplicateUniqueID',
      },
    },
    customer: {
      listTitle: 'crm-app.customer.listTitle',
      'add-customer': 'crm-app.customer.add-customer',
      'customer-title': 'crm-app.customer.customer-title',
      'contact-title': 'crm-app.customer.contact-title',
      'legal-entity-header': 'crm-app.customer.legal-entity-header',
      'customer-info-header': 'crm-app.customer.customer-info-header',
      'customer-new-warning': 'crm-app.customer.customer-new-warning',
      'new-customer': 'crm-app.customer.new-customer',
      'customer-name': 'crm-app.customer.customer-name',
      'unique-id-number': 'crm-app.customer.unique-id-number',
      'registration-code': 'crm-app.customer.registration-code',
      'customer-city': 'crm-app.customer.customer-city',
      'customer-country': 'crm-app.customer.customer-country',
      'main-address': 'crm-app.customer.main-address',
      'main-phone': 'crm-app.customer.main-phone',
      'main-email': 'crm-app.customer.main-email',
      'sales-name': 'crm-app.customer.sales-name',
      'sales-channel': 'crm-app.customer.sales-channel',
      'customer-stage': 'crm-app.customer.customer-stage',
      'customer-credit-status': 'crm-app.customer.customer-credit-status',
      'customer-industry-type': 'crm-app.customer.customer-industry-type',
      'global-account-code': 'crm-app.customer.global-account-code',
      'global-account-type': 'crm-app.customer.global-account-type',
      'profile-gp-brand': 'crm-app.customer.profile-gp-brand',
      'profile-sales-channel': 'crm-app.customer.profile-sales-channel',
      'customer-last-contact-date': 'crm-app.customer.customer-last-contact-date',
      'customer-call-frequency': 'crm-app.customer.customer-call-frequency',
      'territory-name': 'crm-app.customer.territory-name',
      territory: 'crm-app.customer.territory',
      vat: 'crm-app.customer.vat',
      vatRegistration: 'crm-app.customer.vatRegistration',
      vatSplitStatus: 'crm-app.customer.vatSplitStatus',
      vatInactiveStatus: 'crm-app.customer.vatInactiveStatus',
      vatInactivationDate: 'crm-app.customer.vatInactivationDate',
      'customer-loyalty-code': 'crm-app.customer.customer-loyalty-code',
      'customer-search': 'crm-app.customer.customer-search',
      'legal-entity-search': 'crm-app.customer.legal-entity-search',
      generalInfo: 'crm-app.customer.generalInfo',
      profile: 'crm-app.customer.profile',
      financialInfo: 'crm-app.customer.financialInfo',
      totalOpportunityRev: 'crm-app.customer.totalOpportunityRev',
      totalOpportunityGP: 'crm-app.customer.totalOpportunityGP',
      totalCommittedRev: 'crm-app.customer.totalCommittedRev',
      loyaltyCode: 'crm-app.customer.loyaltyCode',
      lastContactDate: 'crm-app.customer.lastContactDate',
      contactedBy: 'crm-app.customer.contactedBy',
      nextContactDate: 'crm-app.customer.nextContactDate',
      YTDRevenue: 'crm-app.customer.YTDRevenue',
      YTDGP: 'crm-app.customer.YTDGP',
      customerRating: 'crm-app.customer.customerRating',
      allCustomers: 'crm-app.customer.allCustomers',
      myCustomers: 'crm-app.customer.myCustomers',
      teamCustomers: 'crm-app.customer.teamCustomers',
      'address-title': 'crm-app.customer.address-title',
      favourite: 'crm-app.customer.favourite',
      error: {
        companyNamerequired: 'crm-app.customer.error.companyNamerequired',
        uniqueIdNumberrequired: 'crm-app.customer.error.uniqueIdNumberrequired',
        countryrequired: 'crm-app.customer.error.countryrequired',
        territoryrequired: 'crm-app.customer.error.territoryrequired',
        customer_exists: 'crm-app.customer.error.customer_exists',
        alreadyExistingAddressOfType: 'crm-app.customer.error.alreadyExistingAddressOfType',
      },
      'customer-profile': {
        title: 'crm-app.customer.customer-profile.title',
        services: 'crm-app.customer.customer-profile.services',
        'last-shipment-date': 'crm-app.customer.customer-profile.last-shipment-date',
        need: 'crm-app.customer.customer-profile.need',
        commodity: 'crm-app.customer.customer-profile.commodity',
        'total-potential-revenue': 'crm-app.customer.customer-profile.total-potential-revenue',
        'total-potential-gp': 'crm-app.customer.customer-profile.total-potential-gp',
        'sales-channel': 'crm-app.customer.customer-profile.sales-channel',
        'revenue-brand': 'crm-app.customer.customer-profile.revenue-brand',
        'gp-brand': 'crm-app.customer.customer-profile.gp-brand',
        competitors: 'crm-app.customer.customer-profile.competitors',
        mainCompetitor: 'crm-app.customer.customer-profile.mainCompetitor',
        'sales-channel-options': {
          directChannel: 'crm-app.customer.customer-profile.sales-channel-options.directChannel',
          telesales: 'crm-app.customer.customer-profile.sales-channel-options.telesales',
          fieldSales: 'crm-app.customer.customer-profile.sales-channel-options.fieldSales',
          majorAccount: 'crm-app.customer.customer-profile.sales-channel-options.majorAccount',
          globalAccount: 'crm-app.customer.customer-profile.sales-channel-options.globalAccount',
        },
        totalGrossProfit: 'crm-app.customer.customer-profile.totalGrossProfit',
        totalRevenue: 'crm-app.customer.customer-profile.totalRevenue',
        error: {
          requiredCustomerNeedValue: 'crm-app.customer.customer-profile.error.requiredCustomerNeedValue',
          requiredCommodity: 'crm-app.customer.customer-profile.error.requiredCommodity',
          requiredSalesChannelValue: 'crm-app.customer.customer-profile.error.requiredSalesChannelValue',
        },
      },
      'loyalty-options': {
        Inactive: 'crm-app.customer.loyalty-options.Inactive',
        Lost: 'crm-app.customer.loyalty-options.Lost',
        Downtrader: 'crm-app.customer.loyalty-options.Downtrader',
        Uptrader: 'crm-app.customer.loyalty-options.Uptrader',
        Stable: 'crm-app.customer.loyalty-options.Stable',
        New: 'crm-app.customer.loyalty-options.New',
      },
      'customer-stages': {
        Suspect: 'crm-app.customer.customer-stages.Suspect',
        Prospect: 'crm-app.customer.customer-stages.Prospect',
        Lost: 'crm-app.customer.customer-stages.Lost',
        Action: 'crm-app.customer.customer-stages.Action',
        Track: 'crm-app.customer.customer-stages.Track',
        Maintain: 'crm-app.customer.customer-stages.Maintain',
      },
      'credit-status': {
        Active: 'crm-app.customer.credit-status.Active',
        Expired: 'crm-app.customer.credit-status.Expired',
        Closed: 'crm-app.customer.credit-status.Closed',
        Warning_exceeded: 'crm-app.customer.credit-status.Warning_exceeded',
      },
      credit: {
        requestStatus: 'crm-app.customer.credit.requestStatus',
        requestHistory: 'crm-app.customer.credit.requestHistory',
        requestDate: 'crm-app.customer.credit.requestDate',
        validationDate: 'crm-app.customer.credit.validationDate',
        approved: 'crm-app.customer.credit.approved',
        approvedAmount: 'crm-app.customer.credit.approvedAmount',
        approvalTitle: 'crm-app.customer.credit.approvalTitle',
        requestComment: 'crm-app.customer.credit.requestComment',
        requestEnum: {
          Requested: 'crm-app.customer.credit.requestEnum.Requested',
          Under_decision: 'crm-app.customer.credit.requestEnum.Under_decision',
          Rejected: 'crm-app.customer.credit.requestEnum.Rejected',
          Approved: 'crm-app.customer.credit.requestEnum.Approved',
        },
        availableCredit: 'crm-app.customer.credit.availableCredit',
        billingCycle: 'crm-app.customer.credit.billingCycle',
        billingCycleEnum: {
          Per_shipment: 'crm-app.customer.credit.billingCycleEnum.Per_shipment',
          Weekly: 'crm-app.customer.credit.billingCycleEnum.Weekly',
          Monthly: 'crm-app.customer.credit.billingCycleEnum.Monthly',
          Bi_monthly: 'crm-app.customer.credit.billingCycleEnum.Bi_monthly',
          Manual: 'crm-app.customer.credit.billingCycleEnum.Manual',
        },
        checkComment: 'crm-app.customer.credit.checkComment',
        checkDate: 'crm-app.customer.credit.checkDate',
        checkedBy: 'crm-app.customer.credit.checkedBy',
        requestedBy: 'crm-app.customer.credit.requestedBy',
        checkExpiryDate: 'crm-app.customer.credit.checkExpiryDate',
        checkValidityDays: 'crm-app.customer.credit.checkValidityDays',
        creditChecked: 'crm-app.customer.credit.creditChecked',
        creditLimit: 'crm-app.customer.credit.creditLimit',
        currencyValue: 'crm-app.customer.credit.currencyValue',
        expectedYearlyRevenue: 'crm-app.customer.credit.expectedYearlyRevenue',
        paymentMethod: 'crm-app.customer.credit.paymentMethod',
        paymentMethodEnum: {
          Cash: 'crm-app.customer.credit.paymentMethodEnum.Cash',
          Credit_card: 'crm-app.customer.credit.paymentMethodEnum.Credit_card',
          Credit: 'crm-app.customer.credit.paymentMethodEnum.Credit',
        },
        paymentTerms: 'crm-app.customer.credit.paymentTerms',
        creditStatus: 'crm-app.customer.credit.creditStatus',
        statusEnum: {
          Active: 'crm-app.customer.credit.statusEnum.Active',
          Expired: 'crm-app.customer.credit.statusEnum.Expired',
          Closed: 'crm-app.customer.credit.statusEnum.Closed',
          Warning_exceeded: 'crm-app.customer.credit.statusEnum.Warning_exceeded',
        },
        title: 'crm-app.customer.credit.title',
        error: {
          currencyValuerequired: 'crm-app.customer.credit.error.currencyValuerequired',
          creditLimitrequired: 'crm-app.customer.credit.error.creditLimitrequired',
          expectedYearlyRevenuerequired: 'crm-app.customer.credit.error.expectedYearlyRevenuerequired',
          requestDaterequired: 'crm-app.customer.credit.error.requestDaterequired',
        },
      },
      contact: {
        contactTabTitle: 'crm-app.customer.contact.contactTabTitle',
        contactTabHeader: 'crm-app.customer.contact.contactTabHeader',
        customerContactTabTitle: 'crm-app.customer.contact.customerContactTabTitle',
        customerContactTabHeader: 'crm-app.customer.contact.customerContactTabHeader',
        list: {
          title: 'crm-app.customer.contact.list.title',
          add: 'crm-app.customer.contact.list.add',
        },
        detail: {
          'person-name': 'crm-app.customer.contact.detail.person-name',
          'person-idSeries': 'crm-app.customer.contact.detail.person-idSeries',
          'person-idNumber': 'crm-app.customer.contact.detail.person-idNumber',
          'person-address': 'crm-app.customer.contact.detail.person-address',
          'person-county': 'crm-app.customer.contact.detail.person-county',
          email: 'crm-app.customer.contact.detail.email',
          phoneNumber: 'crm-app.customer.contact.detail.phoneNumber',
          common: {
            jobTitleValue: 'crm-app.customer.contact.detail.common.jobTitleValue',
            buyingRoleValue: 'crm-app.customer.contact.detail.common.buyingRoleValue',
            contactTypeValue: 'crm-app.customer.contact.detail.common.contactTypeValue',
            neverCall: 'crm-app.customer.contact.detail.common.neverCall',
            selectExistentContact: 'crm-app.customer.contact.detail.common.selectExistentContact',
            clearContactSelection: 'crm-app.customer.contact.detail.common.clearContactSelection',
            autocompletePlaceholder: 'crm-app.customer.contact.detail.common.autocompletePlaceholder',
          },
          new: {
            title: 'crm-app.customer.contact.detail.new.title',
            save: 'crm-app.customer.contact.detail.new.save',
            close: 'crm-app.customer.contact.detail.new.close',
          },
          edit: {
            title: 'crm-app.customer.contact.detail.edit.title',
          },
          inputs: {
            addNewContact: 'crm-app.customer.contact.detail.inputs.addNewContact',
          },
          errors: {
            defaultValidationMessage: 'crm-app.customer.contact.detail.errors.defaultValidationMessage',
          },
        },
        deleteConfirm: 'crm-app.customer.contact.deleteConfirm',
      },
      overview: {
        'next-contact-date': 'crm-app.customer.overview.next-contact-date',
        'opportunity-potential-gross-profit': 'crm-app.customer.overview.opportunity-potential-gross-profit',
        'opportunity-commited-gross-profit': 'crm-app.customer.overview.opportunity-commited-gross-profit',
        'opportunity-total-potential-gross-profit-per-year':
          'crm-app.customer.overview.opportunity-total-potential-gross-profit-per-year',
        'sales-team': 'crm-app.customer.overview.sales-team',
        opportunities: 'crm-app.customer.overview.opportunities',
        contacts: 'crm-app.customer.overview.contacts',
        activities: 'crm-app.customer.overview.activities',
        'opportunity-name': 'crm-app.customer.overview.opportunity-name',
        'opportunity-type': 'crm-app.customer.overview.opportunity-type',
        'business-renewal-date': 'crm-app.customer.overview.business-renewal-date',
        'pipeline-stage': 'crm-app.customer.overview.pipeline-stage',
        'first-shipment-expected-date': 'crm-app.customer.overview.first-shipment-expected-date',
        'service-type': 'crm-app.customer.overview.service-type',
        'shipment-type': 'crm-app.customer.overview.shipment-type',
        'actual-completion-date': 'crm-app.customer.overview.actual-completion-date',
        'planned-start-date': 'crm-app.customer.overview.planned-start-date',
        'start-time': 'crm-app.customer.overview.start-time',
        'end-time': 'crm-app.customer.overview.end-time',
        'activity-status': 'crm-app.customer.overview.activity-status',
        comments: 'crm-app.customer.overview.comments',
        'contact-name': 'crm-app.customer.overview.contact-name',
        'phone-number': 'crm-app.customer.overview.phone-number',
        email: 'crm-app.customer.overview.email',
        'job-title': 'crm-app.customer.overview.job-title',
        'buying-role': 'crm-app.customer.overview.buying-role',
        'contact-type': 'crm-app.customer.overview.contact-type',
        'never-call': 'crm-app.customer.overview.never-call',
        'more-opportunities': 'crm-app.customer.overview.more-opportunities',
        'more-activities': 'crm-app.customer.overview.more-activities',
        'more-contacts': 'crm-app.customer.overview.more-contacts',
        orders: 'crm-app.customer.overview.orders',
        'order-pickups': 'crm-app.customer.overview.order-pickups',
        'order-deliveries': 'crm-app.customer.overview.order-deliveries',
        'order-tasks': 'crm-app.customer.overview.order-tasks',
        'order-status': 'crm-app.customer.overview.order-status',
        contracts: 'crm-app.customer.overview.contracts',
        'contract-valid-from': 'crm-app.customer.overview.contract-valid-from',
        'contract-valid-to': 'crm-app.customer.overview.contract-valid-to',
        'contract-status': 'crm-app.customer.overview.contract-status',
        routes: 'crm-app.customer.overview.routes',
        'route-name': 'crm-app.customer.overview.route-name',
        'route-source-location': 'crm-app.customer.overview.route-source-location',
        'route-destination-location': 'crm-app.customer.overview.route-destination-location',
        'total-value': 'crm-app.customer.overview.total-value',
        profit: 'crm-app.customer.overview.profit',
        noBillingData: 'crm-app.customer.overview.noBillingData',
        dueAmount: 'crm-app.customer.overview.dueAmount',
        dso: 'crm-app.customer.overview.dso',
        actualPaymentTerm: 'crm-app.customer.overview.actualPaymentTerm',
        createdBy: 'crm-app.customer.overview.createdBy',
        totalPotentialRevGP: 'crm-app.customer.overview.totalPotentialRevGP',
        'contract-status-value': {
          requested: 'crm-app.overview.contract-status-value.requested',
          accepted: 'crm-app.overview.contract-status-value.accepted',
        },
      },
      attachments: {
        'uploaded-list': 'crm-app.customer.attachments.uploaded-list',
        'new-upload': 'crm-app.customer.attachments.new-upload',
      },
      errors: {
        DuplicateUniqueID: 'crm-app.customer.errors.DuplicateUniqueID',
        customer_exists: 'crm-app.customer.errors.customer_exists',
      },
      globalAccount: {
        code: 'crm-app.customer.globalAccount.code',
        type: 'crm-app.customer.globalAccount.type',
        add: 'crm-app.customer.globalAccount.add',
      },
    },
    address: {
      'address-line': 'crm-app.address.address-line',
      city: 'crm-app.address.city',
      state: 'crm-app.address.state',
      'postal-code': 'crm-app.address.postal-code',
      country: 'crm-app.address.country',
      'address-type': 'crm-app.address.address-type',
      newTitle: 'crm-app.address.newTitle',
      detailTitle: 'crm-app.address.detailTitle',
      'address-types': {
        Registered: 'crm-app.address.address-types.Registered',
        Billing: 'crm-app.address.address-types.Billing',
        Decision: 'crm-app.address.address-types.Decision',
        Delivery: 'crm-app.address.address-types.Delivery',
        Main: 'crm-app.address.address-types.Main',
        Pickup: 'crm-app.address.address-types.Pickup',
        Shipping: 'crm-app.address.address-types.Shipping',
        Warehouse: 'crm-app.address.address-types.Warehouse',
        Invoicing: 'crm-app.address.address-types.Invoicing',
        Correspondence: 'crm-app.address.address-types.Correspondence',
      },
      list: {
        title: 'crm-app.address.list.title',
        add: 'crm-app.address.list.add',
      },
      error: {
        noAddressSelected: 'crm-app.address.error.noAddressSelected',
      },
    },
    opportunity: {
      'list-title': 'crm-app.opportunity.list-title',
      'detail-title': 'crm-app.opportunity.detail-title',
      'new-title': 'crm-app.opportunity.new-title',
      'opportunity-name': 'crm-app.opportunity.opportunity-name',
      'opportunity-type': 'crm-app.opportunity.opportunity-type',
      'add-opportunity': 'crm-app.opportunity.add-opportunity',
      'pipeline-stage': 'crm-app.opportunity.pipeline-stage',
      account: 'crm-app.opportunity.account',
      'expected-close-date': 'crm-app.opportunity.expected-close-date',
      'reason-won-lost': 'crm-app.opportunity.reason-won-lost',
      'lead-source': 'crm-app.opportunity.lead-source',
      'reason-for-lead': 'crm-app.opportunity.reason-for-lead',
      'business-renewal-date': 'crm-app.opportunity.business-renewal-date',
      'first-shipment-expected-date': 'crm-app.opportunity.first-shipment-expected-date',
      'number-of-shipments': 'crm-app.opportunity.number-of-shipments',
      probability: 'crm-app.opportunity.probability',
      'main-competitor-name': 'crm-app.opportunity.main-competitor-name',
      'customer-name': 'crm-app.opportunity.customer-name',
      territory: 'crm-app.opportunity.territory',
      competitors: 'crm-app.opportunity.competitors',
      'sales-name': 'crm-app.opportunity.sales-name',
      'sales-channel': 'crm-app.opportunity.sales-channel',
      sales: 'crm-app.opportunity.sales',
      service: 'crm-app.opportunity.service',
      'contract-signed': 'crm-app.opportunity.contract-signed',
      'opportunity-title': 'crm-app.opportunity.opportunity-title',
      'opportunity-info-header': 'crm-app.opportunity.opportunity-info-header',
      'revenue-per-shipment': 'crm-app.opportunity.revenue-per-shipment',
      'gp-per-shipment': 'crm-app.opportunity.gp-per-shipment',
      'shipments-per-year': 'crm-app.opportunity.shipments-per-year',
      'potential-gp': 'crm-app.opportunity.potential-gp',
      'potential-revenue': 'crm-app.opportunity.potential-revenue',
      accountTitle: 'crm-app.opportunity.accountTitle',
      accountDetails: 'crm-app.opportunity.accountDetails',
      addServices: 'crm-app.opportunity.addServices',
      addServiceDisabledTooltip: 'crm-app.opportunity.addServiceDisabledTooltip',
      allOpportunities: 'crm-app.opportunity.allOpportunities',
      myOpportunities: 'crm-app.opportunity.myOpportunities',
      teamOpportunities: 'crm-app.opportunity.teamOpportunities',
      version: {
        title: 'crm-app.opportunity.version.title',
        name: 'crm-app.opportunity.version.name',
        pipelineStage: 'crm-app.opportunity.version.pipelineStage',
        modifiedAt: 'crm-app.opportunity.version.modifiedAt',
        modifiedBy: 'crm-app.opportunity.version.modifiedBy',
      },
      revenue: {
        potentialRev: 'crm-app.opportunity.revenue.potentialRev',
        committedRev: 'crm-app.opportunity.revenue.committedRev',
        potentialGp: 'crm-app.opportunity.revenue.potentialGp',
        committedGp: 'crm-app.opportunity.revenue.committedGp',
        percentGp: 'crm-app.opportunity.revenue.percentGp',
        totalRev: 'crm-app.opportunity.revenue.totalRev',
        totalGp: 'crm-app.opportunity.revenue.totalGp',
        totalPercentGp: 'crm-app.opportunity.revenue.totalPercentGp',
      },
      'pipeline-stages': {
        IDENTIFY_BUSINESS: 'crm-app.opportunity.pipeline-stages.IDENTIFY_BUSINESS',
        RECEIVE_TENDER: 'crm-app.opportunity.pipeline-stages.RECEIVE_TENDER',
        SUBMIT_PROPOSAL: 'crm-app.opportunity.pipeline-stages.SUBMIT_PROPOSAL',
        IMPLEMENTED: 'crm-app.opportunity.pipeline-stages.IMPLEMENTED',
        SHIPPING: 'crm-app.opportunity.pipeline-stages.SHIPPING',
        UNABLE_TO_GAIN: 'crm-app.opportunity.pipeline-stages.UNABLE_TO_GAIN',
        FUTURE_OPPORTUNITY: 'crm-app.opportunity.pipeline-stages.FUTURE_OPPORTUNITY',
        SHIPPING_TO_PROFILE: 'crm-app.opportunity.pipeline-stages.SHIPPING_TO_PROFILE',
      },
      'opportunity-types': {
        ACQUISITION: 'crm-app.opportunity.opportunity-types.ACQUISITION',
        CROSS_SELLING: 'crm-app.opportunity.opportunity-types.CROSS_SELLING',
        PRICING: 'crm-app.opportunity.opportunity-types.PRICING',
        SPOT_SHIPMENT: 'crm-app.opportunity.opportunity-types.SPOT_SHIPMENT',
      },
      contact: {
        'new-title': 'crm-app.opportunity.contact.new-title',
        'list-title': 'crm-app.opportunity.contact.list-title',
      },
    },
    activity: {
      'list-title': 'crm-app.activity.list-title',
      'detail-title': 'crm-app.activity.detail-title',
      activityCalendar: 'crm-app.activity.activityCalendar',
      saveAndCreateNew: 'crm-app.activity.saveAndCreateNew',
      list: {
        addNew: 'crm-app.activity.list.addNew',
      },
      contact: {
        new: 'crm-app.activity.contact.new',
        'new-title': 'crm-app.activity.contact.new-title',
        title: 'crm-app.activity.contact.title',
        list: {
          contactName: 'crm-app.activity.contact.list.contactName',
          phoneNumber: 'crm-app.activity.contact.list.phoneNumber',
          buyingRoleValue: 'crm-app.activity.contact.list.buyingRoleValue',
          contactTypeValue: 'crm-app.activity.contact.list.contactTypeValue',
        },
        'add-contact': 'crm-app.activity.contact.add-contact',
      },
      error: {
        requiredCustomerSummaryVO: 'crm-app.activity.error.requiredCustomerSummaryVO',
        requiredAssignedToSalesSummaryVo: 'crm-app.activity.error.requiredAssignedToSalesSummaryVo',
        requiredActivityObjective: 'crm-app.activity.error.requiredActivityObjective',
        requiredActivityType: 'crm-app.activity.error.requiredActivityType',
        requiredActivityPurpose: 'crm-app.activity.error.requiredActivityPurpose',
        requiredActivityOutcome: 'crm-app.activity.error.requiredActivityOutcome',
        requiredActivityStatus: 'crm-app.activity.error.requiredActivityStatus',
        requiredCustomerContactSummaryVO: 'crm-app.activity.error.requiredCustomerContactSummaryVO',
        requiredcontacts: 'crm-app.activity.error.requiredcontacts',
      },
      'activity-name': 'crm-app.activity.activity-name',
      'customer-search': 'crm-app.activity.customer-search',
      'activity-planning': 'crm-app.activity.activity-planning',
      'opportunity-search': 'crm-app.activity.opportunity-search',
      pipelineStage: 'crm-app.activity.pipelineStage',
      'sales-search': 'crm-app.activity.sales-search',
      'activity-title': 'crm-app.activity.activity-title',
      'activity-header': 'crm-app.activity.activity-header',
      'opportunity-header': 'crm-app.activity.opportunity-header',
      'activity-type': 'crm-app.activity.activity-type',
      'activity-objective': 'crm-app.activity.activity-objective',
      'activity-purpose': 'crm-app.activity.activity-purpose',
      'activity-outcome': 'crm-app.activity.activity-outcome',
      'activity-status': 'crm-app.activity.activity-status',
      'planned-start-date': 'crm-app.activity.planned-start-date',
      'start-time': 'crm-app.activity.start-time',
      'end-time': 'crm-app.activity.end-time',
      startTime: 'crm-app.activity.startTime',
      endTime: 'crm-app.activity.endTime',
      'actual-completion-date': 'crm-app.activity.actual-completion-date',
      'completion-date-time-stamp': 'crm-app.activity.completion-date-time-stamp',
      'customer-name': 'crm-app.activity.customer-name',
      'customer-stage': 'crm-app.activity.customer-stage',
      'opportunity-name': 'crm-app.activity.opportunity-name',
      'opportunity-type': 'crm-app.activity.opportunity-type',
      'pipeline-stage': 'crm-app.activity.pipeline-stage',
      territory: 'crm-app.activity.territory',
      sales: 'crm-app.activity.sales',
      comments: 'crm-app.activity.comments',
      'activity-main-contact': 'crm-app.activity.activity-main-contact',
      allActivities: 'crm-app.activity.allActivities',
      myActivities: 'crm-app.activity.myActivities',
      teamActivities: 'crm-app.activity.teamActivities',
      'activity-statuses': {
        Done: 'crm-app.activity.activity-statuses.Done',
        Scheduled: 'crm-app.activity.activity-statuses.Scheduled',
        Rejected: 'crm-app.activity.activity-statuses.Rejected',
        Requested: 'crm-app.activity.activity-statuses.Requested',
        Cancelled: 'crm-app.activity.activity-statuses.Cancelled',
        null: 'crm-app.activity.activity-statuses.null',
      },
      overview: {
        title: 'crm-app.activity.overview.title',
        saveError: 'crm-app.activity.overview.saveError',
        saveSuccess: 'crm-app.activity.overview.saveSuccess',
        activityStatus: 'crm-app.activity.overview.activityStatus',
        assignedTo: 'crm-app.activity.overview.assignedTo',
        customer: 'crm-app.activity.overview.customer',
        activityType: 'crm-app.activity.overview.activityType',
        activityObjective: 'crm-app.activity.overview.activityObjective',
        activityOutcome: 'crm-app.activity.overview.activityOutcome',
        contact: 'crm-app.activity.overview.contact',
        startedAt: 'crm-app.activity.overview.startedAt',
        finishedAt: 'crm-app.activity.overview.finishedAt',
        opportunity: 'crm-app.activity.overview.opportunity',
        actualCompletionDate: 'crm-app.activity.overview.actualCompletionDate',
      },
    },
    service: {
      'new-title': 'crm-app.service.new-title',
      'edit-title': 'crm-app.service.edit-title',
      'service-type': 'crm-app.service.service-type',
      'add-service': 'crm-app.service.add-service',
      'traffic-channel-type': 'crm-app.service.traffic-channel-type',
      'volume-unit': 'crm-app.service.volume-unit',
      'weight-unit': 'crm-app.service.weight-unit',
      'shipment-type': 'crm-app.service.shipment-type',
      'incoterm-value': 'crm-app.service.incoterm-value',
      origin: 'crm-app.service.origin',
      destination: 'crm-app.service.destination',
      'weight-per-shipment': 'crm-app.service.weight-per-shipment',
      'volume-per-shipment': 'crm-app.service.volume-per-shipment',
      'revenue-per-shipment': 'crm-app.service.revenue-per-shipment',
      'gross-profit-per-shipment': 'crm-app.service.gross-profit-per-shipment',
      'shipments-per-year': 'crm-app.service.shipments-per-year',
      'transit-time': 'crm-app.service.transit-time',
      comments: 'crm-app.service.comments',
      tags: 'crm-app.service.tags',
      competitor: 'crm-app.service.competitor',
      error: {
        originDestinationAddressValidationError: 'crm-app.service.error.originDestinationAddressValidationError',
        requiredserviceTypeValue: 'crm-app.service.error.requiredserviceTypeValue',
        requiredtrafficChannelTypeValue: 'crm-app.service.error.requiredtrafficChannelTypeValue',
        requiredvolumeUnitValue: 'crm-app.service.error.requiredvolumeUnitValue',
        requiredweightUnitValue: 'crm-app.service.error.requiredweightUnitValue',
        requiredshipmentType: 'crm-app.service.error.requiredshipmentType',
        requiredincotermValue: 'crm-app.service.error.requiredincotermValue',
        requiredorigin: 'crm-app.service.error.requiredorigin',
        requireddestination: 'crm-app.service.error.requireddestination',
        requiredweightPerShipment: 'crm-app.service.error.requiredweightPerShipment',
        requiredvolumePerShipment: 'crm-app.service.error.requiredvolumePerShipment',
        requiredrevenuePerShipment: 'crm-app.service.error.requiredrevenuePerShipment',
        requiredgrossProfitPerShipment: 'crm-app.service.error.requiredgrossProfitPerShipment',
        requiredshipmentsPerYear: 'crm-app.service.error.requiredshipmentsPerYear',
        requiredtransitTime: 'crm-app.service.error.requiredtransitTime',
      },
    },
    utils: {
      selectFilter: 'crm-app.utils.selectFilter',
      saveFilter: 'crm-app.utils.saveFilter',
      expandFilters: 'crm-app.utils.expandFilters',
      minimizeFilters: 'crm-app.utils.minimizeFilters',
      todayFilter: 'crm-app.utils.todayFilter',
      all: 'crm-app.utils.all',
      enable: 'crm-app.utils.enable',
      currentWeekFilter: 'crm-app.utils.currentWeekFilter',
      addFilterName: 'crm-app.utils.addFilterName',
      resetTableFilters: 'crm-app.utils.resetTableFilters',
      clearTableFilters: 'crm-app.utils.clearTableFilters',
      'columns-selected': 'crm-app.utils.columns-selected',
      'choose-columns': 'crm-app.utils.choose-columns',
      search: 'crm-app.utils.search',
      'show-advanced-filters': 'crm-app.utils.show-advanced-filters',
      'advanced-filters': 'crm-app.utils.advanced-filters',
      preview: 'crm-app.utils.preview',
      details: 'crm-app.utils.details',
      add: 'crm-app.utils.add',
      save: 'crm-app.utils.save',
      edit: 'crm-app.utils.edit',
      newRequest: 'crm-app.utils.newRequest',
      update: 'crm-app.utils.update',
      cancel: 'crm-app.utils.cancel',
      close: 'crm-app.utils.close',
      reset: 'crm-app.utils.reset',
      total: 'crm-app.utils.total',
      nextStep: 'crm-app.utils.nextStep',
      requiredLegend: 'crm-app.utils.requiredLegend',
      deleteConfirmationMessage: 'crm-app.utils.deleteConfirmationMessage',
      yes: 'crm-app.utils.yes',
      no: 'crm-app.utils.no',
      'boolean-values': {
        true: 'crm-app.utils.boolean-values.true',
        false: 'crm-app.utils.boolean-values.false',
        null: 'crm-app.utils.boolean-values.null',
      },
    },
    error: {
      defaultValidationMessage: 'crm-app.error.defaultValidationMessage',
      required: 'crm-app.error.required',
      requiredName: 'crm-app.error.requiredName',
      requiredactualCompletionDate: 'crm-app.error.requiredactualCompletionDate',
      requiredStage: 'crm-app.error.requiredStage',
      requiredCustomerName: 'crm-app.error.requiredCustomerName',
      requiredOpportunityName: 'crm-app.error.requiredOpportunityName',
      requiredCode: 'crm-app.error.requiredCode',
      requiredValue: 'crm-app.error.requiredValue',
      requiredStartDate: 'crm-app.error.requiredStartDate',
      requiredFinishDate: 'crm-app.error.requiredFinishDate',
      startDateAfterEndDate: 'crm-app.error.startDateAfterEndDate',
      territory_name_exists: 'crm-app.error.territory_name_exists',
      alreadyExistingAddressOfType: 'crm-app.error.alreadyExistingAddressOfType',
      activity_contact_exists: 'crm-app.error.activity_contact_exists',
      opportunity_contact_exists: 'crm-app.error.opportunity_contact_exists',
      timeIntervalError: 'crm-app.error.timeIntervalError',
      select_item_exists: 'crm-app.error.select_item_exists',
      activityMustHaveAtLeastOneContact: 'crm-app.error.activityMustHaveAtLeastOneContact',
    },
    selectItem: {
      title: 'crm-app.selectItem.title',
      fieldName: 'crm-app.selectItem.fieldName',
      value: 'crm-app.selectItem.value',
      label: 'crm-app.selectItem.label',
      filterFieldName: 'crm-app.selectItem.filterFieldName',
      filterValue: 'crm-app.selectItem.filterValue',
      filterLabel: 'crm-app.selectItem.filterLabel',
      addValue: 'crm-app.selectItem.addValue',
      addLabel: 'crm-app.selectItem.addLabel',
      edit: 'crm-app.selectItem.edit',
      delete: 'crm-app.selectItem.delete',
      all: 'crm-app.selectItem.all',
    },
    sales: {
      list: {
        title: 'crm-app.sales.list.title',
        pid: 'crm-app.sales.list.pid',
        name: 'crm-app.sales.list.name',
        territories: 'crm-app.sales.list.territories',
        assignedFrom: 'crm-app.sales.list.assignedFrom',
        manager: 'crm-app.sales.list.manager',
        validFrom: 'crm-app.sales.list.validFrom',
        validTo: 'crm-app.sales.list.validTo',
        expired: 'crm-app.sales.list.expired',
        active: 'crm-app.sales.list.active',
        undefinedValidTo: 'crm-app.sales.list.undefinedValidTo',
        latestOpportunity: 'crm-app.sales.list.latestOpportunity',
        LatestActivity: 'crm-app.sales.list.LatestActivity',
        filter: 'crm-app.sales.list.filter',
        addSales: 'crm-app.sales.list.addSales',
        assignSales: 'crm-app.sales.list.assignSales',
        salesChannelValue: 'crm-app.sales.list.salesChannelValue',
      },
      new: {
        title: 'crm-app.sales.new.title',
      },
      edit: {
        title: 'crm-app.sales.edit.title',
      },
      common: {
        employee: 'crm-app.sales.common.employee',
        salesManager: 'crm-app.sales.common.salesManager',
        validFrom: 'crm-app.sales.common.validFrom',
        validTo: 'crm-app.sales.common.validTo',
        salesChannelValue: 'crm-app.sales.common.salesChannelValue',
        selectSalesChannel: 'crm-app.sales.common.selectSalesChannel',
      },
      territory: {
        title: 'crm-app.sales.territory.title',
        territories: 'crm-app.sales.territory.territories',
        territory: 'crm-app.sales.territory.territory',
        sale: 'crm-app.sales.territory.sale',
        sales: 'crm-app.sales.territory.sales',
        historyMenuLabel: 'crm-app.sales.territory.historyMenuLabel',
        name: 'crm-app.sales.territory.name',
        addTitle: 'crm-app.sales.territory.addTitle',
        active: 'crm-app.sales.territory.active',
        pid: 'crm-app.sales.territory.pid',
        salesName: 'crm-app.sales.territory.salesName',
        salesAssignment: 'crm-app.sales.territory.salesAssignment',
        activeStatuses: {
          true: 'crm-app.sales.territory.activeStatuses.true',
          false: 'crm-app.sales.territory.activeStatuses.false',
        },
        validFrom: 'crm-app.sales.territory.validFrom',
        validTo: 'crm-app.sales.territory.validTo',
        markAsMainTooltip: 'crm-app.sales.territory.markAsMainTooltip',
        deleteTooltip: 'crm-app.sales.territory.deleteTooltip',
        dateError: 'crm-app.sales.territory.dateError',
        datePopUp: 'crm-app.sales.territory.datePopUp',
        deleteConfirm: 'crm-app.sales.territory.deleteConfirm',
        deleteTerritoryConfirm: 'crm-app.sales.territory.deleteTerritoryConfirm',
        error: {
          requiredName: 'crm-app.sales.territory.error.requiredName',
        },
      },
      error: {
        requiredEmployee: 'crm-app.sales.error.requiredEmployee',
        requiredSalesManager: 'crm-app.sales.error.requiredSalesManager',
        requiredValidFrom: 'crm-app.sales.error.requiredValidFrom',
        requiredValidTo: 'crm-app.sales.error.requiredValidTo',
        requiredName: 'crm-app.sales.error.requiredName',
        DuplicateEmployeeForSales: 'crm-app.sales.error.DuplicateEmployeeForSales',
        defaultValidationMessage: 'crm-app.sales.error.defaultValidationMessage',
      },
    },
    billingCycle: {
      Per_shipment: 'crm-app.billingCycle.Per_shipment',
      Weekly: 'crm-app.billingCycle.Weekly',
      Monthly: 'crm-app.billingCycle.Monthly',
      Bi_monthly: 'crm-app.billingCycle.Bi_monthly',
      Manual: 'crm-app.billingCycle.Manual',
    },
    credit: {
      requestDate: 'crm-app.credit.requestDate',
      requestedBy: 'crm-app.credit.requestedBy',
      status: 'crm-app.credit.status',
      requestStatus: 'crm-app.credit.requestStatus',
      creditAmount: 'crm-app.credit.creditAmount',
      currencyValue: 'crm-app.credit.currencyValue',
      approvalDate: 'crm-app.credit.approvalDate',
      expiryDate: 'crm-app.credit.expiryDate',
      listTitle: 'crm-app.credit.listTitle',
    },
    contact: {
      list: {
        title: 'crm-app.contact.list.title',
        search: 'crm-app.contact.list.search',
        phoneNumber: 'crm-app.contact.list.phoneNumber',
        email: 'crm-app.contact.list.email',
        contactName: 'crm-app.contact.list.contactName',
        contactCountry: 'crm-app.contact.list.contactCountry',
        visibilityType: 'crm-app.contact.list.visibilityType',
        contactMethod: 'crm-app.contact.list.contactMethod',
        receivesRequests: 'crm-app.contact.list.receivesRequests',
        visibilityTypes: {
          PUBLIC: 'crm-app.contact.list.visibilityTypes.PUBLIC',
          CUSTOMER: 'crm-app.contact.list.visibilityTypes.CUSTOMER',
          SERVICE_PROVIDER: 'crm-app.contact.list.visibilityTypes.SERVICE_PROVIDER',
          BOTH: 'crm-app.contact.list.visibilityTypes.BOTH',
          NONE: 'crm-app.contact.list.visibilityTypes.NONE',
          null: 'crm-app.contact.list.visibilityTypes.null',
        },
        contactMethods: {
          EMAIL: 'crm-app.contact.list.contactMethods.EMAIL',
          TEL: 'crm-app.contact.list.contactMethods.TEL',
          VISIT: 'crm-app.contact.list.contactMethods.VISIT',
          null: 'crm-app.contact.list.contactMethods.null',
        },
        jobTitleValue: 'crm-app.contact.list.jobTitleValue',
        buyingRoleValue: 'crm-app.contact.list.buyingRoleValue',
        contactTypeValue: 'crm-app.contact.list.contactTypeValue',
        neverCall: 'crm-app.contact.list.neverCall',
        add: 'crm-app.contact.list.add',
      },
    },
  },
  'shared-providers': {
    'deactivate-message': 'shared-providers.deactivate-message',
  },
  'delivery-app': {
    suggestions: {
      addAccount: 'delivery-app.suggestions.addAccount',
      addVendorTag: 'delivery-app.suggestions.addVendorTag',
      addBankAccount: 'delivery-app.suggestions.addBankAccount',
      employeeList: 'delivery-app.suggestions.employeeList',
      transportProjectList: 'delivery-app.suggestions.transportProjectList',
      addBankAccountForPartnerPopup: 'delivery-app.suggestions.addBankAccountForPartnerPopup',
      addCustomer: 'delivery-app.suggestions.addCustomer',
      addVendor: 'delivery-app.suggestions.addVendor',
      addExternalVendor: 'delivery-app.suggestions.addExternalVendor',
      orderListPage: 'delivery-app.suggestions.orderListPage',
      selectDispatcher: 'delivery-app.suggestions.selectDispatcher',
      unassignEmployee: 'delivery-app.suggestions.unassignEmployee',
    },
    'navigation-suggestions': {
      offerRequestDetails: 'delivery-app.navigation-suggestions.offerRequestDetails',
      orderDetails: 'delivery-app.navigation-suggestions.orderDetails',
      shipmentGroupSolution: 'delivery-app.navigation-suggestions.shipmentGroupSolution',
      back: {
        undefined: 'delivery-app.navigation-suggestions.back.undefined',
        subcontracting: 'delivery-app.navigation-suggestions.back.subcontracting',
        'customer-offer-request-list': 'delivery-app.navigation-suggestions.back.customer-offer-request-list',
        'sp-offer-request-list': 'delivery-app.navigation-suggestions.back.sp-offer-request-list',
        workspace: 'delivery-app.navigation-suggestions.back.workspace',
        'customer-order-list': 'delivery-app.navigation-suggestions.back.customer-order-list',
        'sp-order-list': 'delivery-app.navigation-suggestions.back.sp-order-list',
        'offer-request-details': 'delivery-app.navigation-suggestions.back.offer-request-details',
        inbox: 'delivery-app.navigation-suggestions.back.inbox',
        outbox: 'delivery-app.navigation-suggestions.back.outbox',
        'customer-shipment-template': 'delivery-app.navigation-suggestions.back.customer-shipment-template',
      },
    },
    guide: {
      skipLabel: 'delivery-app.guide.skipLabel',
      prevLabel: 'delivery-app.guide.prevLabel',
      nextLabel: 'delivery-app.guide.nextLabel',
      doneLabel: 'delivery-app.guide.doneLabel',
      restartTour: 'delivery-app.guide.restartTour',
      'shipment-split': {
        'shipment-panel': 'delivery-app.guide.shipment-split.shipment-panel',
        'own-routing-solutions': 'delivery-app.guide.shipment-split.own-routing-solutions',
        'vendor-routing-solutions': 'delivery-app.guide.shipment-split.vendor-routing-solutions',
        canvas: 'delivery-app.guide.shipment-split.canvas',
        solutions: 'delivery-app.guide.shipment-split.solutions',
        'clear-solution': 'delivery-app.guide.shipment-split.clear-solution',
        'new-segment': 'delivery-app.guide.shipment-split.new-segment',
        'segment-details': 'delivery-app.guide.shipment-split.segment-details',
      },
      'shipment-group-solutions': {
        'segment-canvas': 'delivery-app.guide.shipment-group-solutions.segment-canvas',
        'master-routing-solutions': 'delivery-app.guide.shipment-group-solutions.master-routing-solutions',
        solutions: 'delivery-app.guide.shipment-group-solutions.solutions',
        offers: 'delivery-app.guide.shipment-group-solutions.offers',
        'master-routing-solution': 'delivery-app.guide.shipment-group-solutions.master-routing-solution',
      },
    },
    menu: {
      addresses: 'delivery-app.menu.addresses',
      contacts: 'delivery-app.menu.contacts',
      details: 'delivery-app.menu.details',
      workspace: 'delivery-app.menu.workspace',
      shipmentTracking: 'delivery-app.menu.shipmentTracking',
      packageTracking: 'delivery-app.menu.packageTracking',
      drafts: 'delivery-app.menu.drafts',
      'address-templates': 'delivery-app.menu.address-templates',
      customerDrafts: 'delivery-app.menu.customerDrafts',
      scheduledShipments: 'delivery-app.menu.scheduledShipments',
      vendorDrafts: 'delivery-app.menu.vendorDrafts',
      offerRequest: 'delivery-app.menu.offerRequest',
      offerRequestSent: 'delivery-app.menu.offerRequestSent',
      offerRequestReceived: 'delivery-app.menu.offerRequestReceived',
      offerRequestEmails: 'delivery-app.menu.offerRequestEmails',
      order: 'delivery-app.menu.order',
      orderSent: 'delivery-app.menu.orderSent',
      orderReceived: 'delivery-app.menu.orderReceived',
      complaint: 'delivery-app.menu.complaint',
      contract: 'delivery-app.menu.contract',
      account: 'delivery-app.menu.account',
      tariffs: 'delivery-app.menu.tariffs',
      financial: 'delivery-app.menu.financial',
      invoices: 'delivery-app.menu.invoices',
      invoicesSent: 'delivery-app.menu.invoicesSent',
      customerInvoices: 'delivery-app.menu.customerInvoices',
      invoiceAssociation: 'delivery-app.menu.invoiceAssociation',
      spInvoicePayments: 'delivery-app.menu.spInvoicePayments',
      eFacturi: 'delivery-app.menu.eFacturi',
      anafMessages: 'delivery-app.menu.anafMessages',
      customerInvoicePayments: 'delivery-app.menu.customerInvoicePayments',
      routes: 'delivery-app.menu.routes',
      driver: 'delivery-app.menu.driver',
      vehicle: 'delivery-app.menu.vehicle',
      customerList: 'delivery-app.menu.customerList',
      services: 'delivery-app.menu.services',
      employeeAssignment: 'delivery-app.menu.employeeAssignment',
      vendor: 'delivery-app.menu.vendor',
      courier: 'delivery-app.menu.courier',
      'delivery-inbox': 'delivery-app.menu.delivery-inbox',
      'invoice-payments': 'delivery-app.menu.invoice-payments',
      'delivery-outbox': 'delivery-app.menu.delivery-outbox',
      standardPackageDimensions: 'delivery-app.menu.standardPackageDimensions',
      nomenclatureList: 'delivery-app.menu.nomenclatureListLabel',
      costCenters: 'delivery-app.menu.costCenters',
      contractResponse: 'delivery-app.menu.contractResponse',
      contractRequest: 'delivery-app.menu.contractRequest',
      costs: 'delivery-app.menu.costs',
      budgetManagement: 'delivery-app.menu.budgetManagement',
      dispatcher: 'delivery-app.menu.dispatcher',
      taskList: 'delivery-app.menu.taskList',
      warehouse: 'delivery-app.menu.warehouse',
      warehouseTerminals: 'delivery-app.menu.warehouseTerminals',
      warehouseReservations: 'delivery-app.menu.warehouseReservations',
      namedLocation: 'delivery-app.menu.namedLocation',
      ownershipRequest: 'delivery-app.menu.ownershipRequest',
      cashFlow: 'delivery-app.menu.cashFlow',
      transportProject: 'delivery-app.menu.transportProject',
      eTransportDeclarant: 'delivery-app.menu.eTransportDeclarant',
      eTransportOrganizer: 'delivery-app.menu.eTransportInfo',
      eTransportAnafMessages: 'delivery-app.menu.eTransportInfo',
      eTransportActions: 'delivery-app.menu.eTransportActions',
      collaboration: 'delivery-app.menu.collaboration',
      collaborationShipments: 'delivery-app.menu.collaborationShipments',
      shipmentGroups: 'delivery-app.menu.shipmentGroups',
      operationalTerritory: 'delivery-app.menu.operationalTerritory',
      externalMappings: 'delivery-app.menu.externalMappings',
      shipmentManagement: 'delivery-app.menu.shipmentManagement',
      fleet: 'delivery-app.menu.fleet',
      imports: 'delivery-app.menu.imports',
      ediImport: 'delivery-app.menu.ediImport',
      driverTimesheet: 'deliwell-app.menu.driverTimesheet',
      driverExpense: 'delivery-app.menu.driverExpense',
      supplierDelegation: 'delivery-app.menu.supplierDelegation',
    },
    territoryAssignment: {
      deleteConfirm: 'delivery-app.territoryAssignment.deleteConfirm',
      deleteTerritoryConfirm: 'delivery-app.territoryAssignment.deleteTerritoryConfirm',
    },
    contactList: {
      title: 'delivery-app.contactList.title',
      add: 'delivery-app.contactList.add',
      contactName: 'delivery-app.contactList.contactName',
      ownerCompanyName: 'delivery-app.contactList.ownerCompanyName',
      companyName: 'delivery-app.contactList.companyName',
      phoneNumber: 'delivery-app.contactList.phoneNumber',
      email: 'delivery-app.contactList.email',
      contactCountry: 'delivery-app.contactList.contactCountry',
      visibilityType: 'delivery-app.contactList.visibilityType',
      contactMethod: 'delivery-app.contactList.contactMethod',
      receivesRequests: 'delivery-app.contactList.receivesRequests',
      visibilityTypes: {
        PUBLIC: 'delivery-app.contactList.visibilityTypes.PUBLIC',
        CUSTOMER: 'delivery-app.contactList.visibilityTypes.CUSTOMER',
        SERVICE_PROVIDER: 'delivery-app.contactList.visibilityTypes.SERVICE_PROVIDER',
        BOTH: 'delivery-app.contactList.visibilityTypes.BOTH',
        NONE: 'delivery-app.contactList.visibilityTypes.NONE',
        null: 'delivery-app.contactList.visibilityTypes.null',
      },
      contactMethods: {
        EMAIL: 'delivery-app.contactList.contactMethods.EMAIL',
        TEL: 'delivery-app.contactList.contactMethods.TEL',
        VISIT: 'delivery-app.contactList.contactMethods.VISIT',
        null: 'delivery-app.contactList.contactMethods.null',
      },
      contactIsNotOwned: 'delivery-app.contactList.contactIsNotOwned',
    },
    vendor: {
      title: 'delivery-app.vendor.title',
      wizardTabTitle: 'delivery-app.vendor.wizardTabTitle',
      wizardTabHeader: 'delivery-app.vendor.wizardTabHeader',
      name: 'delivery-app.vendor.name',
      uniqueIdNumber: 'delivery-app.vendor.uniqueIdNumber',
      country: 'delivery-app.vendor.country',
      industryType: 'delivery-app.vendor.industryType',
      mainEmailAddress: 'delivery-app.vendor.mainEmailAddress',
      mainPhoneNumber: 'delivery-app.vendor.mainPhoneNumber',
      contactsWarning: 'delivery-app.vendor.contactsWarning',
      paymentTimeLimit: 'delivery-app.vendor.paymentTimeLimit',
      tags: 'delivery-app.vendor.tags',
      addNew: 'delivery-app.vendor.addNew',
      plural: 'delivery-app.vendor.plural',
      singular: 'delivery-app.vendor.singular',
      courier: 'delivery-app.vendor.courier',
      to: 'delivery-app.vendor.to',
      amendment: 'delivery-app.vendor.amendment',
      'amendment-title': 'delivery-app.vendor.amendment-title',
      searchOne: 'delivery-app.vendor.searchOne',
      searchMultiple: 'delivery-app.vendor.searchMultiple',
      platformMemberLegend: 'delivery-app.vendor.platformMemberLegend',
      refresh: 'delivery-app.vendor.refresh',
      viewCompany: 'delivery-app.vendor.viewCompany',
      blockCompany: 'delivery-app.vendor.blockCompany',
      unblockCompany: 'delivery-app.vendor.unblockCompany',
      blockCommentPlaceholder: 'delivery-app.vendor.blockCommentPlaceholder',
      blockForm: {
        error: {
          requiredComment: 'delivery-app.vendor.blockForm.error.requiredComment',
        },
      },
    },
    vendorTag: {
      search: 'delivery-app.vendorTag.search',
      wizardTabTitle: 'delivery-app.vendorTag.wizardTabTitle',
      wizardTabHeader: 'delivery-app.vendorTag.wizardTabHeader',
      value: 'delivery-app.vendorTag.value',
      newTitle: 'delivery-app.vendorTag.newTitle',
      vendorSort: 'delivery-app.vendorTag.vendorSort',
      vendorFilter: 'delivery-app.vendorTag.vendorFilter',
      error: {
        requiredValue: 'delivery-app.vendorTag.error.requiredValue',
      },
    },
    offerCreation: {
      createOffer: 'delivery-app.offerCreation.createOffer',
      requestDate: 'delivery-app.offerCreation.requestDate',
      deadline: 'delivery-app.offerCreation.deadline',
      serviceProviders: 'delivery-app.offerCreation.serviceProviders',
      shipments: 'delivery-app.offerCreation.shipments',
      groups: 'delivery-app.offerCreation.groups',
      routingSolutions: 'delivery-app.offerCreation.routingSolutions',
      totalCost: 'delivery-app.offerCreation.totalCost',
      sendOffer: 'delivery-app.offerCreation.sendOffer',
      offersPreview: 'delivery-app.offerCreation.offersPreview',
      requiredRoutingSolution: 'delivery-app.offerCreation.requiredRoutingSolution',
    },
    account: {
      'list-title': 'delivery-app.account.list-title',
      addNew: 'delivery-app.account.addNew',
      'new-title': 'delivery-app.account.new-title',
      'edit-title': 'delivery-app.account.edit-title',
      customerName: 'delivery-app.account.customerName',
      serviceProviderName: 'delivery-app.account.serviceProviderName',
      billingName: 'delivery-app.account.billingName',
      billingAccountNumber: 'delivery-app.account.billingAccountNumber',
      billingCycle: 'delivery-app.account.billingCycle',
      contactName: 'delivery-app.account.contactName',
      contactPhoneNumber: 'delivery-app.account.contactPhoneNumber',
      contactEmail: 'delivery-app.account.contactEmail',
      accountName: 'delivery-app.account.accountName',
      accountNumber: 'delivery-app.account.accountNumber',
      accountStatus: 'delivery-app.account.accountStatus',
      accountCreatedAt: 'delivery-app.account.accountCreatedAt',
      accountRequestedAt: 'delivery-app.account.accountRequestedAt',
      accountClosedAt: 'delivery-app.account.accountClosedAt',
      'payment-time-limit': 'delivery-app.account.payment-time-limit',
      creditStopped: 'delivery-app.account.creditStopped',
      lastModifiedAt: 'delivery-app.account.lastModifiedAt',
      firstShipmentDate: 'delivery-app.account.firstShipmentDate',
      latestShipmentDate: 'delivery-app.account.latestShipmentDate',
      status: 'delivery-app.account.status',
      customer: 'delivery-app.account.customer',
      address: 'delivery-app.account.address',
      contact: 'delivery-app.account.contact',
      'account-status-value': {
        requested: 'delivery-app.account.account-status-value.requested',
        created: 'delivery-app.account.account-status-value.created',
        closed: 'delivery-app.account.account-status-value.closed',
      },
      error: {
        defaultValidationMessage: 'delivery-app.account.error.defaultValidationMessage',
      },
    },
    utils: {
      loadMore: 'delivery-app.utils.loadMore',
      loadLess: 'delivery-app.utils.loadLess',
      others: 'delivery-app.utils.others',
      manualAdd: 'delivery-app.utils.manualAdd',
      backToSearch: 'delivery-app.utils.backToSearch',
      selectFromExistentVehicles: 'delivery-app.utils.selectFromExistentVehicles',
      selectFromExistentDrivers: 'delivery-app.utils.selectFromExistentDrivers',
      myContacts: 'delivery-app.utils.myContacts',
      termsAndConditions: 'delivery-app.utils.termsAndConditions',
      ok: 'delivery-app.utils.ok',
      saveAndSend: 'delivery-app.utils.saveAndSend',
      next: 'delivery-app.utils.next',
      group: 'delivery-app.utils.group',
      sort: 'delivery-app.utils.sort',
      filter: 'delivery-app.utils.filter',
      all: 'delivery-app.utils.all',
      day: 'delivery-app.utils.day',
      days: 'delivery-app.utils.days',
      error: 'delivery-app.utils.error',
      shipmentId: 'delivery-app.utils.shipmentId',
      return: 'delivery-app.utils.return',
      pickup: 'delivery-app.utils.pickup',
      delivery: 'delivery-app.utils.delivery',
      pickUpDate: 'delivery-app.utils.pickUpDate',
      deliveryDate: 'delivery-app.utils.deliveryDate',
      packages: 'delivery-app.utils.packages',
      'columns-selected': 'delivery-app.utils.columns-selected',
      'choose-columns': 'delivery-app.utils.choose-columns',
      'statuses-selected': 'delivery-app.utils.statuses-selected',
      'select-statuses': 'delivery-app.utils.select-statuses',
      search: 'delivery-app.utils.search',
      continue: 'delivery-app.utils.continue',
      upload: 'delivery-app.utils.upload',
      'advanced-filters': 'delivery-app.utils.advanced-filters',
      preview: 'delivery-app.utils.preview',
      emptyMessage: 'delivery-app.utils.emptyMessage',
      tableEmptyMessage: 'delivery-app.utils.tableEmptyMessage',
      addService: 'delivery-app.utils.addService',
      save: 'delivery-app.utils.save',
      clear: 'delivery-app.utils.clear',
      bindingBody: 'delivery-app.utils.bindingBody',
      send: 'delivery-app.utils.send',
      invoicePreview: 'delivery-app.utils.invoicePreview',
      update: 'delivery-app.utils.update',
      change: 'delivery-app.utils.change',
      edit: 'delivery-app.utils.edit',
      cancel: 'delivery-app.utils.cancel',
      sentOffer: 'delivery-app.utils.sentOffer',
      sent: 'delivery-app.utils.sent',
      close: 'delivery-app.utils.close',
      nextStep: 'delivery-app.utils.nextStep',
      accept: 'delivery-app.utils.accept',
      negotiationHistory: 'delivery-app.utils.negotiationHistory',
      negotiate: 'delivery-app.utils.negotiate',
      refuse: 'delivery-app.utils.refuse',
      download: 'delivery-app.utils.download',
      reset: 'delivery-app.utils.reset',
      delete: 'delivery-app.utils.delete',
      add: 'delivery-app.utils.add',
      addFile: 'delivery-app.utils.addFile',
      choose: 'delivery-app.utils.choose',
      chooseFile: 'delivery-app.utils.chooseFile',
      details: 'delivery-app.utils.details',
      moreDetails: 'delivery-app.utils.moreDetails',
      findSolution: 'delivery-app.utils.findSolution',
      unselected: 'delivery-app.utils.unselected',
      'empty-list': 'delivery-app.utils.empty-list',
      closePanel: 'delivery-app.utils.closePanel',
      requiredLegend: 'delivery-app.utils.requiredLegend',
      create: 'delivery-app.utils.create',
      language: 'delivery-app.utils.language',
      'boolean-select-item': {
        true: 'delivery-app.utils.boolean-select-item.true',
        false: 'delivery-app.utils.boolean-select-item.false',
        null: 'delivery-app.utils.boolean-select-item.null',
      },
      'needs-invoice-select-item': {
        needsInvoiceLabel: 'delivery-app.utils.needs-invoice-select-item.needsInvoiceLabel',
        hasInvoiceLabel: 'delivery-app.utils.needs-invoice-select-item.hasInvoiceLabel',
        null: 'delivery-app.utils.needs-invoice-select-item.null',
      },
      showAllPackages: 'delivery-app.utils.showAllPackages',
      showLess: 'delivery-app.utils.showLess',
      id: 'delivery-app.utils.id',
      movePieceLeft: 'delivery-app.utils.movePieceLeft',
      movePieceRight: 'delivery-app.utils.movePieceRight',
      yes: 'delivery-app.utils.yes',
      no: 'delivery-app.utils.no',
      deleteConfirmation: 'delivery-app.utils.deleteConfirmation',
      confirmation: 'delivery-app.utils.confirmation',
      attachments: 'delivery-app.utils.attachments',
      signatures: 'delivery-app.utils.signatures',
      maxDimension: 'delivery-app.utils.maxDimension',
      sumWeight: 'delivery-app.utils.sumWeight',
      sumVolume: 'delivery-app.utils.sumVolume',
      nrPcs: 'delivery-app.utils.nrPcs',
      length: 'delivery-app.utils.length',
      width: 'delivery-app.utils.width',
      height: 'delivery-app.utils.height',
      weight: 'delivery-app.utils.weight',
      volume: 'delivery-app.utils.volume',
      type: 'delivery-app.utils.type',
      labels: 'delivery-app.utils.labels',
      settings: 'delivery-app.utils.settings',
    },
    error: {
      defaultValidationMessage: 'delivery-app.error.defaultValidationMessage',
      required: 'delivery-app.error.required',
      shipmentTariffRequired: 'delivery-app.error.shipmentTariffRequired',
      minLengthVendors: 'delivery-app.error.minLengthVendors',
      pickupTimeWindowStartBeforeStandardInterval: 'delivery-app.error.pickupTimeWindowStartBeforeStandardInterval',
      deliveryTimeWindowStartBeforeStandardInterval: 'delivery-app.error.deliveryTimeWindowStartBeforeStandardInterval',
      deliveryIsBeforePickup: 'delivery-app.error.deliveryIsBeforePickup',
      packageLimitExceeded: 'delivery-app.error.packageLimitExceeded',
      requiredName: 'delivery-app.error.requiredName',
      minLengthName: 'delivery-app.error.minLengthName',
      requiredPhoneNumber: 'delivery-app.error.requiredPhoneNumber',
      minLengthPhoneNumber: 'delivery-app.error.minLengthPhoneNumber',
      requiredCompanyName: 'delivery-app.error.requiredCompanyName',
      requiredCode: 'delivery-app.error.requiredCode',
      requiredValue: 'delivery-app.error.requiredValue',
      requiredStartDate: 'delivery-app.error.requiredStartDate',
      requiredFinishDate: 'delivery-app.error.requiredFinishDate',
      startDateAfterEndDate: 'delivery-app.error.startDateAfterEndDate',
      requiredCustomer: 'delivery-app.error.requiredCustomer',
      requiredAccountName: 'delivery-app.error.requiredAccountName',
      DuplicateUniqueID: 'delivery-app.error.DuplicateUniqueID',
      DuplicateNumericPartOfUniqueID: 'delivery-app.error.DuplicateNumericPartOfUniqueID',
      DuplicateCompanyName: 'delivery-app.error.DuplicateCompanyName',
      duplicateVendorTagValueForOwner: 'delivery-app.error.duplicateVendorTagValueForOwner',
      duplicateLegalEntityForVendor: 'delivery-app.error.duplicateLegalEntityForVendor',
      territoryNameExists: 'delivery-app.error.territoryNameExists',
      missingEndTime: 'delivery-app.error.missingEndTime',
      missingStartTime: 'delivery-app.error.missingStartTime',
      invalidStartTime: 'delivery-app.error.invalidStartTime',
      invalidEndTime: 'delivery-app.error.invalidEndTime',
      startTimeAfterEndTime: 'delivery-app.error.startTimeAfterEndTime',
      startTimeNotStandard: 'delivery-app.error.startTimeNotStandard',
      endTimeNotStandard: 'delivery-app.error.endTimeNotStandard',
      maxlengthType: 'delivery-app.error.maxlengthType',
      noAddressSelected: 'delivery-app.error.noAddressSelected',
      requiredInterval: 'delivery-app.error.requiredInterval',
      requiredComments: 'delivery-app.error.requiredComments',
      vendorsRequired: 'delivery-app.error.vendorsRequired',
      customerVORequired: 'delivery-app.error.customerVORequired',
      nameRequired: 'delivery-app.error.nameRequired',
      phoneNumberRequired: 'delivery-app.error.phoneNumberRequired',
      phoneNumberLengthMessage: 'delivery-app.error.phoneNumberLengthMessage',
      shipmentsRequired: 'delivery-app.error.shipmentsRequired',
      packagesRequired: 'delivery-app.error.packagesRequired',
      deadlineInFuture: 'delivery-app.error.deadlineInFuture',
      selectAtLeastOneContactPerEntity: 'delivery-app.error.selectAtLeastOneContactPerEntity',
      selectAtLeastOneAccountNumberPerCourier: 'delivery-app.error.selectAtLeastOneAccountNumberPerCourier',
      validationError: 'delivery-app.error.validationError',
      dateTimeWithTimezoneInPastDeadline: 'delivery-app.error.dateTimeWithTimezoneInPastDeadline',
      orderContactRequired: 'delivery-app.error.orderContactRequired',
      productCustomsClearanceDTOS: 'delivery-app.error.productCustomsClearanceDTOS',
      maxLengthPhoneNumber: 'delivery-app.error.maxLengthPhoneNumber',
      beforeOffsetTimeWindowDto: 'delivery-app.error.delivery.timeWindowDto.beforeOffsetTimeWindowDto',
      shipmentVehicleDTO: {
        vehicleType: {
          required: 'delivery-app.error.shipmentVehicledTO.vehicleType.required',
        },
      },
      pickup: {
        name: {
          required: 'delivery-app.error.pickup.name.required',
        },
        contact: {
          name: {
            required: 'delivery-app.error.pickup.contact.name.required',
            minLength: {
              min: 'delivery-app.error.pickup.contact.name.minLength.min',
            },
          },
          phoneNumber: {
            required: 'delivery-app.error.pickup.contact.phoneNumber.required',
            minLength: {
              min: 'delivery-app.error.pickup.contact.phoneNumber.minLength.min',
            },
          },
        },

        phoneNumber: {
          required: 'delivery-app.error.pickup.phoneNumber.required',
        },
        address: {
          cityRequired: 'delivery-app.error.pickup.address.cityRequired',
          postalCodeRequired: 'delivery-app.error.pickup.address.postalCodeRequired',
        },
        namedLocationVORequired: 'delivery-app.error.pickup.namedLocationVORequired',
        timeWindowDto: {
          startRequired: 'delivery-app.error.pickup.timeWindowDto.startRequired',
          invalidDateTime: 'delivery-app.error.pickup.timeWindowDto.invalidDateTime',
          beforeOffset: 'delivery-app.error.pickup.timeWindowDto.beforeOffset',
        },
      },
      delivery: {
        name: {
          required: 'delivery-app.error.delivery.name.required',
        },
        contact: {
          name: {
            required: 'delivery-app.error.delivery.contact.name.required',
            minLength: {
              min: 'delivery-app.error.delivery.contact.name.minLength.min',
            },
          },
          phoneNumber: {
            required: 'delivery-app.error.delivery.contact.phoneNumber.required',
            minLength: {
              min: 'delivery-app.error.delivery.contact.phoneNumber.minLength.min',
            },
          },
        },
        phoneNumber: {
          required: 'delivery-app.error.delivery.phoneNumber.required',
        },
        address: {
          cityRequired: 'delivery-app.error.delivery.address.cityRequired',
          postalCodeRequired: 'delivery-app.error.delivery.address.postalCodeRequired',
        },
        namedLocationVORequired: 'delivery-app.error.delivery.namedLocationVORequired',
        timeWindowDto: {
          startRequired: 'delivery-app.error.delivery.timeWindowDto.startRequired',
          invalidDateTime: 'delivery-app.error.delivery.timeWindowDto.invalidDateTime',
          beforeOffset: 'delivery-app.error.delivery.timeWindowDto.beforeOffset',
        },
      },
      packages: {
        heightRequired: 'delivery-app.error.packages.heightRequired',
        widthRequired: 'delivery-app.error.packages.widthRequired',
        lengthRequired: 'delivery-app.error.packages.lengthRequired',
        weightRequired: 'delivery-app.error.packages.weightRequired',
        piecesRequired: 'delivery-app.error.packages.piecesRequired',
      },
      offerRequestWithCourierMustHaveOneShipment: 'delivery-app.error.offerRequestWithCourierMustHaveOneShipment',
      $cross: {
        pickupTimeWindowStartInvalid: 'delivery-app.error.$cross.pickupTimeWindowStartInvalid',
        packageRequired: 'delivery-app.error.$cross.packageRequired',
        pickupLocationRequired: 'delivery-app.error.$cross.pickupLocationRequired',
        deliveryLocationRequired: 'delivery-app.error.$cross.deliveryLocationRequired',
        productCustomsClearanceDTOSRequired: 'delivery-app.error.$cross.productCustomsClearanceDTOSRequired',
        isDateTimeEqualOrAfter: 'delivery-app.error.$cross.isDateTimeEqualOrAfter',
        tagsPerPackageGroup: 'delivery-app.error.$cross.tagsPerPackageGroup',
        productsWeightIsBiggerThanPackagesWeight: 'delivery-app.error.$cross.productsWeightIsBiggerThanPackagesWeight',
        packageCountExceeded: 'delivery-app.error.$cross.packageCountExceeded',
        shipmentTariffRequired: 'delivery-app.error.$cross.shipmentTariffRequired',
      },
    },
    vehicle: {
      title: 'delivery-app.vehicle.title',
      subtitle: 'delivery-app.vehicle.subtitle',
      addNew: 'delivery-app.vehicle.addNew',
      chassisSeries: 'delivery-app.vehicle.chassisSeries',
      inventoryNumber: 'delivery-app.vehicle.inventoryNumber',
      name: 'delivery-app.vehicle.name',
      fuel: 'delivery-app.vehicle.fuel',
      owner: 'delivery-app.vehicle.owner',
      user: 'delivery-app.vehicle.user',
      description: 'delivery-app.vehicle.description',
      licensePlate: 'delivery-app.vehicle.licensePlate',
      licensePlateLabel: 'delivery-app.vehicle.licensePlateLabel',
      manufacturingYear: 'delivery-app.vehicle.manufacturingYear',
      maximumAllowedMass: 'delivery-app.vehicle.maximumAllowedMass',
      weight: 'delivery-app.vehicle.weight',
      legalCharge: 'delivery-app.vehicle.legalCharge',
      length: 'delivery-app.vehicle.length',
      width: 'delivery-app.vehicle.width',
      height: 'delivery-app.vehicle.height',
      volume: 'delivery-app.vehicle.volume',
      ewp: 'delivery-app.vehicle.ewp',
      category: 'delivery-app.vehicle.category',
      type: 'delivery-app.vehicle.type',
      make: 'delivery-app.vehicle.make',
      model: 'delivery-app.vehicle.model',
      configuration: 'delivery-app.vehicle.configuration',
      engine: 'delivery-app.vehicle.engine',
      power: 'delivery-app.vehicle.power',
      color: 'delivery-app.vehicle.color',
      registrationDate: 'delivery-app.vehicle.registrationDate',
      'add-vehicle-title': 'delivery-app.vehicle.add-vehicle-title',
      'edit-vehicle-title': 'delivery-app.vehicle.edit-vehicle-title',
      tabs: {
        details: 'delivery-app.vehicle.tabs.details',
        financial: 'delivery-app.vehicle.tabs.financial',
        fuelCards: 'delivery-app.vehicle.tabs.fuelCards',
        equipment: 'delivery-app.vehicle.tabs.equipment',
        documents: 'delivery-app.vehicle.tabs.documents',
        success: 'delivery-app.vehicle.tabs.success',
        saved: 'delivery-app.vehicle.tabs.saved',
      },
      general: {
        general: 'delivery-app.vehicle.general.general',
        vin: 'delivery-app.vehicle.general.vin',
        brand: 'delivery-app.vehicle.general.brand',
        model: 'delivery-app.vehicle.general.model',
        color: 'delivery-app.vehicle.general.color',
        fuelTankCapacity: 'delivery-app.vehicle.general.fuelTankCapacity',
        gpsMonitorisation: 'delivery-app.vehicle.general.gpsMonitorisation',
        GPSActive: 'delivery-app.vehicle.general.GPSActive',
        GPSDisabled: 'delivery-app.vehicle.general.GPSDisabled',
        company: 'delivery-app.vehicle.general.company',
        division: 'delivery-app.vehicle.general.division',
        costCenter: 'delivery-app.vehicle.general.costCenter',
        region: 'delivery-app.vehicle.general.region',
        condition: 'delivery-app.vehicle.general.condition',
        photos: 'delivery-app.vehicle.general.photos',
        technical: 'delivery-app.vehicle.general.technical',
        vehicle: 'delivery-app.vehicle.general.vehicle',
        fuelType: 'delivery-app.vehicle.general.fuelType',
        engineType: 'delivery-app.vehicle.general.engineType',
        engineCMC: 'delivery-app.vehicle.general.engineCMC',
        engineMaxPower: 'delivery-app.vehicle.general.engineMaxPower',
        traction: 'delivery-app.vehicle.general.traction',
        gearBox: 'delivery-app.vehicle.general.gearBox',
        nrDoors: 'delivery-app.vehicle.general.nrDoors',
        nrSeats: 'delivery-app.vehicle.general.nrSeats',
        wheelbase: 'delivery-app.vehicle.general.wheelbase',
        dateOfFabrication: 'delivery-app.vehicle.general.dateOfFabrication',
        mixedConsumption: 'delivery-app.vehicle.general.mixedConsumption',
        urbanConsumption: 'delivery-app.vehicle.general.urbanConsumption',
        extraUrbanConsumption: 'delivery-app.vehicle.general.extraUrbanConsumption',
        co2Emissions: 'delivery-app.vehicle.general.co2Emissions',
        emissionsStandard: 'delivery-app.vehicle.general.emissionsStandard',
        cargo: 'delivery-app.vehicle.general.cargo',
        cargoLength: 'delivery-app.vehicle.general.cargoLength',
        cargoHeight: 'delivery-app.vehicle.general.cargoHeight',
        cargoWidth: 'delivery-app.vehicle.general.cargoWidth',
        doorHeight: 'delivery-app.vehicle.general.doorHeight',
        loadingType: 'delivery-app.vehicle.general.loadingType',
        lateralLoading: 'delivery-app.vehicle.general.lateralLoading',
        backLoading: 'delivery-app.vehicle.general.backLoading',
        lateralDoorHeight: 'delivery-app.vehicle.general.lateralDoorHeight',
        lateralDoorWidth: 'delivery-app.vehicle.general.lateralDoorWidth',
        backDoorHeight: 'delivery-app.vehicle.general.backDoorHeight',
        backDoorWidth: 'delivery-app.vehicle.general.backDoorWidth',
        usableWeight: 'delivery-app.vehicle.general.usableWeight',
        volume: 'delivery-app.vehicle.general.volume',
        loadingMeters: 'delivery-app.vehicle.general.loadingMeters',
      },
      financial: {
        general: 'delivery-app.vehicle.financial.general',
        owner: 'delivery-app.vehicle.financial.owner',
        ownerPlaceholder: 'delivery-app.vehicle.financial.ownerPlaceholder',
        addOwner: 'delivery-app.vehicle.financial.addOwner',
        operator: 'delivery-app.vehicle.financial.operator',
        operatorPlaceholder: 'delivery-app.vehicle.financial.operatorPlaceholder',
        addOperator: 'delivery-app.vehicle.financial.addOperator',
        taxCategory: 'delivery-app.vehicle.financial.taxCategory',
        taxCategoryPlaceholder: 'delivery-app.vehicle.financial.taxCategoryPlaceholder',
        financingType: 'delivery-app.vehicle.financial.financingType',
        financingPeriod: 'delivery-app.vehicle.financial.financingPeriod',
        nrCtr: 'delivery-app.vehicle.financial.nrCtr',
        nrKmCtr: 'delivery-app.vehicle.financial.nrKmCtr',
        kmAtRendition: 'delivery-app.vehicle.financial.kmAtRendition',
        value: 'delivery-app.vehicle.financial.value',
        valVehicle: 'delivery-app.vehicle.financial.valVehicle',
        valResidual: 'delivery-app.vehicle.financial.valResidual',
        valOperations: 'delivery-app.vehicle.financial.valOperations',
        valAccesories: 'delivery-app.vehicle.financial.valAccesories',
        costKm: 'delivery-app.vehicle.financial.costKm',
        costKmNotDriven: 'delivery-app.vehicle.financial.costKmNotDriven',
        additionalInfo: 'delivery-app.vehicle.financial.additionalInfo',
        casco: 'delivery-app.vehicle.financial.casco',
        startDate: 'delivery-app.vehicle.financial.startDate',
        endDate: 'delivery-app.vehicle.financial.endDate',
        deliveryDate: 'delivery-app.vehicle.financial.deliveryDate',
        returnDate: 'delivery-app.vehicle.financial.returnDate',
        nrInventory: 'delivery-app.vehicle.financial.nrInventory',
        insurance: 'delivery-app.vehicle.financial.insurance',
        policyNr: 'delivery-app.vehicle.financial.policyNr',
        insuranceStartDate: 'delivery-app.vehicle.financial.insuranceStartDate',
        insuranceEndDate: 'delivery-app.vehicle.financial.insuranceEndDate',
        monitoringStartDate: 'delivery-app.vehicle.financial.monitoringStartDate',
      },
      fuelCards: {
        title: 'delivery-app.vehicle.fuelCards.title',
        series: 'delivery-app.vehicle.fuelCards.series',
        provider: 'delivery-app.vehicle.fuelCards.provider',
        add: 'delivery-app.vehicle.fuelCards.add',
        edit: 'delivery-app.vehicle.fuelCards.edit',
        details: 'delivery-app.vehicle.fuelCards.details',
        delete: 'delivery-app.vehicle.fuelCards.delete',
        errors: {
          requiredSeries: 'vehicleFuelCard.errors.requiredSeries',
          requiredProvider: 'vehicleFuelCard.errors.requiredProvider',
        },
      },
      equipment: {
        equipments: 'delivery-app.vehicle.equipment.equipments',
        addEquipment: 'delivery-app.vehicle.equipment.addEquipment',
        editEquipment: 'delivery-app.vehicle.equipment.editEquipment',
        equipmentType: 'delivery-app.vehicle.equipment.equipmentType',
        equipmentTypePlaceholder: 'delivery-app.vehicle.equipment.equipmentTypePlaceholder',
        addEquipmentType: 'delivery-app.vehicle.equipment.addEquipmentType',
        installationDate: 'delivery-app.vehicle.equipment.installationDate',
        uninstallationDate: 'delivery-app.vehicle.equipment.uninstallationDate',
        validFrom: 'delivery-app.vehicle.equipment.validFrom',
        validTo: 'delivery-app.vehicle.equipment.validTo',
        validPeriod: 'delivery-app.vehicle.equipment.validPeriod',
        uninstallEquipment: 'delivery-app.vehicle.equipment.uninstallEquipment',
        installEquipment: 'delivery-app.vehicle.equipment.installEquipment',
      },
      documents: {
        title: 'delivery-app.vehicle.documents.title',
        addDocument: 'delivery-app.vehicle.documents.addDocument',
        editDocument: 'delivery-app.vehicle.documents.editDocument',
        document: 'delivery-app.vehicle.documents.document',
        validFrom: 'delivery-app.vehicle.documents.validFrom',
        validTo: 'delivery-app.vehicle.documents.validTo',
        status: 'delivery-app.vehicle.documents.status',
        documentType: 'delivery-app.vehicle.documents.documentType',
        issueDate: 'delivery-app.vehicle.documents.issueDate',
        expirationDate: 'delivery-app.vehicle.documents.expirationDate',
        photos: 'delivery-app.vehicle.documents.photos',
        addDocumentType: 'delivery-app.vehicle.documents.addDocumentType',
        documentTypePlaceholder: 'delivery-app.vehicle.documents.documentTypePlaceholder',
        obs: 'delivery-app.vehicle.documents.obs',
        active: 'delivery-app.vehicle.documents.active',
        inactive: 'delivery-app.vehicle.documents.inactive',
        markActive: 'delivery-app.vehicle.documents.markActive',
        markInactive: 'delivery-app.vehicle.documents.markInactive',
        transferDoc: 'delivery-app.vehicle.documents.transferDoc',
        transferDate: 'delivery-app.vehicle.documents.transferDate',
        currentDocumentHolder: 'delivery-app.vehicle.documents.currentDocumentHolder',
        newDocumentHolder: 'delivery-app.vehicle.documents.newDocumentHolder',
        documentHolder: 'delivery-app.vehicle.documents.documentHolder',
        details: 'delivery-app.vehicle.documents.details',
      },
      vehicleTypeValue: 'delivery-app.vehicle.vehicleTypeValue',
      tonnage: 'delivery-app.vehicle.tonnage',
      pricePerKm: 'delivery-app.vehicle.pricePerKm',
      error: {
        requiredLicensePlate: 'delivery-app.vehicle.error.requiredLicensePlate',
        requiredEquipmentType: 'delivery-app.vehicle.error.requiredEquipmentType',
        requiredInstallationDate: 'delivery-app.vehicle.error.requiredInstallationDate',
        requiredOperator: 'delivery-app.vehicle.error.requiredOperator',
        requiredUninstallationDate: 'delivery-app.vehicle.error.requiredUninstallationDate',
        requiredDocument: 'delivery-app.vehicle.error.requiredDocument',
        requiredTransferDate: 'delivery-app.vehicle.error.requiredTransferDate',
        requiredNewDocumentHolder: 'delivery-app.vehicle.error.requiredNewDocumentHolder',
        requiredField: 'delivery-app.vehicle.error.requiredField',
        requiredCompanyOwner: 'delivery-app.vehicle.error.requiredCompanyOwner',
        requiredDocumentVO: 'delivery-app.vehicle.error.requiredDocumentVO',
        requiredDocumentType: 'delivery-app.vehicle.error.requiredDocumentType',
        requiredEquipmentVO: 'delivery-app.vehicle.error.requiredEquipmentVO',
      },
      requiredField: 'delivery-app.vehicle.requiredField',
    },
    driver: {
      title: 'delivery-app.driver.title',
      subtitle: 'delivery-app.driver.subtitle',
      addNew: 'delivery-app.driver.addNew',
      employee: 'delivery-app.driver.employee',
      pricePerKm: 'delivery-app.driver.pricePerKm',
      licensePlate: 'delivery-app.driver.licensePlate',
      description: 'delivery-app.driver.description',
      workSchedule: 'delivery-app.driver.workSchedule',
      licenseCategory: 'delivery-app.driver.licenseCategory',
      licenseExpirationDate: 'delivery-app.driver.licenseExpirationDate',
      dangerousGoodsCertification: 'delivery-app.driver.dangerousGoodsCertification',
      'add-driver-title': 'delivery-app.driver.add-driver-title',
      'edit-driver-title': 'delivery-app.driver.edit-driver-title',
      name: 'delivery-app.driver.name',
      cnp: 'delivery-app.driver.cnp',
      idSeries: 'delivery-app.driver.idSeries',
      idNumber: 'delivery-app.driver.idNumber',
      county: 'delivery-app.driver.county',
      validTo: 'delivery-app.driver.validTo',
      validFrom: 'delivery-app.driver.validFrom',
      pid: 'delivery-app.driver.pid',
      cityOfResidence: 'delivery-app.driver.cityOfResidence',
      activityType: 'delivery-app.driver.activityType',
      erpId: 'delivery-app.driver.erpId',
      fridCode: 'delivery-app.driver.fridCode',
      activeFrom: 'delivery-app.driver.activeFrom',
      activeTo: 'delivery-app.driver.activeTo',
      contactPersonPhoneNumber: 'delivery-app.driver.contactPersonPhoneNumber',
      bankAccount: 'delivery-app.driver.bankAccount',
      address: 'delivery-app.driver.address',
      phoneNumber: 'delivery-app.driver.phoneNumber',
      common: {
        employee: 'delivery-app.driver.common.employee',
      },
      error: {
        requiredEmployee: 'delivery-app.driver.error.requiredEmployee',
        requiredPricePerKm: 'delivery-app.driver.error.requiredPricePerKm',
        requiredDescription: 'delivery-app.driver.error.requiredDescription',
        requiredLicenseCategory: 'delivery-app.driver.error.requiredLicenseCategory',
        EmployeeRequired: 'delivery-app.driver.error.EmployeeRequired',
        EmployeeAlreadyIsDriver: 'delivery-app.driver.error.EmployeeAlreadyIsDriver',
        requiredSeries: 'delivery-app.driver.error.requiredSeries',
        requiredNumber: 'delivery-app.driver.error.requiredNumber',
        requiredIssueAuthority: 'delivery-app.driver.error.requiredIssueAuthority',
        requiredIssueDate: 'delivery-app.driver.error.requiredIssueDate',
        requiredExpirationDate: 'delivery-app.driver.error.requiredExpirationDate',
        maxlengthSeries: 'delivery-app.driver.error.maxlengthSeries',
        minlengthSeries: 'delivery-app.driver.error.minlengthSeries',
        maxlengthNumber: 'delivery-app.driver.error.maxlengthNumber',
        minlengthNumber: 'delivery-app.driver.error.minlengthNumber',
        requiredDriverLicenseNumber: 'delivery-app.driver.error.requiredDriverLicenseNumber',
      },
      tabs: {
        details: 'delivery-app.driver.tabs.details',
        documents: 'delivery-app.driver.tabs.documents',
        success: 'delivery-app.driver.tabs.success',
        saved: 'delivery-app.driver.tabs.saved',
        license: 'delivery-app.driver.tabs.license',
        'identity-card': 'delivery-app.driver.tabs.identity-card',
        vehicle: 'delivery-app.driver.tabs.vehicle',
      },
      documents: {
        title: 'delivery-app.driver.documents.title',
        addDocument: 'delivery-app.driver.documents.addDocument',
        editDocument: 'delivery-app.driver.documents.editDocument',
        document: 'delivery-app.driver.documents.document',
        validFrom: 'delivery-app.driver.documents.validFrom',
        validTo: 'delivery-app.driver.documents.validTo',
        status: 'delivery-app.driver.documents.status',
        documentType: 'delivery-app.driver.documents.documentType',
        issueDate: 'delivery-app.driver.documents.issueDate',
        expirationDate: 'delivery-app.driver.documents.expirationDate',
        photos: 'delivery-app.driver.documents.photos',
        addDocumentType: 'delivery-app.driver.documents.addDocumentType',
        documentTypePlaceholder: 'delivery-app.driver.documents.documentTypePlaceholder',
        obs: 'delivery-app.driver.documents.obs',
        active: 'delivery-app.driver.documents.active',
        inactive: 'delivery-app.driver.documents.inactive',
        markActive: 'delivery-app.driver.documents.markActive',
        markInactive: 'delivery-app.driver.documents.markInactive',
        details: 'delivery-app.driver.documents.details',
      },
      license: {
        title: 'delivery-app.driver.license.title',
        driverLicenseCategories: 'delivery-app.driver.license.driverLicenseCategories',
        issueAuthority: 'delivery-app.driver.license.issueAuthority',
        driverLicenseNumber: 'delivery-app.driver.license.driverLicenseNumber',
        details: 'delivery-app.driver.license.details',
        addLicense: 'delivery-app.driver.license.addLicense',
        editLicense: 'delivery-app.driver.license.editLicense',
        licenseCategory: {
          addCategory: 'delivery-app.driver.license.licenseCategory.addCategory',
          issueDate: 'delivery-app.driver.license.licenseCategory.issueDate',
          expirationDate: 'delivery-app.driver.license.licenseCategory.expirationDate',
        },
      },
      'identity-document': {
        title: 'delivery-app.driver.identity-document.title',
        issueAuthority: 'delivery-app.driver.identity-document.issueAuthority',
        series: 'delivery-app.driver.identity-document.series',
        number: 'delivery-app.driver.identity-document.number',
        details: 'delivery-app.driver.identity-document.details',
        issueDate: 'delivery-app.driver.identity-document.issueDate',
        expirationDate: 'delivery-app.driver.identity-document.expirationDate',
        addIdentityDocument: 'delivery-app.driver.identity-document.addIdentityDocument',
        editIdentityDocument: 'delivery-app.driver.identity-document.editIdentityDocument',
      },
      vehicle: {
        title: 'delivery-app.driver.vehicle.title',
        subtitle: 'delivery-app.driver.vehicle.subtitle',
        vehiclePlaceholder: 'delivery-app.driver.vehicle.vehiclePlaceholder',
        unassign: 'delivery-app.driver.vehicle.unassign',
        assign: 'delivery-app.driver.vehicle.assign',
        errors: {
          requiredVehicleVO: 'delivery-app.driver.vehicle.errors.requiredVehicleVO',
        },
      },
    },
    driverExpenses: {
      title: 'delivery-app.driverExpenses.title',
      list: {
        expenseDate: 'delivery-app.driverExpenses.list.expenseDate',
        name: 'delivery-app.driverExpenses.list.name',
        licensePlate: 'delivery-app.driverExpenses.list.licensePlate',
        description: 'delivery-app.driverExpenses.list.description',
        expenseType: 'delivery-app.driverExpenses.list.expenseType',
        currencyCode: 'delivery-app.driverExpenses.list.currencyCode',
        amount: 'delivery-app.driverExpenses.list.amount',
        localCurrencyAmount: 'delivery-app.driverExpenses.list.localCurrencyAmount',
        localCurrencyExchangeRate: 'delivery-app.driverExpenses.list.localCurrencyExchangeRate',
        documentNumber: 'delivery-app.driverExpenses.list.documentNumber',
        status: 'delivery-app.driverExpenses.list.status',
      },
      options: {
        expenseType: {
          CLAIM: 'delivery-app.driverExpenses.options.expenseType.CLAIM',
          ADVANCE: 'delivery-app.driverExpenses.options.expenseType.ADVANCE',
        },
        status: {
          REQUESTED: 'delivery-app.driverExpenses.options.status.REQUESTED',
          APPROVED: 'delivery-app.driverExpenses.options.status.APPROVED',
          DECLINED: 'delivery-app.driverExpenses.options.status.DECLINED',
        },
        currencyCode: {
          RON: 'delivery-app.driverExpenses.options.currencyCode.RON',
          EUR: 'delivery-app.driverExpenses.options.currencyCode.EUR',
          USD: 'delivery-app.driverExpenses.options.currencyCode.USD',
        },
      },
      totalInRon: 'delivery-app.driverExpenses.totalInRon',
      monthAndYear: 'delivery-app.driverExpenses.monthAndYear',
      approve: 'delivery-app.driverExpenses.approve',
      decline: 'delivery-app.driverExpenses.decline',
    },
    courierManagement: {
      title: 'delivery-app.courierManagement.title',
      list: {
        courierType: 'delivery-app.courierManagement.list.courierType',
      },
      courierType: {
        FED_EX: 'delivery-app.courierManagement.courierType.FED_EX',
        UPS: 'delivery-app.courierManagement.courierType.UPS',
        DHL: 'delivery-app.courierManagement.courierType.DHL',
      },
      new: 'delivery-app.courierManagement.new',
      form: {
        apis: {
          RATES_AND_TRANSIT_TIMES: 'delivery-app.courierManagement.form.apis.RATES_AND_TRANSIT_TIMES',
          SHIPMENT: 'delivery-app.courierManagement.form.apis.SHIPMENT',
          PICKUP: 'delivery-app.courierManagement.form.apis.PICKUP',
          TRACKING: 'delivery-app.courierManagement.form.apis.TRACKING',
          UPLOAD_DOCUMENT: 'delivery-app.courierManagement.form.apis.UPLOAD_DOCUMENT',
          UPS_APIS: 'delivery-app.courierManagement.form.apis.UPS_APIS',
          DHL_APIS: 'delivery-app.courierManagement.form.apis.DHL_APIS',
        },
        apiKey: 'delivery-app.courierManagement.form.apiKey',
        secretKey: 'delivery-app.courierManagement.form.secretKey',
        accountNumber: 'delivery-app.courierManagement.form.accountNumber',
        courierType: 'delivery-app.courierManagement.form.courierType',
        copy: 'delivery-app.courierManagement.form.copy',
        paste: 'delivery-app.courierManagement.form.paste',
      },
      accountNumber: {
        title: 'delivery-app.courierManagement.accountNumber.title',
        add: 'delivery-app.courierManagement.accountNumber.add',
        saveMultipleForFedEx: 'delivery-app.courierManagement.accountNumber.saveMultipleForFedEx',
        fedexApis: 'delivery-app.courierManagement.accountNumber.fedexApis',
        editLabel: 'delivery-app.courierManagement.accountNumber.editLabel',
        addLabel: 'delivery-app.courierManagement.accountNumber.addLabel',
        noAccountNumbersWarningMessage: 'delivery-app.courierManagement.accountNumber.noAccountNumbersWarningMessage',
        selectAnAccountNumberTooltip: 'delivery-app.courierManagement.accountNumber.selectAnAccountNumberTooltip',
        list: {
          accountNumber: 'delivery-app.courierManagement.accountNumber.list.accountNumber',
          label: 'delivery-app.courierManagement.accountNumber.list.label',
          countryCode: 'delivery-app.courierManagement.accountNumber.list.countryCode',
          postalCode: 'delivery-app.courierManagement.accountNumber.list.postalCode',
        },
        isPrimary: 'delivery-app.courierManagement.accountNumber.isPrimary',
        primaryAccountInfo: 'delivery-app.courierManagement.accountNumber.primaryAccountInfo',
        markPrimary: 'delivery-app.courierManagement.accountNumber.markPrimary',
        unmarkPrimary: 'delivery-app.courierManagement.accountNumber.unmarkPrimary',
        error: {
          requiredAccountNumber: 'delivery-app.courierManagement.accountNumber.error.requiredAccountNumber',
        },
      },
      discount: {
        title: 'delivery-app.courierManagement.discount.title',
        add: 'delivery-app.courierManagement.discount.add',
        chargeTypes: {
          BASE_SERVICE: 'delivery-app.courierManagement.discount.chargeTypes.BASE_SERVICE',
          FUEL_SURCHARGE: 'delivery-app.courierManagement.discount.chargeTypes.FUEL_SURCHARGE',
          ADDITIONAL_SURCHARGE: 'delivery-app.courierManagement.discount.chargeTypes.ADDITIONAL_SURCHARGE',
        },
        discountPercentage: 'delivery-app.courierManagement.discount.discountPercentage',
        chargeType: 'delivery-app.courierManagement.discount.chargeType',
        serviceType: 'delivery-app.courierManagement.discount.serviceType',
        editPercentage: 'delivery-app.courierManagement.discount.editPercentage',
        allCourierChargeTypesHaveBeenAdded:
          'delivery-app.courierManagement.discount.allCourierChargeTypesHaveBeenAdded',
        useDiscounts: 'delivery-app.courierManagement.discount.useDiscounts',
        deleteConfirmationMessage: 'delivery-app.courierManagement.discount.deleteConfirmationMessage',
        selectServiceTypes: 'delivery-app.courierManagement.discount.selectServiceTypes',
        errors: {
          maxDiscountPercentage: 'delivery-app.courierManagement.discount.errors.maxDiscountPercentage',
          minDiscountPercentage: 'delivery-app.courierManagement.discount.errors.minDiscountPercentage',
          requiredDiscountPercentage: 'delivery-app.courierManagement.discount.errors.requiredDiscountPercentage',
        },
      },
      tag: 'delivery-app.courierManagement.tag',
      latestStatusInfo: 'delivery-app.courierManagement.latestStatusInfo',
      noLatestStatusInfo: 'delivery-app.courierManagement.noLatestStatusInfo',
      serviceTypes: {
        FEDEX_FIRST: 'delivery-app.courierManagement.serviceTypes.FEDEX_FIRST',
        FEDEX_PRIORITY_EXPRESS: 'delivery-app.courierManagement.serviceTypes.FEDEX_PRIORITY_EXPRESS',
        FEDEX_PRIORITY: 'delivery-app.courierManagement.serviceTypes.FEDEX_PRIORITY',
        FEDEX_PRIORITY_FREIGHT: 'delivery-app.courierManagement.serviceTypes.FEDEX_PRIORITY_FREIGHT',
        FEDEX_10KG_BOX: 'delivery-app.courierManagement.serviceTypes.FEDEX_10KG_BOX',
        FEDEX_25KG_BOX: 'delivery-app.courierManagement.serviceTypes.FEDEX_25KG_BOX',
        FEDEX_INTERNATIONAL_CONNECT_PLUS:
          'delivery-app.courierManagement.serviceTypes.FEDEX_INTERNATIONAL_CONNECT_PLUS',
        FEDEX_REGIONAL_ECONOMY: 'delivery-app.courierManagement.serviceTypes.FEDEX_REGIONAL_ECONOMY',
        FEDEX_REGIONAL_ECONOMY_FREIGHT: 'delivery-app.courierManagement.serviceTypes.FEDEX_REGIONAL_ECONOMY_FREIGHT',
        EXPRESS_SAVER: 'delivery-app.courierManagement.serviceTypes.EXPRESS_SAVER',
        FEDEX_INTERNATIONAL_PRIORITY_EXPRESS:
          'delivery-app.courierManagement.serviceTypes.FEDEX_INTERNATIONAL_PRIORITY_EXPRESS',
        INTERNATIONAL_FIRST: 'delivery-app.courierManagement.serviceTypes.INTERNATIONAL_FIRST',
        FEDEX_INTERNATIONAL_PRIORITY: 'delivery-app.courierManagement.serviceTypes.FEDEX_INTERNATIONAL_PRIORITY',
        INTERNATIONAL_ECONOMY: 'delivery-app.courierManagement.serviceTypes.INTERNATIONAL_ECONOMY',
        FEDEX_GROUND: 'delivery-app.courierManagement.serviceTypes.FEDEX_GROUND',
        FIRST_OVERNIGHT: 'delivery-app.courierManagement.serviceTypes.FIRST_OVERNIGHT',
        FEDEX_FIRST_FREIGHT: 'delivery-app.courierManagement.serviceTypes.FEDEX_FIRST_FREIGHT',
        FEDEX_1_DAY_FREIGHT: 'delivery-app.courierManagement.serviceTypes.FEDEX_1_DAY_FREIGHT',
        FEDEX_2_DAY_FREIGHT: 'delivery-app.courierManagement.serviceTypes.FEDEX_2_DAY_FREIGHT',
        FEDEX_3_DAY_FREIGHT: 'delivery-app.courierManagement.serviceTypes.FEDEX_3_DAY_FREIGHT',
        INTERNATIONAL_PRIORITY_FREIGHT: 'delivery-app.courierManagement.serviceTypes.INTERNATIONAL_PRIORITY_FREIGHT',
        INTERNATIONAL_ECONOMY_FREIGHT: 'delivery-app.courierManagement.serviceTypes.INTERNATIONAL_ECONOMY_FREIGHT',
        FEDEX_INTERNATIONAL_DEFERRED_FREIGHT:
          'delivery-app.courierManagement.serviceTypes.FEDEX_INTERNATIONAL_DEFERRED_FREIGHT',
        INTERNATIONAL_PRIORITY_DISTRIBUTION:
          'delivery-app.courierManagement.serviceTypes.INTERNATIONAL_PRIORITY_DISTRIBUTION',
        INTERNATIONAL_DISTRIBUTION_FREIGHT:
          'delivery-app.courierManagement.serviceTypes.INTERNATIONAL_DISTRIBUTION_FREIGHT',
        INTL_GROUND_DISTRIBUTION: 'delivery-app.courierManagement.serviceTypes.INTL_GROUND_DISTRIBUTION',
        GROUND_HOME_DELIVERY: 'delivery-app.courierManagement.serviceTypes.GROUND_HOME_DELIVERY',
        SMART_POST: 'delivery-app.courierManagement.serviceTypes.SMART_POST',
        PRIORITY_OVERNIGHT: 'delivery-app.courierManagement.serviceTypes.PRIORITY_OVERNIGHT',
        STANDARD_OVERNIGHT: 'delivery-app.courierManagement.serviceTypes.STANDARD_OVERNIGHT',
        FEDEX_2_DAY: 'delivery-app.courierManagement.serviceTypes.FEDEX_2_DAY',
        FEDEX_2_DAY_AM: 'delivery-app.courierManagement.serviceTypes.FEDEX_2_DAY_AM',
        FEDEX_EXPRESS_SAVER: 'delivery-app.courierManagement.serviceTypes.FEDEX_EXPRESS_SAVER',
        SAME_DAY: 'delivery-app.courierManagement.serviceTypes.SAME_DAY',
        SAME_DAY_CITY: 'delivery-app.courierManagement.serviceTypes.SAME_DAY_CITY',

        UPS_STANDARD: 'delivery-app.courierManagement.serviceTypes.UPS_STANDARD',
        UPS_WORLDWIDE_EXPRESS_PLUS: 'delivery-app.courierManagement.serviceTypes.UPS_WORLDWIDE_EXPRESS_PLUS',
        UPS_WORLDWIDE_SAVER: 'delivery-app.courierManagement.serviceTypes.UPS_WORLDWIDE_SAVER',
        UPS_2ND_DAY_AIR: 'delivery-app.courierManagement.serviceTypes.UPS_2ND_DAY_AIR',
        UPS_2ND_DAY_AIR_AM: 'delivery-app.courierManagement.serviceTypes.UPS_2ND_DAY_AIR_AM',
        UPS_3_DAY_SELECT: 'delivery-app.courierManagement.serviceTypes.UPS_3_DAY_SELECT',
        UPS_GROUND: 'delivery-app.courierManagement.serviceTypes.UPS_GROUND',
        UPS_NEXT_DAY_AIR: 'delivery-app.courierManagement.serviceTypes.UPS_NEXT_DAY_AIR',
        UPS_NEXT_DAY_AIR_EARLY: 'delivery-app.courierManagement.serviceTypes.UPS_NEXT_DAY_AIR_EARLY',
        UPS_NEXT_DAY_AIR_SAVER: 'delivery-app.courierManagement.serviceTypes.UPS_NEXT_DAY_AIR_SAVER',
        ROADIE_XD_AM: 'delivery-app.courierManagement.serviceTypes.ROADIE_XD_AM',
        ROADIE_XD_PM: 'delivery-app.courierManagement.serviceTypes.ROADIE_XD_PM',
        ROADIE_XD: 'delivery-app.courierManagement.serviceTypes.ROADIE_XD',
        UPS_ACCESS_POINT_ECONOMY: 'delivery-app.courierManagement.serviceTypes.UPS_ACCESS_POINT_ECONOMY',
        UPS_EXPEDITED: 'delivery-app.courierManagement.serviceTypes.UPS_EXPEDITED',
        UPS_EXPRESS: 'delivery-app.courierManagement.serviceTypes.UPS_EXPRESS',
        UPS_EXPRESS_12_GERMANY: 'delivery-app.courierManagement.serviceTypes.UPS_EXPRESS_12_GERMANY',
        UPS_WORLDWIDE_EXPRESS_FREIGHT: 'delivery-app.courierManagement.serviceTypes.UPS_WORLDWIDE_EXPRESS_FREIGHT',
        UPS_WORLDWIDE_EXPRESS_FREIGHT_MIDDAY:
          'delivery-app.courierManagement.serviceTypes.UPS_WORLDWIDE_EXPRESS_FREIGHT_MIDDAY',
        UPS_WORLDWIDE_ECONOMY_DDU: 'delivery-app.courierManagement.serviceTypes.UPS_WORLDWIDE_ECONOMY_DDU',
        UPS_WORLDWIDE_ECONOMY_DDP: 'delivery-app.courierManagement.serviceTypes.UPS_WORLDWIDE_ECONOMY_DDP',

        DHL_EXPRESS_WORLDWIDE_DOC: 'delivery-app.courierManagement.serviceTypes.DHL_EXPRESS_WORLDWIDE_DOC',
        DHL_EXPRESS_WORLDWIDE_NON_DOC: 'delivery-app.courierManagement.serviceTypes.DHL_EXPRESS_WORLDWIDE_NON_DOC',
        DHL_EXPRESS_1200_DOC: 'delivery-app.courierManagement.serviceTypes.DHL_EXPRESS_1200_DOC',
        DHL_EXPRESS_1200_NON_DOC: 'delivery-app.courierManagement.serviceTypes.DHL_EXPRESS_1200_NON_DOC',
        DHL_EXPRESS_EASY_NON_DECL: 'delivery-app.courierManagement.serviceTypes.DHL_EXPRESS_EASY_NON_DECL',
        DHL_EXPRESS_EASY_NON_UE_DECL: 'delivery-app.courierManagement.serviceTypes.DHL_EXPRESS_EASY_NON_UE_DECL',

        DHL_MEDICAL_EXPRESS_UE_NON_DECL: 'delivery-app.courierManagement.serviceTypes.DHL_MEDICAL_EXPRESS_UE_NON_DECL',
        DHL_EXPRESS_0900_DOC: 'delivery-app.courierManagement.serviceTypes.DHL_EXPRESS_0900_DOC',
        DHL_EXPRESS_0900_NON_DOC: 'delivery-app.courierManagement.serviceTypes.DHL_EXPRESS_0900_NON_DOC',
        DHL_EXPRESS_WORLDWIDE_UE_NON_DECL:
          'delivery-app.courierManagement.serviceTypes.DHL_EXPRESS_WORLDWIDE_UE_NON_DECL',
        DHL_ECONOMY_SELECT_DOC: 'delivery-app.courierManagement.serviceTypes.DHL_ECONOMY_SELECT_DOC',
        DHL_ECONOMY_SELECT_NON_DOC: 'delivery-app.courierManagement.serviceTypes.DHL_ECONOMY_SELECT_NON_DOC',
        DHL_EXPRESS_BREAKBULK: 'delivery-app.courierManagement.serviceTypes.DHL_EXPRESS_BREAKBULK',
        DHL_ECONOMY_BREAKBULK: 'delivery-app.courierManagement.serviceTypes.DHL_ECONOMY_BREAKBULK',
        DHL_EXPRESS_1030_NON_DECL: 'delivery-app.courierManagement.serviceTypes.DHL_EXPRESS_1030_NON_DECL',
        DHL_EXPRESS_1030_DECL: 'delivery-app.courierManagement.serviceTypes.DHL_EXPRESS_1030_DECL',
        DHL_EXPRESS_DOMESTIC: 'delivery-app.courierManagement.serviceTypes.DHL_EXPRESS_DOMESTIC',
        DHL_MEDICAL_EXPRESS_NON_DECL: 'delivery-app.courierManagement.serviceTypes.DHL_MEDICAL_EXPRESS_NON_DECL',
        DHL_MEDICAL_EXPRESS_DECL: 'delivery-app.courierManagement.serviceTypes.DHL_MEDICAL_EXPRESS_DECL',
      },
      fedex: {
        latestStatusDetailType: {
          AA: 'delivery-app.courierManagement.fedex.latestStatusDetailType.AA',
          AC: 'delivery-app.courierManagement.fedex.latestStatusDetailType.AC',
          AD: 'delivery-app.courierManagement.fedex.latestStatusDetailType.AD',
          AF: 'delivery-app.courierManagement.fedex.latestStatusDetailType.AF',
          AO: 'delivery-app.courierManagement.fedex.latestStatusDetailType.AO',
          AP: 'delivery-app.courierManagement.fedex.latestStatusDetailType.AP',
          AR: 'delivery-app.courierManagement.fedex.latestStatusDetailType.AR',
          AX: 'delivery-app.courierManagement.fedex.latestStatusDetailType.AX',
          CA: 'delivery-app.courierManagement.fedex.latestStatusDetailType.CA',
          CH: 'delivery-app.courierManagement.fedex.latestStatusDetailType.CH',
          DD: 'delivery-app.courierManagement.fedex.latestStatusDetailType.DD',
          DE: 'delivery-app.courierManagement.fedex.latestStatusDetailType.DE',
          DL: 'delivery-app.courierManagement.fedex.latestStatusDetailType.DL',
          DP: 'delivery-app.courierManagement.fedex.latestStatusDetailType.DP',
          DR: 'delivery-app.courierManagement.fedex.latestStatusDetailType.DR',
          DS: 'delivery-app.courierManagement.fedex.latestStatusDetailType.DS',
          DY: 'delivery-app.courierManagement.fedex.latestStatusDetailType.DY',
          EA: 'delivery-app.courierManagement.fedex.latestStatusDetailType.EA',
          ED: 'delivery-app.courierManagement.fedex.latestStatusDetailType.ED',
          EO: 'delivery-app.courierManagement.fedex.latestStatusDetailType.EO',
          EP: 'delivery-app.courierManagement.fedex.latestStatusDetailType.EP',
          FD: 'delivery-app.courierManagement.fedex.latestStatusDetailType.FD',
          HL: 'delivery-app.courierManagement.fedex.latestStatusDetailType.HL',
          HP: 'delivery-app.courierManagement.fedex.latestStatusDetailType.HP',
          IT: 'delivery-app.courierManagement.fedex.latestStatusDetailType.IT',
          IX: 'delivery-app.courierManagement.fedex.latestStatusDetailType.IX',
          LO: 'delivery-app.courierManagement.fedex.latestStatusDetailType.LO',
          OC: 'delivery-app.courierManagement.fedex.latestStatusDetailType.OC',
          OD: 'delivery-app.courierManagement.fedex.latestStatusDetailType.OD',
          OF: 'delivery-app.courierManagement.fedex.latestStatusDetailType.OF',
          OX: 'delivery-app.courierManagement.fedex.latestStatusDetailType.OX',
          PD: 'delivery-app.courierManagement.fedex.latestStatusDetailType.PD',
          PF: 'delivery-app.courierManagement.fedex.latestStatusDetailType.PF',
          PL: 'delivery-app.courierManagement.fedex.latestStatusDetailType.PL',
          PM: 'delivery-app.courierManagement.fedex.latestStatusDetailType.PM',
          PU: 'delivery-app.courierManagement.fedex.latestStatusDetailType.PU',
          PX: 'delivery-app.courierManagement.fedex.latestStatusDetailType.PX',
          RR: 'delivery-app.courierManagement.fedex.latestStatusDetailType.RR',
          RM: 'delivery-app.courierManagement.fedex.latestStatusDetailType.RM',
          RC: 'delivery-app.courierManagement.fedex.latestStatusDetailType.RC',
          RS: 'delivery-app.courierManagement.fedex.latestStatusDetailType.RS',
          RP: 'delivery-app.courierManagement.fedex.latestStatusDetailType.RP',
          LP: 'delivery-app.courierManagement.fedex.latestStatusDetailType.LP',
          RG: 'delivery-app.courierManagement.fedex.latestStatusDetailType.RG',
          RD: 'delivery-app.courierManagement.fedex.latestStatusDetailType.RD',
          SE: 'delivery-app.courierManagement.fedex.latestStatusDetailType.SE',
          SF: 'delivery-app.courierManagement.fedex.latestStatusDetailType.SF',
          SP: 'delivery-app.courierManagement.fedex.latestStatusDetailType.SP',
          TR: 'delivery-app.courierManagement.fedex.latestStatusDetailType.TR',
          CC: 'delivery-app.courierManagement.fedex.latestStatusDetailType.CC',
          CD: 'delivery-app.courierManagement.fedex.latestStatusDetailType.CD',
          CP: 'delivery-app.courierManagement.fedex.latestStatusDetailType.CP',
          SH: 'delivery-app.courierManagement.fedex.latestStatusDetailType.SH',
          CU: 'delivery-app.courierManagement.fedex.latestStatusDetailType.CU',
          BR: 'delivery-app.courierManagement.fedex.latestStatusDetailType.BR',
          TP: 'delivery-app.courierManagement.fedex.latestStatusDetailType.TP',
        },
      },
      errors: {
        requiredCourierType: 'delivery-app.courierManagement.errors.requiredCourierType',
        'requiredSecretKey-RATES_AND_TRANSIT_TIMES':
          'delivery-app.courierManagement.errors.requiredSecretKey-RATES_AND_TRANSIT_TIMES',
        'requiredApiKey-RATES_AND_TRANSIT_TIMES':
          'delivery-app.courierManagement.errors.requiredApiKey-RATES_AND_TRANSIT_TIMES',
        'requiredAccountNumber-RATES_AND_TRANSIT_TIMES':
          'delivery-app.courierManagement.errors.requiredAccountNumber-RATES_AND_TRANSIT_TIMES',
        'requiredSecretKey-SHIPMENT': 'delivery-app.courierManagement.errors.requiredSecretKey-SHIPMENT',
        'requiredApiKey-SHIPMENT': 'delivery-app.courierManagement.errors.requiredApiKey-SHIPMENT',
        'requiredAccountNumber-SHIPMENT': 'delivery-app.courierManagement.errors.requiredAccountNumber-SHIPMENT',
        'requiredSecretKey-PICKUP': 'delivery-app.courierManagement.errors.requiredSecretKey-PICKUP',
        'requiredApiKey-PICKUP': 'delivery-app.courierManagement.errors.requiredApiKey-PICKUP',
        'requiredAccountNumber-PICKUP': 'delivery-app.courierManagement.errors.requiredAccountNumber-PICKUP',
        'requiredSecretKey-TRACKING': 'delivery-app.courierManagement.errors.requiredSecretKey-TRACKING',
        'requiredApiKey-TRACKING': 'delivery-app.courierManagement.errors.requiredApiKey-TRACKING',
        'requiredAccountNumber-TRACKING': 'delivery-app.courierManagement.errors.requiredAccountNumber-TRACKING',
        'requiredSecretKey-UPLOAD_DOCUMENT': 'delivery-app.courierManagement.errors.requiredSecretKey-UPLOAD_DOCUMENT',
        'requiredApiKey-UPLOAD_DOCUMENT': 'delivery-app.courierManagement.errors.requiredApiKey-UPLOAD_DOCUMENT',
        'requiredAccountNumber-UPLOAD_DOCUMENT':
          'delivery-app.courierManagement.errors.requiredAccountNumber-UPLOAD_DOCUMENT',
        'requiredApiKey-UPS_APIS': 'delivery-app.courierManagement.errors.requiredApiKey-UPS_APIS',
        'requiredSecretKey-UPS_APIS': 'delivery-app.courierManagement.errors.requiredSecretKey-UPS_APIS',
        'requiredAccountNumber-UPS_APIS': 'delivery-app.courierManagement.errors.requiredAccountNumber-UPS_APIS',
        'requiredApiKey-DHL_APIS': 'delivery-app.courierManagement.errors.requiredApiKey-DHL_APIS',
        'requiredSecretKey-DHL_APIS': 'delivery-app.courierManagement.errors.requiredSecretKey-DHL_APIS',
        'requiredAccountNumber-DHL_APIS': 'delivery-app.courierManagement.errors.requiredAccountNumber-DHL_APIS',
      },
    },
    supplierDelegationManagement: {
      title: 'delivery-app.supplierDelegationManagement.title',
      new: 'delivery-app.supplierDelegationManagement.new',
      form: {
        add: 'delivery-app.supplierDelegationManagement.form.add',
        edit: 'delivery-app.supplierDelegationManagement.form.edit',
        suppliers: 'delivery-app.supplierDelegationManagement.form.suppliers',
        tariffs: 'delivery-app.supplierDelegationManagement.form.tariffs',
        validFrom: 'delivery-app.supplierDelegationManagement.form.validFrom',
        validTo: 'delivery-app.supplierDelegationManagement.form.validTo',
        availability: 'delivery-app.supplierDelegationManagement.form.availability',
        selectSuppliers: 'delivery-app.supplierDelegationManagement.form.selectSuppliers',
        selectedTariffsBadge: 'delivery-app.supplierDelegationManagement.form.selectedTariffsBadge',
        noAvailableTariffs: 'delivery-app.supplierDelegationManagement.form.noAvailableTariffs',
        contractsSuggestionMessage: 'delivery-app.supplierDelegationManagement.form.contractsSuggestionMessage',
        contactSuggestionMessage: 'delivery-app.supplierDelegationManagement.form.contactSuggestionMessage',
        contactSuggestionMessageWithParam:
          'delivery-app.supplierDelegationManagement.form.contactSuggestionMessageWithParam',
        errors: {
          required: 'delivery-app.supplierDelegationManagement.form.errors.required',
          requiredTariffs: 'delivery-app.supplierDelegationManagement.form.errors.requiredTariffs',
          requiredValidFrom: 'delivery-app.supplierDelegationManagement.form.errors.requiredValidFrom',
          minLengthSuppliers: 'delivery-app.supplierDelegationManagement.form.errors.minLengthSuppliers',
        },
      },
      list: {
        createdAt: 'delivery-app.supplierDelegationManagement.list.createdAt',
        supplierName: 'delivery-app.supplierDelegationManagement.list.supplierName',
        activeTariffDelegationsCount: 'delivery-app.supplierDelegationManagement.list.activeTariffDelegationsCount',
      },
      invalidate: 'delivery-app.supplierDelegationManagement.invalidate',
      invalidateAll: 'delivery-app.supplierDelegationManagement.invalidateAll',
      invalidateAllConfirmationMessage: 'delivery-app.supplierDelegationManagement.invalidateAllConfirmationMessage',
    },
    order: {
      pickup: 'delivery-app.order.pickup',
      pickupDate: 'delivery-app.order.pickupDate',
      pickups: 'delivery-app.order.pickups',
      delivery: 'delivery-app.order.delivery',
      deliveryDate: 'delivery-app.order.deliveryDate',
      deliveries: 'delivery-app.order.deliveries',
      downloadPdf: 'delivery-app.order.downloadPdf',
      pdfSignedAndGenerated: 'delivery-app.order.pdfSignedAndGenerated',
      pdfUnSignedOrNotGenerated: 'delivery-app.order.pdfUnSignedOrNotGenerated',
      task: 'delivery-app.order.task',
      tasks: 'delivery-app.order.tasks',
      status: 'delivery-app.order.status',
      courierDispatchDetails: 'delivery-app.order.courierDispatchDetails',
      courierMasterTrackingNumber: 'delivery-app.order.courierMasterTrackingNumber',
      courierPackageTrackingNumbers: 'delivery-app.order.courierPackageTrackingNumbers',
      courierCreateShipmentError: 'delivery-app.order.courierCreateShipmentError',
      courierCreatePickupError: 'delivery-app.order.courierCreatePickupError',
      courierPickupConfirmationCode: 'delivery-app.order.courierPickupConfirmationCode',
      orderShipperAndPaymentPartiesPopup: {
        title: 'delivery-app.order.orderShipperAndPaymentPartiesPopup.title',
        accountNumber: {
          PAYMENT_PARTY: 'delivery-app.order.orderShipperAndPaymentPartiesPopup.accountNumber.PAYMENT_PARTY',
          SHIPPER_PARTY: 'delivery-app.order.orderShipperAndPaymentPartiesPopup.accountNumber.SHIPPER_PARTY',
        },
        shouldAddUploadTradeDocumentCredentials:
          'delivery-app.order.orderShipperAndPaymentPartiesPopup.shouldAddUploadTradeDocumentCredentials',
      },
      orderShipperParty: {
        title: 'delivery-app.order.orderShipperParty.title',
        accountNumber: 'delivery-app.order.orderShipperParty.accountNumber',
        error: {
          requiredShipperAccountNumber: 'delivery-app.order.orderShipperParty.error.requiredShipperAccountNumber',
        },
      },
      orderPaymentParty: {
        title: 'delivery-app.order.orderPaymentParty.title',
        paymentType: 'delivery-app.order.orderPaymentParty.paymentType',
        paymentTypes: {
          SENDER: 'delivery-app.order.orderPaymentParty.paymentTypes.SENDER',
          RECIPIENT: 'delivery-app.order.orderPaymentParty.paymentTypes.RECIPIENT',
          THIRD_PARTY: 'delivery-app.order.orderPaymentParty.paymentTypes.THIRD_PARTY',
        },
        accountNumber: 'delivery-app.order.orderPaymentParty.accountNumber',
        countryCode: 'delivery-app.order.orderPaymentParty.countryCode',
        postalCode: 'delivery-app.order.orderPaymentParty.postalCode',
        sendOrder: 'delivery-app.order.orderPaymentParty.sendOrder',
        saveAndSendOrder: 'delivery-app.order.orderPaymentParty.saveAndSendOrder',
        seeAccountNumber: 'delivery-app.order.orderPaymentParty.seeAccountNumber',
        editAccountNumber: 'delivery-app.order.orderPaymentParty.editAccountNumber',
        error: {
          requiredPaymentType: 'delivery-app.order.orderPaymentParty.error.requiredPaymentType',
          requiredPayerAccountNumber: 'delivery-app.order.orderPaymentParty.error.requiredPayerAccountNumber',
          requiredCountryCode: 'delivery-app.order.orderPaymentParty.error.requiredCountryCode',
          requiredPostalCode: 'delivery-app.order.orderPaymentParty.error.requiredPostalCode',
        },
      },
      tradeDocument: {
        documentNumber: 'delivery-app.order.tradeDocument.documentNumber',
        issuedOn: 'delivery-app.order.tradeDocument.issuedOn',
        error: {
          requiredDocumentNumber: 'delivery-app.order.tradeDocument.error.requiredDocumentNumber',
          requiredIssuedOn: 'delivery-app.order.tradeDocument.error.requiredIssuedOn',
        },
      },
      incoterm: {
        label: 'delivery-app.order.incoterm.label',
        values: {
          EXW: 'delivery-app.order.incoterm.values.EXW',
          DDP: 'delivery-app.order.incoterm.values.DDP',
          DDU: 'delivery-app.order.incoterm.values.DDU',
        },
        error: {
          requiredIncoterm: 'delivery-app.order.incoterm.error.requiredIncoterm',
        },
      },
      commercialInvoice: 'delivery-app.order.commercialInvoice',
      etdLabel: 'delivery-app.order.etdLabel',
      etdTooltip: 'delivery-app.order.etdTooltip',
      commercialInvoiceRequired: 'delivery-app.order.commercialInvoiceRequired',
      trackPackage: 'delivery-app.order.trackPackage',
      latestScanLocation: 'delivery-app.order.latestScanLocation',
      latestStatus: 'delivery-app.order.latestStatus',
      noTrackingDetails: 'delivery-app.order.noTrackingDetails',
      latestAncillaryDetail: 'delivery-app.order.latestAncillaryDetail',
      latestAncillaryDetailReason: 'delivery-app.order.latestAncillaryDetailReason',
      latestAncillaryDetailAction: 'delivery-app.order.latestAncillaryDetailAction',
      latestServiceCommitMessage: 'delivery-app.order.latestServiceCommitMessage',
      downloadMergedLabel: 'delivery-app.order.downloadMergedLabel',
      downloadLabel: 'delivery-app.order.downloadLabel',
      verifyStatus: 'delivery-app.order.verifyStatus',
      retryCreatingShipmentAndPickup: 'delivery-app.order.retryCreatingShipmentAndPickup',
      downloadProofOfDelivery: 'delivery-app.order.downloadProofOfDelivery',
      seeStatus: 'delivery-app.order.seeStatus',
      successfullyCancelledCourierOrderShipment: 'delivery-app.order.successfullyCancelledCourierOrderShipment',
      successfullyCancelledCourierOrderPickup: 'delivery-app.order.successfullyCancelledCourierOrderPickup',
      previousActions: 'delivery-app.order.previousActions',
      'go-to-mrs': 'delivery-app.order.go-to-mrs',
      'shipment-tracking': 'delivery-app.order.shipment-tracking',
      details: 'delivery-app.order.details',
      totalWeight: 'delivery-app.order.totalWeight',
      packageNumber: 'delivery-app.order.packageNumber',
      pieces: 'delivery-app.order.pieces',
      deliveryCompanyNames: 'delivery-app.order.deliveryCompanyNames',
      externalReferences: 'delivery-app.order.externalReferences',
      uits: 'delivery-app.order.uits',
      pickupCompanyNames: 'delivery-app.order.pickupCompanyNames',
      costCenters: 'delivery-app.order.costCenters',
      addOrder: 'delivery-app.order.addOrder',
      addOrderMessage: 'delivery-app.order.addOrderMessage',
      addPreOrder: 'delivery-app.order.addPreOrder',
      addSupplierOrder: 'delivery-app.order.addSupplierOrder',
      supplierOrderTitle: 'delivery-app.order.supplierOrderTitle',
      supplierOrderEmptyState: 'delivery-app.order.supplierOrderEmptyState',
      supplierOrderTimeline: {
        prepare: {
          title: 'delivery-app.order.supplierOrderTimeline.prepare.title',
          description: 'delivery-app.order.supplierOrderTimeline.prepare.description',
        },
        submit: {
          title: 'delivery-app.order.supplierOrderTimeline.submit.title',
          description: 'delivery-app.order.supplierOrderTimeline.submit.description',
        },
        review: {
          title: 'delivery-app.order.supplierOrderTimeline.review.title',
          description: 'delivery-app.order.supplierOrderTimeline.review.description',
        },
      },
      supplierOrderTariffCheckboxLabel: 'delivery-app.order.supplierOrderTariffCheckboxLabel',
      supplierOrderTariffCheckboxTooltip: 'delivery-app.order.supplierOrderTariffCheckboxTooltip',
      supplierOrderTariffDescription: 'delivery-app.order.supplierOrderTariffDescription',
      'no-preferred-solution': {
        title: 'delivery-app.order.no-preferred-solution.title',
        body: 'delivery-app.order.no-preferred-solution.body',
      },
      fromParty: 'delivery-app.order.fromParty',
      toParty: 'delivery-app.order.toParty',
      uuid: 'delivery-app.order.uuid',
      supplierOrderPartiesTitle: 'delivery-app.order.supplierOrderPartiesTitle',
      supplierOrderPartiesDescription: 'delivery-app.order.supplierOrderPartiesDescription',
      validation: {
        minShipments: 'delivery-app.order.validation.minShipments',
        maxPackagePieces: 'delivery-app.order.validation.maxPackagePieces',
        shipmentsMinLengthShipmentsCount: 'delivery-app.order.validation.shipmentsMinLengthShipmentsCount',
      },
      statusHistory: 'delivery-app.order.statusHistory',
      requestStatus: 'delivery-app.order.requestStatus',
      statusRequested: 'delivery-app.order.statusRequested',
      resendStatusUpdate: 'delivery-app.order.resendStatusUpdate',
      addStatusComment: 'delivery-app.order.addStatusComment',
      statusCommentTitle: 'delivery-app.order.statusCommentTitle',
      receivedTitle: 'delivery-app.order.receivedTitle',
      sendTitle: 'delivery-app.order.sendTitle',
      listTitle: 'delivery-app.order.listTitle',
      savedSuccess: 'delivery-app.order.savedSuccess',
      receivedListTitle: 'delivery-app.order.receivedListTitle',
      sentListTitle: 'delivery-app.order.sentListTitle',
      rejectOrderMessage: 'delivery-app.order.rejectOrderMessage',
      rejectTitle: 'delivery-app.order.rejectTitle',
      add: 'delivery-app.order.add',
      newTitle: 'delivery-app.order.newTitle',
      uninvoicedOrders: 'delivery-app.order.uninvoicedOrders',
      orderStatus: {
        historyTitle: 'delivery-app.order.orderStatus.historyTitle',
        lastModifiedAt: 'delivery-app.order.orderStatus.lastModifiedAt',
        comment: 'delivery-app.order.orderStatus.comment',
        lastModifiedByEmployeeName: 'delivery-app.order.orderStatus.lastModifiedByEmployeeName',
        lastModifiedByEmail: 'delivery-app.order.orderStatus.lastModifiedByEmail',
        success: 'delivery-app.order.orderStatus.success',
        sentSuccessMessage: 'delivery-app.order.orderStatus.sentSuccessMessage',
        requestMessage: 'delivery-app.order.orderStatus.requestMessage',
      },
      changeShipmentStatus: {
        title: 'delivery-app.order.changeShipmentStatus.title',
        status: 'delivery-app.order.changeShipmentStatus.status',
        comments: 'delivery-app.order.changeShipmentStatus.comments',
        actionedByUser: 'delivery-app.order.changeShipmentStatus.actionedByUser',
        achievedAt: 'delivery-app.order.changeShipmentStatus.achievedAt',
        lastModifiedAt: 'delivery-app.order.changeShipmentStatus.lastModifiedAt',
        dialog: {
          rejectLabel: 'delivery-app.order.changeShipmentStatus.dialog.rejectLabel',
          acceptLabel: 'delivery-app.order.changeShipmentStatus.dialog.acceptLabel',
          message: 'delivery-app.order.changeShipmentStatus.dialog.message',
          header: 'delivery-app.order.changeShipmentStatus.dialog.header',
        },
        error: {
          requiredstatus: 'delivery-app.order.changeShipmentStatus.error.requiredstatus',
        },
      },
      generateInvoices: {
        action: 'delivery-app.order.generateInvoices.action',
        title: 'delivery-app.order.generateInvoices.title',
        description: 'delivery-app.order.generateInvoices.description',
        language: 'delivery-app.order.generateInvoices.language',
        languageWarning: 'delivery-app.order.generateInvoices.languageWarning',
        currencyWarning: 'delivery-app.order.generateInvoices.currencyWarning',
      },
      ordersTrackingTitle: 'delivery-app.order.ordersTrackingTitle',
      ordersTrackingDescription: 'delivery-app.order.ordersTrackingDescription',
      customer: 'delivery-app.order.customer',
      create: 'delivery-app.order.create',
      noOfferFound: 'delivery-app.order.noOfferFound',
      orderTrackingTitle: 'delivery-app.order.orderTrackingTitle',
      changeStatusInfo: 'delivery-app.order.changeStatusInfo',
      price: 'delivery-app.order.price',
      accept: 'delivery-app.order.accept',
      refuse: 'delivery-app.order.refuse',
      exclusiveOrder: 'delivery-app.order.exclusiveOrder',
      accountPaymentTimeLimitTooltip: 'delivery-app.order.accountPaymentTimeLimitTooltip',
      preorderTooltip: 'delivery-app.order.preorderTooltip',
      preorder: {
        title: 'delivery-app.order.preorder.title',
        description: 'delivery-app.order.preorder.description',
      },
      invoiceSerialNumber: 'delivery-app.order.invoiceSerialNumber',
      invoiceList: {
        navigateToInvoiceTooltip: 'delivery-app.order.invoiceList.navigateToInvoiceTooltip',
        navigateToInvoiceListTooltip: 'delivery-app.order.invoiceList.navigateToInvoiceListTooltip',
        seeMore: 'delivery-app.order.invoiceList.seeMore',
        seeLess: 'delivery-app.order.invoiceList.seeLess',
      },
      wizard: {
        stepOne: 'delivery-app.order.wizard.stepOne',
        contractStep: 'delivery-app.order.wizard.contractStep',
        stepTwo: 'delivery-app.order.wizard.stepTwo',
        stepThree: 'delivery-app.order.wizard.stepThree',
        stepFour: 'delivery-app.order.wizard.stepFour',
      },
      billingCycleEnum: {
        Per_shipment: 'delivery-app.order.billingCycleEnum.Per_shipment',
        Weekly: 'delivery-app.order.billingCycleEnum.Weekly',
        Monthly: 'delivery-app.order.billingCycleEnum.Monthly',
        Bi_monthly: 'delivery-app.order.billingCycleEnum.Bi_monthly',
        Manual: 'delivery-app.order.billingCycleEnum.Manual',
      },
      statusEnum: {
        sent: 'delivery-app.order.statusEnum.sent',
        accepted: 'delivery-app.order.statusEnum.accepted',
        rejected: 'delivery-app.order.statusEnum.rejected',
        in_progress: 'delivery-app.order.statusEnum.in_progress',
        partially_in_progress: 'delivery-app.order.statusEnum.partially_in_progress',
        returned_to_origin: 'delivery-app.order.statusEnum.returned_to_origin',
        partially_returned_to_origin: 'delivery-app.order.statusEnum.returned_to_origin',
        in_transit: 'delivery-app.order.statusEnum.in_transit',
        partially_in_transit: 'delivery-app.order.statusEnum.partially_in_transit',
        transit_end: 'delivery-app.order.statusEnum.transit_end',
        partially_transit_end: 'delivery-app.order.statusEnum.partially_in_transit',
        return_to_origin: 'delivery-app.order.statusEnum.return_to_origin',
        partially_return_to_origin: 'delivery-app.order.statusEnum.partially_return_to_origin',
        lost: 'delivery-app.order.statusEnum.lost',
        partially_completed: 'delivery-app.order.statusEnum.partially_completed',
        mixed: 'delivery-app.order.statusEnum.mixed',
        mixed_with_failure: 'delivery-app.order.statusEnum.mixed_with_failure',
        completed: 'delivery-app.order.statusEnum.completed',
        completed_with_failure: 'delivery-app.order.statusEnum.completed_with_failure',
        undelivered: 'delivery-app.order.statusEnum.undelivered',
        documents_partially_received: 'delivery-app.order.statusEnum.documents_partially_received',
        documents_received: 'delivery-app.order.statusEnum.documents_received',
        archived: 'delivery-app.order.statusEnum.archived',
        cancelled: 'delivery-app.order.statusEnum.cancelled',
      },
      dispatcher: 'delivery-app.order.dispatcher',
      viewComplaints: 'delivery-app.order.viewComplaints',
      viewBlacklistHistory: 'delivery-app.order.viewBlacklistHistory',
      resendOrderEmail: 'delivery-app.order.resendOrderEmail',
      resendInvoiceUploadInvitationEmail: 'delivery-app.order.resendInvoiceUploadInvitationEmail',
      resendOrderEmailTooltip: 'delivery-app.order.resendOrderEmailTooltip',
      cancelOrderButton: 'delivery-app.order.cancelOrderButton',
      cancelOrderForcedButton: 'delivery-app.order.cancelOrderForcedButton',
      cancelOrderDisabledTooltip: 'delivery-app.order.cancelOrderDisabledTooltip',
      archiveOrder: 'delivery-app.order.archiveOrder',
      archiveOrderTooltip: 'delivery-app.order.archiveOrderTooltip',
      unarchiveOrder: 'delivery-app.order.unarchiveOrder',
      unarchiveOrderTooltip: 'delivery-app.order.unarchiveOrderTooltip',
      downloadOrderAuditPdf: 'delivery-app.order.downloadOrderAuditPdf',
      acceptOrder: {
        title: 'delivery-app.order.acceptOrder.title',
        mainButton: 'delivery-app.order.acceptOrder.mainButton',
        bodyMessage: 'delivery-app.order.acceptOrder.bodyMessage',
        acceptButton: 'delivery-app.order.acceptOrder.acceptButton',
      },
      refuseOrder: {
        title: 'delivery-app.order.refuseOrder.title',
        mainButton: 'delivery-app.order.refuseOrder.mainButton',
        comments: 'delivery-app.order.refuseOrder.comments',
        refuseButton: 'delivery-app.order.refuseOrder.refuseButton',
      },
      cancelOrder: {
        cancelRequest: 'delivery-app.order.cancelOrder.cancelRequest',
        acceptCancelOrder: 'delivery-app.order.cancelOrder.acceptCancelOrder',
        rejectCancelOrder: 'delivery-app.order.cancelOrder.rejectCancelOrder',
        hasCancelRequest: 'delivery-app.order.cancelOrder.hasCancelRequest',
        cancelOrderDialog: {
          title: 'delivery-app.order.cancelOrder.cancelOrderDialog.title',
          details: 'delivery-app.order.cancelOrder.cancelOrderDialog.details',
          attachments: 'delivery-app.order.cancelOrder.cancelOrderDialog.attachments',
          forced: 'delivery-app.order.cancelOrder.cancelOrderDialog.forced',
          forcedWarning: 'delivery-app.order.cancelOrder.cancelOrderDialog.forcedWarning',
        },
        orderCancelled: 'delivery-app.order.cancelOrder.orderCancelled',
      },
      serviceProvider: 'delivery-app.order.serviceProvider',
      orderNumber: 'delivery-app.order.orderNumber',
      error: {
        serviceProviderrequired: 'delivery-app.order.error.serviceProviderrequired',
        customerrequired: 'delivery-app.order.error.customerrequired',
        differentTimeLimitError: 'delivery-app.order.error.differentTimeLimitError',
        defaultValidationMessage: 'delivery-app.order.error.defaultValidationMessage',
        moreOrNoneTariffs: 'delivery-app.order.error.moreOrNoneTariffs',
        DeliveryCustomerNotFoundException: 'delivery-app.order.error.DeliveryCustomerNotFoundException',
        DelServiceProviderNotFoundException: 'delivery-app.order.error.DelServiceProviderNotFoundException',
        noProperPriceInterval: 'delivery-app.order.error.noProperPriceInterval',
        noValidContractFound: 'delivery-app.order.error.noValidContractFound',
        notEqualCustomDuties: 'delivery-app.order.error.notEqualCustomDuties',
        notEqualCustomRegimes: 'delivery-app.order.error.notEqualCustomRegimes',
        isEmptyshipment: 'delivery-app.order.error.isEmptyshipment',
        requiredVehicleType: 'delivery-app.order.error.requiredVehicleType',
      },
      downloadInvoice: 'delivery-app.order.downloadInvoice',
      calculatePrice: 'delivery-app.order.calculatePrice',
      createFromExistingOrder: 'delivery-app.order.createFromExistingOrder',
      createSupplierOrderFromExisting: 'delivery-app.order.createSupplierOrderFromExisting',
      viewOrder: 'delivery-app.order.viewOrder',
      attachments: {
        title: 'delivery-app.order.attachments.title',
        shipments: 'delivery-app.order.attachments.shipments',
        browse: 'delivery-app.order.attachments.browse',
      },
      acceptAndCreate: 'delivery-app.order.acceptAndCreate',
      createTask: 'delivery-app.order.createTask',
      sendCustomerOrderEmailAccepted: 'delivery-app.order.sendCustomerOrderEmailAccepted',
      invalidStatusTooltip: 'delivery-app.order.invalidStatusTooltip',
      statusTooltipForCustomer: 'delivery-app.order.statusTooltipForCustomer',
      statusTooltipForSp: 'delivery-app.order.statusTooltipForSp',
      orderRefuseMessage: 'delivery-app.order.orderRefuseMessage',
      refuseReason: 'delivery-app.order.refuseReason',
      emptyDocuments: 'delivery-app.order.emptyDocuments',
      emptyCMR: 'delivery-app.order.emptyCMR',
      documents: 'delivery-app.order.documents',
      CMR: 'delivery-app.order.CMR',
      customerOrderTerminalReservations: 'delivery-app.order.customerOrderTerminalReservations',
    },
    packageTracking: {
      title: 'delivery-app.packageTracking.title',
      filter: 'delivery-app.packageTracking.filter',
      packageIdFilter: 'delivery-app.packageTracking.packageIdFilter',
      destination: 'delivery-app.packageTracking.destination',
      packageEventSource: {
        web: 'delivery-app.packageTracking.packageEventSource.web',
        mobile: 'delivery-app.packageTracking.packageEventSource.mobile',
        external: 'delivery-app.packageTracking.packageEventSource.external',
      },
      packageSelectionMethod: {
        SCANNED: 'delivery-app.packageTracking.packageSelectionMethod.SCANNED',
        MANUALLY_SELECTED: 'delivery-app.packageTracking.packageSelectionMethod.MANUALLY_SELECTED',
        MANUALLY_INSERTED: 'delivery-app.packageTracking.packageSelectionMethod.MANUALLY_INSERTED',
        AUTOMATICALLY_MATCHED: 'delivery-app.packageTracking.packageSelectionMethod.AUTOMATICALLY_MATCHED',
      },
      packageSelectionMethodShort: {
        SCANNED: 'delivery-app.packageTracking.packageSelectionMethodShort.SCANNED',
        MANUALLY_SELECTED: 'delivery-app.packageTracking.packageSelectionMethodShort.MANUALLY_SELECTED',
        MANUALLY_INSERTED: 'delivery-app.packageTracking.packageSelectionMethodShort.MANUALLY_INSERTED',
        AUTOMATICALLY_MATCHED: 'delivery-app.packageTracking.packageSelectionMethodShort.AUTOMATICALLY_MATCHED',
      },
      adHocPackage: 'delivery-app.packageTracking.adHocPackage',
      statusEnum: {
        REQUESTED: 'delivery-app.packageTracking.statusEnum.REQUESTED',
        REQUEST_REJECTED: 'delivery-app.packageTracking.statusEnum.REQUEST_REJECTED',
        CANCELLED: 'delivery-app.packageTracking.statusEnum.CANCELLED',
        SCHEDULED: 'delivery-app.packageTracking.statusEnum.SCHEDULED',
        IN_PROGRESS: 'delivery-app.packageTracking.statusEnum.IN_PROGRESS',
        TRANSIT_START: 'delivery-app.packageTracking.statusEnum.TRANSIT_START',
        TRANSIT_END: 'delivery-app.packageTracking.statusEnum.TRANSIT_END',
        LOST: 'delivery-app.packageTracking.statusEnum.LOST',
        UNAVAILABLE: 'delivery-app.packageTracking.statusEnum.UNAVAILABLE',
        RETURN_TO_ORIGIN: 'delivery-app.packageTracking.statusEnum.RETURN_TO_ORIGIN',
        RETURNED_TO_ORIGIN: 'delivery-app.packageTracking.statusEnum.RETURNED_TO_ORIGIN',
        DELIVERED: 'delivery-app.packageTracking.statusEnum.DELIVERED',
      },
      shortStatusEnum: {
        REQUESTED: 'delivery-app.packageTracking.shortStatusEnum.REQUESTED',
        REQUEST_REJECTED: 'delivery-app.packageTracking.shortStatusEnum.REQUEST_REJECTED',
        CANCELLED: 'delivery-app.packageTracking.shortStatusEnum.CANCELLED',
        SCHEDULED: 'delivery-app.packageTracking.shortStatusEnum.SCHEDULED',
        IN_PROGRESS: 'delivery-app.packageTracking.shortStatusEnum.IN_PROGRESS',
        TRANSIT_START: 'delivery-app.packageTracking.shortStatusEnum.TRANSIT_START',
        TRANSIT_END: 'delivery-app.packageTracking.shortStatusEnum.TRANSIT_END',
        LOST: 'delivery-app.packageTracking.shortStatusEnum.LOST',
        UNAVAILABLE: 'delivery-app.packageTracking.shortStatusEnum.UNAVAILABLE',
        RETURN_TO_ORIGIN: 'delivery-app.packageTracking.shortStatusEnum.RETURN_TO_ORIGIN',
        RETURNED_TO_ORIGIN: 'delivery-app.packageTracking.shortStatusEnum.RETURNED_TO_ORIGIN',
        DELIVERED: 'delivery-app.packageTracking.shortStatusEnum.DELIVERED',
      },
      shipmentSeriesFilter: 'delivery-app.packageTracking.shipmentSeriesFilter',
      markAsLost: 'delivery-app.packageTracking.markAsLost',
      markAsLostConfirmHeader: 'delivery-app.packageTracking.markAsLostConfirmHeader',
      markAsLostConfirmMessage: 'delivery-app.packageTracking.markAsLostConfirmMessage',
      markedAsLostSuccess: 'delivery-app.packageTracking.markedAsLostSuccess',
    },
    shipment: {
      filters: {
        pickupLocation: 'delivery-app.shipment.filters.pickupLocation',
        deliveryLocation: 'delivery-app.shipment.filters.deliveryLocation',
        pickupCity: 'delivery-app.shipment.filters.pickupCity',
        deliveryCity: 'delivery-app.shipment.filters.deliveryCity',
      },
      routing: {
        assignToAll: 'delivery-app.shipment.routing.assignToAll',
        error: {
          requiredDriverName: 'delivery-app.shipment.routing.requiredDriverName',
          requiredDriverPhone: 'delivery-app.shipment.routing.requiredDriverPhone',
          requiredLicensePlate: 'delivery-app.shipment.routing.requiredLicensePlate',
          requiredVehicleType: 'delivery-app.shipment.routing.requiredVehicleType',
          requiredVehicle: 'delivery-app.shipment.routing.requiredVehicle',
          requiredDriver: 'delivery-app.shipment.routing.requiredDriver',
        },
      },
      packagesDetails: 'delivery-app.shipment.packagesDetails',
      companyName: 'delivery-app.shipment.companyName',
      reference: 'delivery-app.shipment.reference',
      contactPerson: 'delivery-app.shipment.contactPerson',
      awb: 'delivery-app.shipment.awb',
      series: 'delivery-app.shipment.series',
      number: 'delivery-app.shipment.number',
      budget: 'delivery-app.shipment.budget',
      updateVehicle: 'delivery-app.shipment.updateVehicle',
      updateDriver: 'delivery-app.shipment.updateDriver',
      updateDriverSuccessMessage: 'delivery-app.shipment.updateDriverSuccessMessage',
      updateVehicleSuccessMessage: 'delivery-app.shipment.updateVehicleSuccessMessage',
      removeVehicle: 'delivery-app.shipment.removeVehicle',
      removeDriver: 'delivery-app.shipment.removeDriver',
      removeDriverSuccessMessage: 'delivery-app.shipment.removeDriverSuccessMessage',
      removeVehicleSuccessMessage: 'delivery-app.shipment.removeVehicleSuccessMessage',
      emptyVehicleWarningMessage: 'delivery-app.shipment.emptyVehicleWarningMessage',
      emptyDriverWarningMessage: 'delivery-app.shipment.emptyDriverWarningMessage',
      hasAssociatedTerminalReservations: 'delivery-app.shipment.hasAssociatedTerminalReservations',
      summaryTitle: 'delivery-app.shipment.summaryTitle',
      assignToShipments: 'delivery-app.shipment.assignToShipments',
      assignToShipmentsTooltip: 'delivery-app.shipment.assignToShipmentsTooltip',
      assignVehicleToShipments: 'delivery-app.shipment.assignVehicleToShipments',
      assignDriverToShipments: 'delivery-app.shipment.assignDriverToShipments',
      type: 'delivery-app.shipment.type',
      externalReference: 'delivery-app.shipment.externalReference',
      flowType: 'delivery-app.shipment.flowType',
      flowTypeEnum: {
        IN: 'delivery-app.shipment.flowTypeEnum.IN',
        OUT: 'delivery-app.shipment.flowTypeEnum.OUT',
        THIRD_COUNTRY: 'delivery-app.shipment.flowTypeEnum.THIRD_COUNTRY',
      },
      cargoValue: 'delivery-app.shipment.cargoValue',
      locked: 'delivery-app.shipment.locked',
      attachedCMR: 'delivery-app.shipment.attachedCMR',
      chooseCMR: 'delivery-app.shipment.chooseCMR',
      saveCmr: 'delivery-app.shipment.saveCmr',
      savedAttachments: 'delivery-app.shipment.savedAttachments',
      saveAttachments: 'delivery-app.shipment.saveAttachments',
      chooseAttachments: 'delivery-app.shipment.chooseAttachments',
      booleanAffirmationValues: {
        true: 'delivery-app.shipment.booleanAffirmationValues.true',
        false: 'delivery-app.shipment.booleanAffirmationValues.false',
      },
      stackable: 'delivery-app.shipment.stackable',
      unstackable: 'delivery-app.shipment.unstackable',
      tags: 'delivery-app.shipment.tags',
      assignedDispatcher: 'delivery-app.shipment.assignedDispatcher',
      deliveryService: 'delivery-app.shipment.deliveryService',
      add: 'delivery-app.shipment.add',
      delete: 'delivery-app.shipment.delete',
      displayAWB: 'delivery-app.shipment.displayAWB',
      downloadAWB: 'delivery-app.shipment.downloadAWB',
      displayCMR: 'delivery-app.shipment.displayCMR',
      downloadCMR: 'delivery-app.shipment.downloadCMR',
      CMR: 'delivery-app.shipment.CMR',
      downloadTemplateCMR: 'delivery-app.shipment.downloadTemplateCMR',
      otherDocuments: 'delivery-app.shipment.otherDocuments',
      displayPackageLabels: 'delivery-app.shipment.displayPackageLabels',
      downloadPackageLabels: 'delivery-app.shipment.downloadPackageLabels',
      request: {
        title: 'delivery-app.shipment.request.title',
        modalTitle: 'delivery-app.shipment.request.modalTitle',
        error: {
          defaultValidationMessage: 'delivery-app.shipment.request.error.defaultValidationMessage',
        },
      },
      list: {
        title: 'delivery-app.shipment.list.title',
        modalTitle: 'delivery-app.shipment.list.modalTitle',
      },
      common: {
        shipment: 'delivery-app.shipment.common.shipment',
        customerName: 'delivery-app.shipment.common.customerName',
        stackable: 'delivery-app.shipment.common.stackable',
        currency: 'delivery-app.shipment.common.currency',
        onChangeCurrencyNote: 'delivery-app.shipment.common.onChangeCurrencyNote',
        cargoValue: 'delivery-app.shipment.common.cargoValue',
        package: 'delivery-app.shipment.common.package',
        pickup: 'delivery-app.shipment.common.pickup',
        delivery: 'delivery-app.shipment.common.delivery',
        pieces: 'delivery-app.shipment.common.pieces',
        size: 'delivery-app.shipment.common.size',
        weight: 'delivery-app.shipment.common.weight',
        volume: 'delivery-app.shipment.common.volume',
        perPackage: 'delivery-app.shipment.common.perPackage',
        tags: 'delivery-app.shipment.common.tags',
        save: 'delivery-app.shipment.common.save',
        next: 'delivery-app.shipment.common.next',
        close: 'delivery-app.shipment.common.close',
        dropHere: 'delivery-app.shipment.common.dropHere',
        budget: 'delivery-app.shipment.common.budget',
        services: 'delivery-app.shipment.common.services',
        shipmentTags: 'delivery-app.shipment.common.shipmentTags',
        searchClient: 'delivery-app.shipment.common.searchClient',
        'boolean-select-item': {
          true: 'delivery-app.shipment.common.boolean-select-item.true',
          false: 'delivery-app.shipment.common.boolean-select-item.false',
          null: 'delivery-app.shipment.common.boolean-select-item.null',
        },
        vendor: 'delivery-app.shipment.common.vendor',
      },
      customsDuty: 'delivery-app.shipment.customsDuty',
      customsRegime: 'delivery-app.shipment.customsRegime',
      error: {
        deliveryServicerequired: 'delivery-app.shipment.error.deliveryServicerequired',
        deliveryRequired: 'delivery-app.shipment.error.deliveryRequired',
        pickupRequired: 'delivery-app.shipment.error.pickupRequired',
        isEmptyshipment: 'delivery-app.shipment.error.isEmptyshipment',
        isEmptypackages: 'delivery-app.shipment.error.isEmptypackages',
        isEmptyProductCustomsClearanceDTOS: 'delivery-app.shipment.error.isEmptyProductCustomsClearanceDTOS',
        packageCountExceeded: 'delivery-app.shipment.error.packageCountExceeded',
        addressOrLocationRequired: 'delivery-app.shipment.error.addressOrLocationRequired',
      },
      util: {
        requested: 'delivery-app.shipment.util.requested',
        given: 'delivery-app.shipment.util.given',
        overlap: 'delivery-app.shipment.util.overlap',
      },
      tariff: 'delivery-app.shipment.tariff',
      createAutomaticTask: 'delivery-app.shipment.createAutomaticTask',
      status: {
        requested: 'delivery-app.shipment.status.requested',
        request_rejected: 'delivery-app.shipment.status.request_rejected',
        cancelled: 'delivery-app.shipment.status.cancelled',
        before_pickup: 'delivery-app.shipment.status.before_pickup',
        in_progress: 'delivery-app.shipment.status.in_progress',
        partially_in_progress: 'delivery-app.shipment.status.partially_in_progress',
        unavailable_cargo: 'delivery-app.shipment.status.unavailable_cargo',
        returned_to_origin: 'delivery-app.shipment.status.returned_to_origin',
        partially_returned_to_origin: 'delivery-app.shipment.status.partially_returned_to_origin',
        in_transit: 'delivery-app.shipment.status.in_transit',
        partially_in_transit: 'delivery-app.shipment.status.partially_in_transit',
        transit_end: 'delivery-app.shipment.status.transit_end',
        partially_transit_end: 'delivery-app.shipment.status.partially_transit_end',
        return_to_origin: 'delivery-app.shipment.status.return_to_origin',
        partially_return_to_origin: 'delivery-app.shipment.status.partially_return_to_origin',
        lost: 'delivery-app.shipment.status.lost',
        partially_completed: 'delivery-app.shipment.status.partially_completed',
        mixed: 'delivery-app.shipment.status.mixed',
        mixed_with_failure: 'delivery-app.shipment.status.mixed_with_failure',
        completed: 'delivery-app.shipment.status.completed',
        completed_with_failure: 'delivery-app.shipment.status.completed_with_failure',
        undelivered: 'delivery-app.shipment.status.undelivered',
        documents_received: 'delivery-app.shipment.status.documents_received',
      },
    },
    handover: {
      companyName: 'delivery-app.handover.companyName',
      city: 'delivery-app.handover.city',
      postalCode: 'delivery-app.handover.postalCode',
      country: 'delivery-app.handover.country',
      chooseAddress: 'delivery-app.handover.chooseAddress',
      addNewAddress: 'delivery-app.handover.addNewAddress',
      error: {
        noAddressSelected: 'delivery-app.handover.error.noAddressSelected',
        deliveryIsBeforePickup: 'delivery-app.handover.error.deliveryIsBeforePickup',
      },
      Pickup: {
        title: 'delivery-app.handover.Pickup.title',
        timeWindow: 'delivery-app.handover.Pickup.timeWindow',
        startTime: 'delivery-app.handover.Pickup.startTime',
        endTime: 'delivery-app.handover.Pickup.endTime',
        loadingReference: 'delivery-app.handover.Pickup.loadingReference',
        error: {
          timeWindowStartrequired: 'delivery-app.handover.Pickup.error.timeWindowStartrequired',
          pickupIsBeforeToday: 'delivery-app.handover.Pickup.error.pickupIsBeforeToday',
          pickupEndTimeIsBeforeNow: 'delivery-app.handover.Pickup.error.pickupEndTimeIsBeforeNow',
        },
      },
      Delivery: {
        title: 'delivery-app.handover.Delivery.title',
        timeWindow: 'delivery-app.handover.Delivery.timeWindow',
        startTime: 'delivery-app.handover.Delivery.startTime',
        endTime: 'delivery-app.handover.Delivery.endTime',
        loadingReference: 'delivery-app.handover.Delivery.loadingReference',
        error: {
          timeWindowStartrequired: 'delivery-app.handover.Delivery.error.timeWindowStartrequired',
          deliveryIsBeforePickup: 'delivery-app.handover.Delivery.error.deliveryIsBeforePickup',
        },
      },
    },
    contact: {
      title: 'delivery-app.contact.title',
      name: 'delivery-app.contact.name',
      email: 'delivery-app.contact.email',
      phoneNumber: 'delivery-app.contact.phoneNumber',
      selectContacts: 'delivery-app.contact.selectContacts',
      addContact: 'delivery-app.contact.addContact',
      error: {
        requiredContactName: 'delivery-app.contact.error.requiredContactName',
        requiredName: 'delivery-app.contact.error.requiredName',
        requiredPhoneNumber: 'delivery-app.contact.error.requiredPhoneNumber',
        maxlength: 'delivery-app.contact.error.maxlength',
        requiredNamedLocationPartnerContactVO: 'delivery-app.contact.error.requiredNamedLocationPartnerContactVO',
        maxlengthCompanyName: 'delivery-app.contact.error.maxlengthCompanyName',
        maxlengthPhoneNumber: 'delivery-app.contact.error.maxlengthPhoneNumber',
        maxlengthName: 'delivery-app.contact.error.maxlengthName',
        maxlengthLoadingReference: 'delivery-app.contact.error.maxlengthLoadingReference',
        requiredCompanyName: 'delivery-app.contact.error.requiredCompanyName',
        requiredDeliveryContactName: 'delivery-app.contact.error.requiredDeliveryContactName',
        requiredDeliveryName: 'delivery-app.contact.error.requiredDeliveryName',
        requiredDeliveryPhoneNumber: 'delivery-app.contact.error.requiredDeliveryPhoneNumber',
        requiredDeliveryCompanyName: 'delivery-app.contact.error.requiredDeliveryCompanyName',
      },
    },
    address: {
      addressLine: 'delivery-app.address.addressLine',
      city: 'delivery-app.address.city',
      state: 'delivery-app.address.state',
      postalCode: 'delivery-app.address.postalCode',
      country: 'delivery-app.address.country',
      addressType: 'delivery-app.address.addressType',
      selectedAddress: 'delivery-app.address.selectedAddress',
      newAddress: 'delivery-app.address.newAddress',
      addressTypes: {
        Registered: 'delivery-app.address.addressTypes.Registered',
        Billing: 'delivery-app.address.addressTypes.Billing',
        Decision: 'delivery-app.address.addressTypes.Decision',
        Delivery: 'delivery-app.address.addressTypes.Delivery',
        Main: 'delivery-app.address.addressTypes.Main',
        Pickup: 'delivery-app.address.addressTypes.Pickup',
        Shipping: 'delivery-app.address.addressTypes.Shipping',
        Warehouse: 'delivery-app.address.addressTypes.Warehouse',
        Invoicing: 'delivery-app.address.addressTypes.Invoicing',
        Correspondence: 'delivery-app.address.addressTypes.Correspondence',
        WorkPoint: 'delivery-app.address.addressTypes.WorkPoint',
      },
      error: {
        cityrequired: 'delivery-app.address.error.cityrequired',
        countryrequired: 'delivery-app.address.error.countryrequired',
        postalCoderequired: 'delivery-app.address.error.postalCoderequired',
        noAddressSelected: 'delivery-app.address.error.noAddressSelected',
      },
    },
    'address-template': {
      list: {
        title: 'delivery-app.address-template.list.title',
        city: 'delivery-app.address-template.list.city',
        state: 'delivery-app.address-template.list.state',
        country: 'delivery-app.address-template.list.country',
        addressLine: 'delivery-app.address-template.list.addressLine',
        postalCode: 'delivery-app.address-template.list.postalCode',
        label: 'delivery-app.address-template.list.label',
        forCompany: 'delivery-app.address-template.list.forCompany',
        streetName: 'delivery-app.address-template.list.streetName',
        streetNumber: 'delivery-app.address-template.list.streetNumber',
        block: 'delivery-app.address-template.list.block',
        building: 'delivery-app.address-template.list.building',
        floor: 'delivery-app.address-template.list.floor',
        apartment: 'delivery-app.address-template.list.apartment',
        details: 'delivery-app.address-template.list.details',
      },
    },
    package: {
      title: 'delivery-app.package.title',
      id: 'delivery-app.package.id',
      height: 'delivery-app.package.height',
      size: 'delivery-app.package.size',
      width: 'delivery-app.package.width',
      length: 'delivery-app.package.length',
      weight: 'delivery-app.package.weight',
      pieces: 'delivery-app.package.pieces',
      type: 'delivery-app.package.type',
      tags: 'delivery-app.package.tags',
      add: 'delivery-app.package.add',
      select: 'delivery-app.package.select',
      search: 'delivery-app.package.search',
      custom: 'delivery-app.package.custom',
      delete: 'delivery-app.package.delete',
      status: {
        REQUESTED: 'delivery-app.package.status.REQUESTED',
        REQUEST_REJECTED: 'delivery-app.package.status.REQUEST_REJECTED',
        CANCELLED: 'delivery-app.package.status.CANCELLED',
        SCHEDULED: 'delivery-app.package.status.SCHEDULED',
        IN_PROGRESS: 'delivery-app.package.status.IN_PROGRESS',
        TRANSIT_START: 'delivery-app.package.status.TRANSIT_START',
        TRANSIT_END: 'delivery-app.package.status.TRANSIT_END',
        LOST: 'delivery-app.package.status.LOST',
        UNAVAILABLE: 'delivery-app.package.status.UNAVAILABLE',
        RETURN_TO_ORIGIN: 'delivery-app.package.status.RETURN_TO_ORIGIN',
        RETURNED_TO_ORIGIN: 'delivery-app.package.status.RETURNED_TO_ORIGIN',
        DELIVERED: 'delivery-app.package.status.DELIVERED',
      },
      packageEvent: {
        lastEventAchievedAtDate: 'delivery-app.package.packageEvent.lastEventAchievedAtDate',
        lastEventAchievedAtAddress: 'delivery-app.package.packageEvent.lastEventAchievedAtAddress',
      },
      numberOfPackagesAssignedToShipment: 'delivery-app.package.numberOfPackagesAssignedToShipment',
      packages: 'delivery-app.package.packages',
      error: {
        piecesrequired: 'delivery-app.package.error.piecesrequired',
        heightrequired: 'delivery-app.package.error.heightrequired',
        widthrequired: 'delivery-app.package.error.widthrequired',
        lengthrequired: 'delivery-app.package.error.lengthrequired',
        weightrequired: 'delivery-app.package.error.weightrequired',
        descriptionrequired: 'delivery-app.package.error.descriptionrequired',
        noPackages: 'delivery-app.package.error.noPackages',
      },
      totalCount: 'delivery-app.package.totalCount',
      totalWeight: 'delivery-app.package.totalWeight',
      totalVolume: 'delivery-app.package.totalVolume',
      tracking: {
        destination: 'delivery-app.package.tracking.destination',
        pickup: 'delivery-app.package.tracking.pickup',
        indicateAProblem: 'delivery-app.package.tracking.indicateAProblem',
        renewStatus: 'delivery-app.package.tracking.renewStatus',
        moreActions: 'delivery-app.package.tracking.moreActions',
      },
      packageStatusPopupTitle: 'delivery-app.package.packageStatusPopupTitle',
      packageStatusPopupButtonTooltip: 'delivery-app.package.packageStatusPopupButtonTooltip',
      downloadPdf: 'delivery-app.package.downloadPdf',
    },
    productCustomsClearance: {
      title: 'delivery-app.productCustomsClearance.title',
      add: 'delivery-app.productCustomsClearance.add',
      commodityDescription: 'delivery-app.productCustomsClearance.commodityDescription',
      quantity: 'delivery-app.productCustomsClearance.quantity',
      quantityUnits: 'delivery-app.productCustomsClearance.quantityUnits',
      unitPrice: 'delivery-app.productCustomsClearance.unitPrice',
      customsValue: 'delivery-app.productCustomsClearance.customsValue',
      countryOfManufacture: 'delivery-app.productCustomsClearance.countryOfManufacture',
      amount: 'delivery-app.productCustomsClearance.amount',
      currency: 'delivery-app.productCustomsClearance.currency',
      totalWeight: 'delivery-app.productCustomsClearance.totalWeight',
      harmonizedCode: 'delivery-app.productCustomsClearance.harmonizedCode',
      customsCurrency: 'delivery-app.productCustomsClearance.customsCurrency',
      commodity: 'delivery-app.productCustomsClearance.commodity',
      quantityUnitLabels: {
        AR: 'delivery-app.productCustomsClearance.quantityUnitLabels.AR',
        CM: 'delivery-app.productCustomsClearance.quantityUnitLabels.CM',
        CFT: 'delivery-app.productCustomsClearance.quantityUnitLabels.CFT',
        M3: 'delivery-app.productCustomsClearance.quantityUnitLabels.M3',
        DOZ: 'delivery-app.productCustomsClearance.quantityUnitLabels.DOZ',
        DPR: 'delivery-app.productCustomsClearance.quantityUnitLabels.DPR',
        EA: 'delivery-app.productCustomsClearance.quantityUnitLabels.EA',
        LFT: 'delivery-app.productCustomsClearance.quantityUnitLabels.LFT',
        G: 'delivery-app.productCustomsClearance.quantityUnitLabels.G',
        GR: 'delivery-app.productCustomsClearance.quantityUnitLabels.GR',
        KG: 'delivery-app.productCustomsClearance.quantityUnitLabels.KG',
        LNM: 'delivery-app.productCustomsClearance.quantityUnitLabels.LNM',
        LTR: 'delivery-app.productCustomsClearance.quantityUnitLabels.LTR',
        M: 'delivery-app.productCustomsClearance.quantityUnitLabels.M',
        MG: 'delivery-app.productCustomsClearance.quantityUnitLabels.MG',
        ML: 'delivery-app.productCustomsClearance.quantityUnitLabels.ML',
        NO: 'delivery-app.productCustomsClearance.quantityUnitLabels.NO',
        OZ: 'delivery-app.productCustomsClearance.quantityUnitLabels.OZ',
        PR: 'delivery-app.productCustomsClearance.quantityUnitLabels.PR',
        PCS: 'delivery-app.productCustomsClearance.quantityUnitLabels.PCS',
        LB: 'delivery-app.productCustomsClearance.quantityUnitLabels.LB',
        SFT: 'delivery-app.productCustomsClearance.quantityUnitLabels.SFT',
        M2: 'delivery-app.productCustomsClearance.quantityUnitLabels.M2',
        SYD: 'delivery-app.productCustomsClearance.quantityUnitLabels.SYD',
        YD: 'delivery-app.productCustomsClearance.quantityUnitLabels.YD',
      },
      error: {
        requiredCommodityDescription: 'delivery-app.productCustomsClearance.error.requiredCommodityDescription',
        requiredQuantity: 'delivery-app.productCustomsClearance.error.requiredQuantity',
        requiredQuantityUnits: 'delivery-app.productCustomsClearance.error.requiredQuantityUnits',
        requiredCountryOfManufacture: 'delivery-app.productCustomsClearance.error.requiredCountryOfManufacture',
        requiredValue: 'delivery-app.productCustomsClearance.error.requiredValue',
        requiredCurrencyCode: 'delivery-app.productCustomsClearance.error.requiredCurrencyCode',
        requiredTotalWeight: 'delivery-app.productCustomsClearance.error.requiredTotalWeight',
        requiredCustomLabel: 'delivery-app.productCustomsClearance.error.requiredCustomLabel',
        minQuantity: 'delivery-app.productCustomsClearance.error.minQuantity',
        minValue: 'delivery-app.productCustomsClearance.error.minValue',
        greaterThanTotalWeight: 'delivery-app.productCustomsClearance.error.greaterThanTotalWeight',
        requiredProductCustomsClearancesCurrencyCode:
          'delivery-app.productCustomsClearance.error.requiredProductCustomsClearancesCurrencyCode',
        maxlengthHarmonizedCode: 'delivery-app.productCustomsClearance.error.maxLengthHarmonizedCode',
        requiredEnglishLanguage: 'delivery-app.productCustomsClearance.error.requiredEnglishLanguage',
        productsWeightIsBiggerThanPackagesWeight:
          'delivery-app.productCustomsClearance.error.productsWeightIsBiggerThanPackagesWeight',
      },
      nomenclature: {
        productName: 'delivery-app.productCustomsClearance.nomenclature.productName',
        customLabel: 'delivery-app.productCustomsClearance.nomenclature.customLabel',
        addEmptyProduct: 'delivery-app.productCustomsClearance.nomenclature.addEmptyProduct',
        addProductToNomenclature: 'delivery-app.productCustomsClearance.nomenclature.addProductToNomenclature',
        searchProduct: 'delivery-app.productCustomsClearance.nomenclature.searchProduct',
        selectProduct: 'delivery-app.productCustomsClearance.nomenclature.selectProduct',
        saveInNomenclature: 'delivery-app.productCustomsClearance.nomenclature.saveInNomenclature',
        saveSelectedProducts: 'delivery-app.productCustomsClearance.nomenclature.saveSelectedProducts',
        enterCustomLabel: 'delivery-app.productCustomsClearance.nomenclature.enterCustomLabel',
        listTitle: 'delivery-app.productCustomsClearance.nomenclature.listTitle',
        formTitle: 'delivery-app.productCustomsClearance.nomenclature.formTitle',
        editTitle: 'delivery-app.productCustomsClearance.nomenclature.editTitle',
        productSavedSuccessfully: 'delivery-app.productCustomsClearance.nomenclature.productSavedSuccessfully',
        productDeletedSuccessfully: 'delivery-app.productCustomsClearance.nomenclature.productDeletedSuccessfully',
        saveProductChangesHeader: 'delivery-app.productCustomsClearance.nomenclature.saveProductChangesHeader',
        saveProductChangesMessage: 'delivery-app.productCustomsClearance.nomenclature.saveProductChangesMessage',
        saveProductWithNoChangesMessage:
          'delivery-app.productCustomsClearance.nomenclature.saveProductWithNoChangesMessage',
        unitMeasurementInvalidMessage:
          'delivery-app.productCustomsClearance.nomenclature.unitMeasurementInvalidMessage',

        errors: {
          currencyNotTheSame: 'delivery-app.productCustomsClearance.nomenclature.errors.currencyNotTheSame',
          productNomenclatureSaveException:
            'delivery-app.productCustomsClearance.nomenclature.errors.productNomenclatureSaveException',
        },
      },
    },
    planner: {
      name: 'delivery-app.planner.name',
      order: {
        add: 'delivery-app.planner.order.add',
        listTitle: 'delivery-app.planner.order.listTitle',
        title: 'delivery-app.planner.order.title',
        pickup: 'delivery-app.planner.order.pickup',
        customerName: 'delivery-app.planner.order.customerName',
        spName: 'delivery-app.planner.order.spName',
        paymentTimeLimit: 'delivery-app.planner.order.paymentTimeLimit',
        task: 'delivery-app.planner.order.task',
        status: 'delivery-app.planner.order.status',
        delivery: 'delivery-app.planner.order.delivery',
        pickups: 'delivery-app.planner.order.pickups',
        tasks: 'delivery-app.planner.order.tasks',
        billingCycle: 'delivery-app.planner.order.billingCycle',
        deliveries: 'delivery-app.planner.order.deliveries',
        account: 'delivery-app.planner.order.account',
        locked: 'delivery-app.planner.order.locked',
        handover: {
          city: 'delivery-app.planner.order.handover.city',
          country: 'delivery-app.planner.order.handover.country',
        },
        createdAt: 'delivery-app.planner.order.createdAt',
        orderNumber: 'delivery-app.planner.order.orderNumber',
        currencyCode: 'delivery-app.planner.order.currencyCode',
        totalWeight: 'delivery-app.planner.order.totalWeight',
        packageNumber: 'delivery-app.planner.order.packageNumber',
        deliveryCompanyNames: 'delivery-app.planner.order.deliveryCompanyNames',
        pickupCompanyNames: 'delivery-app.planner.rder.pickupCompanyNames',
        pieces: 'delivery-app.planner.order.pieces',
        invoiceGenerated: 'delivery-app.planner.order.invoiceGenerated',
        contact: {
          name: 'delivery-app.planner.order.contact.name',
          phoneNumber: 'delivery-app.planner.order.contact.phoneNumber',
        },
        dispatcher: 'delivery-app.planner.order.dispatcher',
        delete: 'delivery-app.planner.order.delete',
        requestingCompanyName: 'delivery-app.planner.order.requestingCompanyName',
        error: {
          defaultValidationMessage: 'delivery-app.planner.order.error.defaultValidationMessage',
          accountrequired: 'delivery-app.planner.order.error.accountrequired',
        },
        sales: 'delivery-app.planner.order.sales',
        'dispatcher-header': 'delivery-app.planner.order.dispatcher-header',
      },
    },
    tariff: {
      'list-title': 'delivery-app.tariff.list-title',
      'new-title': 'delivery-app.tariff.new-title',
      'detail-title': 'delivery-app.tariff.detail-title',
      'from-template-title': 'delivery-app.tariff.from-template-title',
      addNew: 'delivery-app.tariff.addNew',
      contract: 'delivery-app.tariff.contract',
      account: 'delivery-app.tariff.account',
      service: 'delivery-app.tariff.service',
      'service-name': 'delivery-app.tariff.service-name',
      'customer-name': 'delivery-app.tariff.customer-name',
      currency: 'delivery-app.tariff.currency',
      'start-zone': 'delivery-app.tariff.start-zone',
      'end-zone': 'delivery-app.tariff.end-zone',
      'calculation-method': 'delivery-app.tariff.calculation-method',
      template: 'delivery-app.tariff.template',
      'calculation-method-value': {
        PIECES: 'delivery-app.tariff.calculation-method-value.PIECES',
        WEIGHT: 'delivery-app.tariff.calculation-method-value.WEIGHT',
      },
      'price-interval': {
        title: 'delivery-app.tariff.price-interval.title',
        from: 'delivery-app.tariff.price-interval.from',
        to: 'delivery-app.tariff.price-interval.to',
        'base-quantity': 'delivery-app.tariff.price-interval.base-quantity',
        'base-price': 'delivery-app.tariff.price-interval.base-price',
        'add-quantity-step': 'delivery-app.tariff.price-interval.add-quantity-step',
        'add-price-per-step': 'delivery-app.tariff.price-interval.add-price-per-step',
      },
      error: {
        invalidInterval: 'delivery-app.tariff.error.invalidInterval',
        invalidIntervals: 'delivery-app.tariff.error.invalidIntervals',
        requiredcontractVO: 'delivery-app.tariff.error.requiredcontractVO',
        requiredaccountVO: 'delivery-app.tariff.error.requiredaccountVO',
        requiredcurrency: 'delivery-app.tariff.error.requiredcurrency',
        requireddeliveryServiceVO: 'delivery-app.tariff.error.requireddeliveryServiceVO',
        requiredtariffCalculationMethod: 'delivery-app.tariff.error.requiredtariffCalculationMethod',
        requiredstartZone: 'delivery-app.tariff.error.requiredstartZone',
        requiredendZone: 'delivery-app.tariff.error.requiredendZone',
        requiredfrom: 'delivery-app.tariff.error.requiredfrom',
        requiredto: 'delivery-app.tariff.error.requiredto',
        requiredbaseQuantity: 'delivery-app.tariff.error.requiredbaseQuantity',
        requiredbasePrice: 'delivery-app.tariff.error.requiredbasePrice',
        requiredaddQuantityStep: 'delivery-app.tariff.error.requiredaddQuantityStep',
        requiredaddPricePerStep: 'delivery-app.tariff.error.requiredaddPricePerStep',
      },
    },
    contract: {
      'list-title': 'delivery-app.contract.list-title',
      'new-title': 'delivery-app.contract.new-title',
      'edit-title': 'delivery-app.contract.edit-title',
      addNew: 'delivery-app.contract.addNew',
      customer: 'delivery-app.contract.customer',
      account: 'delivery-app.contract.account',
      'service-provider': 'delivery-app.contract.service-provider',
      'attachments-title': 'delivery-app.contract.attachments-title',
      'company-name': 'delivery-app.contract.company-name',
      'valid-from': 'delivery-app.contract.valid-from',
      'valid-to': 'delivery-app.contract.valid-to',
      comments: 'delivery-app.contract.comments',
      label: 'delivery-app.contract.label',
      'contract-status': 'delivery-app.contract.contract-status',
      'contract-status-value': {
        requested: 'delivery-app.contract.contract-status-value.requested',
        accepted: 'delivery-app.contract.contract-status-value.accepted',
      },
      error: {
        requiredaccountVO: 'delivery-app.contract.error.requiredaccountVO',
        requiredcustomerVO: 'delivery-app.contract.error.requiredcustomerVO',
        requiredvalidFrom: 'delivery-app.contract.error.requiredvalidFrom',
        requiredvalidTo: 'delivery-app.contract.error.requiredvalidTo',
        requiredstatus: 'delivery-app.contract.error.requiredstatus',
        requiredlabel: 'delivery-app.contract.error.requiredlabel',
      },
    },
    invoicePreview: {
      invoiceTitle: 'delivery-app.invoicePreview.invoiceTitle',
      series: 'delivery-app.invoicePreview.series',
      issueDate: 'delivery-app.invoicePreview.issueDate',
      paymentDueDate: 'delivery-app.invoicePreview.paymentDueDate',
      paymentTimeLimit: 'delivery-app.invoicePreview.paymentTimeLimit',
      billTo: 'delivery-app.invoicePreview.billTo',
      shipTo: 'delivery-app.invoicePreview.shipTo',
      storno: 'delivery-app.invoicePreview.storno',
      fromDate: 'delivery-app.invoicePreview.fromDate',
      orderNumber: 'delivery-app.invoicePreview.orderNumber',
      comment: 'delivery-app.invoicePreview.comment',
      totalNet: 'delivery-app.invoicePreview.totalNet',
      billingAddress: 'delivery-app.invoicePreview.billingAddress',
      registrationCode: 'delivery-app.invoicePreview.registrationCode',
      vat: 'delivery-app.invoicePreview.vat',
      exemptionReason: 'delivery-app.invoicePreview.exemptionReason',
      total: 'delivery-app.invoicePreview.total',
      net: 'delivery-app.invoicePreview.net',
      serviceProvider: 'delivery-app.invoicePreview.serviceProvider',
      serviceProviderDetails: 'delivery-app.invoicePreview.serviceProviderDetails',
      companyLocation: 'delivery-app.invoicePreview.companyLocation',
      correspondenceAddress: 'delivery-app.invoicePreview.correspondenceAddress',
      bankAccounts: 'delivery-app.invoicePreview.bankAccounts',
      bankName: 'delivery-app.invoicePreview.bankName',
      customerBankAccounts: 'delivery-app.invoicePreview.customerBankAccounts',
      bankNo: 'delivery-app.invoicePreview.bankNo',
      swiftCode: 'delivery-app.invoicePreview.swiftCode',
      accounting: 'delivery-app.invoicePreview.accounting',
      phone: 'delivery-app.invoicePreview.phone',
      email: 'delivery-app.invoicePreview.email',
      vatCode: 'delivery-app.invoicePreview.vatCode',
      senderAndReceiver: 'delivery-app.invoicePreview.senderAndReceiver',
      service: 'delivery-app.invoicePreview.service',
      date: 'delivery-app.invoicePreview.date',
      shipNumber: 'delivery-app.invoicePreview.shipNumber',
      licensePlate: 'delivery-app.invoicePreview.licensePlate',
      operationType: 'delivery-app.invoicePreview.operationType',
      costCenter: 'delivery-app.invoicePreview.costCenter',
      exchangeWarning: {
        title: 'delivery-app.invoicePreview.exchangeWarning.title',
        description: 'delivery-app.invoicePreview.exchangeWarning.description',
      },
      vatDescriptions: {
        RO_0R: 'delivery-app.invoicePreview.vatDescriptions.RO_0R',
        RO_ST: 'delivery-app.invoicePreview.vatDescriptions.RO_ST',
        RO_XR: 'delivery-app.invoicePreview.vatDescriptions.RO_XR',
        RO_AE: 'delivery-app.invoicePreview.vatDescriptions.RO_AE',
        RO_K: 'delivery-app.invoicePreview.vatDescriptions.RO_K',
        RO_G: 'delivery-app.invoicePreview.vatDescriptions.RO_G',
        RO_O: 'delivery-app.invoicePreview.vatDescriptions.RO_O',
        RO_E: 'delivery-app.invoicePreview.vatDescriptions.RO_E',
      },
      tooltips: {
        deleteService: 'delivery-app.invoicePreview.tooltips.deleteService',
      },
    },
    invoice: {
      clientContacts: 'delivery-app.invoice.clientContacts',
      contacts: 'delivery-app.invoice.contacts',
      issuedTitle: 'delivery-app.invoice.issuedTitle',
      author: 'delivery-app.invoice.author',
      receivedTitle: 'delivery-app.invoice.receivedTitle',
      unselectAll: 'delivery-app.invoice.unselectAll',
      selectedInvoices: 'delivery-app.invoice.selectedInvoices',
      newTitle: 'delivery-app.invoice.newTitle',
      editTitle: 'delivery-app.invoice.editTitle',
      newService: 'delivery-app.invoice.newService',
      addNewLine: 'delivery-app.invoice.addNewLine',
      addInvoice: 'delivery-app.invoice.addInvoice',
      editExternalInvoice: 'delivery-app.invoice.editExternalInvoice',
      detailTitle: 'delivery-app.invoice.detailTitle',
      download: 'delivery-app.invoice.download',
      generate: 'delivery-app.invoice.generate',
      invoiceSeries: 'delivery-app.invoice.invoiceSeries',
      orderNumber: 'delivery-app.invoice.orderNumber',
      issueDate: 'delivery-app.invoice.issueDate',
      customerName: 'delivery-app.invoice.customerName',
      currencyCode: 'delivery-app.invoice.currencyCode',
      addSecondaryCurrencyValues: 'delivery-app.invoice.addSecondaryCurrencyValues',
      paymentTermsNote: 'delivery-app.invoice.paymentTermsNote',
      deleteSecondaryCurrencyValues: 'delivery-app.invoice.deleteSecondaryCurrencyValues',
      attachments: 'delivery-app.invoice.attachments',
      serviceProviderName: 'delivery-app.invoice.serviceProviderName',
      totalPrice: 'delivery-app.invoice.totalPrice',
      netPrice: 'delivery-app.invoice.netPrice',
      paymentStatus: 'delivery-app.invoice.paymentStatus',
      invoiceStatus: 'delivery-app.invoice.invoiceStatus',
      anafInvoiceStatus: 'delivery-app.invoice.anafInvoiceStatus',
      anafInvoiceStatuses: {
        UNSENT: 'delivery-app.invoice.anafInvoiceStatuses.UNSENT',
        CONVERSION_ERROR: 'delivery-app.invoice.anafInvoiceStatuses.CONVERSION_ERROR',
        COMMUNICATION_ERROR: 'delivery-app.invoice.anafInvoiceStatuses.COMMUNICATION_ERROR',
        ERROR: 'delivery-app.invoice.anafInvoiceStatuses.ERROR',
        UPLOAD_SUCCESS: 'delivery-app.invoice.anafInvoiceStatuses.UPLOAD_SUCCESS',
        UNCHECKED: 'delivery-app.invoice.anafInvoiceStatuses.UNCHECKED',
        PENDING: 'delivery-app.invoice.anafInvoiceStatuses.PENDING',
        TEMPORARY_ERROR: 'delivery-app.invoice.anafInvoiceStatuses.TEMPORARY_ERROR',
        NOT_OK: 'delivery-app.invoice.anafInvoiceStatuses.NOT_OK',
        OK: 'delivery-app.invoice.anafInvoiceStatuses.OK',
      },
      anafInvoiceStatusMessage: {
        UNSENT: 'delivery-app.invoice.anafInvoiceStatusMessage.UNSENT',
        CONVERSION_ERROR: 'delivery-app.invoice.anafInvoiceStatusMessage.CONVERSION_ERROR',
        COMMUNICATION_ERROR: 'delivery-app.invoice.anafInvoiceStatusMessage.COMMUNICATION_ERROR',
        ERROR: 'delivery-app.invoice.anafInvoiceStatusMessage.ERROR',
        UPLOAD_SUCCESS: 'delivery-app.invoice.anafInvoiceStatusMessage.UPLOAD_SUCCESS',
        UNCHECKED: 'delivery-app.invoice.anafInvoiceStatusMessage.UNCHECKED',
        PENDING: 'delivery-app.invoice.anafInvoiceStatusMessage.PENDING',
        TEMPORARY_ERROR: 'delivery-app.invoice.anafInvoiceStatusMessage.TEMPORARY_ERROR',
        NOT_OK: 'delivery-app.invoice.anafInvoiceStatusMessage.NOT_OK',
        OK: 'delivery-app.invoice.anafInvoiceStatusMessage.OK',
      },
      paymentTimeLimit: 'delivery-app.invoice.paymentTimeLimit',
      paymentDueDate: 'delivery-app.invoice.paymentDueDate',
      changeInvoiceStartDate: 'delivery-app.invoice.changeInvoiceStartDate',
      newInvoiceStartDate: 'delivery-app.invoice.newInvoiceStartDate',
      comment: 'delivery-app.invoice.comment',
      customPaymentAgreement: 'delivery-app.invoice.customPaymentAgreement',
      dateGTFilter: 'delivery-app.invoice.dateGTFilter',
      numberGTFilter: 'delivery-app.invoice.numberGTFilter',
      dateLTFilter: 'delivery-app.invoice.dateLTFilter',
      numberLTFilter: 'delivery-app.invoice.numberLTFilter',
      showInvoicePDF: 'delivery-app.invoice.showInvoicePDF',
      customPaymentDate: 'delivery-app.invoice.customPaymentDate',
      createdBy: 'delivery-app.invoice.createdBy',
      createdAt: 'delivery-app.invoice.createdAt',
      introducedAt: 'delivery-app.invoice.introducedAt',
      newDueDate: 'delivery-app.invoice.newDueDate',
      dateOfChange: 'delivery-app.invoice.dateOfChange',
      vat: 'delivery-app.invoice.vat',
      vatRate: 'delivery-app.invoice.vatRate',
      exemptionReason: 'delivery-app.invoice.exemptionReason',
      invoiceDateHistory: 'delivery-app.invoice.invoiceDateHistory',
      addNewInvoice: 'delivery-app.invoice.addNewInvoice',
      invoicedOrders: 'delivery-app.invoice.invoicedOrders',
      invoicedOrdersTooltip: 'delivery-app.invoice.invoicedOrdersTooltip',
      allOrders: 'delivery-app.invoice.allOrders',
      allOrdersTooltip: 'delivery-app.invoice.allOrdersTooltip',
      selectCancelable: 'delivery-app.invoice.selectCancelable',
      confirmExternalCancel: 'delivery-app.invoice.confirmExternalCancel',
      ordersTotalCost: 'delivery-app.invoice.ordersTotalCost',
      association: {
        orderNumber: 'delivery-app.invoice.association.orderNumber',
        awb: 'delivery-app.invoice.association.awb',
        orderDate: 'delivery-app.invoice.association.orderDate',
        invoiceSeries: 'delivery-app.invoice.association.invoiceSeries',
        pickupNamedLocationLabel: 'delivery-app.invoice.association.pickupNamedLocationLabel',
        pickupAddress: 'delivery-app.invoice.association.pickupAddress',
        deliveryNamedLocationLabel: 'delivery-app.invoice.association.deliveryNamedLocationLabel',
        deliveryAddress: 'delivery-app.invoice.association.deliveryAddress',
        requestingCompanyName: 'delivery-app.invoice.association.requestingCompanyName',
        courierName: 'delivery-app.invoice.association.courierName',
        orderPriceWithoutVat: 'delivery-app.invoice.association.orderPriceWithoutVat',
        invoicePriceWithoutVat: 'delivery-app.invoice.association.invoicePriceWithoutVat',
        balance: 'delivery-app.invoice.association.balance',
        issueDate: 'delivery-app.invoice.association.issueDate',
        createdAt: 'delivery-app.invoice.association.createdAt',
        orderCurrencyCode: 'delivery-app.invoice.association.orderCurrencyCode',
        invoiceCurrencyCode: 'delivery-app.invoice.association.invoiceCurrencyCode',
        paymentTimeLimit: 'delivery-app.invoice.association.paymentTimeLimit',
        paymentDueDate: 'delivery-app.invoice.association.paymentDueDate',
      },
      seeInvoices: 'delivery-app.invoice.seeInvoices',
      downloadInvoices: 'delivery-app.invoice.downloadInvoices',
      receivedOrdersDropdownDisabledMessage: 'delivery-app.invoice.receivedOrdersDropdownDisabledMessage',
      sentOrdersDropdownDisabledMessage: 'delivery-app.invoice.sentOrdersDropdownDisabledMessage',
      contactsDropdownDisabledMessage: 'delivery-app.invoice.contactsDropdownDisabledMessage',
      refuseReasonPlaceholder: 'delivery-app.invoice.refuseReasonPlaceholder',
      refuseInvoice: 'delivery-app.invoice.refuseInvoice',
      acceptInvoice: {
        confirmMessage: 'delivery-app.invoice.acceptInvoice.confirmMessage',
      },
      selectEfactura: 'delivery-app.invoice.selectEfactura',
      customPaymentDialog: {
        title: 'delivery-app.invoice.customPaymentDialog.title',
        customPaymentDate: 'delivery-app.invoice.customPaymentDialog.customPaymentDate',
        setCustomPaymentDate: 'delivery-app.invoice.customPaymentDialog.setCustomPaymentDate',
        errors: {
          requiredAgreedPaymentDate: 'delivery-app.invoice.customPaymentDialog.errors.requiredAgreedPaymentDate',
        },
      },
      cancelInvoice: 'delivery-app.invoice.cancelInvoice',
      updateAndPreview: 'delivery-app.invoice.updateAndPreview',
      actions: {
        updateAndPreview: 'delivery-app.invoice.actions.updateAndPreview',
        download: 'delivery-app.invoice.actions.download',
        finalize: 'delivery-app.invoice.actions.finalize',
        finalizeTooltip: 'delivery-app.invoice.actions.finalizeTooltip',
        sendByEmail: 'delivery-app.invoice.actions.sendByEmail',
        accept: 'delivery-app.invoice.actions.accept',
        reject: 'delivery-app.invoice.actions.reject',
      },
      list: {
        details: 'delivery-app.invoice.list.details',
        sendInvoiceToAnaf: 'delivery-app.invoice.list.sendInvoiceToAnaf',
        resendInvoiceToAnaf: 'delivery-app.invoice.list.resendInvoiceToAnaf',
        edit: 'delivery-app.invoice.list.edit',
        split: 'delivery-app.invoice.list.split',
        paid: 'delivery-app.invoice.list.paid',
        customerPaid: 'delivery-app.invoice.list.customerPaid',
        storno: 'delivery-app.invoice.list.storno',
        newReceipt: 'delivery-app.invoice.list.newReceipt',
        newPayment: 'delivery-app.invoice.list.newPayment',
        newPaymentTooltip: 'delivery-app.invoice.list.newPaymentTooltip',
        invoiceItemWarningLegend: 'delivery-app.invoice.list.invoiceItemWarningLegend',
        invoiceItemRejectLegend: 'delivery-app.invoice.list.invoiceItemRejectLegend',
        invoiceItemAnafErrorsLegend: 'delivery-app.invoice.list.invoiceItemAnafErrorsLegend',
        anafErrorInvoices: 'delivery-app.invoice.list.anafErrorInvoices',
        waitingForTaxSubmissionInvoices: 'delivery-app.invoice.list.waitingForTaxSubmissionInvoices',
        waitingForTaxProcCompletionInvoices: 'delivery-app.invoice.list.waitingForTaxProcCompletionInvoices',
        invoiceItemStornoLegend: 'delivery-app.invoice.list.invoiceItemStornoLegend',
        tooltips: {
          download: 'delivery-app.invoice.list.tooltips.download',
          downloadConfirmation: 'delivery-app.invoice.list.tooltips.downloadConfirmation',
          disabledStorno: 'delivery-app.invoice.list.tooltips.disabledStorno',
          disabledMarkAsPaid: 'delivery-app.invoice.list.tooltips.disabledMarkAsPaid',
          disabledSendByEmail: 'delivery-app.invoice.list.tooltips.disabledSendByEmail',
          disabledEfacturaDownload: 'delivery-app.invoice.list.tooltips.disabledEfacturaDownload',
          systemInvoice: 'delivery-app.invoice.list.tooltips.systemInvoice',
          externalInvoice: 'delivery-app.invoice.list.tooltips.externalInvoice',
          warningTooltip: 'delivery-app.invoice.list.tooltips.warningTooltip',
        },
      },
      report: {
        generateReport: 'delivery-app.invoice.report.generateReport',
        generateReportSuggestion: 'delivery-app.invoice.report.generateReportSuggestion',
        infoText: 'delivery-app.invoice.report.infoText',
        fromBankAccount: 'delivery-app.invoice.report.fromBankAccount',
        excel: {
          invoiceSeries: 'delivery-app.invoice.report.excel.invoiceSeries',
          lineCount: 'delivery-app.invoice.report.excel.lineCount',
          fromBankAccount: 'delivery-app.invoice.report.excel.fromBankAccount',
          toBankAccountListSummary: 'delivery-app.invoice.report.excel.toBankAccountListSummary',
          amountToPay: 'delivery-app.invoice.report.excel.amountToPay',
          currencyCode: 'delivery-app.invoice.report.excel.currencyCode',
          serviceProviderName: 'delivery-app.invoice.report.excel.serviceProviderName',
        },
        errors: {
          requiredFromBankAccountUuid: 'delivery-app.invoice.report.errors.requiredFromBankAccountUuid',
        },
      },
      customDutyTypes: {
        DUTIES_APPLICABLE: 'delivery-app.invoice.customDutyTypes.DUTIES_APPLICABLE',
        DUTIES_NOT_APPLICABLE: 'delivery-app.invoice.customDutyTypes.DUTIES_NOT_APPLICABLE',
      },
      paymentStatuses: {
        PAID: 'delivery-app.invoice.paymentStatuses.PAID',
        UNPAID: 'delivery-app.invoice.paymentStatuses.UNPAID',
        PARTIAL_PAID: 'delivery-app.invoice.paymentStatuses.PARTIAL_PAID',
      },
      externalInvoiceTypes: {
        ISSUED: 'delivery-app.invoice.externalInvoiceTypes.ISSUED',
        STORNO: 'delivery-app.invoice.externalInvoiceTypes.STORNO',
      },
      invoiceTypes: {
        ISSUED: 'delivery-app.invoice.invoiceTypes.ISSUED',
        STORNO: 'delivery-app.invoice.invoiceTypes.STORNO',
        CANCELLED: 'delivery-app.invoice.invoiceTypes.STORNO',
      },
      invoiceType: 'delivery-app.invoice.invoiceType',
      invoiceStatuses: {
        NOT_FINALIZED: 'delivery-app.invoice.invoiceStatuses.NOT_FINALIZED',
        AWAITING_TAX_SUBMISSION: 'delivery-app.invoice.invoiceStatuses.AWAITING_TAX_SUBMISSION',
        AWAITING_TAX_PROC_COMPLETION: 'delivery-app.invoice.invoiceStatuses.AWAITING_TAX_PROC_COMPLETION',
        TAX_PROC_VALIDATION_FAILURE: 'delivery-app.invoice.invoiceStatuses.TAX_PROC_VALIDATION_FAILURE',
        FINALIZED: 'delivery-app.invoice.invoiceStatuses.FINALIZED',
        PENDING: 'delivery-app.invoice.invoiceStatuses.PENDING',
        REJECTED: 'delivery-app.invoice.invoiceStatuses.REJECTED',
      },
      addService: {
        label: 'delivery-app.invoice.addService.label',
        inputs: {
          description: 'delivery-app.invoice.addService.inputs.description',
          type: 'delivery-app.invoice.addService.inputs.type',
          total: 'delivery-app.invoice.addService.inputs.total',
          currency: 'delivery-app.invoice.addService.inputs.currency',
          vat: 'delivery-app.invoice.addService.inputs.vat',
          operationType: 'delivery-app.invoice.addService.inputs.operationType',
          vatExemptionReason: 'delivery-app.invoice.addService.inputs.vatExemptionReason',
        },
        errors: {
          requiredDescription: 'delivery-app.invoice.addService.errors.requiredDescription',
          requiredTotal: 'delivery-app.invoice.addService.errors.requiredTotal',
          requiredCurrency: 'delivery-app.invoice.addService.errors.requiredCurrency',
          requiredVat: 'delivery-app.invoice.addService.errors.requiredVat',
          requiredVatExemptionReason: 'delivery-app.invoice.addService.errors.requiredVatExemptionReason',
          maxlengthVatExemptionReason: 'delivery-app.invoice.addService.errors.maxlengthvatExemptionReason',
          minTotal: 'delivery-app.invoice.addService.errors.minTotal',
        },
      },
      filters: {
        paymentDueDateExpired: 'delivery-app.invoice.filters.paymentDueDateExpired',
        paymentDueDateAlmostExpired: 'delivery-app.invoice.filters.paymentDueDateAlmostExpired',
        awaitingTaxSubmission: 'delivery-app.invoice.filters.awaitingTaxSubmission',
        anafInvoiceStatusErrors: 'delivery-app.invoice.filters.anafInvoiceStatusErrors',
        awaitingTaxProcCompletion: 'delivery-app.invoice.filters.awaitingTaxProcCompletion',
        statusPending: 'delivery-app.invoice.filters.statusPending',
      },
      errors: {
        noOrders: 'delivery-app.invoice.errors.noOrders',
        requiredLanguage: 'delivery-app.invoice.errors.requiredLanguage',
        differentTimeLimitErrorInvoiceExternalSPOrderDTOs:
          'delivery-app.invoice.errors.differentTimeLimitErrorInvoiceExternalSPOrderDTOs',
        invoicesValidationError: 'delivery-app.invoice.errors.invoicesValidationError',
        customersValidationError: 'delivery-app.invoice.errors.customersValidationError',
        invalidInvoiceTypeSelection: 'delivery-app.invoice.errors.invalidInvoiceTypeSelection',
        multiplePaymentTimeLimitValidationError: 'delivery-app.invoice.errors.multiplePaymentTimeLimitValidationError',
        invalidPaymentTimeLimitValidationError: 'delivery-app.invoice.errors.invalidPaymentTimeLimitValidationError',
        currenciesValidationError: 'delivery-app.invoice.errors.currenciesValidationError',
        accountsValidationError: 'delivery-app.invoice.errors.accountsValidationError',
        accountsLengthValidationError: 'delivery-app.invoice.errors.accountsLengthValidationError',
        shipmentPriceError: 'delivery-app.invoice.errors.shipmentPriceError',
        totalShipmentPriceError: 'delivery-app.invoice.errors.totalShipmentPriceError',
        requiredClient: 'delivery-app.invoice.errors.requiredClient',
        requiredVendor: 'delivery-app.invoice.errors.requiredVendor',
        requiredInvoiceSeries: 'delivery-app.invoice.errors.requiredInvoiceSeries',
        requiredIssueDate: 'delivery-app.invoice.errors.requiredIssueDate',
        isEmptyAttachments: 'delivery-app.invoice.errors.isEmptyAttachments',
        requiredPaymentDueDate: 'delivery-app.invoice.errors.requiredPaymentDueDate',
        requiredInvoiceStatus: 'delivery-app.invoice.errors.requiredInvoiceStatus',
        requiredCurrencyCode: 'delivery-app.invoice.errors.requiredCurrencyCode',
        requiredTotalAmount: 'delivery-app.invoice.errors.requiredTotalAmount',
        requiredTotalVATAmount: 'delivery-app.invoice.errors.requiredTotalVATAmount',
        requiredVatRate: 'delivery-app.invoice.errors.requiredVatRate',
        requiredExemptionReason: 'delivery-app.invoice.errors.requiredExemptionReason',
        requiredPaymentStatus: 'delivery-app.invoice.errors.requiredPaymentStatus',
        requiredInvoiceType: 'delivery-app.invoice.errors.requiredInvoiceType',
        requiredCanceledInvoice: 'delivery-app.invoice.errors.requiredCanceledInvoice',
        requiredContactsFromBothCompanies: 'delivery-app.invoice.errors.requiredContactsFromBothCompanies',
        requiredPaymentTimeLimit: 'delivery-app.invoice.errors.requiredPaymentTimeLimit',
        requiredInvoiceExternalSPOrderDTOs: 'delivery-app.invoice.errors.requiredInvoiceExternalSPOrderDTOs',
        requiredTotalNetAmount: 'delivery-app.invoice.errors.requiredTotalNetAmount',
        requiredSecondaryTotalNetAmount: 'delivery-app.invoice.errors.requiredSecondaryTotalNetAmount',
        requiredSecondaryTotalVATAmount: 'delivery-app.invoice.errors.requiredSecondaryTotalVATAmount',
        requiredSecondaryTotalAmount: 'delivery-app.invoice.errors.requiredSecondaryTotalAmount',
        requiredSecondaryCurrencyCode: 'delivery-app.invoice.errors.requiredSecondaryCurrencyCode',
        requiredInvoiceExchangeRate: 'delivery-app.invoice.errors.requiredInvoiceExchangeRate',
        requiredServiceName: 'delivery-app.invoice.errors.requiredServiceName',
        requiredTotalNetPrice: 'delivery-app.invoice.errors.requiredTotalNetPrice',
        minTotalNetPrice: 'delivery-app.invoice.errors.minTotalNetPrice',
        SingleCompanyContactsSelectedException: 'delivery-app.invoice.errors.SingleCompanyContactsSelectedException',
        InvalidOrderCurrencyCodesException: 'delivery-app.invoice.errors.InvalidOrderCurrencyCodesException',
      },
      error: {
        requiredNewInvoiceStartDate: 'delivery-app.invoice.error.requiredNewInvoiceStartDate',
      },
      payment: {
        title: 'delivery-app.invoice.payment.title',
        'customer-suggestion': 'delivery-app.invoice.payment.customer-suggestion',
        'service-provider-suggestion': 'delivery-app.invoice.payment.service-provider-suggestion',
        'add-payment': 'delivery-app.invoice.payment.add-payment',
        'add-receipt': 'delivery-app.invoice.payment.add-receipt',
        'selected-order-tooltip': 'delivery-app.invoice.payment.selected-order-tooltip',
      },
      orderContacts: 'delivery-app.invoice.orderContacts',
      balance: 'delivery-app.invoice.balance',
      finalPaymentDueDate: 'delivery-app.invoice.finalPaymentDueDate',
      ordersPaymentTimeLimit: 'delivery-app.invoice.ordersPaymentTimeLimit',
      EFacturaStatusTitle: 'delivery-app.invoice.EFacturaStatusTitle',
      checkEFacturaStatus: 'delivery-app.invoice.checkEFacturaStatus',
      downloadEFacturaZip: 'delivery-app.invoice.downloadEFacturaZip',
      downloadEFacturaPdf: 'delivery-app.invoice.downloadEFacturaPdf',
    },
    email: {
      title: 'delivery-app.email.title',
      'receive-date': 'delivery-app.email.receive-date',
      subject: 'delivery-app.email.subject',
      to: 'delivery-app.email.to',
      from: 'delivery-app.email.from',
      cc: 'delivery-app.email.cc',
      'plain-text-content': 'delivery-app.email.plain-text-content',
      'create-offer-request': 'delivery-app.email.create-offer-request',
    },
    offer: {
      offerContacts: 'delivery-app.offer.offerContacts',
      selectRoutingSolutionsHeader: 'delivery-app.offer.selectRoutingSolutionsHeader',
      text: 'delivery-app.offer.text',
      save: 'delivery-app.offer.save',
      masterRoutingSolution: 'delivery-app.offer.masterRoutingSolution',
      price: 'delivery-app.offer.price',
      noOffers: 'delivery-app.offer.noOffers',
      currency: 'delivery-app.offer.currency',
      details: 'delivery-app.offer.details',
      basedOn: 'delivery-app.offer.basedOn',
      binding: 'delivery-app.offer.binding',
      label: 'delivery-app.offer.label',
      createdBy: 'delivery-app.offer.createdBy',
      vehicleType: 'delivery-app.offer.vehicleType',
      licensePlate: 'delivery-app.offer.licensePlate',
      driverName: 'delivery-app.offer.driverName',
      contactPhone: 'delivery-app.offer.contactPhone',
      driver: 'delivery-app.offer.driver',
      vehicle: 'delivery-app.offer.vehicle',
      vehicleAndDriverData: 'delivery-app.offer.vehicleAndDriverData',
      paymentTimeLimit: 'delivery-app.offer.paymentTimeLimit',
      minOfferTimeAvailability: 'delivery-app.offer.minOfferTimeAvailability',
      minPaymentTimeLimit: 'delivery-app.offer.minPaymentTimeLimit',
      transitDays: 'delivery-app.offer.transitDays',
      offerPopupTitle: 'delivery-app.offer.offerPopupTitle',
      customer: 'delivery-app.offer.customer',
      shipmentList: 'delivery-app.offer.shipmentList',
      savedSuccess: 'delivery-app.offer.savedSuccess',
      createCompleteOffer: 'delivery-app.offer.createCompleteOffer',
      offerAccepted: 'delivery-app.offer.offerAccepted',
      baseOffer: 'delivery-app.offer.baseOffer',
      deliveryTimeWindowEnd: 'delivery-app.offer.deliveryTimeWindowEnd',
      deliveryTimeWindowStart: 'delivery-app.offer.deliveryTimeWindowStart',
      pickupTimeWindowEnd: 'delivery-app.offer.pickupTimeWindowEnd',
      pickupTimeWindowStart: 'delivery-app.offer.pickupTimeWindowStart',
      changesFromOfferRequest: 'delivery-app.offer.changesFromOfferRequest',
      resendOfferEmail: 'delivery-app.offer.resendOfferEmail',
      timeAvailability: 'delivery-app.offer.timeAvailability',
      amendment: 'delivery-app.offer.amendment',
      expired: 'delivery-app.offer.expired',
      termsAndConditionsTooltip: 'delivery-app.offer.termsAndConditionsTooltip',
      termsAndConditionsDisabledTooltip: 'delivery-app.offer.termsAndConditionsDisabledTooltip',
      refuseOffer: 'delivery-app.offer.refuseOffer',
      updateVehicle: 'delivery-app.offer.updateVehicle',
      refuseReason: 'delivery-app.offer.refuseReason',
      offerRefused: 'delivery-app.offer.offerRefused',
      hasConflictsTooltip: 'delivery-app.offer.hasConflictsTooltip',
      hasConflictsMessage: 'delivery-app.offer.hasConflictsMessage',
      acceptOfferAndCreateOrder: 'delivery-app.offer.acceptOfferAndCreateOrder',
      error: {
        detailsrequired: 'delivery-app.offer.error.detailsrequired',
        requiredRefuseReason: 'delivery-app.offer.error.requiredRefuseReason',
        requiredPrice: 'delivery-app.offer.error.requiredPrice',
      },
      alreadyAcceptedAnotherOffer: 'delivery-app.offer.alreadyAcceptedAnotherOffer',
      acceptedOffer: 'delivery-app.offer.acceptedOffer',
      resendOffer: 'delivery-app.offer.resendOffer',
      completeOffer: {
        'form-title': 'delivery-app.offer.completeOffer.form-title',
        'enable-complete-solution-details': 'delivery-app.offer.completeOffer.enable-complete-solution-details',
        'close-complete-solution-details': 'delivery-app.offer.completeOffer.close-complete-solution-details',
        'complete-solution-details': {
          title: 'delivery-app.offer.completeOffer.complete-solution-details.title',
        },
      },
      newSolution: {
        title: 'delivery-app.offer.newSolution.title',
        description: 'delivery-app.offer.newSolution.description',
      },
      directOffer: {
        title: 'delivery-app.offer.directOffer.title',
        description: 'delivery-app.offer.directOffer.description',
      },
      selectMasterRoutingSolution: 'delivery-app.offer.selectMasterRoutingSolution',
      masterRoutingSolutions: {
        disabledMasterRoutingSolution: 'delivery-app.offer.masterRoutingSolutions.disabledMasterRoutingSolution',
      },
      steps: {
        termsAndConditions: 'delivery-app.offer.steps.termsAndConditions',
        masterRoutingSolutions: 'delivery-app.offer.steps.masterRoutingSolutions',
        offer: 'delivery-app.offer.steps.offer',
        completeOffer: 'delivery-app.offer.steps.completeOffer',
      },
      termsAndConditionsStep: {
        offerRequestTermsAndConditions: 'delivery-app.offer.termsAndConditionsStep.offerRequestTermsAndConditions',
      },
      amendmentStep: {
        offerRequestTermsAndConditions: 'delivery-app.offer.amendmentStep.offerRequestTermsAndConditions',
        offerTermsAndConditions: 'delivery-app.offer.amendmentStep.offerTermsAndConditions',
        termsAndConditionsNotFound: 'delivery-app.offer.amendmentStep.termsAndConditionsNotFound',
      },
      totalCostWarning: 'delivery-app.offer.totalCostWarning',
      deliveredBy: 'delivery-app.offer.deliveredBy',
      deliveredBetween: 'delivery-app.offer.deliveredBetween',
    },
    offerChat: {
      chatThreadTitle: 'delivery-app.offerChat.chatThreadTitle',
      basedOnOffer: 'delivery-app.offerChat.basedOnOffer',
      navigateToOfferRequestTooltip: 'delivery-app.offerChat.navigateToOfferRequestTooltip',
      textInput: 'delivery-app.offerChat.textInput',
      offerLoading: 'delivery-app.offerChat.offerLoading',
      actionBar: {
        createOffer: 'delivery-app.offerChat.actionBar.createOffer',
      },
      confirmationDialog: {
        acceptConfirm: 'delivery-app.offerChat.confirmationDialog.acceptConfirm',
        confirmHeader: 'delivery-app.offerChat.confirmationDialog.confirmHeader',
      },
      systemMessage: {
        username: 'delivery-app.offerChat.systemMessage.username',
        content: {
          customer_closed: 'delivery-app.offerChat.systemMessage.content.customer_closed',
          sp_closed: 'delivery-app.offerChat.systemMessage.content.sp_closed',
          closed: 'delivery-app.offerChat.systemMessage.content.closed',
        },
      },
    },
    'offer-request': {
      list: {
        receivedTitle: 'delivery-app.offer-request.list.receivedTitle',
        sentTitle: 'delivery-app.offer-request.list.sentTitle',
        addNew: 'delivery-app.offer-request.list.addNew',
      },
      new: {
        titleServiceProvider: 'delivery-app.offer-request.new.titleServiceProvider',
        titleCustomer: 'delivery-app.offer-request.new.titleCustomer',
        titleCustomerSubcontracting: 'delivery-app.offer-request.new.titleCustomerSubcontracting',
        titleCustomerPre: 'delivery-app.offer-request.new.titleCustomerPre',
        titleCustomerPreSubcontracting: 'delivery-app.offer-request.new.titleCustomerPreSubcontracting',
      },
      savedSuccess: 'delivery-app.offer-request.savedSuccess',
    },
    offerSummary: {
      carType: 'delivery-app.offerSummary.carType',
      transitTime: 'delivery-app.offerSummary.transitTime',
    },
    offerRequest: {
      preOfferRequestTooltip: 'delivery-app.offerRequest.preOfferRequestTooltip',
      preOfferRequest: {
        title: 'delivery-app.offerRequest.preOfferRequest.title',
        description: 'delivery-app.offerRequest.preOfferRequest.description',
      },
      sentNotifications: 'delivery-app.offerRequest.sentNotifications',
      binding: 'delivery-app.offerRequest.binding',
      paymentTimeLimit: 'delivery-app.offerRequest.paymentTimeLimit',
      paymentTimeLimitWarning: 'delivery-app.offerRequest.paymentTimeLimitWarning',
      minimumOfferTimeAvailability: 'delivery-app.offerRequest.minimumOfferTimeAvailability',
      add: 'delivery-app.offerRequest.add',
      resolve: 'delivery-app.offerRequest.resolve',
      from: 'delivery-app.offerRequest.from',
      to: 'delivery-app.offerRequest.to',
      customer: 'delivery-app.offerRequest.customer',
      serviceProviders: 'delivery-app.offerRequest.serviceProviders',
      description: 'delivery-app.offerRequest.description',
      serviceType: 'delivery-app.offerRequest.serviceType',
      pickup: 'delivery-app.offerRequest.pickup',
      pickups: 'delivery-app.offerRequest.pickups',
      delivery: 'delivery-app.offerRequest.delivery',
      deliveries: 'delivery-app.offerRequest.deliveries',
      offerRequestNumber: 'delivery-app.offerRequest.offerRequestNumber',
      save: 'delivery-app.offerRequest.save',
      saveAndSend: 'delivery-app.offerRequest.saveAndSend',
      noOffers: 'delivery-app.offerRequest.noOffers',
      newOffer: 'delivery-app.offerRequest.newOffer',
      deadline: 'delivery-app.offerRequest.deadline',
      details: 'delivery-app.offerRequest.details',
      dispatcher: 'delivery-app.offerRequest.dispatcher',
      offerAccepted: 'delivery-app.offerRequest.offerAccepted',
      offerNotAccepted: 'delivery-app.offerRequest.offerNotAccepted',
      status: 'delivery-app.offerRequest.status',
      statusReject: 'delivery-app.offerRequest.statusReject',
      shipments: 'delivery-app.offerRequest.shipments',
      suppliers: 'delivery-app.offerRequest.suppliers',
      offers: 'delivery-app.offerRequest.offers',
      courierErrorRates: 'delivery-app.offerRequest.courierErrorRates',
      correctOfferRequest: 'delivery-app.offerRequest.correctOfferRequest',
      seeOfferRequestCourierSuccessRateResponses:
        'delivery-app.offerRequest.seeOfferRequestCourierSuccessRateResponses',
      offerRequestCourierSuccessRateResponses: 'delivery-app.offerRequest.offerRequestCourierSuccessRateResponses',
      shipment: 'delivery-app.offerRequest.shipment',
      templates: 'delivery-app.offerRequest.templates',
      bindingTitle: 'delivery-app.offerRequest.bindingTitle',
      negotiateTitle: 'delivery-app.offerRequest.negotiateTitle',
      negotiateBody: 'delivery-app.offerRequest.negotiateBody',
      addCompleteOffer: 'delivery-app.offerRequest.addCompleteOffer',
      noContactsChosen: 'delivery-app.offerRequest.noContactsChosen',
      addCompleteOfferTooltip: 'delivery-app.offerRequest.addCompleteOfferTooltip',
      disabledAddCompleteOfferTooltip: 'delivery-app.offerRequest.disabledAddCompleteOfferTooltip',
      resendOfferRequestEmail: 'delivery-app.offerRequest.resendOfferRequestEmail',
      resendOfferRequestCancelledEmail: 'delivery-app.offerRequest.resendOfferRequestCancelledEmail',
      createFromExisting: 'delivery-app.offerRequest.createFromExisting',
      cancelOfferRequest: 'delivery-app.offerRequest.cancelOfferRequest',
      cancelRequest: 'delivery-app.offerRequest.cancelRequest',
      cancelReason: 'delivery-app.offerRequest.cancelReason',
      cancelledOfferRequest: 'delivery-app.offerRequest.cancelledOfferRequest',
      createOfferRequestFromDraft: 'delivery-app.offerRequest.createOfferRequestFromDraft',
      moreDetails: 'delivery-app.offerRequest.moreDetails',
      hideDetails: 'delivery-app.offerRequest.hideDetails',
      spOfferRequestTitle: 'delivery-app.offerRequest.spOfferRequestTitle',
      offerRequestTitle: 'delivery-app.offerRequest.offerRequestTitle',
      customerContacts: 'delivery-app.offerRequest.customerContacts',
      vendorContacts: 'delivery-app.offerRequest.vendorContacts',
      offerRequestSentTo: 'delivery-app.offerRequest.offerRequestSentTo',
      offerRequestDetailsTitle: 'delivery-app.offerRequest.offerRequestDetailsTitle',
      externalVendorsQuestion: 'delivery-app.offerRequest.externalVendorsQuestion',
      deliveryCompanyNames: 'delivery-app.offerRequest.deliveryCompanyNames',
      pickupCompanyNames: 'delivery-app.offerRequest.pickupCompanyNames',

      wizard: {
        stepOne: 'delivery-app.offerRequest.wizard.stepOne',
        stepTwo: 'delivery-app.offerRequest.wizard.stepTwo',
        stepThree: 'delivery-app.offerRequest.wizard.stepThree',
      },
      confirmationDialog: {
        body: 'delivery-app.offerRequest.confirmationDialog.body',
        header: 'delivery-app.offerRequest.confirmationDialog.header',
      },
      form: {
        invalidShipments: 'delivery-app.offerRequest.form.invalidShipments',
        handoverChangeWarning: 'delivery-app.offerRequest.form.handoverChangeWarning',
      },
      shipmentDetails: {
        invalid: 'delivery-app.offerRequest.shipmentDetails.invalid',
        service: 'delivery-app.offerRequest.shipmentDetails.service',
        budget: 'delivery-app.offerRequest.shipmentDetails.budget',
        value: 'delivery-app.offerRequest.shipmentDetails.value',
        stackable: 'delivery-app.offerRequest.shipmentDetails.stackable',
        singleCar: 'delivery-app.offerRequest.shipmentDetails.singleCar',
        type: 'delivery-app.offerRequest.shipmentDetails.type',
      },
      list: {
        title: 'delivery-app.offerRequest.list.title',
        serviceProviders: 'delivery-app.offerRequest.list.serviceProviders',
        requestedAt: 'delivery-app.offerRequest.list.requestedAt',
        requestBy: 'delivery-app.offerRequest.list.requestBy',
        requestStatus: 'delivery-app.offerRequest.list.requestStatus',
        paymentTimeLimit: 'delivery-app.offerRequest.list.paymentTimeLimit',
        rejectStatus: 'delivery-app.offerRequest.list.rejectStatus',
        offerRequestStatusType: {
          sent: 'delivery-app.offerRequest.list.offerRequestStatusType.sent',
          offer_accepted: 'delivery-app.offerRequest.list.offerRequestStatusType.offer_accepted',
          cancelled: 'delivery-app.offerRequest.list.offerRequestStatusType.cancelled',
        },
        spOfferRequestStatusType: {
          received: 'delivery-app.offerRequest.list.spOfferRequestStatusType.received',
          in_progress: 'delivery-app.offerRequest.list.spOfferRequestStatusType.in_progress',
          offer_accepted: 'delivery-app.offerRequest.list.spOfferRequestStatusType.offer_accepted',
          cancelled: 'delivery-app.offerRequest.list.spOfferRequestStatusType.cancelled',
        },
        spOfferRequestRejectStatusType: {
          lost_improper_sol: 'delivery-app.offerRequest.list.spOfferRequestRejectStatusType.lost_improper_sol',
          lost_no_feedback: 'delivery-app.offerRequest.list.spOfferRequestRejectStatusType.lost_no_feedback',
          lost_no_solution: 'delivery-app.offerRequest.list.spOfferRequestRejectStatusType.lost_no_solution',
          lost_offer_late: 'delivery-app.offerRequest.list.spOfferRequestRejectStatusType.lost_offer_late',
          lost_price: 'delivery-app.offerRequest.list.spOfferRequestRejectStatusType.lost_price',
          lost_blocked: 'delivery-app.offerRequest.list.spOfferRequestRejectStatusType.lost_blocked',
          rejected_terms_and_conditions:
            'delivery-app.offerRequest.list.spOfferRequestRejectStatusType.rejected_terms_and_conditions',
        },
        offerStatus: 'delivery-app.offerRequest.list.offerStatus',
        offerStatusType: {
          offer_received: 'delivery-app.offerRequest.list.offerStatusType.offer_received',
          no_offer: 'delivery-app.offerRequest.list.offerStatusType.no_offer',
          offer_accepted: 'delivery-app.offerRequest.list.offerStatusType.offer_accepted',
        },
        spOfferStatusType: {
          offer_accepted: 'delivery-app.offerRequest.list.spOfferStatusType.offer_accepted',
          offer_not_sent: 'delivery-app.offerRequest.list.spOfferStatusType.offer_not_sent',
          offer_sent: 'delivery-app.offerRequest.list.spOfferStatusType.offer_sent',
        },
        search: 'delivery-app.offerRequest.list.search',
      },
      offerStatus: {
        offer_received: 'delivery-app.offerRequest.offerStatus.offer_received',
        offer_accepted: 'delivery-app.offerRequest.offerStatus.offer_accepted',
        offer_not_sent: 'delivery-app.offerRequest.offerStatus.offer_not_sent',
        offer_sent: 'delivery-app.offerRequest.offerStatus.offer_sent',
        no_offer: 'delivery-app.offerRequest.offerStatus.no_offer',
      },
      requestStatus: {
        sent: 'delivery-app.offerRequest.requestStatus.sent',
        received: 'delivery-app.offerRequest.requestStatus.received',
        offer_accepted: 'delivery-app.offerRequest.requestStatus.offer_accepted',
        cancelled: 'delivery-app.offerRequest.requestStatus.cancelled',
        in_progress: 'delivery-app.offerRequest.requestStatus.in_progress',
        offers_received: 'delivery-app.offerRequest.requestStatus.offers_received',
        completed: 'delivery-app.offerRequest.requestStatus.completed',
        rejected: 'delivery-app.offerRequest.requestStatus.rejected',
        archived: 'delivery-app.offerRequest.requestStatus.archived',
      },
      rejectStatus: {
        lost_improper_sol: 'delivery-app.offerRequest.rejectStatus.lost_improper_sol',
        lost_no_feedback: 'delivery-app.offerRequest.rejectStatus.lost_no_feedback',
        lost_no_solution: 'delivery-app.offerRequest.rejectStatus.lost_no_solution',
        lost_offer_late: 'delivery-app.offerRequest.rejectStatus.lost_offer_late',
        lost_price: 'delivery-app.offerRequest.rejectStatus.lost_price',
        lost_blocked: 'delivery-app.offerRequest.rejectStatus.lost_blocked',
        rejected_terms_and_conditions: 'delivery-app.offerRequest.rejectStatus.rejected_terms_and_conditions',
      },
      detail: {
        search: 'delivery-app.offerRequest.detail.search',
        offerTitle: 'delivery-app.offerRequest.detail.offerTitle',
        name: 'delivery-app.offerRequest.detail.name',
        priceValue: 'delivery-app.offerRequest.detail.priceValue',
        paymentTimeLimit: 'delivery-app.offerRequest.detail.paymentTimeLimit',
        currency: 'delivery-app.offerRequest.detail.currency',
        pickupLocations: 'delivery-app.offerRequest.detail.pickupLocations',
        deliveryLocations: 'delivery-app.offerRequest.detail.deliveryLocations',
        createOrderTooltip: 'delivery-app.offerRequest.detail.createOrderTooltip',
        acceptTooltip: 'delivery-app.offerRequest.detail.acceptTooltip',
        spName: 'delivery-app.offerRequest.detail.spName',
        status: 'delivery-app.offerRequest.detail.status',
        pageTitle: 'delivery-app.offerRequest.detail.pageTitle',
        offerRequestTitle: 'delivery-app.offerRequest.detail.offerRequestTitle',
        offersTitle: 'delivery-app.offerRequest.detail.offersTitle',
        serviceProvidersTitle: 'delivery-app.offerRequest.detail.serviceProvidersTitle',
        budget: 'delivery-app.offerRequest.detail.budget',
        locked: 'delivery-app.offerRequest.detail.locked',
        type: 'delivery-app.offerRequest.detail.type',
        stackable: 'delivery-app.offerRequest.detail.stackable',
        cargoValue: 'delivery-app.offerRequest.detail.cargoValue',
        packages: 'delivery-app.offerRequest.detail.packages',
        height: 'delivery-app.offerRequest.detail.height',
        width: 'delivery-app.offerRequest.detail.width',
        length: 'delivery-app.offerRequest.detail.length',
        weight: 'delivery-app.offerRequest.detail.weight',
        pieces: 'delivery-app.offerRequest.detail.pieces',
        tags: 'delivery-app.offerRequest.detail.tags',
        pickup: 'delivery-app.offerRequest.detail.pickup',
        address: 'delivery-app.offerRequest.detail.address',
        postalCode: 'delivery-app.offerRequest.detail.postalCode',
        delivery: 'delivery-app.offerRequest.detail.delivery',
        deadline: 'delivery-app.offerRequest.detail.deadline',
        comments: 'delivery-app.offerRequest.detail.comments',
        reject: 'delivery-app.offerRequest.detail.reject',
        vehicleType: 'delivery-app.offerRequest.detail.vehicleType',
        transitPeriod: 'delivery-app.offerRequest.detail.transitPeriod',
        licensePlate: 'delivery-app.offerRequest.detail.licensePlate',
        driverName: 'delivery-app.offerRequest.detail.driverName',
        contactPhone: 'delivery-app.offerRequest.detail.contactPhone',
        sendAt: 'delivery-app.offerRequest.detail.sendAt',
        customerOfferStatus: 'delivery-app.offerRequest.detail.customerOfferStatus',
        customerOfferStatuses: {
          no_offer: 'delivery-app.offerRequest.detail.customerOfferStatuses.no_offer',
          offer_received: 'delivery-app.offerRequest.detail.customerOfferStatuses.offer_received',
          offer_accepted: 'delivery-app.offerRequest.detail.customerOfferStatuses.offer_accepted',
        },
        offerRequestStatus: {
          sent: 'delivery-app.offerRequest.detail.offerRequestStatus.sent',
          offers_received: 'delivery-app.offerRequest.detail.offerRequestStatus.offers_received',
          offer_accepted: 'delivery-app.offerRequest.detail.offerRequestStatus.offer_accepted',
          completed: 'delivery-app.offerRequest.detail.offerRequestStatus.completed',
          cancelled: 'delivery-app.offerRequest.detail.offerRequestStatus.cancelled',
        },
      },
      error: {
        NullPointerException: 'delivery-app.offerRequest.error.NullPointerException',
        requireddeadline: 'delivery-app.offerRequest.error.requireddeadline',
        selectedDateAfterCurrentDate: 'delivery-app.offerRequest.error.selectedDateAfterCurrentDate',
        requiredPieces: 'delivery-app.offerRequest.error.requiredPieces',
        requiredHeight: 'delivery-app.offerRequest.error.requiredHeight',
        requiredWidth: 'delivery-app.offerRequest.error.requiredWidth',
        requiredLength: 'delivery-app.offerRequest.error.requiredLength',
        requiredWeight: 'delivery-app.offerRequest.error.requiredWeight',
        heightRequired: 'delivery-app.offerRequest.error.heightRequired',
        weightRequired: 'delivery-app.offerRequest.error.weightRequired',
        widthRequired: 'delivery-app.offerRequest.error.widthRequired',
        lengthRequired: 'delivery-app.offerRequest.error.lengthRequired',
        piecesRequired: 'delivery-app.offerRequest.error.piecesRequired',
        requiredaddress: 'delivery-app.offerRequest.error.requiredaddress',
        requiredCustomerVO: 'delivery-app.offerRequest.error.requiredCustomerVO',
        isEmptyvendors: 'delivery-app.offerRequest.error.isEmptyvendors',
        isEmptypackage: 'delivery-app.offerRequest.error.isEmptypackage',
        packageLimitExceeded: 'delivery-app.offerRequest.error.packageLimitExceeded',
        minLength: 'delivery-app.offerRequest.error.minLength',
        minWeight: 'delivery-app.offerRequest.error.minWeight',
        greaterThanWeight: 'delivery-app.offerRequest.error.greaterThanWeight',
        minPieces: 'delivery-app.offerRequest.error.minPieces',
        maxPieces: 'delivery-app.offerRequest.error.maxPieces',
        minWidth: 'delivery-app.offerRequest.error.minWidth',
        minHeight: 'delivery-app.offerRequest.error.minHeight',
        arrayItemsFieldhasContactsNotEqualTo: 'delivery-app.offerRequest.error.arrayItemsFieldhasContactsNotEqualTo',
      },
      unavailableOfferRequest: 'delivery-app.offerRequest.unavailableOfferRequest',
    },
    routingSolution: {
      cost: 'delivery-app.routingSolution.cost',
      vehicleType: 'delivery-app.routingSolution.vehicleType',
      transitDays: 'delivery-app.routingSolution.transitDays',
      currency: 'delivery-app.routingSolution.currency',
      details: 'delivery-app.routingSolution.details',
      expired: 'delivery-app.routingSolution.expired',
      minTimeAvailability: 'delivery-app.routingSolution.minTimeAvailability',
      error: {
        requiredpackageGroupUuid: 'delivery-app.routingSolution.error.requiredpackageGroupUuid',
        requiredrouteUuid: 'delivery-app.routingSolution.error.requiredrouteUuid',
        requiredcost: 'delivery-app.routingSolution.error.requiredcost',
        requiredcurrency: 'delivery-app.routingSolution.error.requiredcurrency',
      },
      segmentSuggestionMessage: 'delivery-app.routingSolution.segmentSuggestionMessage',
    },
    customer: {
      title: 'delivery-app.customer.title',
      order: {
        listTitle: 'delivery-app.customer.order.listTitle',
      },
      list: {
        title: 'delivery-app.customer.list.title',
        name: 'delivery-app.customer.list.name',
        uniqueIdentificationNumber: 'delivery-app.customer.list.uniqueIdentificationNumber',
        country: 'delivery-app.customer.list.country',
        mainEmailAddress: 'delivery-app.customer.list.mainEmailAddress',
        mainPhoneNumber: 'delivery-app.customer.list.mainPhoneNumber',
        territoryVo: 'delivery-app.customer.list.territoryVo',
        favourite: 'delivery-app.customer.list.favourite',
        globalAccCode: 'delivery-app.customer.list.globalAccCode',
        globalAccType: 'delivery-app.customer.list.globalAccType',
        walletBalance: 'delivery-app.customer.list.walletBalance',
        walletCurrencyCode: 'delivery-app.customer.list.walletCurrencyCode',
        blockCompany: 'delivery-app.customer.list.blockCompany',
        unblockCompany: 'delivery-app.customer.list.unblockCompany',
      },
      addressList: {
        title: 'delivery-app.customer.addressList.title',
        add: 'delivery-app.customer.addressList.add',
        label: 'delivery-app.customer.addressList.label',
        type: 'delivery-app.customer.addressList.type',
        address: 'delivery-app.customer.addressList.address',
        city: 'delivery-app.customer.addressList.city',
        state: 'delivery-app.customer.addressList.state',
        postalCode: 'delivery-app.customer.addressList.postalCode',
        country: 'delivery-app.customer.addressList.country',
        location: 'delivery-app.customer.addressList.location',
        companyAddress: 'delivery-app.customer.addressList.companyAddress',
      },
      address: {
        addTitle: 'delivery-app.customer.address.addTitle',
        pickup: 'delivery-app.customer.address.pickup',
        delivery: 'delivery-app.customer.address.delivery',
        editTitle: 'delivery-app.customer.address.editTitle',
      },
      detail: {
        title: 'delivery-app.customer.detail.title',
        header: 'delivery-app.customer.detail.header',
        generalInfo: 'delivery-app.customer.detail.generalInfo',
        customerName: 'delivery-app.customer.detail.customerName',
        uniqueIdNumber: 'delivery-app.customer.detail.uniqueIdNumber',
        mainEmail: 'delivery-app.customer.detail.mainEmail',
        mainAddress: 'delivery-app.customer.detail.mainAddress',
        industryType: 'delivery-app.customer.detail.industryType',
        territory: 'delivery-app.customer.detail.territory',
        favouriteCustomer: 'delivery-app.customer.detail.favouriteCustomer',
      },
      contactsWarning: 'delivery-app.customer.contactsWarning',
      searchClient: 'delivery-app.customer.searchClient',
    },
    services: {
      title: 'delivery-app.services.title',
      newService: 'delivery-app.services.newService',
      name: 'delivery-app.services.name',
      description: 'delivery-app.services.description',
      error: {
        requiredserviceName: 'delivery-app.services.error.requiredserviceName',
      },
    },
    currencyValue: {
      currencyCode: 'delivery-app.currencyValue.currencyCode',
      value: 'delivery-app.currencyValue.value',
    },
    complaint: {
      title: 'delivery-app.complaint.title',
      createdAt: 'delivery-app.complaint.createdAt',
      message: 'delivery-app.complaint.message',
      history: 'delivery-app.complaint.history',
      addNew: 'delivery-app.complaint.addNew',
      addToExisting: 'delivery-app.complaint.addToExisting',
      noParentComplaint: 'delivery-app.complaint.noParentComplaint',
      noChildComplaints: 'delivery-app.complaint.noChildComplaints',
      noComplaintHistory: 'delivery-app.complaint.noComplaintHistory',
      initialComplaint: 'delivery-app.complaint.initialComplaint',
      replies: 'delivery-app.complaint.replies',
      chooseFile: 'delivery-app.complaint.chooseFile',
      resolveComplaint: 'delivery-app.complaint.resolveComplaint',
      status: 'delivery-app.complaint.status',
      statuses: {
        created: 'delivery-app.complaint.statuses.created',
        in_progress: 'delivery-app.complaint.statuses.in_progress',
        resolved: 'delivery-app.complaint.statuses.resolved',
      },
      lastReplyBy: 'delivery-app.complaint.lastReplyBy',
      error: {
        requiredMessage: 'delivery-app.complaint.error.requiredMessage',
      },
    },
    employeeAssignment: {
      employee: 'delivery-app.employeeAssignment.employee',
      employeeName: 'delivery-app.employeeAssignment.employeeName',
      employees: 'delivery-app.employeeAssignment.employees',
      territory: 'delivery-app.employeeAssignment.territory',
      territories: 'delivery-app.employeeAssignment.territories',
      title: 'delivery-app.employeeAssignment.title',
      newTerritory: 'delivery-app.employeeAssignment.newTerritory',
      territoryName: 'delivery-app.employeeAssignment.territoryName',
      validFrom: 'delivery-app.employeeAssignment.validFrom',
      validTo: 'delivery-app.employeeAssignment.validTo',
      active: 'delivery-app.employeeAssignment.active',
      pid: 'delivery-app.employeeAssignment.pid',
      employeeAssignment: 'delivery-app.employeeAssignment.employeeAssignment',
      activeStatuses: {
        true: 'delivery-app.employeeAssignment.activeStatuses.true',
        false: 'delivery-app.employeeAssignment.activeStatuses.false',
      },
      markAsMainTooltip: 'delivery-app.employeeAssignment.markAsMainTooltip',
      deleteTooltip: 'delivery-app.employeeAssignment.deleteTooltip',
      error: {
        requiredName: 'delivery-app.employeeAssignment.error.requiredName',
        requiredValidTo: 'delivery-app.employeeAssignment.error.requiredValidTo',
        requiredValidFrom: 'delivery-app.employeeAssignment.error.requiredValidFrom',
      },
    },
    serviceProvider: {
      list: {
        title: 'delivery-app.serviceProvider.list.title',
        name: 'delivery-app.serviceProvider.list.name',
        deliveredInTimePercentage: 'delivery-app.serviceProvider.list.deliveredInTimePercentage',
        averagePricePerKm: 'delivery-app.serviceProvider.list.averagePricePerKm',
        complaintPercentage: 'delivery-app.serviceProvider.list.complaintPercentage',
        countries: 'delivery-app.serviceProvider.list.countries',
        routes: 'delivery-app.serviceProvider.list.routes',
        fleetSize: 'delivery-app.serviceProvider.list.fleetSize',
        vehicleTypes: 'delivery-app.serviceProvider.list.vehicleTypes',
      },
    },
    common: {
      map: 'delivery-app.common.map',
    },
    billingCycle: {
      Per_shipment: 'delivery-app.billingCycle.Per_shipment',
      Weekly: 'delivery-app.billingCycle.Weekly',
      Monthly: 'delivery-app.billingCycle.Monthly',
      Bi_monthly: 'delivery-app.billingCycle.Bi_monthly',
      Manual: 'delivery-app.billingCycle.Manual',
    },
    routes: {
      title: 'delivery-app.routes.title',
      withETAAfter: 'delivery-app.routes.withETAAfter',
      addButtonLabel: 'delivery-app.routes.addButtonLabel',
      common: {
        source: 'delivery-app.routes.common.source',
        destination: 'delivery-app.routes.common.destination',
        addWaypoint: 'delivery-app.routes.common.addWaypoint',
        googleError: 'delivery-app.routes.common.googleError',
        error: {
          isEmptySource: 'delivery-app.routes.common.error.isEmptySource',
          isEmptyDestination: 'delivery-app.routes.common.error.isEmptyDestination',
          isEmptyWaypoint: 'delivery-app.routes.common.error.isEmptyWaypoint',
        },
      },
      filters: {
        origin: 'delivery-app.routes.filters.origin',
        destination: 'delivery-app.routes.filters.destination',
        'vehicle-type': 'delivery-app.routes.filters.vehicle-type',
        'license-plate': 'delivery-app.routes.filters.license-plate',
        'driver-name': 'delivery-app.routes.filters.driver-name',
        'route-type': 'delivery-app.routes.filters.route-type',
      },
      route: {
        'update-title': 'delivery-app.routes.route.update-title',
        'add-title': 'delivery-app.routes.route.add-title',
        'details-title': 'delivery-app.routes.route.details-title',
        'edit-confirmation': 'delivery-app.routes.route.edit-confirmation',
        label: 'delivery-app.routes.route.label',
        etd: 'delivery-app.routes.route.etd',
        eta: 'delivery-app.routes.route.eta',
        vehicle: 'delivery-app.routes.route.vehicle',
        driver: 'delivery-app.routes.route.driver',
        'add-location': 'delivery-app.routes.route.add-location',
        locations: 'delivery-app.routes.route.locations',
        templates: 'delivery-app.routes.route.templates',
        error: {
          waypointsInvalid: 'delivery-app.routes.route.error.waypointsInvalid',
          requiredName: 'delivery-app.routes.route.error.requiredName',
          requiredStart: 'delivery-app.routes.route.error.requiredStart',
          requiredFinish: 'delivery-app.routes.route.error.requiredFinish',
        },
      },
      'route-template': {
        'update-title': 'delivery-app.routes.route-template.update-title',
      },
    },
    location: {
      autocomplete: 'delivery-app.location.autocomplete',
    },
    'shipment-group': {
      'routing-solution': 'delivery-app.shipment-group.routing-solution',
      'routing-solution-title': 'delivery-app.shipment-group.routing-solution-title',
      subcontract: 'delivery-app.shipment-group.subcontract',
      'subcontracting-title': 'delivery-app.shipment-group.subcontracting-title',
      'vehicle-type': 'delivery-app.shipment-group.vehicle-type',
      'driver-name': 'delivery-app.shipment-group.driver-name',
      paymentTimeLimit: 'delivery-app.shipment-group.paymentTimeLimit',
      'license-plate': 'delivery-app.shipment-group.license-plate',
      'transit-time': 'delivery-app.shipment-group.transit-time',
    },
    'shipment-groups-dashboard': {
      title: 'delivery-app.shipment-groups-dashboard.title',
      resolve: 'delivery-app.shipment-groups-dashboard.resolve',
      status: {
        orderStatus: 'delivery-app.shipment-groups-dashboard.status.orderStatus',
        paymentTimeLimit: 'delivery-app.shipment-groups-dashboard.status.paymentTimeLimit',
        sentOrdersNumber: 'delivery-app.shipment-groups-dashboard.status.sentOrdersNumber',
        createdTasksNumber: 'delivery-app.shipment-groups-dashboard.status.createdTasksNumber',
        orderAccepted: 'delivery-app.shipment-groups-dashboard.status.orderAccepted',
        noOrderAccepted: 'delivery-app.shipment-groups-dashboard.status.noOrderAccepted',
        masterRsNumber: 'delivery-app.shipment-groups-dashboard.status.masterRsNumber',
        workInProgress: 'delivery-app.shipment-groups-dashboard.status.workInProgress',
        noWorkInProgress: 'delivery-app.shipment-groups-dashboard.status.noWorkInProgress',
        offerSent: 'delivery-app.shipment-groups-dashboard.status.offerSent',
        noOfferSent: 'delivery-app.shipment-groups-dashboard.status.noOfferSent',
        receivedOffersNumberPerSentOfferRequestsNumber:
          'delivery-app.shipment-groups-dashboard.status.receivedOffersNumberPerSentOfferRequestsNumber',
      },
      dispatcher: 'delivery-app.shipment-groups-dashboard.dispatcher',
      shipments: 'delivery-app.shipment-groups-dashboard.shipments',
      dueTime: 'delivery-app.shipment-groups-dashboard.dueTime',
      filter: 'delivery-app.shipment-groups-dashboard.filter',
      order: 'delivery-app.shipment-groups-dashboard.order',
      customerName: 'delivery-app.shipment-groups-dashboard.customerName',
      pickupCity: 'delivery-app.shipment-groups-dashboard.pickupCity',
      account: 'delivery-app.shipment-groups-dashboard.account',
      'account-input-label': 'delivery-app.shipment-groups-dashboard.account-input-label',
      deliveryCity: 'delivery-app.shipment-groups-dashboard.deliveryCity',
      addOfferRequest: 'delivery-app.shipment-groups-dashboard.addOfferRequest',
      assignedToUser: 'delivery-app.shipment-groups-dashboard.assignedToUser',
      newOfferRequestsNotification: 'delivery-app.shipment-groups-dashboard.newOfferRequestsNotification',
      noRoutingSolution: 'delivery-app.shipment-groups-dashboard.noRoutingSolution',
      routingSolution: 'delivery-app.shipment-groups-dashboard.routingSolution',
      notificationTooltip: 'delivery-app.shipment-groups-dashboard.notificationTooltip',
      expiredGroup: 'delivery-app.shipment-groups-dashboard.expiredGroup',
      activeGroup: 'delivery-app.shipment-groups-dashboard.activeGroup',
      goToOfferRequestDetails: 'delivery-app.shipment-groups-dashboard.goToOfferRequestDetails',
      goToOrderDetails: 'delivery-app.shipment-groups-dashboard.goToOrderDetails',
      tooltips: {
        'shipment-group-solution-tracking':
          'delivery-app.shipment-groups-dashboard.tooltips.shipment-group-solution-tracking',
      },
    },
    'shipment-templates': {
      common: {
        dashboard: {
          subtitle: 'delivery-app.shipment-templates.common.dashboard.subtitle',
          'add-button': 'delivery-app.shipment-templates.common.dashboard.add-button',
          createOffReq: 'delivery-app.shipment-templates.common.dashboard.createOffReq',
          createOffReqTooltip: 'delivery-app.shipment-templates.common.dashboard.createOffReqTooltip',
        },
        chips: {
          placedOnOfferReq: 'delivery-app.shipment-templates.common.chips.placedOnOfferReq',
        },
        'action-menu': {
          newTemplateFromTemplate: 'delivery-app.shipment-templates.common.action-menu.newTemplateFromTemplate',
          newScheduledShipmentFromTemplate:
            'delivery-app.shipment-templates.common.action-menu.newScheduledShipmentFromTemplate',
        },
        'add-shipment-template': {
          title: 'delivery-app.shipment-templates.common.add-shipment-template.title',
        },
        'edit-shipment-template': {
          title: 'delivery-app.shipment-templates.common.edit-shipment-template.title',
        },
      },
      customer: {
        dashboard: {
          title: 'delivery-app.shipment-templates.customer.dashboard.title',
        },
      },
      vendor: {
        dashboard: {
          title: 'delivery-app.shipment-templates.vendor.dashboard.title',
        },
        'add-shipment-template': {
          errors: {
            isEmptyvendors: 'delivery-app.shipment-templates.vendor.add-shipment-template.errors.isEmptyvendors',
          },
        },
      },
      recurrentShipment: 'delivery-app.shipment-templates.recurrentShipment',
      recurrence: 'delivery-app.shipment-templates.recurrence',
      recurrenceEndDate: 'delivery-app.shipment-templates.recurrenceEndDate',
      defaultRecurrenceEndDate: 'delivery-app.shipment-templates.defaultRecurrenceEndDate',
      chooseRecurrence: 'delivery-app.shipment-templates.chooseRecurrence',
      errors: {
        requiredCronExpression: 'delivery-app.shipment-templates.errors.requiredCronExpression',
      },
    },
    'scheduled-shipments': {
      title: 'delivery-app.scheduled-shipments.title',
      createOfferRequest: 'delivery-app.scheduled-shipments.createOfferRequest',
      createOfferRequestTooltip: 'delivery-app.scheduled-shipments.createOfferRequestTooltip',
      'add-scheduled-shipment': 'delivery-app.scheduled-shipments.add-scheduled-shipment',
      add: 'delivery-app.scheduled-shipments.add',
    },
    util: {
      save: 'delivery-app.util.save',
      defaultError: 'delivery-app.util.defaultError',
      showDetails: 'delivery-app.util.showDetails',
      isEmailAuthTooltipMessage: 'delivery-app.util.isEmailAuthTooltipMessage',
    },
    'shipment-tracking': {
      title: 'delivery-app.shipment-tracking.title',
      filter: 'delivery-app.shipment-tracking.filter',
      costCenter: 'delivery-app.shipment-tracking.costCenter',
      deliveryDate: 'delivery-app.shipment-tracking.deliveryDate',
      pickupDate: 'delivery-app.shipment-tracking.pickupDate',
      deliveryCity: 'delivery-app.shipment-tracking.deliveryCity',
      pickupCity: 'delivery-app.shipment-tracking.pickupCity',
      deliveryCompany: 'delivery-app.shipment-tracking.deliveryCompany',
      pickupCompany: 'delivery-app.shipment-tracking.pickupCompany',
      documentNumber: 'delivery-app.shipment-tracking.documentNumber',
      shipmentSeries: 'delivery-app.shipment-tracking.shipmentSeries',
      setAsFavorite: 'delivery-app.shipment-tracking.setAsFavorite',
      removeFavorite: 'delivery-app.shipment-tracking.removeFavorite',
      externalReference: 'delivery-app.shipment-tracking.externalReference',
      timelineView: 'delivery-app.shipment-tracking.timelineView',
      listView: 'delivery-app.shipment-tracking.listView',
      packageId: 'delivery-app.shipment-tracking.packageId',
      status: 'delivery-app.shipment-tracking.status',
      noPackages: 'delivery-app.shipment-tracking.noPackages',
    },
    'shipment-split': {
      title: 'delivery-app.shipment-split.title',
      yes: 'delivery-app.shipment-split.yes',
      no: 'delivery-app.shipment-split.no',
      'shipments-actions': {
        split: 'delivery-app.shipment-split.shipments-actions.split',
        'assign-to-new-shipment': 'delivery-app.shipment-split.shipments-actions.assign-to-new-shipment',
      },
      activeSegment: 'delivery-app.shipment-split.activeSegment',
      selectedSegment: 'delivery-app.shipment-split.selectedSegment',
      shipments: 'delivery-app.shipment-split.shipments',
      emptySegment: 'delivery-app.shipment-split.emptySegment',
      choseSaveMode: 'delivery-app.shipment-split.choseSaveMode',
      missingRouteSelection: 'delivery-app.shipment-split.missingRouteSelection',
      saveWithUpdatedSegment: 'delivery-app.shipment-split.saveWithUpdatedSegment',
      updateSegment: 'delivery-app.shipment-split.updateSegment',
      'replace-segment': 'delivery-app.shipment-split.replace-segment',
      'resolve-choice': {
        title: 'delivery-app.shipment-split.resolve-choice.title',
        subcontractingTitle: 'delivery-app.shipment-split.resolve-choice.subcontractingTitle',
        splitTitle: 'delivery-app.shipment-split.resolve-choice.splitTitle',
        subcontractingDescription: 'delivery-app.shipment-split.resolve-choice.subcontractingDescription',
        splitDescription: 'delivery-app.shipment-split.resolve-choice.splitDescription',
      },
      confirmation: 'delivery-app.shipment-split.confirmation',
      solutions: 'delivery-app.shipment-split.solutions',
      'are-you-sure-delete': 'delivery-app.shipment-split.are-you-sure-delete',
      'select-route': 'delivery-app.shipment-split.select-route',
      'delete-segment': 'delivery-app.shipment-split.delete-segment',
      'no-shipment-info': 'delivery-app.shipment-split.no-shipment-info',
      'add-segment': 'delivery-app.shipment-split.add-segment',
      'create-new-route': 'delivery-app.shipment-split.create-new-route',
      'select-existing-root-segment': 'delivery-app.shipment-split.select-existing-root-segment',
      'no-segment-error': 'delivery-app.shipment-split.no-segment-error',
      'select-existing-route': 'delivery-app.shipment-split.select-existing-route',
      'create-route-inline': 'delivery-app.shipment-split.create-route-inline',
      'routes-list-title': 'delivery-app.shipment-split.routes-list-title',
      clearSolutionTooltip: 'delivery-app.shipment-split.clearSolutionTooltip',
      unsavedChanges: 'delivery-app.shipment-split.unsavedChanges',
      sort: 'delivery-app.shipment-split.sort',
      nextButtonHasChangesTooltip: 'delivery-app.shipment-split.nextButtonHasChangesTooltip',
      nextButtonSolutionNotCompleteTooltip: 'delivery-app.shipment-split.nextButtonSolutionNotCompleteTooltip',
      unsavedChangesWarning: 'delivery-app.shipment-split.unsavedChangesWarning',
      success: 'delivery-app.shipment-split.success',
      saveSuccessMessage: 'delivery-app.shipment-split.saveSuccessMessage',
      allSegmentsMustHaveAtLeastOneShipmentMessage:
        'delivery-app.shipment-split.allSegmentsMustHaveAtLeastOneShipmentMessage',
      errorSummary: 'delivery-app.shipment-split.errorSummary',
      childPackagesMismatch: 'delivery-app.shipment-split.childPackagesMismatch',
      pickup: 'delivery-app.shipment-split.pickup',
      delivery: 'delivery-app.shipment-split.delivery',
      pickupAndDeliveryTitle: 'delivery-app.shipment-split.pickupAndDeliveryTitle',
      packagesTitle: 'delivery-app.shipment-split.packagesTitle',
      errorSuccessMessage: 'delivery-app.shipment-split.errorSuccessMessage',
      'more-waypoints': 'delivery-app.shipment-split.more-waypoints',
      'routes-filter-form': {
        origin: 'delivery-app.shipment-split.routes-filter-form.origin',
        destination: 'delivery-app.shipment-split.routes-filter-form.destination',
        'vehicle-type': 'delivery-app.shipment-split.routes-filter-form.vehicle-type',
        'license-plate': 'delivery-app.shipment-split.routes-filter-form.license-plate',
        'vendor-name': 'delivery-app.shipment-split.routes-filter-form.vendor-name',
        'route-type': 'delivery-app.shipment-split.routes-filter-form.route-type',
      },
      routes: {
        'route-types': {
          route: 'delivery-app.shipment-split.routes.route-types.route',
          route_template: 'delivery-app.shipment-split.routes.route-types.route_template',
          vendor_route: 'delivery-app.shipment-split.routes.route-types.vendor_route',
        },
        tooltip: {
          'create-from-template': 'delivery-app.shipment-split.routes.tooltip.create-from-template',
          details: 'delivery-app.shipment-split.routes.tooltip.details',
          'show-on-map': 'delivery-app.shipment-split.routes.tooltip.show-on-map',
        },
      },
      'split-wizard': {
        packages: 'delivery-app.shipment-split.split-wizard.packages',
        packagesDisabledTooltip: 'delivery-app.shipment-split.split-wizard.packagesDisabledTooltip',
        enablePackagesGrouping: 'delivery-app.shipment-split.split-wizard.enablePackagesGrouping',
        disablePackagesGrouping: 'delivery-app.shipment-split.split-wizard.disablePackagesGrouping',
        locations: 'delivery-app.shipment-split.split-wizard.locations',
        splitMethodTitle: 'delivery-app.shipment-split.split-wizard.splitMethodTitle',
        splitConditionTitle: 'delivery-app.shipment-split.split-wizard.splitConditionTitle',
        packagesSplitTitle: 'delivery-app.shipment-split.split-wizard.packagesSplitTitle',
        locationSplitTitle: 'delivery-app.shipment-split.split-wizard.locationSplitTitle',
        'next-step': 'delivery-app.shipment-split.split-wizard.next-step',
        firstCardFooter: 'delivery-app.shipment-split.split-wizard.firstCardFooter',
        secondCardFooter: 'delivery-app.shipment-split.split-wizard.secondCardFooter',
        addPoint: 'delivery-app.shipment-split.split-wizard.addPoint',
      },
      'route-load': {
        title: 'delivery-app.shipment-split.route-load.title',
        volume: 'delivery-app.shipment-split.route-load.volume',
        weight: 'delivery-app.shipment-split.route-load.weight',
        nrPcs: 'delivery-app.shipment-split.route-load.nrPcs',
        empty: 'delivery-app.shipment-split.route-load.empty',
      },
      canvas: {
        howToStartPartOne: 'delivery-app.shipment-split.canvas.howToStartPartOne',
        howToStartPartTwo: 'delivery-app.shipment-split.canvas.howToStartPartTwo',
      },
      error: {
        maxValueExceeded: 'delivery-app.shipment-split.error.maxValueExceeded',
        maxDistanceExceeded: 'delivery-app.shipment-split.error.maxDistanceExceeded',
        notPositiveValue: 'delivery-app.shipment-split.error.notPositiveValue',
        requiredPieces: 'delivery-app.shipment-split.error.requiredPieces',
        allPiecesAreZero: 'delivery-app.shipment-split.error.allPiecesAreZero',
        minTotalPieces: 'delivery-app.shipment-split.error.minTotalPieces',
      },
      'segment-popup-form': {
        'owned-route-tab': {
          title: 'delivery-app.shipment-split.segment-popup-form.owned-route-tab.title',
          source: 'delivery-app.shipment-split.segment-popup-form.owned-route-tab.source',
          waypoints: 'delivery-app.shipment-split.segment-popup-form.owned-route-tab.waypoints',
          'add-waypoint': 'delivery-app.shipment-split.segment-popup-form.owned-route-tab.add-waypoint',
          destination: 'delivery-app.shipment-split.segment-popup-form.owned-route-tab.destination',
          vehicleType: 'delivery-app.shipment-split.segment-popup-form.owned-route-tab.vehicleType',
          'map-placeholder': 'delivery-app.shipment-split.segment-popup-form.owned-route-tab.map-placeholder',
          save: 'delivery-app.shipment-split.segment-popup-form.owned-route-tab.save',
          error: {
            isEmptySource: 'delivery-app.shipment-split.segment-popup-form.owned-route-tab.error.isEmptySource',
            isEmptyDestination:
              'delivery-app.shipment-split.segment-popup-form.owned-route-tab.error.isEmptyDestination',
            isEmptyWaypoint: 'delivery-app.shipment-split.segment-popup-form.owned-route-tab.error.isEmptyWaypoint',
          },
        },
        'vendor-route-tab': {
          title: 'delivery-app.shipment-split.segment-popup-form.vendor-route-tab.title',
          vendor: 'delivery-app.shipment-split.segment-popup-form.vendor-route-tab.vendor',
          source: 'delivery-app.shipment-split.segment-popup-form.vendor-route-tab.source',
          destination: 'delivery-app.shipment-split.segment-popup-form.vendor-route-tab.destination',
          save: 'delivery-app.shipment-split.segment-popup-form.vendor-route-tab.save',
          errors: {
            isEmptySource: 'delivery-app.shipment-split.segment-popup-form.vendor-route-tab.errors.isEmptySource',
            isEmptyDestination:
              'delivery-app.shipment-split.segment-popup-form.vendor-route-tab.errors.isEmptyDestination',
          },
        },
      },
      route: {
        'show-on-map': 'delivery-app.shipment-split.route.show-on-map',
      },
      'show-on-map': 'delivery-app.shipment-split.show-on-map',
      packages: 'delivery-app.shipment-split.packages',
      'choose-split-type': 'delivery-app.shipment-split.choose-split-type',
      'choose-pickup-address': 'delivery-app.shipment-split.choose-pickup-address',
      'choose-delivery-address': 'delivery-app.shipment-split.choose-delivery-address',
      'choose-package-number': 'delivery-app.shipment-split.choose-package-number',
      save: 'delivery-app.shipment-split.save',
      'shipment-group-solution-tracking': {
        title: 'delivery-app.shipment-split.shipment-group-solution-tracking.title',
        delayed: 'delivery-app.shipment-split.shipment-group-solution-tracking.delayed',
        'empty-tracking': 'delivery-app.shipment-split.shipment-group-solution-tracking.empty-tracking',
      },
      'shipment-group-solutions': {
        title: 'delivery-app.shipment-split.shipment-group-solutions.title',
        'segments-title': 'delivery-app.shipment-split.shipment-group-solutions.segments-title',
        'order-create': 'delivery-app.shipment-split.shipment-group-solutions.order-create',
        'pre-order-create': 'delivery-app.shipment-split.shipment-group-solutions.pre-order-create',
        'pre-offer-request-create': 'delivery-app.shipment-split.shipment-group-solutions.pre-offer-request-create',
        'summaries-panel': {
          title: 'delivery-app.shipment-split.shipment-group-solutions.summaries-panel.title',
          seeAll: 'delivery-app.shipment-split.shipment-group-solutions.summaries-panel.seeAll',
          routingSolutions: 'delivery-app.shipment-split.shipment-group-solutions.summaries-panel.routingSolutions',
          offerRequests: 'delivery-app.shipment-split.shipment-group-solutions.summaries-panel.offerRequests',
          offers: 'delivery-app.shipment-split.shipment-group-solutions.summaries-panel.offers',
        },
        defaultForSubco: 'delivery-app.shipment-split.shipment-group-solutions.defaultForSubco',
        lockedInSolution: 'delivery-app.shipment-split.shipment-group-solutions.lockedInSolution',
        inProgressSolution: 'delivery-app.shipment-split.shipment-group-solutions.inProgressSolution',
        createdAt: 'delivery-app.shipment-split.shipment-group-solutions.createdAt',
        sellAllSolutions: 'delivery-app.shipment-split.shipment-group-solutions.sellAllSolutions',
        'master-routing-solutions': {
          title: 'delivery-app.shipment-split.shipment-group-solutions.master-routing-solutions.title',
          'additional-info':
            'delivery-app.shipment-split.shipment-group-solutions.master-routing-solutions.additional-info',
          'create-solution':
            'delivery-app.shipment-split.shipment-group-solutions.master-routing-solutions.create-solution',
          'save-solution':
            'delivery-app.shipment-split.shipment-group-solutions.master-routing-solutions.save-solution',
          'cancel-solution':
            'delivery-app.shipment-split.shipment-group-solutions.master-routing-solutions.cancel-solution',
          'unselected-routing-solution':
            'delivery-app.shipment-split.shipment-group-solutions.master-routing-solutions.unselected-routing-solution',
          'context-menu': {
            preferred:
              'delivery-app.shipment-split.shipment-group-solutions.master-routing-solutions.context-menu.preferred',
            'complete-offer':
              'delivery-app.shipment-split.shipment-group-solutions.master-routing-solutions.context-menu.complete-offer',
            'set-preferred':
              'delivery-app.shipment-split.shipment-group-solutions.master-routing-solutions.context-menu.set-preferred',
          },
          'confirmation-dialog': {
            dialogHeader:
              'delivery-app.shipment-split.shipment-group-solutions.master-routing-solutions.confirmation-dialog.dialogHeader',
            dialogMessage:
              'delivery-app.shipment-split.shipment-group-solutions.master-routing-solutions.confirmation-dialog.dialogMessage',
            acceptLabel:
              'delivery-app.shipment-split.shipment-group-solutions.master-routing-solutions.confirmation-dialog.acceptLabel',
            cancelLabel:
              'delivery-app.shipment-split.shipment-group-solutions.master-routing-solutions.confirmation-dialog.cancelLabel',
          },
        },
        'routing-solution': {
          title: 'delivery-app.shipment-split.shipment-group-solutions.routing-solution.title',
          rsTitle: 'delivery-app.shipment-split.shipment-group-solutions.routing-solution.rsTitle',
          offerTitle: 'delivery-app.shipment-split.shipment-group-solutions.routing-solution.offerTitle',
          'list-title': 'delivery-app.shipment-split.shipment-group-solutions.routing-solution.list-title',
          'disabled-selection':
            'delivery-app.shipment-split.shipment-group-solutions.routing-solution.disabled-selection',
          'empty-list': 'delivery-app.shipment-split.shipment-group-solutions.routing-solution.empty-list',
          'empty-create': 'delivery-app.shipment-split.shipment-group-solutions.routing-solution.empty-create',
          details: 'delivery-app.shipment-split.shipment-group-solutions.routing-solution.details',
          expired: 'delivery-app.shipment-split.shipment-group-solutions.routing-solution.expired',
          'offer-expired': 'delivery-app.shipment-split.shipment-group-solutions.routing-solution.offer-expired',
          'rs-expired': 'delivery-app.shipment-split.shipment-group-solutions.routing-solution.rs-expired',
          'solution-created-message':
            'delivery-app.shipment-split.shipment-group-solutions.routing-solution.solution-created-message',
          'offer-request-message':
            'delivery-app.shipment-split.shipment-group-solutions.routing-solution.offer-request-message',
          'create-solution-message':
            'delivery-app.shipment-split.shipment-group-solutions.routing-solution.create-solution-message',
          'create-vendor-solution-message':
            'delivery-app.shipment-split.shipment-group-solutions.routing-solution.create-vendor-solution-message',
          'more-details': 'delivery-app.shipment-split.shipment-group-solutions.routing-solution.more-details',
        },
        offer: {
          title: 'delivery-app.shipment-split.shipment-group-solutions.offer.title',
          'list-title': 'delivery-app.shipment-split.shipment-group-solutions.offer.list-title',
          'empty-list': 'delivery-app.shipment-split.shipment-group-solutions.offer.empty-list',
          'empty-create': 'delivery-app.shipment-split.shipment-group-solutions.offer.empty-create',
          negotiate: 'delivery-app.shipment-split.shipment-group-solutions.offer.negotiate',
          expired: 'delivery-app.shipment-split.shipment-group-solutions.offer.expired',
          'create-routing-solution':
            'delivery-app.shipment-split.shipment-group-solutions.offer.create-routing-solution',
        },
        driver: 'delivery-app.shipment-split.shipment-group-solutions.driver',
        vehicle: 'delivery-app.shipment-split.shipment-group-solutions.vehicle',
        'transit-time': 'delivery-app.shipment-split.shipment-group-solutions.transit-time',
        'available-until': 'delivery-app.shipment-split.shipment-group-solutions.available-until',
        tooltips: {
          'add-task': 'delivery-app.shipment-split.shipment-group-solutions.tooltips.add-task',
          'task-details': 'delivery-app.shipment-split.shipment-group-solutions.tooltips.task-details',
          'order-details': 'delivery-app.shipment-split.shipment-group-solutions.tooltips.order-details',
          'accept-offer-and-create-order':
            'delivery-app.shipment-split.shipment-group-solutions.tooltips.accept-offer-and-create-order',
          'not-preferred': 'delivery-app.shipment-split.shipment-group-solutions.tooltips.not-preferred',
          disabled: 'delivery-app.shipment-split.shipment-group-solutions.tooltips.disabled',
        },
        dialog: {
          'create-order': 'delivery-app.shipment-split.shipment-group-solutions.dialog.create-order',
          'order-details': 'delivery-app.shipment-split.shipment-group-solutions.dialog.order-details',
        },
        'graphic-legend': {
          primary: 'delivery-app.shipment-split.shipment-group-solutions.graphic-legend.primary',
          warn: 'delivery-app.shipment-split.shipment-group-solutions.graphic-legend.warn',
        },
      },
      'shipment-segment-solution': {
        title: 'delivery-app.shipment-split.shipment-segment-solution.title',
        back: 'delivery-app.shipment-split.shipment-segment-solution.back',
        'selection-dialog-title': 'delivery-app.shipment-split.shipment-segment-solution.selection-dialog-title',
        'create-solution': 'delivery-app.shipment-split.shipment-segment-solution.create-solution',
        'create-offer-request': 'delivery-app.shipment-split.shipment-segment-solution.create-offer-request',
        'offer-requests': 'delivery-app.shipment-split.shipment-segment-solution.offer-requests',
        'offer-request': {
          deadline: 'delivery-app.shipment-split.shipment-segment-solution.offer-request.deadline',
          status: 'delivery-app.shipment-split.shipment-segment-solution.offer-request.status',
          details: 'delivery-app.shipment-split.shipment-segment-solution.offer-request.details',
          'empty-list': 'delivery-app.shipment-split.shipment-segment-solution.offer-request.empty-list',
        },
      },
      'segment-definition': {
        title: 'delivery-app.shipment-split.segment-definition.title',
        info: 'delivery-app.shipment-split.segment-definition.info',
        selected: 'delivery-app.shipment-split.segment-definition.selected',
        'not-selected': 'delivery-app.shipment-split.segment-definition.not-selected',
        waypointError: 'delivery-app.shipment-split.segment-definition.waypointError',
      },
      pickupIsFarAway: 'delivery-app.shipment-split.pickupIsFarAway',
      deliveryIsFarAway: 'delivery-app.shipment-split.deliveryIsFarAway',
      shipmentSplitRequired: 'delivery-app.shipment-split.shipmentSplitRequired',
      splitAndDispatch: 'delivery-app.shipment-split.splitAndDispatch',
      dispatchOriginal: 'delivery-app.shipment-split.dispatchOriginal',
      pickupSplitRequired: 'delivery-app.shipment-split.pickupSplitRequired',
      deliverySplitRequired: 'delivery-app.shipment-split.deliverySplitRequired',
      bothSplitRequired: 'delivery-app.shipment-split.bothSplitRequired',
      makeChanges: 'delivery-app.shipment-split.makeChanges',
      continue: 'delivery-app.shipment-split.continue',
    },
    'ship-transaction-terms-and-cond': {
      accept: 'delivery-app.ship-transaction-terms-and-cond.accept',
      reject: 'delivery-app.ship-transaction-terms-and-cond.reject',
      currentStatus: 'delivery-app.ship-transaction-terms-and-cond.currentStatus',
      statuses: {
        accepted: 'delivery-app.ship-transaction-terms-and-cond.statuses.accepted',
        rejected: 'delivery-app.ship-transaction-terms-and-cond.statuses.rejected',
      },
      accepted: 'delivery-app.ship-transaction-terms-and-cond.accepted',
      rejected: 'delivery-app.ship-transaction-terms-and-cond.rejected',
      comments: 'delivery-app.ship-transaction-terms-and-cond.comments',
    },
    'routing-solution': {
      licensePlate: 'delivery-app.routing-solution.licensePlate',
      driverName: 'delivery-app.routing-solution.driverName',
      vehicleType: 'delivery-app.routing-solution.vehicleType',
    },
    'delivery-inbox': {
      isNew: 'delivery-app.delivery-inbox.isNew',
      statusChange: 'delivery-app.delivery-inbox.statusChange',
      assigmentChange: 'delivery-app.delivery-inbox.assigmentChange',
      phaseChange: 'delivery-app.delivery-inbox.phaseChange',
    },
    title: 'delivery-app.title',
    localTimezoneInfoMessage: 'delivery-app.localTimezoneInfoMessage',
  },
  'saft-app': {
    downloadFile: 'saft-app.downloadFile',
    d406Declaration: 'saft-app.d406Declaration',
    cnpValidation: 'saft-app.cnpValidation',
    cnpValidationUpload: 'saft-app.cnpValidationUpload',
    cnpFileWarn: 'saft-app.cnpFileWarn',
    title: 'saft-app.title',
    accountingNote: 'saft-app.accountingNote',
    uploadFile: 'saft-app.uploadFile',
    segmentNumber: 'saft-app.segmentNumber',
    filesWarn: 'saft-app.filesWarn',
    noRecentFiles: 'saft-app.noRecentFiles',
  },
  generalErrors: {
    isNotServiceProvider: 'generalErrors.isNotServiceProvider',
  },
  sharedComponents: {
    dateRange: {
      start: 'sharedComponents.dateRange.start',
      end: 'sharedComponents.dateRange.end',
    },
    dateTimeRange: {
      start: 'sharedComponents.dateTimeRange.start',
      end: 'sharedComponents.dateTimeRange.end',
    },
    'language-dialog': {
      'select-language': 'sharedComponents.language-dialog.select-language',
      language: 'sharedComponents.language-dialog.language',
    },
    errors: {
      minLengthWaypoints: 'sharedComponents.errors.minLengthWaypoints',
    },
    search: 'sharedComponents.search',
    timeInterval: {
      startTime: 'sharedComponents.timeInterval.startTime',
      endTime: 'sharedComponents.timeInterval.endTime',
    },
    numberInterval: {
      startNumber: 'sharedComponents.numberInterval.startNumber',
      endNumber: 'sharedComponents.numberInterval.endNumber',
    },
    attachments: {
      confirmDeletionMessage: 'sharedComponents.attachments.confirmDeletionMessage',
      confirmationHeader: 'sharedComponents.attachments.confirmationHeader',
      confirmed: 'sharedComponents.attachments.confirmed',
      fileRemoved: 'sharedComponents.attachments.fileRemoved',
      invalidFileSizeMessageSummary: 'sharedComponents.attachments.invalidFileSizeMessageSummary',
      invalidFileSizeMessageDetail: 'sharedComponents.attachments.invalidFileSizeMessageDetail',
      invalidTotalFileSizeMessageSummary: 'sharedComponents.attachments.invalidTotalFileSizeMessageSummary',
      invalidTotalFileSizeMessageDetail: 'sharedComponents.attachments.invalidTotalFileSizeMessageDetail',
    },
  },
  timeUnit: {
    SECOND: 'timeUnit.SECOND',
    MINUTE: 'timeUnit.MINUTE',
    HOUR: 'timeUnit.HOUR',
    DAY: 'timeUnit.DAY',
    WEEK: 'timeUnit.WEEK',
  },
  greeting: 'greeting',
  'notification-ui': {
    title: 'notification-ui.title',
    delete: 'notification-ui.delete',
  },
  'not-found': {
    errorMessage: 'not-found.errorMessage',
    title: 'not-found.title',
    message: 'not-found.message',
    back: 'not-found.back',
  },
  'shell-app': {
    termsAndConditions: {
      title: 'shell-app.termsAndConditions.title',
      accept: 'shell-app.termsAndConditions.accept',
      accepted: 'shell-app.termsAndConditions.accepted',
      validFrom: 'shell-app.termsAndConditions.validFrom',
      needLogin: 'shell-app.termsAndConditions.needLogin',
      acceptedMessage: 'shell-app.termsAndConditions.acceptedMessage',
      retryLater: 'shell-app.termsAndConditions.retryLater',
      error: {
        defaultValidationMessage: 'shell-app.termsAndConditions.error.defaultValidationMessage',
        user_agreement_exists: 'shell-app.termsAndConditions.error.user_agreement_exists',
        email_agreement_exists: 'shell-app.termsAndConditions.error.email_agreement_exists',
      },
    },
    companyValidation: {
      title: 'shell-app.companyValidation.title',
      validateCompanyDetails: 'shell-app.companyValidation.validateCompanyDetails',
      enableCompanyValidation: 'shell-app.companyValidation.enableCompanyValidation',
      validatedMessage: 'shell-app.companyValidation.validatedMessage',
    },
    navigationMenu: {
      crm: 'shell-app.navigationMenu.crm',
      delivery: 'shell-app.navigationMenu.delivery',
      myCompany: 'shell-app.navigationMenu.myCompany',
      allCompanies: 'shell-app.navigationMenu.allCompanies',
      selectItems: 'shell-app.navigationMenu.selectItems',
      logout: 'shell-app.navigationMenu.logout',
      saftLabel: 'shell-app.navigationMenu.saftLabel',
    },
    dashboard: {
      crm: 'shell-app.dashboard.crm',
      delivery: 'shell-app.dashboard.delivery',
      companyAdministration: 'shell-app.dashboard.companyAdministration',
      saft: 'shell-app.dashboard.saft',
    },
  },
  notification: {
    DELIVERY_OFFER_REQUEST_CREATED_FOR_EXTERNAL_VENDOR:
      'notification.DELIVERY_OFFER_REQUEST_CREATED_FOR_EXTERNAL_VENDOR',
    DELIVERY_ORDER_STATUS_CHANGED_FOR_CUSTOMER: 'notification.DELIVERY_ORDER_STATUS_CHANGED_FOR_CUSTOMER',
    DELIVERY_ORDER_SENT: 'notification.DELIVERY_ORDER_SENT',
    DELIVERY_ORDER_RECEIVED: 'notification.DELIVERY_ORDER_RECEIVED',
    DELIVERY_ORDER_CANCEL: 'notification.DELIVERY_ORDER_CANCEL',
    DELIVERY_ORDER_CANCEL_REQUEST: 'notification.DELIVERY_ORDER_CANCEL_REQUEST',
    DELIVERY_ORDER_CANCEL_REQUEST_REJECTED: 'notification.DELIVERY_ORDER_CANCEL_REQUEST_REJECTED',
    DELIVERY_ORDER_HANDOVER_SP_ALERT_MAIL: 'notification.DELIVERY_ORDER_HANDOVER_SP_ALERT_MAIL',
    DELIVERY_ORDER_HANDOVER_ALERT_MAIL: 'notification.DELIVERY_ORDER_HANDOVER_ALERT_MAIL',
    DELIVERY_OFFER_REFUSED_FOR_VENDOR_MAIL: 'notification.DELIVERY_OFFER_REFUSED_FOR_VENDOR_MAIL',
    DELIVERY_OFFER_NEGOTIATION_MAIL: 'notification.DELIVERY_OFFER_NEGOTIATION_MAIL',
    DELIVERY_OFFER_CREATED_FOR_EXTERNAL_CUSTOMER: 'notification.DELIVERY_OFFER_CREATED_FOR_EXTERNAL_CUSTOMER',
    AUTH_USER_EMAIL_CONFIRMATION: 'notification.AUTH_USER_EMAIL_CONFIRMATION',
    AUTH_USER_PASSWORD_RECOVERY: 'notification.AUTH_USER_PASSWORD_RECOVERY',
    AUTH_SUPER_ADMIN_USER_EMAIL_CONFIRMATION: 'notification.AUTH_SUPER_ADMIN_USER_EMAIL_CONFIRMATION',
    COMPANY_TERMS_AND_CONDITIONS_AGREEMENT_EMAIL: 'notification.COMPANY_TERMS_AND_CONDITIONS_AGREEMENT_EMAIL',
    COMPANY_DETAILS_EMAIL: 'notification.COMPANY_DETAILS_EMAIL',
  },
  'http-error-interceptor': {
    ETransportNotificationInvalidStateException: 'http-error-interceptor.ETransportNotificationInvalidStateException',
    GENERAL: 'http-error-interceptor.GENERAL',
    CostCenterDuplicateLabelException: 'http-error-interceptor.CostCenterDuplicateLabelException',
    EmployeeUserPhoneNotFoundException: 'http-error-interceptor.EmployeeUserPhoneNotFoundException',
    InvalidOrderStatusTransitionException: 'http-error-interceptor.InvalidOrderStatusTransitionException',
    MissingAppropriateAddressException: 'http-error-interceptor.MissingAppropriateAddressException',
    sent: 'http-error-interceptor.sent',
    in_progress: 'http-error-interceptor.in_progress',
    in_transit: 'http-error-interceptor.in_transit',
    completed: 'http-error-interceptor.completed',
    cancelled: 'http-error-interceptor.cancelled',
    documents_received: 'http-error-interceptor.documents_received',
    archived: 'http-error-interceptor.archived',
    SingleCompanyContactsSelectedException: 'http-error-interceptor.SingleCompanyContactsSelectedException',
    OperationalTerritoryPartnerNamedLocationDuplicateException:
      'http-error-interceptor.OperationalTerritoryPartnerNamedLocationDuplicateException',
  },
  'system-administration': {
    utils: {
      save: 'system-administration.utils.save',
      cancel: 'system-administration.utils.cancel',
    },
    error: {
      defaultError: 'system-administration.error.defaultError',
    },
    menu: {
      jobSystem: 'system-administration.menu.jobSystem',
      jobDefinition: 'system-administration.menu.jobDefinition',
      jobExecution: 'system-administration.menu.jobExecution',
      jobLogs: 'system-administration.menu.jobLogs',
      integration: 'system-administration.menu.integration',
      integrationDefinitions: 'system-administration.menu.integrationDefinitions',
      integrationExecutions: 'system-administration.menu.integrationExecutions',
      exceptions: 'system-administration.menu.exceptions',
      pdfTemplates: 'system-administration.menu.pdfTemplates',
      reports: 'system-administration.menu.reports',
      reportTemplates: 'system-administration.menu.reportTemplates',
      dashboard: 'system-administration.menu.dashboard',
      dashboardDefinitions: 'system-administration.menu.dashboarDefinitions',
    },
  },
  'delivery-inbox': {
    title: 'delivery-inbox.title',
    filter: 'delivery-inbox.filter',
    documentNumber: 'delivery-inbox.documentNumber',
    shipmentSeries: 'delivery-inbox.shipmentSeries',
    customerName: 'delivery-inbox.customerName',
    employeeName: 'delivery-inbox.employeeName',
    pickupCity: 'delivery-inbox.pickupCity',
    deliveryCity: 'delivery-inbox.deliveryCity',
    pickupStart: 'delivery-inbox.pickupStart',
    deliveryEnd: 'delivery-inbox.deliveryEnd',
    accountName: 'delivery-inbox.accountName',
    type: 'delivery-inbox.type',
    urgent: 'delivery-inbox.urgent',
    expiringOffersMessage: 'delivery-inbox.expiringOffersMessage',
    assignedToUser: 'delivery-inbox.assignedToUser',
    'timeline-phase': {
      offer_request: 'delivery-inbox.timeline-phase.offer_request',
      order: 'delivery-inbox.timeline-phase.order',
      transport: 'delivery-inbox.timeline-phase.transport',
      invoice: 'delivery-inbox.timeline-phase.invoice',
      finished: 'delivery-inbox.timeline-phase.finished',
    },
    solve: 'delivery-inbox.solve',
    viewInvoice: 'delivery-inbox.viewInvoice',
    more: {
      refuseOfferRequest: 'delivery-inbox.more.refuseOfferRequest',
      orderCancelRequest: 'delivery-inbox.more.orderCancelRequest',
      orderCancelForced: 'delivery-inbox.more.orderCancelForced',
      orderCancelRequestDisabledTooltip: 'delivery-inbox.more.orderCancelRequestDisabledTooltip',
    },
    phases: {
      'offer-request': 'delivery-inbox.phases.offer-request',
      order: 'delivery-inbox.phases.order',
      transport: 'delivery-inbox.phases.transport',
      invoice: 'delivery-inbox.phases.invoice',
    },
    orderStatus: 'delivery-inbox.orderStatus',
    offerRequestStatus: 'delivery-inbox.offerRequestStatus',
    addOfferRequest: 'delivery-inbox.addOfferRequest',
    bulkActions: {
      title: 'delivery-inbox.bulkActions.title',
      submit: 'delivery-inbox.bulkActions.submit',
      selectedItems: 'delivery-inbox..bulkActions.selectedItems',
      selectAll: 'delivery-inbox..bulkActions.selectAll',
      deselectAll: 'delivery-inbox..bulkActions.deselectAll',
      toggleSelection: {
        order: {
          accept: 'delivery-inbox.bulkActions.toggleSelection.order.accept',
          reject: 'delivery-inbox.bulkActions.toggleSelection.order.reject',
          archive: 'delivery-inbox.bulkActions.toggleSelection.order.archive',
          selectEmployee: 'delivery-inbox.bulkActions.toggleSelection.order.selectEmployee',
        },
      },
      clearSelection: 'delivery-inbox.bulkActions.clearSelection',
    },
    sort: 'delivery-inbox.sort',
    'sort-labels': {
      createdAt: 'delivery-inbox.sort-labels.createdAt',
      deadline: 'delivery-inbox.sort-labels.deadline',
    },
    offerRequestStatusEnum: {
      sent: 'delivery-inbox.offerRequestStatusEnum.sent',
      received: 'delivery-inbox.offerRequestStatusEnum.received',
      offer_accepted: 'delivery-inbox.offerRequestStatusEnum.offer_accepted',
      cancelled: 'delivery-inbox.offerRequestStatusEnum.cancelled',
      in_progress: 'delivery-inbox.offerRequestStatusEnum.in_progress',
      offers_received: 'delivery-inbox.offerRequestStatusEnum.offers_received',
      completed: 'delivery-inbox.offerRequestStatusEnum.completed',
      rejected: 'delivery-inbox.offerRequestStatusEnum.rejected',
      archived: 'delivery-inbox.offerRequestStatusEnum.archived',
    },
    'no-results-found': 'delivery-inbox.no-results-found',
    'try-again': 'delivery-inbox.try-again',
    'choose-account': 'delivery-inbox.choose-account',
    shipments: 'delivery-inbox.shipments',
  },
  contract: {
    sp: {
      title: 'contract.sp.title',
      from: 'contract.sp.from',
      details: 'contract.sp.details',
      comments: 'contract.sp.comments',
      tariffs: 'contract.sp.tariffs',
      exclusive: 'contract.sp.exclusive',
      price: 'contract.sp.price',
      transitTime: 'contract.sp.transitTime',
      transitNamedLocation: 'contract.sp.transitNamedLocation',
      save: 'contract.sp.save',
      cancel: 'contract.sp.cancel',
      account: 'contract.sp.account',
      selectAccount: 'contract.sp.selectAccount',
      dynamicTariffsInfoMessage: 'contract.sp.dynamicTariffsInfoMessage',
      disabledDynamicTariffsInfoMessage: 'contract.sp.disabledDynamicTariffsInfoMessage',
      tooltip: {
        exclusive: 'contract.sp.tooltip.exclusive',
        vehicleType: 'contract.sp.tooltip.vehicleType',
        noticeTime: 'contract.sp.tooltip.noticeTime',
        paymentTimeLimit: 'contract.sp.tooltip.paymentTimeLimit',
        transitTime: 'contract.sp.tooltip.transitTime',
        transitNamedLocation: 'contract.sp.tooltip.transitNamedLocation',
        transitPoint: 'contract.sp.tooltip.transitPoint',
        validFrom: 'contract.sp.tooltip.validFrom',
        validTo: 'contract.sp.tooltip.validTo',
        weight: 'contract.sp.tooltip.weight',
        size: 'contract.sp.tooltip.size',
        pieces: 'contract.sp.tooltip.pieces',
        type: 'contract.sp.tooltip.type',
        tags: 'contract.sp.tooltip.tags',
        label: 'contract.sp.tooltip.label',
        referenceNumber: 'contract.sp.tooltip.referenceNumber',
        customer: 'contract.sp.tooltip.customer',
        serviceProvider: 'contract.sp.tooltip.serviceProvider',
        validity: 'contract.sp.tooltip.validity',
        customerComments: 'contract.sp.tooltip.customerComments',
        operationalTerritory: 'contract.sp.tooltip.operationalTerritory',
        pickupNamedLocation: 'contract.sp.tooltip.pickupNamedLocation',
        deliveryNamedLocation: 'contract.sp.tooltip.deliveryNamedLocation',
        centralNamedLocation: 'contract.sp.tooltip.centralNamedLocation',
      },
      errors: {
        requiredPrice: 'contract.sp.errors.requiredPrice',
        requiredTransitTime: 'contract.sp.errors.requiredTransitTime',
        requiredAccount: 'contract.sp.errors.requiredAccount',
        required: 'contract.sp.errors.required',
      },
      'contract-answer': 'contract.sp.contract-answer',
      'answer-details': 'contract.sp.answer-details',
    },
    customer: {
      'list-title': 'contract.customer.list-title',
      contractRejectTitle: 'contract.customer.contractRejectTitle',
      contractRejectReason: 'contract.customer.contractRejectReason',
      label: 'contract.customer.label',
      serviceProvider: 'contract.customer.serviceProvider',
      'valid-from': 'contract.customer.valid-from',
      'valid-to': 'contract.customer.valid-to',
      status: 'contract.customer.status',
      statuses: {
        PENDING: 'contract.customer.statuses.PENDING',
        ACCEPTED: 'contract.customer.statuses.ACCEPTED',
        CONFIRMATION_PENDING: 'contract.customer.statuses.CONFIRMATION_PENDING',
        REJECTED: 'contract.customer.statuses.REJECTED',
        CANCELED: 'contract.customer.statuses.CANCELED',
        null: 'contract.customer.statuses.null',
      },
      'edit-contract-request': 'contract.customer.edit-contract-request',
      'contract-request-details': 'contract.customer.contract-request-details',
      utils: {
        add: 'contract.customer.utils.add',
      },
    },
    request: {
      waypoint: 'contract.request.waypoint',
      'page-title': 'contract.request.page-title',
      'edit-page-title': 'contract.request.edit-page-title',
      'view-response-title': 'contract.request.view-response-title',
      acceptRequest: 'contract.request.acceptRequest',
      rejectedRequest: 'contract.request.rejectedRequest',
      rejectedReason: 'contract.request.rejectedReason',
      editUnavailable: 'contract.request.editUnavailable',
      fixedPriceContract: 'contract.request.fixedPriceContract',
      useFixedPriceContract: 'contract.request.useFixedPriceContract',
      dynamicPriceContract: 'contract.request.dynamicPriceContract',
      form: {
        serviceProvider: 'contract.request.form.serviceProvider',
        locked: 'contract.request.form.locked',
        carType: 'contract.request.form.carType',
        notice: 'contract.request.form.notice',
        transitTime: 'contract.request.form.transitTime',
        paymentTimeLimit: 'contract.request.form.paymentTimeLimit',
        referenceNumber: 'contract.request.form.referenceNumber',
        validFrom: 'contract.request.form.validFrom',
        validTo: 'contract.request.form.validTo',
        currency: 'contract.request.form.currency',
        description: 'contract.request.form.description',
        height: 'contract.request.form.height',
        width: 'contract.request.form.width',
        length: 'contract.request.form.length',
        pieces: 'contract.request.form.pieces',
        weight: 'contract.request.form.weight',
        type: 'contract.request.form.type',
        tags: 'contract.request.form.tags',
        'list-title': 'contract.request.form.list-title',
        label: 'contract.request.form.label',
        'service-provider-name': 'contract.request.form.service-provider-name',
        'valid-from': 'contract.request.form.valid-from',
        'valid-to': 'contract.request.form.valid-to',
        'contract-request-status': 'contract.request.form.contract-request-status',
        details: 'contract.request.form.details',
        'location-required': 'contract.request.form.location-required',
        'location-or-territory-required': 'contract.request.form.location-or-territory-required',
      },
      quantity: 'contract.request.quantity',
      routes: 'contract.request.routes',
      routesAndTerritories: 'contract.request.routesAndTerritories',
      addCustomDimensions: 'contract.request.addCustomDimensions',
      comments: 'contract.request.comments',
      packages: 'contract.request.packages',
      selectedPackages: 'contract.request.selectedPackages',
      addRoute: 'contract.request.addRoute',
      addRouteOrTerritory: 'contract.request.addRouteOrTerritory',
      addTerritory: 'contract.request.addTerritory',
      addLocations: 'contract.request.addLocations',
      addTerritories: 'contract.request.addTerritories',
      removeRoute: 'contract.request.removeRoute',
      addWaypoint: 'contract.request.addWaypoint',
      removeWaypoint: 'contract.request.removeWaypoint',
      errors: {
        requiredHeight: 'contract.request.errors.requiredHeight',
        requiredWidth: 'contract.request.errors.requiredWidth',
        requiredLength: 'contract.request.errors.requiredLength',
        requiredWeight: 'contract.request.errors.requiredWeight',
        requiredPieces: 'contract.request.errors.requiredPieces',
        minPieces: 'contract.request.errors.minPieces',
        invalidForm: 'contract.request.errors.invalidForm',
        invalidFormWithContacts: 'contract.request.errors.invalidFormWithContacts',
        requiredCurrencyCode: 'contract.request.errors.requiredCurrencyCode',
        requiredValidFrom: 'contract.request.errors.requiredValidFrom',
        requiredValidTo: 'contract.request.errors.requiredValidTo',
        requiredContacts: 'contract.request.errors.requiredContacts',
      },
      utils: {
        to: 'contract.request.utils.to',
        transport: 'contract.request.utils.transport',
        close: 'contract.request.utils.close',
        save: 'contract.request.utils.save',
        edit: 'contract.request.utils.edit',
        cancel: 'contract.request.utils.cancel',
        accept: 'contract.request.utils.accept',
        reject: 'contract.request.utils.reject',
        delete: 'contract.request.utils.delete',
        duplicate: 'contract.request.utils.duplicate',
      },
    },
    order: {
      tariffRequired: 'contract.order.tariffRequired',
      tariffType: 'contract.order.tariffType',
      orderTariff: 'contract.order.orderTariff',
      shipmentTariff: 'contract.order.shipmentTariff',
      changeTariffType: 'contract.order.changeTariffType',
    },
    tariff: 'contract.tariff',
    'select-tariff': 'contract.select-tariff',
    'remove-tariff': 'contract.remove-tariff',
    selectedTariff: 'contract.selectedTariff',
    cancellation: {
      cancelContractButton: 'contract.cancellation.cancelContractButton',
      cancelContractForcedButton: 'contract.cancellation.cancelContractForcedButton',
      cancelContractDialog: {
        title: 'contract.cancellation.cancelContractDialog.title',
        details: 'contract.cancellation.cancelContractDialog.details',
        forced: 'contract.cancellation.cancelContractDialog.forced',
        forcedWarning: 'contract.cancellation.cancelContractDialog.forcedWarning',
      },
      cancelledContract: 'contract.cancellation.cancelledContract',
      cancelRequest: 'contract.cancellation.cancelRequest',
      acceptCancelContract: 'contract.cancellation.acceptCancelContract',
      rejectCancelContract: 'contract.cancellation.rejectCancelContract',
    },
  },
  tariff: {
    currencyCode: 'tariff.currencyCode',
    pickupCity: 'tariff.pickupCity',
    deliveryCity: 'tariff.deliveryCity',
    packageWeight: 'tariff.packageWeight',
    packageType: 'tariff.packageType',
    tags: 'tariff.tags',
    emptyTariffsMessage: 'tariff.emptyTariffsMessage',
  },
  costCenter: {
    selectButton: 'costCenter.selectButton',
    selectDialog: {
      title: 'costCenter.selectDialog.title',
    },
    input: 'costCenter.input',
    manage: {
      title: 'costCenter.manage.title',
    },
    list: {
      title: 'costCenter.list.title',
      label: 'costCenter.list.label',
      parentLabel: 'costCenter.list.parentLabel',
      createdAt: 'costCenter.list.createdAt',
      validTo: 'costCenter.list.validTo',
      isCustomerBehalf: 'costCenter.list.isCustomerBehalf',
      isPrivate: 'costCenter.list.isPrivate',
      disabledDeleteTooltip: 'costCenter.list.disabledDeleteTooltip',
    },
    add: {
      title: 'costCenter.add.title',
      parent: 'costCenter.add.parent',
      label: 'costCenter.add.label',
      isPrivate: 'costCenter.add.isPrivate',
      error: {
        requiredLabel: 'costCenter.add.error.requiredLabel',
      },
    },
    edit: {
      title: 'costCenter.edit.title',
    },
    utils: {
      close: 'costCenter.utils.close',
      update: 'costCenter.utils.update',
      add: 'costCenter.utils.add',
      search: 'costCenter.utils.search',
      cancel: 'costCenter.utils.cancel',
      save: 'costCenter.utils.save',
      requiredLegend: 'costCenter.utils.requiredLegend',
      deleteConfirmationMessage: 'costCenter.utils.deleteConfirmationMessage',
    },
  },
  dispatcher: {
    tasks: {
      listTitle: 'dispatcher.tasks.listTitle',
      updatedAt: 'dispatcher.tasks.updatedAt',
      online: 'dispatcher.tasks.online',
      updatedByDriver: 'dispatcher.tasks.updatedByDriver',
      updatedByDispatcher: 'dispatcher.tasks.updatedByDispatcher',
      offline: 'dispatcher.tasks.offline',
      lastSeen: 'dispatcher.tasks.lastSeen',
      edit: 'dispatcher.tasks.edit',
      cancel: 'dispatcher.tasks.cancel',
      details: 'dispatcher.tasks.details',
      viewDetails: 'dispatcher.tasks.viewDetails',
      assignToDriver: 'dispatcher.tasks.assignToDriver',
      changeStatus: 'dispatcher.tasks.changeStatus',
      unavailableDelivery: 'dispatcher.tasks.unavailableDelivery',
      delete: 'dispatcher.tasks.delete',
      showTasks: 'dispatcher.tasks.showTasks',
      showMap: 'dispatcher.tasks.showMap',
      showAvailableResources: 'dispatcher.tasks.showAvailableResources',
      availableTasks: 'dispatcher.tasks.availableTasks',
      changeVehicle: 'dispatcher.tasks.changeVehicle',
      changeMainDriver: 'dispatcher.tasks.changeMainDriver',
      changeSecondDriver: 'dispatcher.tasks.changeSecondDriver',
      warehouseEmployee: 'dispatcher.tasks.warehouseEmployee',
      warehouseEmployeeManuallyAddedTooltip: 'dispatcher.tasks.warehouseEmployeeManuallyAddedTooltip',
      warehouseEmployeeScannedTooltip: 'dispatcher.tasks.warehouseEmployeeScannedTooltip',
      driverEmployee: 'dispatcher.tasks.driverEmployee',
      driverEmployeeManuallyAddedTooltip: 'dispatcher.tasks.driverEmployeeManuallyAddedTooltip',
      driverEmployeeScannedTooltip: 'dispatcher.tasks.driverEmployeeScannedTooltip',
      latestStatusAchieved: 'dispatcher.tasks.latestStatusAchieved',
      comments: 'dispatcher.tasks.comments',
      checkpoints: {
        status: {
          not_started: 'dispatcher.tasks.checkpoints.status.not_started',
          completed: 'dispatcher.tasks.checkpoints.status.completed',
          completed_delayed: 'dispatcher.tasks.checkpoints.status.completed_delayed',
          unavailable: 'dispatcher.tasks.checkpoints.status.unavailable',
          refused: 'dispatcher.tasks.checkpoints.status.refused',
          cancelled: 'dispatcher.tasks.checkpoints.status.cancelled',
          closed: 'dispatcher.tasks.checkpoints.status.closed',
        },
      },
      taskStatusChange: {
        title: 'dispatcher.tasks.taskStatusChange.title',
        pickup: 'dispatcher.tasks.taskStatusChange.pickup',
        delivery: 'dispatcher.tasks.taskStatusChange.delivery',
        return: 'dispatcher.tasks.taskStatusChange.return',
        reject: 'dispatcher.tasks.taskStatusChange.reject',
        chooseAction: 'dispatcher.tasks.taskStatusChange.chooseAction',
        submit: 'dispatcher.tasks.taskStatusChange.submit',
        description: 'dispatcher.tasks.taskStatusChange.description',
        handshakePersonName: 'dispatcher.tasks.taskStatusChange.handshakePersonName',
        rejectReason: 'dispatcher.tasks.taskStatusChange.rejectReason',
        error: {
          requiredHandshakePersonName: 'dispatcher.tasks.taskStatusChange.error.requiredHandshakePersonName',
          requiredRejectReason: 'dispatcher.tasks.taskStatusChange.error.requiredRejectReason',
          requiredAchievedAt: 'dispatcher.tasks.taskStatusChange.error.requiredAchievedAt',
        },
        comment: 'dispatcher.tasks.taskStatusChange.comment',
        achievedAt: 'dispatcher.tasks.taskStatusChange.achievedAt',
      },
      summary: {
        cardTitle: 'dispatcher.tasks.summary.cardTitle',
        vehicles: 'dispatcher.tasks.summary.vehicles',
        'available-tasks': 'dispatcher.tasks.summary.available-tasks',
        drivers: 'dispatcher.tasks.summary.drivers',
        tasks: 'dispatcher.tasks.summary.tasks',
        addNewRoute: 'dispatcher.tasks.summary.addNewRoute',
      },
      completedDirection: 'dispatcher.tasks.completedDirection',
      estimatedDirection: 'dispatcher.tasks.estimatedDirection',
      noDataFoundDescription: 'dispatcher.tasks.noDataFoundDescription',
      takenPackages: 'dispatcher.tasks.takenPackages',
      takenPackagesSummary: 'dispatcher.tasks.takenPackagesSummary',
      proofOfHandover: {
        signature: 'dispatcher.tasks.proofOfHandover.signature',
        signatures: 'dispatcher.tasks.proofOfHandover.signatures',
        achievedAt: 'dispatcher.tasks.proofOfHandover.achievedAt',
        responsibleName: 'dispatcher.tasks.proofOfHandover.responsibleName',
        executedBy: 'dispatcher.tasks.proofOfHandover.executedBy',
        comment: 'dispatcher.tasks.proofOfHandover.comment',
        unavailableMessage: 'dispatcher.tasks.proofOfHandover.unavailableMessage',
        executedByType: {
          DRIVER: 'dispatcher.tasks.proofOfHandover.executedByType.DRIVER',
          WAREHOUSE: 'dispatcher.tasks.proofOfHandover.executedByType.WAREHOUSE',
          PREORDER_LINK: 'dispatcher.tasks.proofOfHandover.executedByType.PREORDER_LINK',
          OFFICE: 'dispatcher.tasks.proofOfHandover.executedByType.OFFICE',
        },
        responsibleType: {
          CARRIER: 'dispatcher.tasks.proofOfHandover.responsibleType.CARRIER',
          SENDER: 'dispatcher.tasks.proofOfHandover.responsibleType.SENDER',
          CONSIGNEE: 'dispatcher.tasks.proofOfHandover.responsibleType.CONSIGNEE',
        },
      },
    },
  },
  'route-share-location': {
    'share-checkpoint': 'route-share-location.share-checkpoint',
    'view-route': 'route-share-location.view-route',
    'no-data-share-checkpoint': 'route-share-location.no-data-share-checkpoint',
    'sent-route-share-location': 'route-share-location.sent-route-share-location',
    'received-route-share-location': 'route-share-location.received-route-share-location',
    title: 'route-share-location.title',
    details: 'route-share-location.details',
    'final-destination': 'route-share-location.final-destination',
    'total-package-count': 'route-share-location.total-package-count',
    'total-package-weight': 'route-share-location.total-package-weight',
    'total-package-volume': 'route-share-location.total-package-volume',
    'shared-with': 'route-share-location.shared-with',
    'shared-by': 'route-share-location.shared-by',
    'future-checkpoints': 'route-share-location.future-checkpoints',
    'driver-name': 'route-share-location.driver-name',
    'driver-phone': 'route-share-location.driver-phone',
    form: {
      'task-checkpoint-required-error': 'route-share-location.form.task-checkpoint-required-error',
      partners: 'route-share-location.form.partners',
      checkpoint: 'route-share-location.form.checkpoint',
    },
    'saved-succes': 'route-share-location.saved-succes',
    list: 'route-share-location.list',
    back: 'route-share-location.back',
  },
  'scheduled-shipments': {
    'filter-fields': {
      pickupStart: 'scheduled-shipments.filter-fields.pickupStart',
      createdAt: 'scheduled-shipments.filter-fields.createdAt',
      shipmentFlowType: 'scheduled-shipments.filter-fields.shipmentFlowType',
      externalReference: 'scheduled-shipments.filter-fields.externalReference',
      shipmentSeries: 'scheduled-shipments.filter-fields.shipmentSeries',
      pickupCompanyName: 'scheduled-shipments.filter-fields.pickupCompanyName',
      deliveryCompanyName: 'scheduled-shipments.filter-fields.deliveryCompanyName',
      pickupLocation: 'scheduled-shipments.filter-fields.pickupLocation',
      deliveryLocation: 'scheduled-shipments.filter-fields.deliveryLocation',
      pickupCity: 'scheduled-shipments.filter-fields.pickupCity',
      deliveryCity: 'scheduled-shipments.filter-fields.deliveryCity',
      filterTags: 'scheduled-shipments.filter-fields.filterTags',
      transportProject: 'scheduled-shipments.filter-fields.transportProject',
      vendor: 'scheduled-shipments.filter-fields.vendor',
      type: 'scheduled-shipments.filter-fields.type',
    },
    'add-scheduled-shipment': 'scheduled-shipments.add-scheduled-shipment',
    'add-scheduled-shipment-from-template': 'scheduled-shipments.add-scheduled-shipment-from-template',
    'edit-scheduled-shipment': 'scheduled-shipments.edit-scheduled-shipment',
    'delete-title': 'scheduled-shipments.delete-title',
    deleteConfirmation: 'scheduled-shipments.deleteConfirmation',
    assignedToMe: 'scheduled-shipments.assignedToMe',
    assignToMe: 'scheduled-shipments.assignToMe',
    'empty-list': 'scheduled-shipments.empty-list',
  },
  'vendor-templates': {
    title: 'vendor-templates.title',
    'empty-list': 'vendor-templates.empty-list',
    'add-template': 'vendor-templates.add-template',
  },
  'scheduled-shipments-shared': {
    'create-offer-request-info': 'scheduled-shipments-shared.create-offer-request-info',
    'create-offer-request-button-text': 'scheduled-shipments-shared.create-offer-request-button-text',
    filter: 'scheduled-shipments-shared.filter',
    'change-layout': 'scheduled-shipments-shared.change-layout',
    'create-order-info-message': 'scheduled-shipments-shared.create-order-info-message',
    'create-order-button-text': 'scheduled-shipments-shared.create-order-button-text',
    'create-supplier-order-button-text': 'scheduled-shipments-shared.create-supplier-order-button-text',
    'invalid-order-button-tooltip': 'scheduled-shipments-shared.invalid-order-button-tooltip',
  },
  'scheduled-utils': {
    add: 'scheduled-utils.add',
    delete: 'scheduled-utils.delete',
    edit: 'scheduled-utils.edit',
    newScheduledFromTemplate: 'scheduled-utils.newScheduledFromTemplate',
    deleteConfirmation: 'scheduled-utils.deleteConfirmation',
    deleteTemplateMessage: 'scheduled-utils.deleteTemplateMessage',
    deleteTemplate: 'scheduled-utils.deleteTemplate',
    stopRecurrence: 'scheduled-utils.stopRecurrence',
    recurrentShipmentTooltip: 'scheduled-utils.recurrentShipmentTooltip',
    stopRecurrenceMessage: 'scheduled-utils.stopRecurrenceMessage',
    stopRecurrenceConfirmation: 'scheduled-utils.stopRecurrenceConfirmation',
    open: 'scheduled-utils.open',
    close: 'scheduled-utils.close',
  },
  'standard-package-dimension': {
    'page-title': 'standard-package-dimension.page-title',
    package: 'standard-package-dimension.package',
    standardPackage: 'standard-package-dimension.standardPackage',
    emptyStandardPackagesMessage: 'standard-package-dimension.emptyStandardPackagesMessage',
    list: {
      name: 'standard-package-dimension.list.name',
      height: 'standard-package-dimension.list.height',
      width: 'standard-package-dimension.list.width',
      length: 'standard-package-dimension.list.length',
      weight: 'standard-package-dimension.list.weight',
      type: 'standard-package-dimension.list.type',
      tags: 'standard-package-dimension.list.tags',
    },
    form: {
      name: 'standard-package-dimension.form.name',
      height: 'standard-package-dimension.form.height',
      width: 'standard-package-dimension.form.width',
      length: 'standard-package-dimension.form.length',
      weight: 'standard-package-dimension.list.weight',
      type: 'standard-package-dimension.form.type',
      tags: 'standard-package-dimension.form.tags',
      errors: {
        requiredDescription: 'standard-package-dimension.form.errors.requiredDescription',
        requiredlength: 'standard-package-dimension.form.errors.requiredlength',
        requiredwidth: 'standard-package-dimension.form.errors.requiredwidth',
        requiredheight: 'standard-package-dimension.form.errors.requiredheight',
      },
    },
    'update-package': 'standard-package-dimension.update-package',
    'delete-package': 'standard-package-dimension.delete-package',
    'delete-confirmation-message': 'standard-package-dimension.delete-confirmation-message',
    utils: {
      close: 'standard-package-dimension.utils.close',
      save: 'standard-package-dimension.utils.save',
      delete: 'standard-package-dimension.utils.delete',
    },
  },
  task: {
    list: {
      title: 'task.list.title',
      updatedAt: 'task.list.updatedAt',
      deleteMessage: 'task.list.deleteMessage',
      deleteTaskOnly: 'task.list.deleteTaskOnly',
      deleteSolution: 'task.list.deleteSolution',
      solutionNotDeletable: 'task.list.solutionNotDeletable',
      solutionDeletableWarning: 'task.list.solutionDeletableWarning',
      deletedSuccessfully: 'task.list.deletedSuccessfully',
      deleteQuestionTask: 'task.list.deleteQuestionTask',
      deleteQuestionSegment: 'task.list.deleteQuestionSegment',
      deleteSegment: 'task.list.deleteSegment',
      deleteQuestionSolution: 'task.list.deleteQuestionSolution',
      deleteEntireSolution: 'task.list.deleteEntireSolution',
      closeMessage: 'task.list.closeMessage',
      closeBody: 'task.list.closeBody',
      closeTask: 'task.list.closeTask',
      closedSuccessfully: 'task.list.closedSuccessfully',
      fullHandoverMessage: 'task.list.fullHandoverMessage',
      fullHandoverBody: 'task.list.fullHandoverBody',
      fullHandover: 'task.list.fullHandover',
      fullHandoverSuccessfully: 'task.list.fullHandoverSuccessfully',
      legend: {
        task: 'task.list.legend.task',
        shipment: 'task.list.legend.shipment',
      },
      filter: 'task.list.filter',
      filterInputs: {
        packageId: 'task.list.filterInputs.packageId',
        orderNumber: 'task.list.filterInputs.orderNumber',
        series: 'task.list.filterInputs.series',
        serviceProviderName: 'task.list.filterInputs.serviceProviderName',
        pickupDate: 'task.list.filterInputs.pickupDate',
        deliveredBy: 'task.list.filterInputs.deliveredBy',
        mainDriverName: 'task.list.filterInputs.mainDriverName',
        licensePlate: 'task.list.filterInputs.licensePlate',
        pickupAddress: 'task.list.filterInputs.pickupAddress',
        deliveryAddress: 'task.list.filterInputs.deliveryAddress',
        pickupLocation: 'task.list.filterInputs.pickupLocation',
        deliveryLocation: 'task.list.filterInputs.deliveryLocation',
        taskStatus: 'task.list.filterInputs.taskStatus',
        shipmentStatus: 'task.list.filterInputs.shipmentStatus',
        lastModifiedAt: 'task.list.filterInputs.lastModifiedAt',
        unknownDestination: 'task.list.filterInputs.unknownDestination',
      },
    },
    wizard: {
      firstStep: {
        title: 'task.wizard.firstStep.title',
        selectRoute: 'task.wizard.firstStep.selectRoute',
        changeRoute: 'task.wizard.firstStep.changeRoute',
        errors: {
          requiredMainDriver: 'task.wizard.firstStep.errors.requiredMainDriver',
          requiredVehicle: 'task.wizard.firstStep.errors.requiredVehicle',
        },
      },
      secondStep: {
        title: 'task.wizard.secondStep.title',
        task: 'task.wizard.secondStep.task',
        timeWarningMessage: 'task.wizard.secondStep.timeWarningMessage',
        dimensions: 'task.wizard.secondStep.dimensions',
      },
    },
    statusEnum: {
      created: 'task.statusEnum.created',
      accepted: 'task.statusEnum.accepted',
      rejected: 'task.statusEnum.rejected',
      in_transit: 'task.statusEnum.in_transit',
      in_transit_returning: 'task.statusEnum.in_transit_returning',
      completed: 'task.statusEnum.completed',
      cancelled: 'task.statusEnum.cancelled',
      closed: 'task.statusEnum.closed',
      partially_closed: 'task.statusEnum.partially_closed',
    },
  },
  'add-form': {
    title: 'add-form.title',
    pickup: 'add-form.pickup',
    delivery: 'add-form.delivery',
    start: 'add-form.start',
    finish: 'add-form.finish',
    mainDriver: 'add-form.mainDriver',
    secondDriver: 'add-form.secondDriver',
    'vehicle-type': 'add-form.vehicle-type',
    vehicle: 'add-form.vehicle',
    packages: 'add-form.packages',
    save: 'add-form.save',
    error: {
      requiredVehicleVO: 'add-form.error.requiredVehicleVO',
      requiredDriverVO: 'add-form.error.requiredDriverVO',
      selectedDateAfterCurrentDateStart: 'add-form.error.selectedDateAfterCurrentDateStart',
      selectedDateAfterCurrentDateFinish: 'add-form.error.selectedDateAfterCurrentDateFinish',
      endBeforeStartDateValidationError: 'add-form.error.endBeforeStartDateValidationError',
      requiredPickupTimeWindowStart: 'add-form.error.requiredPickupTimeWindowStart',
      requiredPickupTimeWindowEnd: 'add-form.error.requiredPickupTimeWindowEnd',
    },
    'warning-driver': 'add-form.warning-driver',
    'warning-vehicle': 'add-form.warning-vehicle',
  },
  utils: {
    close: 'utils.close',
    save: 'utils.save',
    update: 'utils.update',
    status: 'utils.status',
    partialSave: 'utils.partialSave',
    validateAndSave: 'utils.validateAndSave',
    saveAndUpload: 'utils.saveAndUpload',
    back: 'utils.back',
    add: 'utils.add',
    confirmation: 'utils.confirmation',
    search: 'utils.search',
    closeDetails: 'utils.closeDetails',
    timeLimit: 'utils.timeLimit',
    requiredLegend: 'utils.requiredLegend',
    successSave: 'utils.successSave',
    verifyData: 'utils.verifyData',
    deliverByDate: 'utils.deliverByDate',
    plannedDelivery: 'utils.plannedDelivery',
    deliveryDate: 'utils.deliveryDate',
    defaultInfoSummary: 'utils.defaultInfoSummary',
    defaultInfoDetails: 'utils.defaultInfoDetails',
    'show-more': 'utils.show-more',
    'show-less': 'utils.show-less',
    deleteConfirmationMessage: 'utils.deleteConfirmationMessage',
    no: 'utils.no',
    yes: 'utils.yes',
    loadingSuccess: 'utils.loadingSuccess',
    daysOfWeek: {
      MONDAY: 'utils.daysOfWeek.MONDAY',
      TUESDAY: 'utils.daysOfWeek.TUESDAY',
      WEDNESDAY: 'utils.daysOfWeek.WEDNESDAY',
      THURSDAY: 'utils.daysOfWeek.THURSDAY',
      FRIDAY: 'utils.daysOfWeek.FRIDAY',
      SATURDAY: 'utils.daysOfWeek.SATURDAY',
      SUNDAY: 'utils.daysOfWeek.SUNDAY',
    },

    shortDaysOfWeek: {
      MONDAY: 'utils.shortDaysOfWeek.MONDAY',
      TUESDAY: 'utils.shortDaysOfWeek.TUESDAY',
      WEDNESDAY: 'utils.shortDaysOfWeek.WEDNESDAY',
      THURSDAY: 'utils.shortDaysOfWeek.THURSDAY',
      FRIDAY: 'utils.shortDaysOfWeek.FRIDAY',
      SATURDAY: 'utils.shortDaysOfWeek.SATURDAY',
      SUNDAY: 'utils.shortDaysOfWeek.SUNDAY',
    },
    visibilityTypeDescription: {
      PUBLIC: 'utils.visibilityTypeDescription.PUBLIC',
      NONE: 'utils.visibilityTypeDescription.NONE',
      CUSTOMER: 'utils.visibilityTypeDescription.CUSTOMER',
      SERVICE_PROVIDER: 'utils.visibilityTypeDescription.SERVICE_PROVIDER',
      BOTH: 'utils.visibilityTypeDescription.BOTH',
    },
    languages: {
      ro: 'utils.languages.ro',
      en: 'utils.languages.en',
    },
    delete: 'utils.delete',
    download: 'utils.download',
    sync: 'utils.sync',
    all: 'utils.all',
    edit: 'utils.edit',
    noDataFound: 'utils.noDataFound',
    emptyMessage: 'utils.emptyMessage',
    downloadPdf: 'utils.downloadPdf',
    send: 'utils.send',
    seeDetails: 'utils.seeDetails',
    seeMore: 'utils.seeMore',
    details: 'utils.details',
    saveForLater: 'utils.saveForLater',
    resetData: 'utils.resetData',
    addContactInfoMessage: 'utils.addContactInfoMessage',
    existentCompany: 'utils.existentCompany',
    existentCompanyDetails: 'utils.existentCompanyDetails',
    publicContact: 'utils.publicContact',
    partnerContact: 'utils.partnerContact',
    inactive: 'utils.inactive',
    packages: 'utils.packages',
    itemsSelected: 'utils.itemsSelected',
    upload: 'utils.upload',
  },
  'delivery-outbox': {
    title: 'delivery-outbox.title',
    addOfferRequest: 'delivery-outbox.addOfferRequest',
    addContractOrder: 'delivery-outbox.addContractOrder',
    addSupplierOrder: 'delivery-outbox.addSupplierOrder',
    addInternalOrder: 'delivery-outbox.addInternalOrder',
    addPreOrder: 'delivery-outbox.addPreOrder',
    createdAt: 'delivery-outbox.createdAt',
    invoiceStatus: 'delivery-outbox.invoiceStatus',
    receivedOffers: 'delivery-outbox.receivedOffers',
    deadline: 'delivery-outbox.deadline',
    orderStatus: 'delivery-outbox.orderStatus',
    offerRequestStatus: 'delivery-outbox.offerRequestStatus',
    totalWeight: 'delivery-outbox.totalWeight',
    costCenters: 'delivery-outbox.costCenters',
    assignedToUser: 'delivery-outbox.assignedToUser',
    pickupLocation: 'delivery-outbox.pickupLocation',
    deliveryLocation: 'delivery-outbox.deliveryLocation',
    invoiceStatusEnum: {
      UNPAID: 'delivery-outbox.invoiceStatusEnum.UNPAID',
      PARTIAL_PAID: 'delivery-outbox.invoiceStatusEnum.PARTIAL_PAID',
      PAID: 'delivery-outbox.invoiceStatusEnum.PAID',
      STORNO: 'delivery-outbox.invoiceStatusEnum.STORNO',
      CANCELLED: 'delivery-outbox.invoiceStatusEnum.CANCELLED',
      NOT_INVOICED: 'delivery-outbox.invoiceStatusEnum.NOT_INVOICED',
    },
    offerRequestStatusEnum: {
      sent: 'delivery-outbox.offerRequestStatusEnum.sent',
      received: 'delivery-outbox.offerRequestStatusEnum.received',
      offer_accepted: 'delivery-outbox.offerRequestStatusEnum.offer_accepted',
      cancelled: 'delivery-outbox.offerRequestStatusEnum.cancelled',
      in_progress: 'delivery-outbox.offerRequestStatusEnum.in_progress',
      offers_received: 'delivery-outbox.offerRequestStatusEnum.offers_received',
      completed: 'delivery-outbox.offerRequestStatusEnum.completed',
      rejected: 'delivery-outbox.offerRequestStatusEnum.rejected',
      archived: 'delivery-outbox.offerRequestStatusEnum.archived',
    },
    more: {
      resendInvoiceUploadInvitationEmail: 'delivery-outbox.more.resendInvoiceUploadInvitationEmail',
      orderCancelRequest: 'delivery-outbox.more.orderCancelRequest',
      orderCancelForced: 'delivery-outbox.more.orderCancelForced',
      orderCancelRequestDisabledTooltip: 'delivery-outbox.more.orderCancelRequestDisabledTooltip',
    },
    utils: {
      open: 'delivery-outbox.utils.open',
      'empty-list': 'delivery-outbox.utils.empty-list',
      'empty-message': 'delivery-outbox.utils.empty-message',
      shipments: 'delivery-outbox.utils.shipments',
    },
    sort: 'delivery-outbox.sort',
    'timeline-phase': {
      offer_request: 'delivery-outbox.timeline-phase.offer_request',
      order: 'delivery-outbox.timeline-phase.order',
      transport: 'delivery-outbox.timeline-phase.transport',
      invoice: 'delivery-outbox.timeline-phase.invoice',
    },
    filter: 'delivery-outbox.filter',
    documentNumber: 'delivery-outbox.documentNumber',
    shipmentSeries: 'delivery-outbox.shipmentSeries',
    employeeName: 'delivery-outbox.employeeName',
    vendorName: 'delivery-outbox.vendorName',
    pickupCity: 'delivery-outbox.pickupCity',
    pickupStart: 'delivery-outbox.pickupStart',
    deliveryCity: 'delivery-outbox.deliveryCity',
    deliveryEnd: 'delivery-outbox.deliveryEnd',
    pickupCompany: 'delivery-outbox.pickupCompany',
    deliveryCompany: 'delivery-outbox.deliveryCompany',
    type: 'delivery-outbox.type',
    shipmentFlowType: 'delivery-outbox.shipmentFlowType',
    requestedBy: 'delivery-outbox.requestedBy',
    moreShipments: 'delivery-outbox.moreShipments',
    lessShipments: 'delivery-outbox.lessShipments',
    units: {
      kg: 'delivery-outbox.units.kg',
      pcs: 'delivery-outbox.units.pcs',
    },
  },
  'delivery-shared': {
    shipmentList: {
      pcs: 'delivery-shared.shipmentList.pcs',
      moreShipments: 'delivery-shared.shipmentList.moreShipments',
      lessShipments: 'delivery-shared.shipmentList.lessShipments',
    },
  },
  fileStorage: {
    dragAndDrop: 'fileStorage.dragAndDrop',
  },
  'payments-per-invoice': {
    list: {
      title: 'payments-per-invoice.list.title',
      invoiceSeries: 'payments-per-invoice.list.invoiceSeries',
      currencyCode: 'payments-per-invoice.list.currencyCode',
      paidAmount: 'payments-per-invoice.list.paidAmount',
      paymentDate: 'payments-per-invoice.list.paymentDate',
      fromBankAccount: 'payments-per-invoice.list.fromBankAccount',
      toBankAccount: 'payments-per-invoice.list.toBankAccount',
      paymentStatusType: 'payments-per-invoice.list.paymentStatusType',
      paymentStatuses: {
        accepted: 'payments-per-invoice.list.paymentStatuses.accepted',
        canceled: 'payments-per-invoice.list.paymentStatuses.canceled',
        deallocated: 'payments-per-invoice.list.paymentStatuses.deallocated',
      },
    },
    utils: {
      all: 'payments-per-invoice.utils.all',
      search: 'payments-per-invoice.utils.search',
    },
  },
  costs: {
    form: {
      title: 'costs.form.title',
      description: 'costs.form.description',
      documentType: 'costs.form.documentType',
      costCenter: 'costs.form.costCenter',
      order: 'costs.form.order',
      driver: 'costs.form.driver',
      recurrence: 'costs.form.recurrence',
      attachments: 'costs.form.attachments',
      vehicleAttachments: 'costs.form.vehicleAttachments',
      cronExpressions: {
        monthly: 'costs.form.cronExpressions.monthly',
        yearly: 'costs.form.cronExpressions.yearly',
      },
      quantity: 'costs.form.quantity',
      measurementUnit: 'costs.form.measurementUnit',
      errors: {
        requiredTitle: 'costs.form.errors.requiredTitle',
        requiredPrice: 'costs.form.errors.requiredPrice',
        '0Price': 'costs.form.errors.0Price',
        requiredCurrencyCode: 'costs.form.errors.requiredCurrencyCode',
        requiredValue: 'costs.form.errors.requiredValue',
        requiredDriver: 'costs.form.errors.requiredDriver',
        requiredVehicle: 'costs.form.errors.requiredVehicle',
        requiredValidFrom: 'costs.form.errors.requiredValidFrom',
        requiredValidTo: 'costs.form.errors.requiredValidTo',
        requiredOneOfFour: 'costs.form.errors.requiredOneOfFour',
        patternServiceProviderCUI: 'costs.form.errors.patternServiceProviderCUI',
      },
      documentInfo: 'costs.form.documentInfo',
      serviceProviderName: 'costs.form.serviceProviderName',
      serviceProviderCUI: 'costs.form.serviceProviderCUI',
      validFrom: 'costs.form.validFrom',
      validTo: 'costs.form.validTo',
      oneTimeCost: 'costs.form.oneTimeCost',
      value: 'costs.form.value',
      currencyCode: 'costs.form.currencyCode',
      orderNumber: 'costs.form.orderNumber',
      customerName: 'costs.form.customerName',
      vehicle: 'costs.form.vehicle',
    },
    totalCosts: 'costs.totalCosts',
    add: 'costs.add',
    edit: 'costs.edit',
    list: {
      title: 'costs.list.title',
      name: 'costs.list.name',
      description: 'costs.list.description',
      costAssociationType: 'costs.list.costAssociationType',
      value: 'costs.list.value',
      currencyCode: 'costs.list.currencyCode',
      createdBy: 'costs.list.createdBy',
      createdAt: 'costs.list.createdAt',
      coveragePeriod: 'costs.list.coveragePeriod',
      validFrom: 'costs.list.validFrom',
      validTo: 'costs.list.validTo',
      serviceProviderName: 'costs.list.serviceProviderName',
      serviceProviderCUI: 'costs.list.serviceProviderCUI',
      documentType: 'costs.list.documentType',
      documentInfo: 'costs.list.documentInfo',
      costAssociationTypes: {
        VEHICLE: 'costs.list.costAssociationTypes.VEHICLE',
        DRIVER: 'costs.list.costAssociationTypes.DRIVER',
        COST_CENTER: 'costs.list.costAssociationTypes.COST_CENTER',
        SERVICE_PROVIDER_ORDER: 'costs.list.costAssociationTypes.SERVICE_PROVIDER_ORDER',
      },
    },
    'delete-confirmation-message': 'costs.delete-confirmation-message',
    delete: 'costs.delete',
    costs: 'costs.costs',
  },
  dash: {
    dashboard_admin: 'dash.dashboard_admin',
    user: 'dash.user',
    charts: 'dash.charts',
    delete: 'dash.delete',
    cancel: 'dash.cancel',
    upload: 'dash.upload',
    edit: 'dash.edit',
    active_offers_req_offers: 'dash.active_offers_req_offers',
    active_offers_req_offers_value: 'dash.active_offers_req_offers_value',
    users: 'dash.users',
    requests: 'dash.requests',
    orders: 'dash.orders',
    abandoned_signups_to_date: 'dash.abandoned_signups_to_date',
    avg_gross_profit_ytd: 'dash.avg_gross_profit_ytd',
    avg_transactions_current_month: 'dash.avg_transactions_current_month',
    avg_transactions_prev_year: 'dash.avg_transactions_prev_year',
    gross_profit_mtd: 'dash.gross_profit_mtd',
    total_GP: 'dash.total_GP',
    avg_GP: 'dash.avg_GP',
    gross_profit_ytd: 'dash.gross_profit_ytd',
    new_platform_customers: 'dash.new_platform_customers',
    new_temp_users_current_month: 'dash.new_temp_users_current_month',
    new_temp_users_prev_year: 'dash.new_temp_users_prev_year',
    orders_by_status: 'dash.orders_by_status',
    registered_users_current_month: 'dash.registered_users_current_month',
    registered_users_prev_year: 'dash.registered_users_prev_year',
    total_offer_requests_per_day_mtd: 'dash.total_offer_requests_per_day_mtd',
    total_offer_requests_per_month_ytd: 'dash.total_offer_requests_per_month_ytd',
    total_orders_per_day_mtd: 'dash.total_orders_per_day_mtd',
    total_orders_per_month_ytd: 'dash.total_orders_per_month_ytd',
    users_current_month: 'dash.users_current_month',
    users_prev_year: 'dash.users_prev_year',
    order_status: {
      sent: 'dash.order_status.sent',
      accepted: 'dash.order_status.accepted',
      rejected: 'dash.order_status.rejected',
      in_progress: 'dash.order_status.in_progress',
      partially_in_progress: 'dash.order_status.partially_in_progress',
      returned_to_origin: 'dash.order_status.returned_to_origin',
      partially_returned_to_origin: 'dash.order_status.returned_to_origin',
      in_transit: 'dash.order_status.in_transit',
      partially_in_transit: 'dash.order_status.partially_in_transit',
      transit_end: 'dash.order_status.transit_end',
      partially_transit_end: 'dash.order_status.partially_transit_end',
      return_to_origin: 'dash.order_status.return_to_origin',
      partially_return_to_origin: 'dash.order_status.partially_return_to_origin',
      lost: 'dash.order_status.lost',
      partially_completed: 'dash.order_status.partially_completed',
      mixed: 'dash.order_status.mixed',
      mixed_with_failure: 'dash.order_status.mixed_with_failure',
      completed: 'dash.order_status.completed',
      completed_with_failure: 'dash.order_status.completed_with_failure',
      undelivered: 'dash.order_status.undelivered',
      documents_partially_received: 'dash.order_status.documents_partially_received',
      documents_received: 'dash.order_status.documents_received',
      archived: 'dash.order_status.archived',
      cancelled: 'dash.order_status.cancelled',
    },
  },
  'date-utils': {
    errors: {
      deliveryIsBeforePickup: 'date-utils.errors.deliveryIsBeforePickup',
      pickupEndTimeIsBeforeNow: 'date-utils.errors.pickupEndTimeIsBeforeNow',
      pickupIsBeforeToday: 'date-utils.errors.pickupIsBeforeToday',
      selectedDateAfterCurrentDatedateRange: 'date-utils.errors.selectedDateAfterCurrentDatedateRange',
    },
    days: 'date-utils.days',
    hours: 'date-utils.hours',
    minutes: 'date-utils.minutes',
    seconds: 'date-utils.seconds',
  },
  error: {
    '403': 'error.403',
    requiredGlobalAccountCode: 'error.requiredGlobalAccountCode',
    requiredGlobalAccountTypeValue: 'error.requiredGlobalAccountTypeValue',
    title: 'error.title',
    'external-invoice-orders-different-payment-time-limit-error':
      'error.external-invoice-orders-different-payment-time-limit-error',
    'external-invoice-orders-invoiced-by-other-invoices-error':
      'error.external-invoice-orders-invoiced-by-other-invoices-error',
    'external-invoice-orders-invoiced-error': 'error.external-invoice-orders-invoiced-error',
    'invoice-external-error-single-company-contacts-selected':
      'error.invoice-external-error-single-company-contacts-selected',
    internalServerError: 'error.internalServerError',
    server: {
      not: {
        reachable: 'error.server.not.reachable',
      },
    },
    url: {
      not: {
        found: 'error.url.not.found',
      },
    },
    NotNull: 'error.NotNull',
    Size: 'error.Size',
    userexists: 'error.userexists',
    emailexists: 'error.emailexists',
    idexists: 'error.idexists',
    unauthorized: 'error.unauthorized',
    'bad-credentials': 'error.bad-credentials',
    error: {
      validation: 'error.error.validation',
      '429': 'error.error.429',
    },
    defaultError: 'error.defaultError',
    UserAlreadyAssignedException: 'error.UserAlreadyAssignedException',
    InvalidGeneratedAndSignedPdfException: 'error.InvalidGeneratedAndSignedPdfException',
    UserNotFoundException: 'error.UserNotFoundException',
    AssignedUserAlreadyExistsException: 'error.AssignedUserAlreadyExistsException',
    currentUserNotFound: 'error.currentUserNotFound',
    userAlreadyHasOwner: 'error.userAlreadyHasOwner',
    companyAlreadyHasSuperUser: 'error.companyAlreadyHasSuperUser',
    PackageContractTariffNotUnique: 'error.PackageContractTariffNotUnique',
    OrderAuditPdfGenerationException: 'error.OrderAuditPdfGenerationException',
    TaskDeletedException: 'error.TaskDeletedException',
    TaskCheckpointDeletedException: 'error.TaskCheckpointDeletedException',
    TaskCheckpointUpdateStatusException: 'error.TaskCheckpointUpdateStatusException',
    EmployeeAlreadyIsDriver: 'error.EmployeeAlreadyIsDriver',
    validExternalReferenceAlreadyExistForTheReferenceType:
      'error.validExternalReferenceAlreadyExistForTheReferenceType',
    'invalid-status-for-offer-request': 'error.invalid-status-for-offer-request',
    'terminal-reservation-end-time-before-start-time-error':
      'error.terminal-reservation-end-time-before-start-time-error',
    'terminal-reservation-end-time-same-with-start-time-error':
      'error.terminal-reservation-end-time-same-with-start-time-error',
    'overlapping-terminal-reservation-error': 'error.overlapping-terminal-reservation-error',
    'warehouse-end-time-before-start-time-error': 'error.warehouse-end-time-before-start-time-error',
    'warehouse-times-minimum-one-interval-error': 'error.warehouse-times-minimum-one-interval-error',
    'email-already-sent-in-the-last-five-minutes-error': 'error.email-already-sent-in-the-last-five-minutes-error',
    'external-invoice-orders-invalid-currency-codes-error':
      'error.external-invoice-orders-invalid-currency-codes-error',
    'no-rights-selected': 'error.no-rights-selected',
    'error-cannot-add-ownership-request-phone-not-validated':
      'error.error-cannot-add-ownership-request-phone-not-validated',
    'error-cannot-add-ownership-request-phone-null': 'error.error-cannot-add-ownership-request-phone-null',
    EFacturaAuthorizationException: 'error.EFacturaAuthorizationException',
    EmailImportSettingsWrongFormatException: 'error.EmailImportSettingsWrongFormatException',
    activityMustHaveAtLeastOneContact: 'error.activityMustHaveAtLeastOneContact',
    AbstractNotifiableEntityEmptyContactListException: 'error.AbstractNotifiableEntityEmptyContactListException',
    ShipmentGroupDefaultSolutionException: 'error.ShipmentGroupException',
    InvalidCompanyAddressException: 'error.InvalidCompanyAddressException',
    invalidPasswordFormat: 'error.invalidPasswordFormat',
    '429': 'error.429',
    ShipmentCanNotBeCancelledException: 'error.ShipmentCanNotBeCancelledException',
    PickupAndShipmentCanNotBeCancelledException: 'error.PickupAndShipmentCanNotBeCancelledException',
    OrderTariffCancelledException: 'error.OrderTariffCancelledException',
    ActiveTariffOnOperationalTerritoryInvalidateException:
      'error.ActiveTariffOnOperationalTerritoryInvalidateException',
    MaxAttemptsExceededException: 'error.MaxAttemptsExceededException',
    AttemptsExceededExceptionPT1M: 'error.AttemptsExceededExceptionPT1M',
    AttemptsExceededExceptionPT1H: 'error.AttemptsExceededExceptionPT1M',
    AttemptsExceededExceptionPT24H: 'error.AttemptsExceededExceptionPT24H',
    AttemptsExceededExceptionPT240H: 'error.AttemptsExceededExceptionPT240H',
    AttemptsLeft4: 'error.AttemptsLeft4',
    AttemptsLeft3: 'error.AttemptsLeft3',
    AttemptsLeft2: 'error.AttemptsLeft2',
    AttemptsLeft1: 'error.AttemptsLeft1',
    'blocked-user': 'error.blocked-user',
    'remaining-time-until-unblocked-beggining-message': 'error.remaining-time-until-unblocked-beggining-message',
    'remaining-days-until-unblocked': 'error.remaining-days-until-unblocked',
    'remaining-hours-until-unblocked': 'error.remaining-hours-until-unblocked',
    'remaining-minutes-until-unblocked': 'error.remaining-minutes-until-unblocked',
    'remaining-seconds-until-unblocked': 'error.remaining-seconds-until-unblocked',
    usernameAlreadyExists: 'error.usernameAlreadyExists',
    missingPhoneNumber: 'error.missingPhoneNumber',
    invalidPhoneNumber: 'error.invalidPhoneNumber',
    invalidEmail: 'error.invalidEmail',
    externalVendorRequestCredentialDTOMap: 'error.externalVendorRequestCredentialDTOMap',
    'order-shipper-party': 'error.order-shipper-party',
    'order-payment-party': 'error.order-payment-party',
    'order-with-already-allocated-shipment-drafts': 'error.order-with-already-allocated-shipment-drafts',
    'task-with-already-allocated-shipment-drafts': 'error.task-with-already-allocated-shipment-drafts',
    'original-sp-pre-order-not-updatable': 'error.original-sp-pre-order-not-updatable',
    'shipment-group-solution-not-locked-in': 'error.shipment-group-solution-not-locked-in',
    'terminal-reservation-vendor-and-external-service-provider-error':
      'error.terminal-reservation-vendor-and-external-service-provider-error',
    InvalidOrderForAuditException: 'error.InvalidOrderForAuditException',
    'invalid-shipment-status-change-invoice-generated': 'error.invalid-shipment-status-change-invoice-generated',
    'invalid-shipment-status-change': 'error.invalid-shipment-status-change',
    'duplicate-routed-order-template-label': 'error.duplicate-routed-order-template-label',
  },
  'exception-web-lib': {
    exception_list: 'exception-web-lib.exception_list',
    list_of_exceptions: 'exception-web-lib.list_of_exceptions',
    message: 'exception-web-lib.message',
    author: 'exception-web-lib.author',
    date: 'exception-web-lib.date',
    system_name: 'exception-web-lib.system_name',
    stack_trace: 'exception-web-lib.stack_trace',
    search: 'exception-web-lib.search',
  },
  fwl: {
    detail_title: 'fwl.detail_title',
    list_title: 'fwl.list_title',
    name: 'fwl.name',
    cif: 'fwl.cif',
    address: 'fwl.address',
    county: 'fwl.county',
    nrComReg: 'fwl.nrComReg',
    phone: 'fwl.phone',
    fax: 'fwl.fax',
    capital: 'fwl.capital',
    bankAccounts: 'fwl.bankAccounts',
    bank: 'fwl.bank',
    account: 'fwl.account',
    edit: 'fwl.edit',
    remove: 'fwl.remove',
    back: 'fwl.back',
    yes: 'fwl.yes',
    no: 'fwl.no',
    search: 'fwl.search',
    save: 'fwl.save',
    firm_delete: 'fwl.firm_delete',
    firm_create: 'fwl.firm_create',
    firm_edit: 'fwl.firm_edit',
    confirm_delete: 'fwl.confirm_delete',
    createBankAccount: 'fwl.createBankAccount',
    reset: 'fwl.reset',
  },
  integ: {
    import_execution_list: 'integ.import_execution_list',
    date: 'integ.date',
    duration: 'integ.duration',
    import_label: 'integ.import_label',
    description: 'integ.description',
    owner: 'integ.owner',
    execution_status: 'integ.execution_status',
    label: 'integ.label',
    import_definition_list: 'integ.import_definition_list',
    upload: 'integ.upload',
    cancel: 'integ.cancel',
    create_import_def: 'integ.create_import_def',
    edit_import_def: 'integ.edit_import_def',
    delete: 'integ.delete',
    execution_details: 'integ.execution_details',
    import_parameters: 'integ.import_parameters',
    all_values: 'integ.all_values',
    _executionStatuses: {
      SUCCESS: 'integ._executionStatuses.SUCCESS',
      FAILED: 'integ._executionStatuses.FAILED',
      FAILURE: 'integ._executionStatuses.FAILURE',
    },
    msg: {
      q_delete_import_def: 'integ.msg.q_delete_import_def',
    },
  },
  'issue-reporter': {
    message: 'issue-reporter.message',
    submit_comment: 'issue-reporter.submit_comment',
    summary: 'issue-reporter.summary',
    type: 'issue-reporter.type',
    user: 'issue-reporter.user',
    description: 'issue-reporter.description',
    submit_feedback: 'issue-reporter.submit_feedback',
    actions_description: 'issue-reporter.actions_description',
    form: 'issue-reporter.form',
    'text-notes': 'issue-reporter.text-notes',
    paint: 'issue-reporter.paint',
    'form-description': 'issue-reporter.form-description',
    'text-notes-description': 'issue-reporter.text-notes-description',
    'paint-description': 'issue-reporter.paint-description',
  },
  job: {
    job_definitions: {
      job_definitions: 'job.job_definitions.job_definitions',
      job_parameters: 'job.job_definitions.job_parameters',
      status: {
        TRIGGERED: 'job.job_definitions.status.TRIGGERED',
        NOT_TRIGGERED: 'job.job_definitions.status.NOT_TRIGGERED',
        ARCHIVED: 'job.job_definitions.status.ARCHIVED',
        SCHEDULED: 'job.job_definitions.status.SCHEDULED',
        INTERRUPTED: 'job.job_definitions.status.INTERRUPTED',
        INTERRUPTED_TRIGGERED: 'job.job_definitions.status.INTERRUPTED_TRIGGERED',
      },
    },
    job_executions: {
      job_executions: 'job.job_executions.job_executions',
      processing_started_at: 'job.job_executions.processing_started_at',
      processing_ended_at: 'job.job_executions.processing_ended_at',
      jobExecutionStatus: {
        WAITING: 'job.job_executions.jobExecutionStatus.WAITING',
        PENDING: 'job.job_executions.jobExecutionStatus.PENDING',
        STOPPING: 'job.job_executions.jobExecutionStatus.STOPPING',
        HALTED: 'job.job_executions.jobExecutionStatus.HALTED',
        PROCESSING: 'job.job_executions.jobExecutionStatus.PROCESSING',
        SUCCESS: 'job.job_executions.jobExecutionStatus.SUCCESS',
        SUCCESSWITHWARNING: 'job.job_executions.jobExecutionStatus.SUCCESSWITHWARNING',
        SUCCESS_WITH_WARNING: 'job.job_executions.jobExecutionStatus.SUCCESS_WITH_WARNING',
        ERROR: 'job.job_executions.jobExecutionStatus.ERROR',
      },
      priority: {
        Lowest: 'job.job_executions.priority.Lowest',
        Lower: 'job.job_executions.priority.Lower',
        Low: 'job.job_executions.priority.Low',
        Medium: 'job.job_executions.priority.Medium',
        Default: 'job.job_executions.priority.Default',
        High: 'job.job_executions.priority.High',
        Higher: 'job.job_executions.priority.Higher',
        Highest: 'job.job_executions.priority.Highest',
      },
      cron_expression: 'job.job_executions.cron_expression',
      originator_system: 'job.job_executions.originator_system',
      execution_duration: 'job.job_executions.execution_duration',
    },
    log_executions: {
      log_executions: 'job.log_executions.log_executions',
      log_level: 'job.log_executions.log_level',
      thread_name: 'job.log_executions.thread_name',
      logger_name: 'job.log_executions.logger_name',
      log_message: 'job.log_executions.log_message',
      originator_system: 'job.log_executions.originator_system',
      processing_started_at: 'job.log_executions.processing_started_at',
      execution_duration: 'job.log_executions.execution_duration',
      processing_ended_at: 'job.log_executions.processing_ended_at',
    },
    search: 'job.search',
    options: 'job.options',
    date: {
      start: 'job.date.start',
      end: 'job.date.end',
    },
    _priority: {
      Lowest: 'job._priority.Lowest',
      Lower: 'job._priority.Lower',
      Low: 'job._priority.Low',
      Medium: 'job._priority.Medium',
      Default: 'job._priority.Default',
      High: 'job._priority.High',
      Higher: 'job._priority.Higher',
      Highest: 'job._priority.Highest',
    },
    job_descr: 'job.job_descr',
    job: 'job.job',
    job_name: 'job.job_name',
    priority: 'job.priority',
    status: 'job.status',
    createdAt: 'job.createdAt',
    lastTriggeredAt: 'job.lastTriggeredAt',
    utilization: 'job.utilization',
    utilizationHint: {
      UTILIZATION_MINOR: 'job.utilizationHint.UTILIZATION_MINOR',
      UTILIZATION_DEFAULT: 'job.utilizationHint.UTILIZATION_DEFAULT',
      UTILIZATION_CONSIDERABLE: 'job.utilizationHint.UTILIZATION_CONSIDERABLE',
      UTILIZATION_MAJOR: 'job.utilizationHint.UTILIZATION_MAJOR',
    },
    parameterType: {
      NUMERIC: 'job.parameterType.NUMERIC',
      STRING: 'job.parameterType.STRING',
      DATE: 'job.parameterType.DATE',
      BOOLEAN: 'job.parameterType.BOOLEAN',
    },
    exception_details: 'job.exception_details',
    details: 'job.details',
    prerequisistes: 'job.prerequisistes',
    retry: 'job.retry',
  },
  notif: {
    notifiable_event: 'notif.notifiable_event',
    mail_acc_list: 'notif.mail_acc_list',
    notif_config_list: 'notif.notif_config_list',
    notif_sender_config_list: 'notif.notif_sender_config_list',
    notifications_list: 'notif.notifications_list',
    host: 'notif.host',
    port: 'notif.port',
    username: 'notif.username',
    password: 'notif.password',
    protocol: 'notif.protocol',
    properties: 'notif.properties',
    recipients: 'notif.recipients',
    subject: 'notif.subject',
    add_new_acc: 'notif.add_new_acc',
    add_new_config: 'notif.add_new_config',
    delete_confirmation: 'notif.delete_confirmation',
    type: 'notif.type',
    event_type: 'notif.event_type',
    body: 'notif.body',
    date: 'notif.date',
    type_params: 'notif.type_params',
    content_params: 'notif.content_params',
    processing_status: 'notif.processing_status',
    group_content: 'notif.group_content',
    content_template: 'notif.content_template',
    group_content_template: 'notif.group_content_template',
    edit_config: 'notif.edit_config',
    expected_type_params: 'notif.expected_type_params',
    default_recipients: 'notif.default_recipients',
    description: 'notif.description',
    sender_type: 'notif.sender_type',
    config_params: 'notif.config_params',
    senders: 'notif.senders',
    msg: {
      delete: 'notif.msg.delete',
    },
    _eventType: {
      MISSING_TIMEKEEPING_ENTRIES: 'notif._eventType.MISSING_TIMEKEEPING_ENTRIES',
      MISSING_TIMEKEEPING_MANAGEMENT: 'notif._eventType.MISSING_TIMEKEEPING_MANAGEMENT',
      DELEGATION_ORDER_AWAITING_APPROVAL: 'notif._eventType.DELEGATION_ORDER_AWAITING_APPROVAL',
      DELEGATION_ORDER_APPROVED_OR_REJECTED: 'notif._eventType.DELEGATION_ORDER_APPROVED_OR_REJECTED',
    },
    sentList: {
      title: 'notif.sentList.title',
      createdAt: 'notif.sentList.createdAt',
      senderType: 'notif.sentList.senderType',
      eventType: 'notif.sentList.eventType',
      subject: 'notif.sentList.subject',
      recipientAddress: 'notif.sentList.recipientAddress',
      status: 'notif.sentList.status',
      processingStatus: 'notif.sentList.processingStatus',
      entityUuid: 'notif.sentList.entityUuid',
    },
    senderType: {
      EMAIL: 'notif.senderType.EMAIL',
      EMAIL_WITH_ATCH: 'notif.senderType.EMAIL_WITH_ATCH',
      SES_EMAIL: 'notif.senderType.SES_EMAIL',
      SES_EMAIL_WITH_ATTACH: 'notif.senderType.SES_EMAIL_WITH_ATTACH',
      IN_APP: 'notif.senderType.IN_APP',
      PUSH: 'notif.senderType.PUSH',
    },
    status: {
      PENDING: 'notif.status.PENDING',
      SENDING: 'notif.status.SENDING',
      FAILED_TO_SEND: 'notif.status.FAILED_TO_SEND',
      SENT: 'notif.status.SENT',
      SEEN: 'notif.status.SEEN',
    },
    processingStatus: {
      PENDING: 'notif.processingStatus.PENDING',
      PROCESSING: 'notif.processingStatus.PROCESSING',
      FAILED_TO_PROCESS: 'notif.processingStatus.FAILED_TO_PROCESS',
      PROCESSED: 'notif.processingStatus.PROCESSED',
    },
    utils: {
      all: 'notif.utils.all',
      search: 'notif.utils.search',
      tableEmptyMessage: 'notif.utils.tableEmptyMessage',
    },
  },
  pdf: {
    list_title: 'pdf.list_title',
    name: 'pdf.name',
    template: 'pdf.template',
    uploadFile: 'pdf.uploadFile',
    author: 'pdf.author',
    key: 'pdf.key',
    date: 'pdf.date',
    children: 'pdf.children',
    search: 'pdf.search',
    create: 'pdf.create',
    edit: 'pdf.edit',
    remove: 'pdf.remove',
    yes: 'pdf.yes',
    no: 'pdf.no',
    pdf_delete: 'pdf.pdf_delete',
    confirm_delete: 'pdf.confirm_delete',
    edit_title: 'pdf.edit_title',
    save: 'pdf.save',
    back: 'pdf.back',
    confirm_selection: 'pdf.confirm_selection',
    cancel: 'pdf.cancel',
    error: {
      defaultValidationMessage: 'pdf.error.defaultValidationMessage',
      required: 'pdf.error.required',
      requiredresources: 'pdf.error.requiredresources',
      requireddates: 'pdf.error.requireddates',
      startDateAfterEndDate: 'pdf.error.startDateAfterEndDate',
    },
  },
  pwl: {
    detail_title: 'pwl.detail_title',
    list_title: 'pwl.list_title',
    name: 'pwl.name',
    address: 'pwl.address',
    county: 'pwl.county',
    cnp: 'pwl.cnp',
    idSeries: 'pwl.idSeries',
    idNumber: 'pwl.idNumber',
    edit: 'pwl.edit',
    remove: 'pwl.remove',
    back: 'pwl.back',
    yes: 'pwl.yes',
    no: 'pwl.no',
    search: 'pwl.search',
    save: 'pwl.save',
    person_delete: 'pwl.person_delete',
    person_create: 'pwl.person_create',
    person_edit: 'pwl.person_edit',
    confirm_delete: 'pwl.confirm_delete',
    reset: 'pwl.reset',
  },
  'reporting-client-lib': {
    hello: 'reporting-client-lib.hello',
    search: 'reporting-client-lib.search',
    authorization: 'reporting-client-lib.authorization',
    parametrized: 'reporting-client-lib.parametrized',
    parameters: 'reporting-client-lib.parameters',
    createdBy: 'reporting-client-lib.createdBy',
    new: 'reporting-client-lib.new',
    name: 'reporting-client-lib.name',
    details: 'reporting-client-lib.details',
    folder: 'reporting-client-lib.folder',
    newFolder: 'reporting-client-lib.newFolder',
    createFolder: 'reporting-client-lib.createFolder',
    private: 'reporting-client-lib.private',
    save: 'reporting-client-lib.save',
    cancel: 'reporting-client-lib.cancel',
    date: 'reporting-client-lib.date',
    columns: 'reporting-client-lib.columns',
    download: 'reporting-client-lib.download',
    edit: 'reporting-client-lib.edit',
    delete: 'reporting-client-lib.delete',
    refresh: 'reporting-client-lib.refresh',
    createReport: 'reporting-client-lib.createReport',
    generateReport: 'reporting-client-lib.generateReport',
    generate: 'reporting-client-lib.generate',
    showGeneratedReports: 'reporting-client-lib.showGeneratedReports',
    back: 'reporting-client-lib.back',
    noRecords: 'reporting-client-lib.noRecords',
    template: {
      title: 'reporting-client-lib.template.title',
      edit: 'reporting-client-lib.template.edit',
      create: 'reporting-client-lib.template.create',
      createdBy: 'reporting-client-lib.template.createdBy',
      new: 'reporting-client-lib.template.new',
      xml: 'reporting-client-lib.template.xml',
      uploadXML: 'reporting-client-lib.template.uploadXML',
      xls: 'reporting-client-lib.template.xls',
      uploadXLS: 'reporting-client-lib.template.uploadXLS',
      parentFolder: 'reporting-client-lib.template.parentFolder',
    },
    report: {
      title: 'reporting-client-lib.report.title',
      edit: 'reporting-client-lib.report.edit',
      create: 'reporting-client-lib.report.create',
      template: 'reporting-client-lib.report.template',
      cron: {
        title: 'reporting-client-lib.report.cron.title',
        schedule: 'reporting-client-lib.report.cron.schedule',
        cronExpression: 'reporting-client-lib.report.cron.cronExpression',
        time: 'reporting-client-lib.report.cron.time',
        weekDays: 'reporting-client-lib.report.cron.weekDays',
        monthDays: 'reporting-client-lib.report.cron.monthDays',
        months: 'reporting-client-lib.report.cron.months',
      },
      filter: {
        title: 'reporting-client-lib.report.filter.title',
        columnName: 'reporting-client-lib.report.filter.columnName',
        dataType: 'reporting-client-lib.report.filter.dataType',
        filterType: 'reporting-client-lib.report.filter.filterType',
        values: 'reporting-client-lib.report.filter.values',
        negated: 'reporting-client-lib.report.filter.negated',
        filterTypes: {
          LIKE: 'reporting-client-lib.report.filter.filterTypes.LIKE',
          EQUALS: 'reporting-client-lib.report.filter.filterTypes.EQUALS',
          LT: 'reporting-client-lib.report.filter.filterTypes.LT',
          LE: 'reporting-client-lib.report.filter.filterTypes.LE',
          GT: 'reporting-client-lib.report.filter.filterTypes.GT',
          GE: 'reporting-client-lib.report.filter.filterTypes.GE',
          BETWEEN: 'reporting-client-lib.report.filter.filterTypes.BETWEEN',
          IN: 'reporting-client-lib.report.filter.filterTypes.IN',
          IS_NULL: 'reporting-client-lib.report.filter.filterTypes.IS_NULL',
        },
      },
    },
    generatedReports: {
      title: 'reporting-client-lib.generatedReports.title',
      dataLinesNumber: 'reporting-client-lib.generatedReports.dataLinesNumber',
      executionTime: 'reporting-client-lib.generatedReports.executionTime',
    },
    error: {
      'xml-error': 'reporting-client-lib.error.xml-error',
      'xls-error': 'reporting-client-lib.error.xls-error',
      'validation-error': 'reporting-client-lib.error.validation-error',
    },
  },
  'resource-availability': {
    resType: 'resource-availability.resType',
    resRole: 'resource-availability.resRole',
    availability: 'resource-availability.availability',
    name: 'resource-availability.name',
    department: 'resource-availability.department',
    delegation: 'resource-availability.delegation',
    partTimeDelegation: 'resource-availability.partTimeDelegation',
    fullTimeDelegation: 'resource-availability.fullTimeDelegation',
    selectResType: 'resource-availability.selectResType',
    selectRole: 'resource-availability.selectRole',
    search: 'resource-availability.search',
  },
  sswl: {
    list_title: 'sswl.list_title',
    name: 'sswl.name',
    system: 'sswl.system',
    name_filter: 'sswl.name_filter',
    value: 'sswl.value',
    add_new_setting: 'sswl.add_new_setting',
    delete_confirmation: 'sswl.delete_confirmation',
    type: 'sswl.type',
    msg: {
      delete: 'sswl.msg.delete',
    },
  },
  'user-action-tracking': {
    list: {
      userName: 'user-action-tracking.list.userName',
      userAction: 'user-action-tracking.list.userAction',
      userActionType: 'user-action-tracking.list.userActionType',
      actionUrl: 'user-action-tracking.list.actionUrl',
      actionedAt: 'user-action-tracking.list.actionedAt',
      trackedEntity: 'user-action-tracking.list.trackedEntity',
      search: 'user-action-tracking.list.search',
      all: 'user-action-tracking.list.all',
    },
    menu: {
      userActions: 'user-action-tracking.menu.userActions',
    },
    userAction: {
      offer_request_page_open: 'user-action-tracking.userAction.offer_request_page_open',
      offer_page_open: 'user-action-tracking.userAction.offer_page_open',
      order_page_open: 'user-action-tracking.userAction.order_page_open',
      invoice_page_open: 'user-action-tracking.userAction.invoice_page_open',
      inbox_open: 'user-action-tracking.userAction.inbox_open',
      outbox_open: 'user-action-tracking.userAction.outbox_open',
      sp_invoices_open: 'user-action-tracking.userAction.sp_invoices_open',
      customer_invoices_open: 'user-action-tracking.userAction.customer_invoices_open',
      sp_invoice_payments_open: 'user-action-tracking.userAction.sp_invoice_payments_open',
      customer_invoice_payments_open: 'user-action-tracking.userAction.customer_invoice_payments_open',
      homepage_open: 'user-action-tracking.userAction.homepage_open',
    },
    userActionType: {
      page_open: 'user-action-tracking.userActionType.page_open',
      button_press: 'user-action-tracking.userActionType.button_press',
      scroll: 'user-action-tracking.userActionType.scroll',
      page_exit: 'user-action-tracking.userActionType.page_exit',
    },
  },
  legalEntity: {
    autocompletePlaceholder: 'legalEntity.autocompletePlaceholder',
    existentAnafCompanyLabel: 'legalEntity.existentAnafCompanyLabel',
    noCompanyFound: 'legalEntity.noCompanyFound',
    addManualCompany: 'legalEntity.addManualCompany',
    selectCountry: 'legalEntity.selectCountry',
    closeInputs: 'legalEntity.closeInputs',
    autocomplete: 'legalEntity.autocomplete',
    country: 'legalEntity.country',
    inputs: {
      companyName: 'legalEntity.inputs.companyName',
      uniqueIdNumber: 'legalEntity.inputs.uniqueIdNumber',
      country: 'legalEntity.inputs.country',
      city: 'legalEntity.inputs.city',
      mainAddress: 'legalEntity.inputs.mainAddress',
      mainPhone: 'legalEntity.inputs.mainPhone',
      mainEmailAddress: 'legalEntity.inputs.mainEmailAddress',
      registrationCode: 'legalEntity.inputs.registrationCode',
      industryType: 'legalEntity.inputs.industryType',
      preferredLanguage: 'legalEntity.inputs.preferredLanguage',
      emailImportSettings: 'legalEntity.inputs.emailImportSettings',
      vatRegistration: 'legalEntity.inputs.vatRegistration',
      vatSplitStatus: 'legalEntity.inputs.vatSplitStatus',
      vatInactiveStatus: 'legalEntity.inputs.vatInactiveStatus',
      vatInactivationDate: 'legalEntity.inputs.vatInactivationDate',
      officeAddress: 'legalEntity.inputs.officeAddress',
      financialAddress: 'legalEntity.inputs.financialAddress',
    },
    error: {
      requiredCompanyName: 'legalEntity.error.requiredCompanyName',
      requiredUniqueIdNumber: 'legalEntity.error.requiredUniqueIdNumber',
      requiredCountry: 'legalEntity.error.requiredCountry',
      requiredPreferredLanguage: 'legalEntity.error.requiredPreferredLanguage',
      noLegalEntityCreated: 'legalEntity.error.noLegalEntityCreated',
      requiredOfficeAddressDTO: 'legalEntity.error.requiredOfficeAddressDTO',
      invalidOfficeAddressDTO: 'legalEntity.error.invalidOfficeAddressDTO',
      invalidFinancialAddressDTO: 'legalEntity.error.invalidFinancialAddressDTO',
      requiredFinancialAddressDTO: 'legalEntity.error.requiredFinancialAddressDTO',
      patternUniqueIdNumber: 'legalEntity.error.patternUniqueIdNumber',
    },
    confirmationDialog: {
      dialogHeader: 'legalEntity.confirmationDialog.dialogHeader',
      dialogMessage: 'legalEntity.confirmationDialog.dialogMessage',
      acceptLabel: 'legalEntity.confirmationDialog.acceptLabel',
      cancelLabel: 'legalEntity.confirmationDialog.cancelLabel',
    },
  },
  'offer-request': {
    'sp-offer-request-reject': {
      title: 'offer-request.sp-offer-request-reject.title',
      'reject-status': 'offer-request.sp-offer-request-reject.reject-status',
    },
  },
  order: {
    'add-page-title': 'order.add-page-title',
    addOrderSubcontractingPageTitle: 'order.addOrderSubcontractingPageTitle',
    'add-internal-page-title': 'order.add-internal-page-title',
    addPreOrderPageTitle: 'order.addPreOrderPageTitle',
    addPreOrderSubcontractingPageTitle: 'order.addPreOrderSubcontractingPageTitle',
    invalidCurrencyShipments: 'order.invalidCurrencyShipments',
    invalidShipmentTariffs: 'order.invalidShipmentTariffs',
    contactsMissing: 'order.contactsMissing',
    contract: 'order.contract',
    tariffs: 'order.tariffs',
    details: 'order.details',
    specialConditions: 'order.specialConditions',
    orderExternalPackages: 'order.orderExternalPackages',
    'navigation-suggestions': {
      back: 'order.navigation-suggestions.back',
    },
    errors: {
      requiredVendor: 'order.errors.requiredVendor',
    },
    orderNumber: 'order.orderNumber',
    clientOrders: 'order.clientOrders',
    price: 'order.price',
    currencyCode: 'order.currencyCode',
    customerName: 'order.customerName',
  },
  person: {
    idSeries: 'person.idSeries',
    idNumber: 'person.idNumber',
  },
  'resource-dropdown': {
    utils: {
      'empty-message': 'resource-dropdown.utils.empty-message',
    },
  },
  'select-items': {
    all: 'select-items.all',
  },
  emptyListPlaceholder: {
    description: 'emptyListPlaceholder.description',
    changeFilters: 'emptyListPlaceholder.changeFilters',
  },
  price: {
    value: 'price.value',
    currencyCode: 'price.currencyCode',
  },
  timeAvailability: {
    error: {
      minValueExceededDuration: 'timeAvailability.error.minValueExceededDuration',
      requiredDuration: 'timeAvailability.error.requiredDuration',
      requiredUnit: 'timeAvailability.error.requiredUnit',
    },
  },
  'terms-and-conditions': {
    'preview-title': 'terms-and-conditions.preview-title',
    'not-found': 'terms-and-conditions.not-found',
    comments: 'terms-and-conditions.comments',
    currentStatus: 'terms-and-conditions.currentStatus',
    statuses: {
      accepted: 'terms-and-conditions.statuses.accepted',
      rejected: 'terms-and-conditions.statuses.rejected',
    },
  },
  'company-details': {
    details: 'company-details.details',
    'terms-and-conditions': 'company-details.terms-and-conditions',
  },
  place: {
    searchOnGoogle: 'place.searchOnGoogle',
  },
  'suggestion-message': {
    title: 'suggestion-message.title',
    'button-tooltip': 'suggestion-message.button-tooltip',
  },
  'wip-message': {
    title: 'wip-message.title',
    description: 'wip-message.description',
  },
  'alert-notification': {
    message: 'alert-notification.message',
    solve: 'alert-notification.solve',
  },
  resourceSavedNavigationDialog: {
    title: 'resourceSavedNavigationDialog.title',
    backButton: 'resourceSavedNavigationDialog.backButton',
    closeButton: 'resourceSavedNavigationDialog.closeButton',
  },
  globalFilter: {
    minimizeFilters: 'globalFilter.minimizeFilters',
    expandFilters: 'globalFilter.expandFilters',
  },
  'select-account': 'select-account',
  abstractNotifiableEntityContact: {
    editTooltip: 'abstractNotifiableEntityContact.editTooltip',
    editDisabledTooltip: 'abstractNotifiableEntityContact.editDisabledTooltip',
  },
  'bp-selectable-contact-list': {
    'contact-list-title': 'bp-selectable-contact-list.contact-list-title',
    selected: 'bp-selectable-contact-list.selected',
    noContactsSelected: 'bp-selectable-contact-list.noContactsSelected',
  },
  'abstract-entity-contact-list-update-popup': {
    title: 'abstract-entity-contact-list-update-popup.title',
    update: 'abstract-entity-contact-list-update-popup.update',
  },
  user: {
    phoneNumberNotValidated: 'user.phoneNumberNotValidated',
  },
  attachmentUploader: {
    browse: 'attachmentUploader.browse',
  },
  'shipment-timeline': {
    'shipment-management': 'shipment-timeline.shipment-management',
    'notification-monitoring': 'shipment-timeline.notification-monitoring',
    'notification-monitoring-tooltip': 'shipment-timeline.notification-monitoring-tooltip',
    'delivery-monitoring': 'shipment-timeline.delivery-monitoring',
    offerRequestTab: {
      receivedOfferRequest: 'shipment-timeline.offerRequestTab.receivedOfferRequest',
      offersSent: 'shipment-timeline.offerRequestTab.offersSent',
      offerAccepted: 'shipment-timeline.offerRequestTab.offerAccepted',
      offerRefused: 'shipment-timeline.offerRequestTab.offerRefused',
    },
    orderTab: {
      orderReceived: 'shipment-timeline.orderTab.orderReceived',
      currency: 'shipment-timeline.orderTab.currency',
      price: 'shipment-timeline.orderTab.price',
      viewVehicle: 'shipment-timeline.orderTab.viewVehicle',
      viewResume: 'shipment-timeline.orderTab.viewResume',
    },
    solutionTab: {
      solution: 'shipment-timeline.solutionTab.solution',
      notAllow: 'shipment-timeline.solutionTab.notAllow',
      routingOptions: 'shipment-timeline.solutionTab.routingOptions',
      completeSolutions: 'shipment-timeline.solutionTab.completeSolutions',
      preferredCompleteSolution: 'shipment-timeline.solutionTab.preferredCompleteSolution',
      receivedOffers: 'shipment-timeline.solutionTab.receivedOffers',
      requestOffer: 'shipment-timeline.solutionTab.requestOffer',
      requestPreOffer: 'shipment-timeline.solutionTab.requestPreOffer',
      completeSolution: 'shipment-timeline.solutionTab.completeSolution',
      signup: 'shipment-timeline.solutionTab.signup',
      order: 'shipment-timeline.solutionTab.order',
      orderDisabled: 'shipment-timeline.solutionTab.orderDisabled',
      preOrder: 'shipment-timeline.solutionTab.preOrder',
      preOrderDisabled: 'shipment-timeline.solutionTab.preOrderDisabled',
      task: 'shipment-timeline.solutionTab.task',
      taskDisabled: 'shipment-timeline.solutionTab.taskDisabled',
      taskTooltip: 'shipment-timeline.solutionTab.taskTooltip',
      requestOfferTooltip: 'shipment-timeline.solutionTab.requestOfferTooltip',
      orderTooltip: 'shipment-timeline.solutionTab.orderTooltip',
    },
    orderTrackingTab: {
      transport: 'shipment-timeline.orderTrackingTab.transport',
      segmentsSolution: 'shipment-timeline.orderTrackingTab.segmentsSolution',
      pickUpDate: 'shipment-timeline.orderTrackingTab.pickUpDate',
      in_transit: 'shipment-timeline.orderTrackingTab.in_transit',
      complaints: 'shipment-timeline.orderTrackingTab.complaints',
    },
    invoiceTab: {
      invoice: 'shipment-timeline.invoiceTab.invoice',
      account: 'shipment-timeline.invoiceTab.account',
      paymentTerm: 'shipment-timeline.invoiceTab.paymentTerm',
    },
    utils: {
      shipments: 'shipment-timeline.utils.shipments',
      availableDocuments: 'shipment-timeline.utils.availableDocuments',
      attachments: 'shipment-timeline.utils.attachments',
      date: 'shipment-timeline.utils.date',
      orderStatus: 'shipment-timeline.utils.orderStatus',
      workInProgressSolution: 'shipment-timeline.utils.workInProgressSolution',
      addSolution: 'shipment-timeline.utils.addSolution',
      consolidation: 'shipment-timeline.utils.consolidation',
      inactiveTooltip: 'shipment-timeline.utils.inactiveTooltip',
    },
    change: {
      offer_added: 'shipment-timeline.change.offer_added',
      offer_received: 'shipment-timeline.change.offer_received',
      order_created: 'shipment-timeline.change.order_created',
      order_status_updated: 'shipment-timeline.change.order_status_updated',
      invoice_created: 'shipment-timeline.change.invoice_created',
      segment_solution_created: 'shipment-timeline.change.segment_solution_created',
      mrs_created: 'shipment-timeline.change.mrs_created',
      marked_mrs_preferred: 'shipment-timeline.change.marked_mrs_preferred',
    },
  },
  'payment-method': {
    'long-processing-warning': 'payment-method.long-processing-warning',
    retry: 'payment-method.retry',
    'pending-payment-method': 'payment-method.pending-payment-method',
    'change-payment-method': 'payment-method.change-payment-method',
    refresh: 'payment-method.refresh',
    'failed-payment-method': 'payment-method.failed-payment-method',
    'payment-order': 'payment-method.payment-order',
    'payment-method': 'payment-method.payment-method',
  },
  signup: {
    'company-info': 'signup.company-info',
    subscription: 'signup.subscription',
    'payment-info': 'signup.payment-info',
    payment: {
      paymentOrder: 'signup.payment.paymentOrder',
      card: 'signup.payment.card',
      error: 'signup.payment.error',
      paymentMethod: 'signup.payment.paymentMethod',
      terms: 'signup.payment.terms',
      termsAccept: 'signup.payment.termsAccept',
      go: 'signup.payment.go',
    },
    contact: 'signup.contact',
    save: 'signup.save',
    password: 'signup.password',
    confirm: 'signup.confirm',
    error: {
      requiredCompanyName: 'signup.error.requiredCompanyName',
      requiredUniqueIdNumber: 'signup.error.requiredUniqueIdNumber',
      requiredCountry: 'signup.error.requiredCountry',
      requiredPreferredLanguage: 'signup.error.requiredPreferredLanguage',
      requiredInvoiceSeriesPrefix: 'signup.error.requiredInvoiceSeriesPrefix',
      companyTypeMismatch: 'signup.error.companyTypeMismatch',
      patternUniqueIdNumber: 'signup.error.patternUniqueIdNumber',
    },
    address: {
      errors: {
        alreadyExistingAddressOfType: 'signup.address.errors.alreadyExistingAddressOfType',
      },
    },
    companyInfo: {
      title: 'signup.companyInfo.title',
      confirmLegalEntitySignup: 'signup.companyInfo.confirmLegalEntitySignup',
      confirmPassword: {
        error: {
          'Bad credentials': 'signup.companyInfo.confirmPassword.error.Bad credentials',
        },
      },
    },
    firstContact: {
      visibilityTypes: {
        PUBLIC: 'signup.firstContact.visibilityTypes.PUBLIC',
        CUSTOMER: 'signup.firstContact.visibilityTypes.CUSTOMER',
        SERVICE_PROVIDER: 'signup.firstContact.visibilityTypes.SERVICE_PROVIDER',
        BOTH: 'signup.firstContact.visibilityTypes.BOTH',
        NONE: 'signup.firstContact.visibilityTypes.NONE',
      },
      contactMethods: {
        EMAIL: 'signup.firstContact.contactMethods.EMAIL',
        TEL: 'signup.firstContact.contactMethods.TEL',
        VISIT: 'signup.firstContact.contactMethods.VISIT',
      },
      inputs: {
        phoneNumber: 'signup.firstContact.inputs.phoneNumber',
        email: 'signup.firstContact.inputs.email',
        receivesRequests: 'signup.firstContact.inputs.receivesRequests',
        receivesRequestsRequiredTooltip: 'signup.firstContact.inputs.receivesRequestsRequiredTooltip',
        contactMethod: 'signup.firstContact.inputs.contactMethod',
        visibilityType: 'signup.firstContact.inputs.visibilityType',
        departmentName: 'signup.firstContact.inputs.departmentName',
        newDepartment: 'signup.firstContact.inputs.newDepartment',
        validFrom: 'signup.firstContact.inputs.validFrom',
        validTo: 'signup.firstContact.inputs.validTo',
      },
      error: {
        requiredPerson: 'signup.firstContact.error.requiredPerson',
        requiredValidFrom: 'signup.firstContact.error.requiredValidFrom',
        requiredVisibility: 'signup.firstContact.error.requiredVisibility',
        requiredPhoneNumber: 'signup.firstContact.error.requiredPhoneNumber',
        requiredEmail: 'signup.firstContact.error.requiredEmail',
        requiredContactMethod: 'signup.firstContact.error.requiredContactMethod',
        DuplicateUniqueID: 'signup.firstContact.error.DuplicateUniqueID',
        DuplicateCompanyName: 'signup.firstContact.error.DuplicateCompanyName',
        companyNamerequired: 'signup.firstContact.error.companyNamerequired',
        uniqueIdNumberrequired: 'signup.firstContact.error.uniqueIdNumberrequired',
        cityrequired: 'signup.firstContact.error.cityrequired',
        countryrequired: 'signup.firstContact.error.countryrequired',
        requiredInvoiceSeriesPrefix: 'signup.firstContact.error.requiredInvoiceSeriesPrefix',
      },
    },
    successfulIfValid: 'signup.successfulIfValid',
    actions: {
      detailTitle: 'signup.actions.detailTitle',
      addTitle: 'signup.actions.addTitle',
      list: {
        adminTitle: 'signup.actions.list.adminTitle',
        title: 'signup.actions.list.title',
        name: 'signup.actions.list.name',
        cost: 'signup.actions.list.cost',
        validFrom: 'signup.actions.list.validFrom',
        validTo: 'signup.actions.list.validTo',
        search: 'signup.actions.list.search',
        subscriptionTypeName: 'signup.actions.list.subscriptionTypeName',
        subscriptionTypeModule: 'signup.actions.list.subscriptionTypeModule',
        monthlyIncludedAmount: 'signup.actions.list.monthlyIncludedAmount',
      },
      inputs: {
        actionName: 'signup.actions.inputs.actionName',
        validFrom: 'signup.actions.inputs.validFrom',
        validTo: 'signup.actions.inputs.validTo',
        actionCost: 'signup.actions.inputs.actionCost',
        monthlyIncludedAmount: 'signup.actions.inputs.monthlyIncludedAmount',
      },
      errors: {
        requiredcost: 'signup.actions.errors.requiredcost',
        requiredactionName: 'signup.actions.errors.requiredactionName',
      },
    },
    'subscription-plan': {
      title: 'signup.subscription-plan.title',
      'card-info': 'signup.subscription-plan.card-info',
    },
    'subscription-type': {
      'list-title': 'signup.subscription-type.list-title',
      'add-title': 'signup.subscription-type.add-title',
      'new-actions': 'signup.subscription-type.new-actions',
      add: 'signup.subscription-type.add',
      companies: 'signup.subscription-type.companies',
      private: 'signup.subscription-type.private',
      subscription: {
        legalEntity: 'signup.subscription-type.subscription.legalEntity',
        detail: 'signup.subscription-type.subscription.detail',
        list: {
          title: 'signup.subscription-type.subscription.list.title',
        },
      },
      actions: {
        'offer-request': 'signup.subscription-type.actions.offer-request',
        info: 'signup.subscription-type.actions.info',
        monthlyIncludedAmount: 'signup.subscription-type.actions.monthlyIncludedAmount',
        actionCost: 'signup.subscription-type.actions.actionCost',
        creditStart: 'signup.subscription-type.actions.creditStart',
        CREATE_OFFER: 'signup.subscription-type.actions.CREATE_OFFER',
        SEND_ORDER: 'signup.subscription-type.actions.SEND_ORDER',
        RECEIVE_ORDER: 'signup.subscription-type.actions.RECEIVE_ORDER',
      },
      errors: {
        requiredtypeName: 'signup.subscription-type.errors.requiredtypeName',
        requiredsubscriptionPrice: 'signup.subscription-type.errors.requiredsubscriptionPrice',
        requiredsubscriptionCurrency: 'signup.subscription-type.errors.requiredsubscriptionCurrency',
      },
      inputs: {
        creditStart: 'signup.subscription-type.inputs.creditStart',
        private: 'signup.subscription-type.inputs.private',
        subscriptionCurrency: 'signup.subscription-type.inputs.subscriptionCurrency',
        subscriptionPrice: 'signup.subscription-type.inputs.subscriptionPrice',
        legalEntity: 'signup.subscription-type.inputs.legalEntity',
        typeName: 'signup.subscription-type.inputs.typeName',
      },
    },
    title: 'signup.title',
    companyTabTitle: 'signup.companyTabTitle',
    companyTabHeader: 'signup.companyTabHeader',
    companyFormSubTitle: 'signup.companyFormSubTitle',
    existingCompanyError: 'signup.existingCompanyError',
    firstEmployee: 'signup.firstEmployee',
    firstUser: 'signup.firstUser',
    bankAccountTabTitle: 'signup.bankAccountTabTitle',
    bankAccountTabHeader: 'signup.bankAccountTabHeader',
    subscriptionTypeTabTitle: 'signup.subscriptionTypeTabTitle',
    subscriptionTypeTabHeader: 'signup.subscriptionTypeTabHeader',
    cardTabTitle: 'signup.cardTabTitle',
    cardTabHeader: 'signup.cardTabHeader',
    autocompletePlaceholder: 'signup.autocompletePlaceholder',
    addCompany: 'signup.addCompany',
    legalEntityNotFound: 'signup.legalEntityNotFound',
    indication: 'signup.indication',
    close: 'signup.close',
    companyName: 'signup.companyName',
    uniqueIdNumber: 'signup.uniqueIdNumber',
    country: 'signup.country',
    city: 'signup.city',
    mainAddress: 'signup.mainAddress',
    mainPhone: 'signup.mainPhone',
    mainEmailAddress: 'signup.mainEmailAddress',
    registrationCode: 'signup.registrationCode',
    industryTypeValue: 'signup.industryTypeValue',
    preferredLanguage: 'signup.preferredLanguage',
    emailImportSettings: 'signup.emailImportSettings',
    vat: 'signup.vat',
    vatRegistration: 'signup.vatRegistration',
    vatSplitStatus: 'signup.vatSplitStatus',
    vatInactiveStatus: 'signup.vatInactiveStatus',
    vatInactivationDate: 'signup.vatInactivationDate',
    editData: 'signup.editData',
    companyRegistration: 'signup.companyRegistration',
    selectIndustryType: 'signup.selectIndustryType',
    createServiceProvider: 'signup.createServiceProvider',
    invoiceSeriesPrefix: 'signup.invoiceSeriesPrefix',
    startingBalance: 'signup.startingBalance',
    discount: 'signup.discount',
    description: 'signup.description',
    'terms-and-conditions': 'signup.terms-and-conditions',
    'account-type': {
      title: 'signup.account-type.title',
      client: 'signup.account-type.client',
      'expedition-house': 'signup.account-type.expedition-house',
      'client-with-fleet': 'signup.account-type.client-with-fleet',
      vendor: 'signup.account-type.vendor',
      'client-description': 'signup.account-type.client-description',
      'expedition-house-description': 'signup.account-type.expedition-house-description',
      'vendor-description': 'signup.account-type.vendor-description',
      'client-with-fleet-description': 'signup.account-type.client-with-fleet-description',
    },
    utils: {
      choose: 'signup.utils.choose',
      edit: 'signup.utils.edit',
      close: 'signup.utils.close',
      save: 'signup.utils.save',
      select: 'signup.utils.select',
      cancel: 'signup.utils.cancel',
      all: 'signup.utils.all',
      requiredLabel: 'signup.utils.requiredLabel',
      next: 'signup.utils.next',
    },
    creditCard: {
      card: 'signup.creditCard.card',
      cardNumber: 'signup.creditCard.cardNumber',
      expirationDate: 'signup.creditCard.expirationDate',
      cardOwner: 'signup.creditCard.cardOwner',
      expirationDateFormat: 'signup.creditCard.expirationDateFormat',
      error: {
        invalidCardNumber: 'signup.creditCard.error.invalidCardNumber',
        invalidExpirationDate: 'signup.creditCard.error.invalidExpirationDate',
        requiredCardNumber: 'signup.creditCard.error.requiredCardNumber',
        requiredExpirationDate: 'signup.creditCard.error.requiredExpirationDate',
        requiredName: 'signup.creditCard.error.requiredName',
      },
    },
    employee: {
      common: {
        departmentName: 'signup.employee.common.departmentName',
        newDepartment: 'signup.employee.common.newDepartment',
      },
      error: {
        requireduserName: 'signup.employee.error.requireduserName',
        requiredpassword: 'signup.employee.error.requiredpassword',
        requiredname: 'signup.employee.error.requiredname',
        requiredcounty: 'signup.employee.error.requiredcounty',
        requiredValidFrom: 'signup.employee.error.requiredValidFrom',
        requiredValidTo: 'signup.employee.error.requiredValidTo',
        requiredPerson: 'signup.employee.error.requiredPerson',
      },
    },
  },
  address: {
    addressLabel: 'address.addressLabel',
    type: 'address.type',
    addressLine: 'address.addressLine',
    locationChanged: 'address.locationChanged',
    city: 'address.city',
    state: 'address.state',
    postalCode: 'address.postalCode',
    country: 'address.country',
    'address-title': 'address.address-title',
    location: 'address.location',
    visibility: 'address.visibility',
    addNew: 'address.addNew',
    choose: 'address.choose',
    searchSavedAddress: 'address.searchSavedAddress',
    mainAddress: 'address.mainAddress',
    selectAddress: 'address.selectAddress',
    streetName: 'address.streetName',
    streetNumber: 'address.streetNumber',
    countyCode: 'address.countyCode',
    block: 'address.block',
    building: 'address.building',
    floor: 'address.floor',
    apartment: 'address.apartment',
    details: 'address.details',
    clearSelection: 'address.clearSelection',
    readonlyAddressType: 'address.readonlyAddressType',
    addressIsNotOwned: 'address.addressIsNotOwned',
    list: {
      label: 'address.list.label',
      type: 'address.list.type',
      city: 'address.list.city',
      state: 'address.list.state',
      addressLine: 'address.list.addressLine',
      postalCode: 'address.list.postalCode',
      country: 'address.list.country',
      search: 'address.list.search',
      ownerCompanyName: 'address.list.ownerCompanyName',
      companyName: 'address.list.companyName',
      visibilityType: 'address.list.visibilityType',
    },
    addressTypes: {
      Registered: 'address.addressTypes.Registered',
      Billing: 'address.addressTypes.Billing',
      Decision: 'address.addressTypes.Decision',
      Delivery: 'address.addressTypes.Delivery',
      Main: 'address.addressTypes.Main',
      Pickup: 'address.addressTypes.Pickup',
      Shipping: 'address.addressTypes.Shipping',
      Warehouse: 'address.addressTypes.Warehouse',
      Invoicing: 'address.addressTypes.Invoicing',
      Correspondence: 'address.addressTypes.Correspondence',
      FiscalResidence: 'address.addressTypes.FiscalResidence',
      Office: 'address.addressTypes.Office',
    },
    visibilityTypes: {
      null: 'address.visibilityTypes.null',
      PUBLIC: 'address.visibilityTypes.PUBLIC',
      CUSTOMER: 'address.visibilityTypes.CUSTOMER',
      SERVICE_PROVIDER: 'address.visibilityTypes.SERVICE_PROVIDER',
      BOTH: 'address.visibilityTypes.BOTH',
      NONE: 'address.visibilityTypes.NONE',
    },
    error: {
      maxDistanceExceeded: 'address.error.maxDistanceExceeded',
      ZERO_RESULTS: 'address.error.ZERO_RESULTS',
      requiredaddress: 'address.error.requiredaddress',
      requiredCity: 'address.error.requiredCity',
      requiredState: 'address.error.requiredState',
      requiredStreetName: 'address.error.requiredStreetName',
      requiredStreetNumber: 'address.error.requiredStreetNumber',
      requiredAddressLabel: 'address.error.requiredaddressLabel',
      requiredCountry: 'address.error.requiredcountry',
      requiredPostalCode: 'address.error.requiredpostalCode',
      requiredVisibilityType: 'address.error.requiredvisibilityType',
      requiredAddressTypeValue: 'address.error.addressTypeValuerequired',
      noAddressSelected: 'address.error.noAddressSelected',
      requiredAddressValueType: 'address.error.requiredaddressValueType',
      pinDistanceTooLong: 'address.error.pinDistanceTooLong',
    },
    addressPickup: {
      saveAddress: 'address.addressPickup.saveAddress',
    },
    'search-box': {
      label: 'address.search-box.label',
      local: 'address.search-box.local',
      google: 'address.search-box.google',
      'update-address': 'address.search-box.update-address',
    },
    hideDialog: 'address.hideDialog',
    'save-address-title': 'address.save-address-title',
    'save-address-label': 'address.save-address-label',
    'save-disabled': 'address.save-disabled',
    inaccurateAddressMessage: 'address.inaccurateAddressMessage',
    savedAddressMessage: 'address.savedAddressMessage',
    utils: {
      all: 'address.utils.all',
      save: 'address.utils.save',
      apply: 'address.utils.apply',
      deleteConfirmation: 'address.utils.deleteConfirmation',
      yes: 'address.utils.yes',
      no: 'address.utils.no',
    },
    google: {
      status: {
        ZERO_RESULTS: 'address.google.status.ZERO_RESULTS',
        UNKNOWN_ERROR: 'address.google.status.UNKNOWN_ERROR',
        REQUEST_DENIED: 'address.google.status.REQUEST_DENIED',
        OVER_QUERY_LIMIT: 'address.google.status.OVER_QUERY_LIMIT',
        NOT_FOUND: 'address.google.status.NOT_FOUND',
        INVALID_REQUEST: 'address.google.status.INVALID_REQUEST',
      },
    },
  },
  account: {
    'list-title': 'account.list-title',
    'new-title': 'account.new-title',
    customerName: 'account.customerName',
    serviceProviderName: 'account.serviceProviderName',
    billingName: 'account.billingName',
    billingAccountNumber: 'account.billingAccountNumber',
    billingCycle: 'account.billingCycle',
    contactName: 'account.contactName',
    contactPhoneNumber: 'account.contactPhoneNumber',
    phoneNumber: 'account.phoneNumber',
    contactEmail: 'account.contactEmail',
    email: 'account.email',
    accountName: 'account.accountName',
    accountNumber: 'account.accountNumber',
    accountStatus: 'account.accountStatus',
    accountCreatedAt: 'account.accountCreatedAt',
    accountRequestedAt: 'account.accountRequestedAt',
    accountClosedAt: 'account.accountClosedAt',
    'payment-time-limit': 'account.payment-time-limit',
    creditStopped: 'account.creditStopped',
    creditStoppedReason: 'account.creditStoppedReason',
    creditCloseDate: 'account.creditCloseDate',
    creditLimit: 'account.creditLimit',
    creditAvailable: 'account.creditAvailable',
    firstShipmentDate: 'account.firstShipmentDate',
    latestShipmentDate: 'account.latestShipmentDate',
    status: 'account.status',
    customer: 'account.customer',
    address: 'account.address',
    contact: 'account.contact',
    'account-status-value': {
      requested: 'account.account-status-value.requested',
      created: 'account.account-status-value.created',
      closed: 'account.account-status-value.closed',
    },
    utils: {
      'columns-selected': 'account.utils.columns-selected',
      'choose-columns': 'account.utils.choose-columns',
      search: 'account.utils.search',
      'advanced-filters': 'account.utils.advanced-filters',
      preview: 'account.utils.preview',
      save: 'account.utils.save',
      send: 'account.utils.send',
      update: 'account.utils.update',
      cancel: 'account.utils.cancel',
      close: 'account.utils.close',
      reset: 'account.utils.reset',
      delete: 'account.utils.delete',
      add: 'account.utils.add',
      addFile: 'account.utils.addFile',
      choose: 'account.utils.choose',
      chooseFile: 'account.utils.chooseFile',
      requiredLegend: 'account.utils.requiredLegend',
      'boolean-select-item': {
        true: 'account.utils.boolean-select-item.true',
        false: 'account.utils.boolean-select-item.false',
        null: 'account.utils.boolean-select-item.null',
      },
      showAllPackages: 'account.utils.showAllPackages',
      showLess: 'account.utils.showLess',
    },
    error: {
      defaultValidationMessage: 'account.error.defaultValidationMessage',
      required: 'account.error.required',
      requiredName: 'account.error.requiredName',
      requiredCode: 'account.error.requiredCode',
      requiredValue: 'account.error.requiredValue',
      requiredStartDate: 'account.error.requiredStartDate',
      requiredFinishDate: 'account.error.requiredFinishDate',
      startDateAfterEndDate: 'account.error.startDateAfterEndDate',
      requiredCustomer: 'account.error.requiredCustomer',
      requiredAccountName: 'account.error.requiredAccountName',
      requiredPaymentTimeLimit: 'account.error.requiredPaymentTimeLimit',
    },
    billingCycleEnum: {
      Per_shipment: 'account.billingCycleEnum.Per_shipment',
      Weekly: 'account.billingCycleEnum.Weekly',
      Monthly: 'account.billingCycleEnum.Monthly',
      Bi_monthly: 'account.billingCycleEnum.Bi_monthly',
      Manual: 'account.billingCycleEnum.Manual',
    },
  },
  companyAsset: {
    unsupportedType: 'companyAsset.unsupportedType',
  },
  globalAccount: 'globalAccount',
  code: 'code',
  add: 'add',
  close: 'close',
  type: 'type',
  wss: {
    toggleOfferRequestValidators: 'wss.toggleOfferRequestValidators',
  },
  'invoice-payment': {
    actions: {
      accept: 'invoice-payment.actions.accept',
      reject: 'invoice-payment.actions.reject',
    },
    'new-per-invoice': {
      title: 'invoice-payment.new-per-invoice.title',
      infoText: 'invoice-payment.new-per-invoice.infoText',
    },
    'payment-form': {
      toBankAccount: 'invoice-payment.payment-form.toBankAccount',
      fromBankAccount: 'invoice-payment.payment-form.fromBankAccount',
      paymentDate: 'invoice-payment.payment-form.paymentDate',
      paidAmount: 'invoice-payment.payment-form.paidAmount',
      paymentReference: 'invoice-payment.payment-form.paymentReference',
      currency: 'invoice-payment.payment-form.currency',
    },
    errors: {
      requiredToBankAccountUuid: 'invoice-payment.errors.requiredToBankAccountUuid',
      requiredFromBankAccountUuid: 'invoice-payment.errors.requiredFromBankAccountUuid',
      requiredPaymentDate: 'invoice-payment.errors.requiredPaymentDate',
      requiredPaidAmount: 'invoice-payment.errors.requiredPaidAmount',
      requiredCurrencyCode: 'invoice-payment.errors.requiredCurrencyCode',
      maxValueExceeded: 'invoice-payment.errors.maxValueExceeded',
    },
    list: {
      'payments-title': 'invoice-payment.list.payments-title',
      sendPaymentDoneMail: 'invoice-payment.list.sendPaymentDoneMail',
      acceptPaymentMessage: 'invoice-payment.list.acceptPaymentMessage',
      paymentAgreementStatus: 'invoice-payment.list.paymentAgreementStatus',
      'receipts-title': 'invoice-payment.list.receipts-title',
      invoiceSeries: 'invoice-payment.list.invoiceSeries',
      customerName: 'invoice-payment.list.customerName',
      serviceProviderName: 'invoice-payment.list.serviceProviderName',
      currencyCode: 'invoice-payment.list.currencyCode',
      paidAmount: 'invoice-payment.list.paidAmount',
      sold: 'invoice-payment.list.sold',
      paymentDate: 'invoice-payment.list.paymentDate',
      fromBankAccount: 'invoice-payment.list.fromBankAccount',
      toBankAccount: 'invoice-payment.list.toBankAccount',
      openPartialPayments: 'invoice-payment.list.openPartialPayments',
      cancelPayment: 'invoice-payment.list.cancelPayment',
      deallocatePayment: 'invoice-payment.list.deallocatePayment',
      paymentStatus: 'invoice-payment.list.paymentStatus',
      paymentReference: 'invoice-payment.list.paymentReference',
      createdBy: 'invoice-payment.list.createdBy',
      canceledBy: 'invoice-payment.list.canceledBy',
      invoiceDetailsTooltip: 'invoice-payment.list.invoiceDetailsTooltip',
      paymentStatuses: {
        accepted: 'invoice-payment.list.paymentStatuses.accepted',
        canceled: 'invoice-payment.list.paymentStatuses.canceled',
        deallocated: 'invoice-payment.list.paymentStatuses.deallocated',
      },
      invoicePaymentStatus: {
        PARTIAL_PAID: 'invoice-payment.list.invoicePaymentStatus.PARTIAL_PAID',
        PAID: 'invoice-payment.list.invoicePaymentStatus.PAID',
        UNPAID: 'invoice-payment.list.invoicePaymentStatus.UNPAID',
      },
      paymentAgreementStatuses: {
        pending: 'invoice-payment.list.paymentAgreementStatuses.pending',
        finalized: 'invoice-payment.list.paymentAgreementStatuses.finalized',
        rejected: 'invoice-payment.list.paymentAgreementStatuses.rejected',
      },
    },
    filters: {
      paymentAgreementStatusPending: 'invoice-payment.filters.paymentAgreementStatusPending',
    },
    utils: {
      all: 'invoice-payment.utils.all',
      search: 'invoice-payment.utils.search',
      yes: 'invoice-payment.utils.yes',
      no: 'invoice-payment.utils.no',
      confirm: 'invoice-payment.utils.confirm',
    },
    'mark-as-paid': {
      title: 'invoice-payment.mark-as-paid.title',
      customer: {
        title: 'invoice-payment.mark-as-paid.customer.title',
      },
    },
    'cancel-payment-form': {
      cancelReason: 'invoice-payment.cancel-payment-form.cancelReason',
      errors: {
        requiredCancelReason: 'invoice-payment.cancel-payment-form.errors.requiredCancelReason',
      },
    },
    'reject-payment-form': {
      reason: 'invoice-payment.reject-payment-form.reason',
    },
    'deallocate-payment-form': {
      deallocateReason: 'invoice-payment.deallocate-payment-form.deallocateReason',
      errors: {
        requiredDeallocateReason: 'invoice-payment.deallocate-payment-form.errors.requiredDeallocateReason',
      },
    },
    customer: {
      title: 'invoice-payment.customer.title',
      infoText: 'invoice-payment.customer.infoText',
    },
  },
  'invoice-partial-payments': {
    list: {
      title: 'invoice-partial-payments.list.title',
    },
  },
  'invoice-cancel': {
    title: 'invoice-cancel.title',
    description: 'invoice-cancel.description',
  },
  'invoice-payment-reject': {
    title: 'invoice-payment-reject.title',
  },
  'invoice-payment-deallocate': {
    title: 'invoice-payment-deallocate.title',
  },
  personManagement: {
    input: {
      name: 'personManagement.input.name',
      idSeries: 'personManagement.input.idSeries',
      idNumber: 'personManagement.input.idNumber',
      address: 'personManagement.input.address',
      county: 'personManagement.input.county',
      country: 'personManagement.input.country',
      error: {
        requiredCounty: 'personManagement.input.error.requiredCounty',
        requiredName: 'personManagement.input.error.requiredName',
      },
    },
  },
  priceManagement: {
    utils: {
      currency: 'priceManagement.utils.currency',
    },
    error: {
      requiredCurrencyCode: 'priceManagement.error.requiredCurrencyCode',
      requiredValue: 'priceManagement.error.requiredValue',
      currencyCoderequired: 'priceManagement.error.currencyCoderequired',
    },
  },
  contactManagement: {
    inputs: {
      email: 'contactManagement.inputs.email',
      phoneNumber: 'contactManagement.inputs.phoneNumber',
      new: 'contactManagement.inputs.new',
      searchPerson: 'contactManagement.inputs.searchPerson',
      person: 'contactManagement.inputs.person',
      clearSelection: 'contactManagement.inputs.clearSelection',
      visibilityType: 'contactManagement.inputs.visibilityType',
      contactMethod: 'contactManagement.inputs.contactMethod',
      receivesRequests: 'contactManagement.inputs.receivesRequests',
      addPerson: 'contactManagement.inputs.addPerson',
      addContact: 'contactManagement.inputs.addContact',
      visibilityTypes: {
        PUBLIC: 'contactManagement.inputs.visibilityTypes.PUBLIC',
        CUSTOMER: 'contactManagement.inputs.visibilityTypes.CUSTOMER',
        SERVICE_PROVIDER: 'contactManagement.inputs.visibilityTypes.SERVICE_PROVIDER',
        BOTH: 'contactManagement.inputs.visibilityTypes.BOTH',
        NONE: 'contactManagement.inputs.visibilityTypes.NONE',
      },
      contactMethods: {
        EMAIL: 'contactManagement.inputs.contactMethods.EMAIL',
        TEL: 'contactManagement.inputs.contactMethods.TEL',
        VISIT: 'contactManagement.inputs.contactMethods.VISIT',
      },
    },
    companyPartnerContact: {
      addTitle: 'contactManagement.companyPartnerContact.addTitle',
    },
    error: {
      requiredPerson: 'contactManagement.error.requiredPerson',
      patternEmail: 'contactManagement.error.patternEmail',
      requiredVisibility: 'contactManagement.error.requiredVisibility',
      requiredPhoneNumber: 'contactManagement.error.requiredPhoneNumber',
      requiredEmail: 'contactManagement.error.requiredEmail',
      requiredContactMethod: 'contactManagement.error.requiredContactMethod',
    },
    receivesRequestsRequiredTooltip: 'contactManagement.receivesRequestsRequiredTooltip',
  },
  'platform-administration': {
    company: {
      'legal-entity': {
        title: 'platform-administration.company.legal-entity.title',
        inputs: {
          companyName: 'platform-administration.company.legal-entity.inputs.companyName',
          registrationCode: 'platform-administration.company.legal-entity.inputs.registrationCode',
          uniqueIdentificationNumber: 'platform-administration.company.legal-entity.inputs.uniqueIdentificationNumber',
          preferredLanguage: 'platform-administration.company.legal-entity.inputs.preferredLanguage',
          mainPhoneNumber: 'platform-administration.company.legal-entity.inputs.mainPhoneNumber',
          mainEmailAddress: 'platform-administration.company.legal-entity.inputs.mainEmailAddress',
          address: {
            addressLine: 'platform-administration.company.legal-entity.inputs.address.addressLine',
            city: 'platform-administration.company.legal-entity.inputs.address.city',
            state: 'platform-administration.company.legal-entity.inputs.address.state',
            country: 'platform-administration.company.legal-entity.inputs.address.country',
            postalCode: 'platform-administration.company.legal-entity.inputs.address.postalCode',
          },
          bankAccount: {
            bankName: 'platform-administration.company.legal-entity.inputs.bankAccount.bankName',
            iban: 'platform-administration.company.legal-entity.inputs.bankAccount.iban',
            currencyCode: 'platform-administration.company.legal-entity.inputs.bankAccount.currencyCode',
            swiftCode: 'platform-administration.company.legal-entity.inputs.bankAccount.swiftCode',
          },
          invoicingTerms: {
            paymentTimeLimit: 'platform-administration.company.legal-entity.inputs.invoicingTerms.paymentTimeLimit',
            invoiceSeriesPrefix:
              'platform-administration.company.legal-entity.inputs.invoicingTerms.invoiceSeriesPrefix',
          },
        },
        errors: {
          requiredCompanyName: 'platform-administration.company.legal-entity.errors.requiredCompanyName',
          requiredRegistrationCode: 'platform-administration.company.legal-entity.errors.requiredRegistrationCode',
          requiredUniqueIdentificationNumber:
            'platform-administration.company.legal-entity.errors.requiredUniqueIdentificationNumber',
          requiredPreferredLanguage: 'platform-administration.company.legal-entity.errors.requiredPreferredLanguage',
        },
      },
    },
    legalEntity: {
      'list-title': 'platform-administration.legalEntity.list-title',
      'detail-title': 'platform-administration.legalEntity.detail-title',
      companyName: 'platform-administration.legalEntity.companyName',
      uniqueIdNumber: 'platform-administration.legalEntity.uniqueIdNumber',
      subscriptionCurrency: 'platform-administration.legalEntity.subscriptionCurrency',
      subscriptionPrice: 'platform-administration.legalEntity.subscriptionPrice',
      validFrom: 'platform-administration.legalEntity.validFrom',
      validTo: 'platform-administration.legalEntity.validTo',
      createdAt: 'platform-administration.legalEntity.createdAt',
      subscriptionStatus: 'platform-administration.legalEntity.subscriptionStatus',
      active: 'platform-administration.legalEntity.active',
      inactive: 'platform-administration.legalEntity.inactive',
      overduePaymentTerm: 'platform-administration.legalEntity.overduePaymentTerm',
      paymentPeriods: {
        OVERDUE: 'platform-administration.legalEntity.paymentPeriods.OVERDUE',
        IN_TIME: 'platform-administration.legalEntity.paymentPeriods.IN_TIME',
      },
      activeStatuses: {
        true: 'platform-administration.legalEntity.activeStatuses.true',
        false: 'platform-administration.legalEntity.activeStatuses.false',
      },
      invalidateSubscription: 'platform-administration.legalEntity.invalidateSubscription',
      reactivateSubscription: 'platform-administration.legalEntity.reactivateSubscription',
      invalidateDialogHeader: 'platform-administration.legalEntity.invalidateDialogHeader',
      reactivateDialogHeader: 'platform-administration.legalEntity.reactivateDialogHeader',
      invalidateMessage: 'platform-administration.legalEntity.invalidateMessage',
      reactivateMessage: 'platform-administration.legalEntity.reactivateMessage',
      dialogButtonMessages: {
        yes: 'platform-administration.legalEntity.dialogButtonMessages.yes',
        no: 'platform-administration.legalEntity.dialogButtonMessages.no',
      },
    },
    subscriptionHistory: {
      'list-title': 'platform-administration.subscriptionHistory.list-title',
      typeName: 'platform-administration.subscriptionHistory.typeName',
      subscriptionCurrency: 'platform-administration.subscriptionHistory.subscriptionCurrency',
      subscriptionPrice: 'platform-administration.subscriptionHistory.subscriptionPrice',
      validFrom: 'platform-administration.subscriptionHistory.validFrom',
      validTo: 'platform-administration.subscriptionHistory.validTo',
    },
    invoice: {
      'list-title': 'platform-administration.invoice.list-title',
      invoiceSeries: 'platform-administration.invoice.invoiceSeries',
      issueDate: 'platform-administration.invoice.issueDate',
      paymentDueDate: 'platform-administration.invoice.paymentDueDate',
      totalPrice: 'platform-administration.invoice.totalPrice',
      priceCurrencyCode: 'platform-administration.invoice.priceCurrencyCode',
      paymentTimeLimit: 'platform-administration.invoice.paymentTimeLimit',
      paymentStatus: 'platform-administration.invoice.paymentStatus',
      paymentStatuses: {
        UNPAID: 'platform-administration.invoice.paymentStatuses.UNPAID',
        PAID: 'platform-administration.invoice.paymentStatuses.PAID',
      },
      download: 'platform-administration.invoice.download',
      markAsPaid: 'platform-administration.invoice.markAsPaid',
      payment: {
        paymentDate: 'platform-administration.invoice.payment.paymentDate',
      },
    },
    utils: {
      search: 'platform-administration.utils.search',
      emptyMessage: 'platform-administration.utils.emptyMessage',
      details: 'platform-administration.utils.details',
      platformCompany: 'platform-administration.utils.platformCompany',
      billingDetails: 'platform-administration.utils.billingDetails',
      all: 'platform-administration.utils.all',
      save: 'platform-administration.utils.save',
      cancel: 'platform-administration.utils.cancel',
    },
  },
  workflows: {
    configuration: {
      title: 'workflows.configuration.title',
      list: {
        name: 'workflows.configuration.list.name',
        systemName: 'workflows.configuration.list.systemName',
        validFrom: 'workflows.configuration.list.validFrom',
        validTo: 'workflows.configuration.list.validTo',
        configuredForOwner: 'workflows.configuration.list.configuredForOwner',
        configurationType: {
          default: 'workflows.configuration.list.configurationType.default',
          custom: 'workflows.configuration.list.configurationType.custom',
        },
      },
    },
    workflowNames: {
      PAYMENTS: 'workflows.workflowNames.PAYMENTS',
      PAYMENT_DONE: 'workflows.workflowNames.PAYMENT_DONE',
      INVOICE_RECEIVED: 'workflows.workflowNames.INVOICE_RECEIVED',
      CUSTOM_ETRANSPORT_UPLOAD: 'workflows.workflowNames.CUSTOM_ETRANSPORT_UPLOAD',
      LOGO: 'workflows.workflowNames.LOGO',
    },
    workflowDescriptions: {
      PAYMENTS: 'workflows.workflowDescriptions.PAYMENTS',
      PAYMENT_DONE: 'workflows.workflowDescriptions.PAYMENT_DONE',
      INVOICE_RECEIVED: 'workflows.workflowDescriptions.INVOICE_RECEIVED',
      CUSTOM_ETRANSPORT_UPLOAD: 'workflows.workflowDescriptions.CUSTOM_ETRANSPORT_UPLOAD',
      LOGO: 'workflows.workflowDescriptions.LOGO',
    },
    selectableItems: {
      SHOW_CUSTOM_ETRANSPORT_UPLOAD: 'workflows.selectableItems.UPLOAD_ETRANSPORT_IMPORT',
      LOGO_LOGO_1: 'workflows.selectableItems.LOGO_LOGO_1',
      PAYMENTS_PAYMENTS_1: 'workflows.selectableItems.PAYMENTS_PAYMENTS_1',
      PAYMENTS_EMAIL: 'workflows.selectableItems.PAYMENTS_EMAIL',
      PAYMENT_DONE_EMAIL: 'workflows.selectableItems.PAYMENT_DONE_EMAIL',
      PAYMENT_DONE_FINAL_DUE_DATE: 'workflows.selectableItems.PAYMENT_DONE_FINAL_DUE_DATE',
      PAYMENTS_TEST_WORKFLOW_STEP_001: 'workflows.selectableItems.PAYMENTS_TEST_WORKFLOW_STEP_001',
      INVOICE_RECEIVED_INVOICE_WORKFLOW_NEVER_ACCEPT:
        'workflows.selectableItems.INVOICE_RECEIVED_INVOICE_WORKFLOW_NEVER_ACCEPT',
    },
    details: {
      title: 'workflows.details.title',
      workflowName: 'workflows.details.workflowName',
      workflowDefaultDescription: 'workflows.details.workflowDefaultDescription',
      generalTitle: 'workflows.details.generalTitle',
      label: 'workflows.details.label',
      systemName: 'workflows.details.systemName',
      stepsTitle: 'workflows.details.stepsTitle',
      stepName: 'workflows.details.stepName',
      notiTitle: 'workflows.details.notiTitle',
      stepsUiTitle: 'workflows.details.stepsUiTitle',
      notificationType: 'workflows.details.notificationType',
      errors: {
        requiredLabel: 'workflows.details.errors.requiredLabel',
      },
    },
  },
  warehouses: {
    create: {
      noExistingDeposit: 'warehouses.create.noExistingDeposit',
      createWarehouseForm: 'warehouses.create.createWarehouseForm',
      error: {
        requiredWarehouseName: 'warehouses.create.error.requiredWarehouseName',
        requiredTimeSlot: 'warehouses.create.error.requiredTimeSlot',
        requiredOpeningTime: 'warehouses.create.error.requiredOpeningTime',
        requiredClosingTime: 'warehouses.create.error.requiredClosingTime',
        requiredAddress: 'warehouses.create.error.requiredAddress',
        '0AddressDTO': 'warehouses.create.error.0AddressDTO',
        timeOrderError: 'warehouses.create.error.timeOrderError',
      },
      warehouseName: 'warehouses.create.warehouseName',
      timeSlot: 'warehouses.create.timeSlot',
      openingTime: 'warehouses.create.openingTime',
      closingTime: 'warehouses.create.closingTime',
      title: 'warehouses.create.title',
    },
    terminals: {
      hour: 'warehouses.terminals.hour',
      addTerminal: 'warehouses.terminals.addTerminal',
      editTerminal: 'warehouses.terminals.editTerminal',
      name: 'warehouses.terminals.name',
      description: 'warehouses.terminals.description',
      contactName: 'warehouses.terminals.contactName',
      contactPhoneNumber: 'warehouses.terminals.contactPhoneNumber',
      terminalType: 'warehouses.terminals.terminalType',
      loading: 'warehouses.terminals.loading',
      unloading: 'warehouses.terminals.unloading',
      loadingAndUnloading: 'warehouses.terminals.loadingAndUnloading',
      delete: 'warehouses.terminals.delete',
      deleted: 'warehouses.terminals.deleted',
      active: 'warehouses.terminals.active',
      'delete-confirmation-message': 'warehouses.terminals.delete-confirmation-message',
      terminalTypeErrorMessage: 'warehouses.terminals.terminalTypeErrorMessage',
      attachmentsTooltip: 'warehouses.terminals.attachmentsTooltip',
      attachments: 'warehouses.terminals.attachments',
      emptyAttachments: 'warehouses.terminals.emptyAttachments',
      vendor: 'warehouses.terminals.vendor',
      externalSP: 'warehouses.terminals.externalSP',
      reservations: {
        tag: 'warehouses.terminals.reservations.tag',
        LOADING: 'warehouses.terminals.reservations.LOADING',
        UNLOADING: 'warehouses.terminals.reservations.UNLOADING',
        MAINTENANCE: 'warehouses.terminals.reservations.MAINTENANCE',
        CLEANING: 'warehouses.terminals.reservations.CLEANING',
        vendorVo: 'warehouses.terminals.reservations.vendorVo',
        terminalReservationNumber: 'warehouses.terminals.reservations.terminalReservationNumber',
        vehicleType: 'warehouses.terminals.reservations.vehicleType',
        licencePlate: 'warehouses.terminals.reservations.licencePlate',
        driver: 'warehouses.terminals.reservations.driver',
        contactName: 'warehouses.terminals.reservations.contactName',
        contactPhoneNumber: 'warehouses.terminals.reservations.contactPhoneNumber',
        driverPhoneNumber: 'warehouses.terminals.reservations.driverPhoneNumber',
        order: 'warehouses.terminals.reservations.order',
        orders: 'warehouses.terminals.reservations.orders',
        from: 'warehouses.terminals.reservations.from',
        to: 'warehouses.terminals.reservations.to',
        comments: 'warehouses.terminals.reservations.comments',
        reservationStatus: 'warehouses.terminals.reservations.reservationStatus',
        reservationType: 'warehouses.terminals.reservations.reservationType',
        status: 'warehouses.terminals.reservations.status',
        cancel: 'warehouses.terminals.reservations.cancel',
        types: {
          LOADING: 'warehouses.terminals.reservations.types.LOADING',
          UNLOADING: 'warehouses.terminals.reservations.types.UNLOADING',
          MAINTENANCE: 'warehouses.terminals.reservations.types.MAINTENANCE',
          CLEANING: 'warehouses.terminals.reservations.types.CLEANING',
        },
        statuses: {
          upcoming: 'warehouses.terminals.reservations.statuses.upcoming',
          expired: 'warehouses.terminals.reservations.statuses.expired',
          completed: 'warehouses.terminals.reservations.statuses.completed',
          partially_completed: 'warehouses.terminals.reservations.statuses.partially_completed',
          cancelled: 'warehouses.terminals.reservations.statuses.cancelled',
          archived: 'warehouses.terminals.reservations.statuses.archived',
          arrived_at_gate: 'warehouses.terminals.reservations.statuses.arrived_at_gate',
          check_in: 'warehouses.terminals.reservations.statuses.check_in',
          loading_in_progress: 'warehouses.terminals.reservations.statuses.loading_in_progress',
          loading_completed: 'warehouses.terminals.reservations.statuses.loading_completed',
          exited_gate: 'warehouses.terminals.reservations.statuses.exited_gate',
          not_present_at_loading: 'warehouses.terminals.reservations.statuses.not_present_at_loading',
          unloading_in_progress: 'warehouses.terminals.reservations.statuses.unloading_in_progress',
          unloading_completed: 'warehouses.terminals.reservations.statuses.unloading_completed',
          not_present_at_unloading: 'warehouses.terminals.reservations.statuses.not_present_at_unloading',
        },
        receivedProtectionMaterials: 'warehouses.terminals.reservations.statuses.receivedProtectionMaterials',
        retrievedProtectionMaterials: 'warehouses.terminals.reservations.statuses.retrievedProtectionMaterials',
        hasUitCode: 'warehouses.terminals.reservations.statuses.hasUitCode',
        nextStatus: 'warehouses.terminals.reservations.nextStatus',
        notPresentAtLoading: 'warehouses.terminals.reservations.notPresentAtLoading',
        notPresentAtUnloading: 'warehouses.terminals.reservations.notPresentAtUnloading',
        confirmHeader: 'warehouses.terminals.reservations.confirmHeader',
        deleteMessage: 'warehouses.terminals.reservations.deleteMessage',
        shipments: 'warehouses.terminals.reservations.shipments',
        statusAlertMessage: 'warehouses.terminals.reservations.statusAlertMessage',
        list: {
          title: 'warehouses.terminals.reservations.list.title',
          columns: {
            terminalName: 'warehouses.terminals.reservations.list.columns.terminalName',
            terminalReservationNumber: 'warehouses.terminals.reservations.list.columns.terminalReservationNumber',
            orderNumbers: 'warehouses.terminals.reservations.list.columns.orderNumbers',
            serviceProviderName: 'warehouses.terminals.reservations.list.columns.serviceProviderName',
            timeRange: 'warehouses.terminals.reservations.list.columns.timeRange',
            licencePlate: 'warehouses.terminals.reservations.list.columns.licencePlate',
            reservationType: 'warehouses.terminals.reservations.list.columns.reservationType',
            reservationStatus: 'warehouses.terminals.reservations.list.columns.reservationStatus',
            terminalStatus: 'warehouses.terminals.reservations.list.columns.terminalStatus',
          },
        },
      },
      errors: {
        requiredName: 'warehouses.terminals.errors.requiredName',
        requiredDescription: 'warehouses.terminals.errors.requiredDescription',
        requiredContactName: 'warehouses.terminals.errors.requiredContactName',
        requiredContactPhoneNumber: 'warehouses.terminals.errors.requiredContactPhoneNumber',
        requiredDriverPhoneNumber: 'warehouses.terminals.errors.requiredDriverPhoneNumber',
        requiredTerminalReservationNumber: 'warehouses.terminals.errors.requiredTerminalReservationNumber',
        requiredReservationType: 'warehouses.terminals.errors.requiredReservationType',
        requiredSpOrCourier: 'warehouse.terminals.errors.requiredSpOrCourier ',
        requiredVehicleType: 'warehouse.terminals.errors.requiredVehicleType',
        requiredDriver: 'warehouse.terminals.errors.requiredDriver',
        requiredLicencePlate: 'warehouse.terminals.errors.requiredLicencePlate',
      },
    },
    orderReservationButton: 'warehouses.orderReservationButton',
    currentScheduled: 'warehouses.currentScheduled',
    futureSchedule: 'warehouses.futureSchedule',
    editWarehouse: 'warehouses.editWarehouse',
    addFutureSchedule: 'warehouses.addFutureSchedule',
    editFutureSchedule: 'warehouses.editFutureSchedule',
    deleteFutureSchedule: 'warehouses.deleteFutureSchedule',
    deleteFutureScheduleHeader: 'warehouses.deleteFutureScheduleHeader',
    deleteFutureScheduleMessage: 'warehouses.deleteFutureScheduleMessage',
    moreDetails: 'warehouses.moreDetails',
    lessDetails: 'warehouses.lessDetails',
    warehouseDetails: 'warehouses.warehouseDetails',
    warehouseName: 'warehouses.warehouseName',
    location: 'warehouses.location',
    tooltipFromOrderSchedulingMode: 'warehouses.tooltipFromOrderSchedulingMode',
    clearOrderContext: 'warehouses.clearOrderContext',
  },
  blacklist: {
    blacklistHistory: 'blacklist.blacklistHistory',
    type: 'blacklist.type',
    date: 'blacklist.date',
    lastModifiedByEmployeeName: 'blacklist.lastModifiedByEmployeeName',
    comment: 'blacklist.comment',
  },
  'company-profile': {
    performedActions: {
      actionName: 'company-profile.performedActions.actionName',
      creditPaymentSum: 'company-profile.performedActions.creditPaymentSum',
      paymentDate: 'company-profile.performedActions.paymentDate',
      performedBy: 'company-profile.performedActions.performedBy',
      'list-title': 'company-profile.performedActions.list-title',
    },
    utils: {
      search: 'company-profile.utils.search',
      emptyMessage: 'company-profile.utils.emptyMessage',
      all: 'company-profile.utils.all',
      save: 'company-profile.utils.save',
      cancel: 'company-profile.utils.cancel',
    },
  },
  constants: {
    cronExpressions: {
      daily: 'constants.cronExpressions.daily',
      weekly: 'constants.cronExpressions.weekly',
      monthly: 'constants.cronExpressions.monthly',
      yearly: 'constants.cronExpressions.yearly',
    },
  },
  paymentTermBannerMessage: 'paymentTermBannerMessage',
  'budget-management': {
    'list-title': 'budget-management.list-title',
    selectQuarter: 'budget-management.selectQuarter',
    totalCosts: 'budget-management.totalCosts',
    budgetCosts: 'budget-management.budgetCosts',
    actualCosts: 'budget-management.actualCosts',
    quarterWeek: 'budget-management.quarterWeek',
    emptyCell: 'budget-management.emptyCell',
  },
  'cash-flow': {
    title: 'cash-flow.title',
    transaction: 'cash-flow.transaction',
    noCurrenciesSelected: 'cash-flow.noCurrenciesSelected',
    selectStartDate: 'cash-flow.selectStartDate',
    currentDayBalance: 'cash-flow.currentDayBalance',
    viewTransactions: 'cash-flow.viewTransactions',
    addTransaction: 'cash-flow.addTransaction',
    updateBalance: 'cash-flow.updateBalance',
    transactions: {
      title: 'cash-flow.transactions.title',
      value: 'cash-flow.transactions.value',
      currencyCode: 'cash-flow.transactions.currencyCode',
      date: 'cash-flow.transactions.date',
      comments: 'cash-flow.transactions.comments',
      invoiceSeries: 'cash-flow.transactions.invoiceSeries',
      employee: 'cash-flow.transactions.employee',
      add: 'cash-flow.transactions.add',
      edit: 'cash-flow.transactions.edit',
      deleteHeader: 'cash-flow.transactions.deleteHeader',
      deleteMessage: 'cash-flow.transactions.deleteMessage',
      emptyTransactionsMessage: 'cash-flow.transactions.emptyTransactionsMessage',
      Correction: 'cash-flow.transactions.Correction',
      dateTransactionsTitle: 'cash-flow.transactions.dateTransactionsTitle',
      form: {
        errors: {
          requiredValue: 'cash-flow.transactions.form.errors.requiredValue',
          requiredCurrencyCode: 'cash-flow.transactions.form.errors.requiredCurrencyCode',
          requiredDate: 'cash-flow.transactions.form.errors.requiredDate',
          requiredComments: 'cash-flow.transactions.form.errors.requiredComments',
        },
      },
      type: {
        invoice: 'cash-flow.transactions.type.invoice',
        payment: 'cash-flow.transactions.type.payment',
        cashflow_item: 'cash-flow.transactions.type.cashflow_item',
      },
    },
    correction: {
      title: 'cash-flow.correction.title',
      targetAmount: 'cash-flow.correction.targetAmount',
      currencyCode: 'cash-flow.correction.currencyCode',
      date: 'cash-flow.correction.date',
      form: {
        errors: {
          requiredTargetAmount: 'cash-flow.correction.form.errors.requiredTargetAmount',
          requiredCurrencyCode: 'cash-flow.correction.form.errors.requiredCurrencyCode',
          requiredDate: 'cash-flow.correction.form.errors.requiredDate',
        },
      },
    },
  },
  'order-consolidation': {
    order: 'order-consolidation.order',
    customerOrders: 'order-consolidation.customerOrders',
    viewOrder: 'order-consolidation.viewOrder',
  },
  consolidation: {
    'shipment-group': {
      title: 'consolidation.shipment-group.title',
      addGroup: 'consolidation.shipment-group.addGroup',
      invalidShipmentGroupsMessage: 'consolidation.shipment-group.invalidShipmentGroupsMessage',
      saveShipmentGroupDisabledTooltip: 'consolidation.shipment-group.saveShipmentGroupDisabledTooltip',
      noDataDescription: 'consolidation.shipment-group.noDataDescription',
      list: {
        title: 'consolidation.shipment-group.list.title',
      },
    },
    utils: {
      solve: 'consolidation.utils.solve',
    },
  },
  footer: {
    companyDetails: 'footer.companyDetails',
    usefulLinks: {
      links: 'footer.usefulLinks.links',
      termsAndConditions: 'footer.usefulLinks.termsAndConditions',
      privacyPolicy: 'footer.usefulLinks.privacyPolicy',
      cookiePolicy: 'footer.usefulLinks.cookiePolicy',
      ANPC: 'footer.usefulLinks.ANPC',
    },
    contactUs: 'footer.contactUs',
  },
  'platform-company-contact-form': {
    leaveUsAMessage: 'platform-company-contact-form.leaveUsAMessage',
    inputs: {
      company: 'platform-company-contact-form.inputs.company',
      category: 'platform-company-contact-form.inputs.category',
      email: 'platform-company-contact-form.inputs.email',
      subject: 'platform-company-contact-form.inputs.subject',
      message: 'platform-company-contact-form.inputs.message',
      categoriesPlaceholder: 'platform-company-contact-form.inputs.categoriesPlaceholder',
      categories: {
        TECHNICAL_ISSUES: 'platform-company-contact-form.inputs.categories.TECHNICAL_ISSUES',
        ACCOUNT_ASSISTANCE: 'platform-company-contact-form.inputs.categories.ACCOUNT_ASSISTANCE',
        SERVICE_INFORMATION: 'platform-company-contact-form.inputs.categories.SERVICE_INFORMATION',
        COMPLAINTS: 'platform-company-contact-form.inputs.categories.COMPLAINTS',
        FEEDBACK: 'platform-company-contact-form.inputs.categories.FEEDBACK',
        OFFER_REQUEST: 'platform-company-contact-form.inputs.categories.OFFER_REQUEST',
        QUESTION: 'platform-company-contact-form.inputs.categories.QUESTION',
      },
    },
    send: 'platform-company-contact-form.send',
    error: {
      requiredEmail: 'platform-company-contact-form.error.requiredEmail',
      requiredSubject: 'platform-company-contact-form.error.requiredSubject',
      requiredMessage: 'platform-company-contact-form.error.requiredMessage',
      emailEmail: 'platform-company-contact-form.error.emailEmail',
    },
  },
  'transport-project': {
    list: {
      title: 'transport-project.list.title',
      label: 'transport-project.list.label',
      validFrom: 'transport-project.list.validFrom',
      validTo: 'transport-project.list.validTo',
      description: 'transport-project.list.description',
    },
    add: 'transport-project.add',
    edit: 'transport-project.edit',
    form: {
      label: 'transport-project.form.label',
      validFrom: 'transport-project.form.validFrom',
      validTo: 'transport-project.form.validTo',
      description: 'transport-project.form.description',
      error: {
        requiredLabel: 'transport-project.form.requiredLabel',
        requiredValidFrom: 'transport-project.form.requiredValidFrom',
      },
    },
    shipment: {
      title: 'transport-project.shipment.title',
    },
  },
  etransport: {
    declarant: {
      messages: 'etransport.declarant.messages',
      list: {
        type: 'etransport.declarant.list.type',
        status: 'etransport.declarant.list.status',
        uit: 'etransport.declarant.list.uit',
        declarationCode: 'etransport.declarant.list.declarationCode',
        declarationReference: 'etransport.declarant.list.declarationReference',
        postDamage: 'etransport.declarant.list.postDamage',
        source: 'etransport.declarant.list.source',
        loadId: 'etransport.declarant.list.loadId',
        creationDate: 'etransport.declarant.list.creationDate',
        modificationDate: 'etransport.declarant.list.modificationDate',
        operationType: 'etransport.declarant.list.operationType',
        transportDate: 'etransport.declarant.list.transportDate',
        pickupCountry: 'etransport.declarant.list.pickupCountry',
        pickupCode: 'etransport.declarant.list.pickupCode',
        pickupName: 'etransport.declarant.list.pickupName',
        deliveryCountry: 'etransport.declarant.list.deliveryCountry',
        deliveryCode: 'etransport.declarant.list.deliveryCode',
        deliveryName: 'etransport.declarant.list.deliveryName',
        vehicleModificationDate: 'etransport.declarant.list.vehicleModificationDate',
        vehicleNumber: 'etransport.declarant.list.vehicleNumber',
        trailer1Number: 'etransport.declarant.list.trailer1Number',
        trailer2Number: 'etransport.declarant.list.trailer2Number',
        lineCount: 'etransport.declarant.list.lineCount',
        totalNetWeight: 'etransport.declarant.list.totalNetWeight',
        totalGrossWeight: 'etransport.declarant.list.totalGrossWeight',
        totalValue: 'etransport.declarant.list.totalValue',
        confirmation: 'etransport.declarant.list.confirmation',
        vehicleModifications: 'etransport.declarant.list.vehicleModifications',
        expiresIn: 'etransport.declarant.list.expiresIn',
        expired: 'etransport.declarant.list.expired',
        messages: 'etransport.declarant.list.messages',
        actions: {
          seeVehicleModificationsAndAnafMessages:
            'etransport.declarant.list.actions.seeVehicleModificationsAndAnafMessages',
        },
      },
      modifiedVehicleMessagesAndMessages: {
        title: 'etransport.declarant.modifiedVehicleMessagesAndMessages.title',
      },
      vehicleModifMessages: {
        title: 'etransport.declarant.vehicleModifMessages.title',
        dataModifVeh: 'etransport.declarant.vehicleModifMessages.dataModifVeh',
        nrVeh: 'etransport.declarant.vehicleModifMessages.nrVeh',
        nrRem1: 'etransport.declarant.vehicleModifMessages.nrRem1',
        nrRem2: 'etransport.declarant.vehicleModifMessages.nrRem2',
        codDecl: 'etransport.declarant.vehicleModifMessages.codDecl',
        refDecl: 'etransport.declarant.vehicleModifMessages.refDecl',
        postAvarie: 'etransport.declarant.vehicleModifMessages.postAvarie',
        sursa: 'etransport.declarant.vehicleModifMessages.sursa',
        dataDecl: 'etransport.declarant.vehicleModifMessages.dataDecl',
        idIncarcare: 'etransport.declarant.vehicleModifMessages.idIncarcare',
        obs: 'etransport.declarant.vehicleModifMessages.obs',
      },
      anafMessages: {
        title: 'etransport.declarant.anafMessages.title',
        tip: 'etransport.declarant.anafMessages.tip',
        mesaj: 'etransport.declarant.anafMessages.mesaj',
      },
    },
    integration: {
      title: 'etransport.integration.title',
      cancelConfirmationMessage: 'etransport.integration.cancelConfirmationMessage',
      notificationButton: 'etransport.integration.notificationButton',
      uploadButton: 'etransport.integration.uploadButton',
      uploadButtonTooltip: 'etransport.integration.uploadButtonTooltip',
      resendButton: 'etransport.integration.resendButton',
      checkButton: 'etransport.integration.checkButton',
      duplicateButton: 'etransport.integration.duplicateButton',
      cancelButton: 'etransport.integration.cancelButton',
      deleteButton: 'etransport.integration.deleteButton',
      commercialDataInvitationEmail: 'etransport.integration.commercialDataInvitationEmail',
      shipmentDataInvitationEmail: 'etransport.integration.shipmentDataInvitationEmail',
      modifVehicleButton: 'etransport.integration.modifVehicleButton',
      uploadStatus: 'etransport.integration.uploadStatus',
      checkStatus: 'etransport.integration.checkStatus',
      anafMessage: 'etransport.integration.anafMessage',
      moreDetailsMessage: 'etransport.integration.moreDetailsMessage',
      uit: 'etransport.integration.uit',
      notificationDetails: 'etransport.integration.notificationDetails',
      uits: 'etransport.integration.uits',
      defaultStatusLabel: 'etransport.integration.defaultStatusLabel',
      emailCommercialPartner: 'etransport.integration.emailCommercialPartner',
      disabledEmailCommercialPartner: 'etransport.integration.disabledEmailCommercialPartner',
      disabledEmailShipmentOrganizer: 'etransport.integration.disabledEmailShipmentOrganizer',
      emailShipmentOrganizer: 'etransport.integration.emailShipmentOrganizer',
      downloadPdf: 'etransport.integration.downloadPdf',
      anafSearch: 'etransport.integration.anafSearch',
    },
    checkStatuses: {
      UNCHECKED: 'etransport.checkStatuses.UNCHECKED',
      PENDING: 'etransport.checkStatuses.PENDING',
      COMMUNICATION_ERROR: 'etransport.checkStatuses.COMMUNICATION_ERROR',
      AUTHORIZATION_ERROR: 'etransport.checkStatuses.AUTHORIZATION_ERROR',
      ERROR: 'etransport.checkStatuses.ERROR',
      NOT_OK: 'etransport.checkStatuses.NOT_OK',
      OK: 'etransport.checkStatuses.OK',
    },
    uploadStatuses: {
      UNSENT: 'etransport.uploadStatuses.UNSENT',
      CONVERSION_ERROR: 'etransport.uploadStatuses.CONVERSION_ERROR',
      COMMUNICATION_ERROR: 'etransport.uploadStatuses.COMMUNICATION_ERROR',
      ERROR: 'etransport.uploadStatuses.ERROR',
      UPLOAD_SUCCESS: 'etransport.uploadStatuses.UPLOAD_SUCCESS',
      AUTHORIZATION_ERROR: 'etransport.uploadStatuses.AUTHORIZATION_ERROR',
      CANCEL_SUCCESS: 'etransport.uploadStatuses.CANCEL_SUCCESS',
    },
    modifVehicle: {
      title: 'etransport.modifVehicle.title',
      modifyDateSuggestion: 'etransport.modifVehicle.modifyDateSuggestion',
      notificationVehicle: 'etransport.modifVehicle.notificationVehicle',
      form: {
        licensePlate: 'etransport.modifVehicle.form.licensePlate',
        firstTrailerLicensePlate: 'etransport.modifVehicle.form.firstTrailerLicensePlate',
        secondTrailerLicensePlate: 'etransport.modifVehicle.form.secondTrailerLicensePlate',
        modificationDate: 'etransport.modifVehicle.form.modificationDate',
        observations: 'etransport.modifVehicle.form.observations',
        errors: {
          requiredModificationDate: 'etransport.modifVehicle.form.errors.requiredModificationDate',
          requiredLicensePlate: 'etransport.modifVehicle.form.errors.requiredLicensePlate',
          patternLicensePlate: 'etransport.modifVehicle.form.errors.patternLicensePlate',
          patternFirstTrailerLicensePlate: 'etransport.modifVehicle.form.errors.patternFirstTrailerLicensePlate',
          patternSecondTrailerLicensePlate: 'etransport.modifVehicle.form.errors.patternSecondTrailerLicensePlate',
        },
      },
    },
    details: 'etransport.details',
    nullUitMessage: 'etransport.nullUitMessage',
    vehicleHistory: {
      licensePlates: 'etransport.vehicleHistory.licensePlates',
      modificationDate: 'etransport.vehicleHistory.modificationDate',
      declaringCompanyCode: 'etransport.vehicleHistory.declaringCompanyCode',
      declaringCompanyReference: 'etransport.vehicleHistory.declaringCompanyReference',
      observation: 'etransport.vehicleHistory.observation',
      activeVehicle: 'etransport.vehicleHistory.activeVehicle',
      title: 'etransport.vehicleHistory.title',
    },
    form: {
      title: 'etransport.form.title',
      editTitle: 'etransport.form.editTitle',
      operationType: 'etransport.form.operationType',
      selectContactWarning: 'etransport.form.selectContactWarning',
      notificationContacts: 'etransport.form.notificationContacts',
      legendRequiredForSending: 'etransport.form.legendRequiredForSending',
      legendRequiredForSaving: 'etransport.form.legendRequiredForSaving',
      declaringCompanyReference: 'etransport.form.declaringCompanyReference',
      confirmation: {
        confirmationType: 'etransport.form.confirmation.confirmationType',
        observations: 'etransport.form.confirmation.observations',
        confirmationTypes: {
          10: 'etransport.form.confirmation.confirmationTypes.10',
          20: 'etransport.form.confirmation.confirmationTypes.20',
          30: 'etransport.form.confirmation.confirmationTypes.30',
        },
        errors: {
          requiredConfirmationTypeUuid: 'etransport.form.confirmation.errors.requiredConfirmationTypeUuid',
        },
      },
      errors: {
        requiredOperationType: 'etransport.form.errors.etransport.form.operationType',
        maxLength50: 'etransport.form.errors.etransport.form.maxLength50',
        requiredShipment: 'etransport.form.errors.etransport.form.requiredShipment',
      },
      operationTypes: {
        10: 'etransport.form.operationTypes.10',
        12: 'etransport.form.operationTypes.12',
        14: 'etransport.form.operationTypes.14',
        20: 'etransport.form.operationTypes.20',
        22: 'etransport.form.operationTypes.22',
        24: 'etransport.form.operationTypes.24',
        30: 'etransport.form.operationTypes.30',
        40: 'etransport.form.operationTypes.40',
        50: 'etransport.form.operationTypes.50',
        60: 'etransport.form.operationTypes.60',
        70: 'etransport.form.operationTypes.70',
      },
      shipmentDocument: {
        title: 'etransport.form.shipmentDocument.title',
        documentTitle: 'etransport.form.shipmentDocument.documentTitle',
        documentType: 'etransport.form.shipmentDocument.documentType',
        documentNumber: 'etransport.form.shipmentDocument.documentNumber',
        documentDate: 'etransport.form.shipmentDocument.documentDate',
        observations: 'etransport.form.shipmentDocument.observations',
        add: 'etransport.form.shipmentDocument.add',
        documentTypes: {
          10: 'etransport.form.shipmentDocument.documentTypes.10',
          20: 'etransport.form.shipmentDocument.documentTypes.20',
          30: 'etransport.form.shipmentDocument.documentTypes.30',
          9999: 'etransport.form.shipmentDocument.documentTypes.9999',
        },
        errors: {
          requiredDocumentType: 'etransport.form.shipmentDocument.errors.requiredDocumentType',
          requiredDocumentDate: 'etransport.form.shipmentDocument.errors.requiredDocumentDate',
          requiredObservations: 'etransport.form.shipmentDocument.errors.requiredObservations',
          maxLength50: 'etransport.form.shipmentDocument.errors.maxLength50',
          maxLength200: 'etransport.form.shipmentDocument.errors.maxLength200',
        },
      },
      commercialPartner: {
        title: 'etransport.form.commercialPartner.title',
        country: 'etransport.form.commercialPartner.country',
        code: 'etransport.form.commercialPartner.code',
        asIndividual: 'etransport.form.commercialPartner.asIndividual',
        name: 'etransport.form.commercialPartner.name',
        contacts: 'etransport.form.commercialPartner.contacts',
        errors: {
          requiredCountry: 'etransport.form.commercialPartner.errors.requiredCountry',
          requiredName: 'etransport.form.commercialPartner.errors.requiredName',
          maxLength30: 'etransport.form.commercialPartner.errors.maxLength30',
          maxLength300: 'etransport.form.commercialPartner.errors.maxLength300',
          patternCode: 'etransport.form.commercialPartner.errors.patternCode',
        },
      },
      shipmentData: {
        title: 'etransport.form.shipmentData.title',
        licensePlate: 'etransport.form.shipmentData.licensePlate',
        firstTrailerLicensePlate: 'etransport.form.shipmentData.firstTrailerLicensePlate',
        secondTrailerLicensePlate: 'etransport.form.shipmentData.secondTrailerLicensePlate',
        transporterCountry: 'etransport.form.shipmentData.transporterCountry',
        shipmentOrganizerCode: 'etransport.form.shipmentData.shipmentOrganizerCode',
        shipmentOrganizerAsIndividual: 'etransport.form.shipmentData.shipmentOrganizerAsIndividual',
        shipmentOrganizerName: 'etransport.form.shipmentData.shipmentOrganizerName',
        shipmentDate: 'etransport.form.shipmentData.shipmentDate',
        shipmentDateTooltip: 'etransport.form.shipmentData.shipmentDateTooltip',
        contacts: 'etransport.form.shipmentData.contacts',
        errors: {
          requiredLicensePlate: 'etransport.form.shipmentData.errors.requiredLicensePlate',
          requiredTransporterCountry: 'etransport.form.shipmentData.errors.requiredTransporterCountry',
          requiredShipmentOrganizerName: 'etransport.form.shipmentData.errors.requiredShipmentOrganizerName',
          requiredShipmentOrganizerCountryCode:
            'etransport.form.shipmentData.errors.requiredShipmentOrganizerCountryCode',
          requiredShipmentDate: 'etransport.form.shipmentData.errors.requiredShipmentDate',
          patternLicensePlate: 'etransport.form.shipmentData.errors.patternLicensePlate',
          patternFirstTrailerLicensePlate: 'etransport.form.shipmentData.errors.patternFirstTrailerLicensePlate',
          patternSecondTrailerLicensePlate: 'etransport.form.shipmentData.errors.patternSecondTrailerLicensePlate',
          maxLength20: 'etransport.form.shipmentData.errors.maxLength20',
          maxLength30: 'etransport.form.shipmentData.errors.maxLength30',
          maxLength200: 'etransport.form.shipmentData.errors.maxLength200',
          patternShipmentOrganizerCode: 'etransport.form.shipmentData.errors.patternShipmentOrganizerCode',
        },
      },
      location: {
        startTitle: 'etransport.form.location.startTitle',
        endTitle: 'etransport.form.location.endTitle',
        ptf: 'etransport.form.location.ptf',
        customsOffice: 'etransport.form.location.customsOffice',
        stateType: {
          ptf: 'etransport.form.location.stateType.ptf',
          customsOffice: 'etransport.form.location.stateType.customsOffice',
          address: 'etransport.form.location.stateType.address',
        },
        errors: {
          requiredPtf: 'etransport.form.location.errors.requiredPtf',
          requiredCustomsOffice: 'etransport.form.location.errors.requiredCustomsOffice',
          requiredAddress: 'etransport.form.location.errors.requiredAddress',
        },
        noLocation: 'etransport.form.location.noLocation',
      },
      packages: {
        title: 'etransport.form.packages.title',
        addProduct: 'etransport.form.packages.addProduct',
        changeLayout: 'etransport.form.packages.changeLayout',
        copyValueToAll: 'etransport.form.packages.copyValueToAll',
        operationPurpose: 'etransport.form.packages.operationPurpose',
        combinedNomenclature: 'etransport.form.packages.combinedNomenclature',
        unitMeasurement: 'etransport.form.packages.unitMeasurement',
        cargoName: 'etransport.form.packages.cargoName',
        quantity: 'etransport.form.packages.quantity',
        netWeight: 'etransport.form.packages.netWeight',
        grossWeight: 'etransport.form.packages.grossWeight',
        valueWithoutVAT: 'etransport.form.packages.valueWithoutVAT',
        refDeclarant: 'etransport.form.packages.refDeclarant',
        unitPrice: 'etransport.form.packages.unitPrice',
        exchangeRate: 'etransport.form.packages.exchangeRate',
        productsResume: 'etransport.form.packages.productsResume',
        getBnrExchangeRate: 'etransport.form.packages.getBnrExchangeRate',
        successfulExchangeRateMessage: 'etransport.form.packages.successfulExchangeRateMessage',
        convertToLeiMessage: 'etransport.form.packages.convertToLeiMessage',
        operationPurposes: {
          1001: 'etransport.form.packages.operationPurposes.1001',
          101: 'etransport.form.packages.operationPurposes.101',
          1101: 'etransport.form.packages.operationPurposes.1101',
          201: 'etransport.form.packages.operationPurposes.201',
          301: 'etransport.form.packages.operationPurposes.301',
          401: 'etransport.form.packages.operationPurposes.401',
          501: 'etransport.form.packages.operationPurposes.501',
          601: 'etransport.form.packages.operationPurposes.601',
          703: 'etransport.form.packages.operationPurposes.703',
          704: 'etransport.form.packages.operationPurposes.704',
          705: 'etransport.form.packages.operationPurposes.705',
          801: 'etransport.form.packages.operationPurposes.801',
          802: 'etransport.form.packages.operationPurposes.802',
          901: 'etransport.form.packages.operationPurposes.901',
          9901: 'etransport.form.packages.operationPurposes.9901',
          9999: 'etransport.form.packages.operationPurposes.9999',
        },
        measurementUnitTranslation: 'etransport.form.packages.measurementUnit',
        measurementUnit: {
          null: 'etransport.form.packages.measurementUnit.null',
          '10': 'etransport.form.packages.measurementUnit.10',
          '11': 'etransport.form.packages.measurementUnit.11',
          '13': 'etransport.form.packages.measurementUnit.13',
          '14': 'etransport.form.packages.measurementUnit.14',
          '15': 'etransport.form.packages.measurementUnit.15',
          '20': 'etransport.form.packages.measurementUnit.20',
          '21': 'etransport.form.packages.measurementUnit.21',
          '22': 'etransport.form.packages.measurementUnit.22',
          '23': 'etransport.form.packages.measurementUnit.23',
          '24': 'etransport.form.packages.measurementUnit.24',
          '25': 'etransport.form.packages.measurementUnit.25',
          '27': 'etransport.form.packages.measurementUnit.27',
          '28': 'etransport.form.packages.measurementUnit.28',
          '33': 'etransport.form.packages.measurementUnit.33',
          '34': 'etransport.form.packages.measurementUnit.34',
          '35': 'etransport.form.packages.measurementUnit.35',
          '37': 'etransport.form.packages.measurementUnit.37',
          '38': 'etransport.form.packages.measurementUnit.38',
          '40': 'etransport.form.packages.measurementUnit.40',
          '41': 'etransport.form.packages.measurementUnit.41',
          '56': 'etransport.form.packages.measurementUnit.56',
          '57': 'etransport.form.packages.measurementUnit.57',
          '58': 'etransport.form.packages.measurementUnit.58',
          '59': 'etransport.form.packages.measurementUnit.59',
          '60': 'etransport.form.packages.measurementUnit.60',
          '61': 'etransport.form.packages.measurementUnit.61',
          '74': 'etransport.form.packages.measurementUnit.74',
          '77': 'etransport.form.packages.measurementUnit.77',
          '80': 'etransport.form.packages.measurementUnit.80',
          '81': 'etransport.form.packages.measurementUnit.81',
          '85': 'etransport.form.packages.measurementUnit.85',
          '87': 'etransport.form.packages.measurementUnit.87',
          '89': 'etransport.form.packages.measurementUnit.89',
          '91': 'etransport.form.packages.measurementUnit.91',
          '1I': 'etransport.form.packages.measurementUnit.1I',
          '2A': 'etransport.form.packages.measurementUnit.2A',
          '2B': 'etransport.form.packages.measurementUnit.2B',
          '2C': 'etransport.form.packages.measurementUnit.2C',
          '2G': 'etransport.form.packages.measurementUnit.2G',
          '2H': 'etransport.form.packages.measurementUnit.2H',
          '2I': 'etransport.form.packages.measurementUnit.2I',
          '2J': 'etransport.form.packages.measurementUnit.2J',
          '2K': 'etransport.form.packages.measurementUnit.2K',
          '2L': 'etransport.form.packages.measurementUnit.2L',
          '2M': 'etransport.form.packages.measurementUnit.2M',
          '2N': 'etransport.form.packages.measurementUnit.2N',
          '2P': 'etransport.form.packages.measurementUnit.2P',
          '2Q': 'etransport.form.packages.measurementUnit.2Q',
          '2R': 'etransport.form.packages.measurementUnit.2R',
          '2U': 'etransport.form.packages.measurementUnit.2U',
          '2X': 'etransport.form.packages.measurementUnit.2X',
          '2Y': 'etransport.form.packages.measurementUnit.2Y',
          '2Z': 'etransport.form.packages.measurementUnit.2Z',
          '3B': 'etransport.form.packages.measurementUnit.3B',
          '3C': 'etransport.form.packages.measurementUnit.3C',
          '4C': 'etransport.form.packages.measurementUnit.4C',
          '4G': 'etransport.form.packages.measurementUnit.4G',
          '4H': 'etransport.form.packages.measurementUnit.4H',
          '4K': 'etransport.form.packages.measurementUnit.4K',
          '4L': 'etransport.form.packages.measurementUnit.4L',
          '4M': 'etransport.form.packages.measurementUnit.4M',
          '4N': 'etransport.form.packages.measurementUnit.4N',
          '4O': 'etransport.form.packages.measurementUnit.4O',
          '4P': 'etransport.form.packages.measurementUnit.4P',
          '4Q': 'etransport.form.packages.measurementUnit.4Q',
          '4R': 'etransport.form.packages.measurementUnit.4R',
          '4T': 'etransport.form.packages.measurementUnit.4T',
          '4U': 'etransport.form.packages.measurementUnit.4U',
          '4W': 'etransport.form.packages.measurementUnit.4W',
          '4X': 'etransport.form.packages.measurementUnit.4X',
          '5A': 'etransport.form.packages.measurementUnit.5A',
          '5B': 'etransport.form.packages.measurementUnit.5B',
          '5E': 'etransport.form.packages.measurementUnit.5E',
          '5J': 'etransport.form.packages.measurementUnit.5J',
          A10: 'etransport.form.packages.measurementUnit.A10',
          A11: 'etransport.form.packages.measurementUnit.A11',
          A12: 'etransport.form.packages.measurementUnit.A12',
          A13: 'etransport.form.packages.measurementUnit.A13',
          A14: 'etransport.form.packages.measurementUnit.A14',
          A15: 'etransport.form.packages.measurementUnit.A15',
          A16: 'etransport.form.packages.measurementUnit.A16',
          A17: 'etransport.form.packages.measurementUnit.A17',
          A18: 'etransport.form.packages.measurementUnit.A18',
          A19: 'etransport.form.packages.measurementUnit.A19',
          A2: 'etransport.form.packages.measurementUnit.A2',
          A20: 'etransport.form.packages.measurementUnit.A20',
          A21: 'etransport.form.packages.measurementUnit.A21',
          A22: 'etransport.form.packages.measurementUnit.A22',
          A23: 'etransport.form.packages.measurementUnit.A23',
          A24: 'etransport.form.packages.measurementUnit.A24',
          A26: 'etransport.form.packages.measurementUnit.A26',
          A27: 'etransport.form.packages.measurementUnit.A27',
          A28: 'etransport.form.packages.measurementUnit.A28',
          A29: 'etransport.form.packages.measurementUnit.A29',
          A3: 'etransport.form.packages.measurementUnit.A3',
          A30: 'etransport.form.packages.measurementUnit.A30',
          A31: 'etransport.form.packages.measurementUnit.A31',
          A32: 'etransport.form.packages.measurementUnit.A32',
          A33: 'etransport.form.packages.measurementUnit.A33',
          A34: 'etransport.form.packages.measurementUnit.A34',
          A35: 'etransport.form.packages.measurementUnit.A35',
          A36: 'etransport.form.packages.measurementUnit.A36',
          A37: 'etransport.form.packages.measurementUnit.A37',
          A38: 'etransport.form.packages.measurementUnit.A38',
          A39: 'etransport.form.packages.measurementUnit.A39',
          A4: 'etransport.form.packages.measurementUnit.A4',
          A40: 'etransport.form.packages.measurementUnit.A40',
          A41: 'etransport.form.packages.measurementUnit.A41',
          A42: 'etransport.form.packages.measurementUnit.A42',
          A43: 'etransport.form.packages.measurementUnit.A43',
          A44: 'etransport.form.packages.measurementUnit.A44',
          A45: 'etransport.form.packages.measurementUnit.A45',
          A47: 'etransport.form.packages.measurementUnit.A47',
          A48: 'etransport.form.packages.measurementUnit.A48',
          A49: 'etransport.form.packages.measurementUnit.A49',
          A5: 'etransport.form.packages.measurementUnit.A5',
          A53: 'etransport.form.packages.measurementUnit.A53',
          A54: 'etransport.form.packages.measurementUnit.A54',
          A55: 'etransport.form.packages.measurementUnit.A55',
          A56: 'etransport.form.packages.measurementUnit.A56',
          A59: 'etransport.form.packages.measurementUnit.A59',
          A6: 'etransport.form.packages.measurementUnit.A6',
          A68: 'etransport.form.packages.measurementUnit.A68',
          A69: 'etransport.form.packages.measurementUnit.A69',
          A7: 'etransport.form.packages.measurementUnit.A7',
          A70: 'etransport.form.packages.measurementUnit.A70',
          A71: 'etransport.form.packages.measurementUnit.A71',
          A73: 'etransport.form.packages.measurementUnit.A73',
          A74: 'etransport.form.packages.measurementUnit.A74',
          A75: 'etransport.form.packages.measurementUnit.A75',
          A76: 'etransport.form.packages.measurementUnit.A76',
          A8: 'etransport.form.packages.measurementUnit.A8',
          A84: 'etransport.form.packages.measurementUnit.A84',
          A85: 'etransport.form.packages.measurementUnit.A85',
          A86: 'etransport.form.packages.measurementUnit.A86',
          A87: 'etransport.form.packages.measurementUnit.A87',
          A88: 'etransport.form.packages.measurementUnit.A88',
          A89: 'etransport.form.packages.measurementUnit.A89',
          A9: 'etransport.form.packages.measurementUnit.A9',
          A90: 'etransport.form.packages.measurementUnit.A90',
          A91: 'etransport.form.packages.measurementUnit.A91',
          A93: 'etransport.form.packages.measurementUnit.A93',
          A94: 'etransport.form.packages.measurementUnit.A94',
          A95: 'etransport.form.packages.measurementUnit.A95',
          A96: 'etransport.form.packages.measurementUnit.A96',
          A97: 'etransport.form.packages.measurementUnit.A97',
          A98: 'etransport.form.packages.measurementUnit.A98',
          A99: 'etransport.form.packages.measurementUnit.A99',
          AA: 'etransport.form.packages.measurementUnit.AA',
          AB: 'etransport.form.packages.measurementUnit.AB',
          ACR: 'etransport.form.packages.measurementUnit.ACR',
          ACT: 'etransport.form.packages.measurementUnit.ACT',
          AD: 'etransport.form.packages.measurementUnit.AD',
          AE: 'etransport.form.packages.measurementUnit.AE',
          AH: 'etransport.form.packages.measurementUnit.AH',
          AI: 'etransport.form.packages.measurementUnit.AI',
          AK: 'etransport.form.packages.measurementUnit.AK',
          AL: 'etransport.form.packages.measurementUnit.AL',
          AMH: 'etransport.form.packages.measurementUnit.AMH',
          AMP: 'etransport.form.packages.measurementUnit.AMP',
          ANN: 'etransport.form.packages.measurementUnit.ANN',
          APZ: 'etransport.form.packages.measurementUnit.APZ',
          AQ: 'etransport.form.packages.measurementUnit.AQ',
          AS: 'etransport.form.packages.measurementUnit.AS',
          ASM: 'etransport.form.packages.measurementUnit.ASM',
          ASU: 'etransport.form.packages.measurementUnit.ASU',
          ATM: 'etransport.form.packages.measurementUnit.ATM',
          AWG: 'etransport.form.packages.measurementUnit.AWG',
          AY: 'etransport.form.packages.measurementUnit.AY',
          AZ: 'etransport.form.packages.measurementUnit.AZ',
          B1: 'etransport.form.packages.measurementUnit.B1',
          B10: 'etransport.form.packages.measurementUnit.B10',
          B11: 'etransport.form.packages.measurementUnit.B11',
          B12: 'etransport.form.packages.measurementUnit.B12',
          B13: 'etransport.form.packages.measurementUnit.B13',
          B14: 'etransport.form.packages.measurementUnit.B14',
          B15: 'etransport.form.packages.measurementUnit.B15',
          B16: 'etransport.form.packages.measurementUnit.B16',
          B17: 'etransport.form.packages.measurementUnit.B17',
          B18: 'etransport.form.packages.measurementUnit.B18',
          B19: 'etransport.form.packages.measurementUnit.B19',
          B20: 'etransport.form.packages.measurementUnit.B20',
          B21: 'etransport.form.packages.measurementUnit.B21',
          B22: 'etransport.form.packages.measurementUnit.B22',
          B23: 'etransport.form.packages.measurementUnit.B23',
          B24: 'etransport.form.packages.measurementUnit.B24',
          B25: 'etransport.form.packages.measurementUnit.B25',
          B26: 'etransport.form.packages.measurementUnit.B26',
          B27: 'etransport.form.packages.measurementUnit.B27',
          B28: 'etransport.form.packages.measurementUnit.B28',
          B29: 'etransport.form.packages.measurementUnit.B29',
          B3: 'etransport.form.packages.measurementUnit.B3',
          B30: 'etransport.form.packages.measurementUnit.B30',
          B31: 'etransport.form.packages.measurementUnit.B31',
          B32: 'etransport.form.packages.measurementUnit.B32',
          B33: 'etransport.form.packages.measurementUnit.B33',
          B34: 'etransport.form.packages.measurementUnit.B34',
          B35: 'etransport.form.packages.measurementUnit.B35',
          B4: 'etransport.form.packages.measurementUnit.B4',
          B41: 'etransport.form.packages.measurementUnit.B41',
          B42: 'etransport.form.packages.measurementUnit.B42',
          B43: 'etransport.form.packages.measurementUnit.B43',
          B44: 'etransport.form.packages.measurementUnit.B44',
          B45: 'etransport.form.packages.measurementUnit.B45',
          B46: 'etransport.form.packages.measurementUnit.B46',
          B47: 'etransport.form.packages.measurementUnit.B47',
          B48: 'etransport.form.packages.measurementUnit.B48',
          B49: 'etransport.form.packages.measurementUnit.B49',
          B50: 'etransport.form.packages.measurementUnit.B50',
          B52: 'etransport.form.packages.measurementUnit.B52',
          B53: 'etransport.form.packages.measurementUnit.B53',
          B54: 'etransport.form.packages.measurementUnit.B54',
          B55: 'etransport.form.packages.measurementUnit.B55',
          B56: 'etransport.form.packages.measurementUnit.B56',
          B57: 'etransport.form.packages.measurementUnit.B57',
          B58: 'etransport.form.packages.measurementUnit.B58',
          B59: 'etransport.form.packages.measurementUnit.B59',
          B60: 'etransport.form.packages.measurementUnit.B60',
          B61: 'etransport.form.packages.measurementUnit.B61',
          B62: 'etransport.form.packages.measurementUnit.B62',
          B63: 'etransport.form.packages.measurementUnit.B63',
          B64: 'etransport.form.packages.measurementUnit.B64',
          B66: 'etransport.form.packages.measurementUnit.B66',
          B67: 'etransport.form.packages.measurementUnit.B67',
          B68: 'etransport.form.packages.measurementUnit.B68',
          B69: 'etransport.form.packages.measurementUnit.B69',
          B7: 'etransport.form.packages.measurementUnit.B7',
          B70: 'etransport.form.packages.measurementUnit.B70',
          B71: 'etransport.form.packages.measurementUnit.B71',
          B72: 'etransport.form.packages.measurementUnit.B72',
          B73: 'etransport.form.packages.measurementUnit.B73',
          B74: 'etransport.form.packages.measurementUnit.B74',
          B75: 'etransport.form.packages.measurementUnit.B75',
          B76: 'etransport.form.packages.measurementUnit.B76',
          B77: 'etransport.form.packages.measurementUnit.B77',
          B78: 'etransport.form.packages.measurementUnit.B78',
          B79: 'etransport.form.packages.measurementUnit.B79',
          B8: 'etransport.form.packages.measurementUnit.B8',
          B80: 'etransport.form.packages.measurementUnit.B80',
          B81: 'etransport.form.packages.measurementUnit.B81',
          B82: 'etransport.form.packages.measurementUnit.B82',
          B83: 'etransport.form.packages.measurementUnit.B83',
          B84: 'etransport.form.packages.measurementUnit.B84',
          B85: 'etransport.form.packages.measurementUnit.B85',
          B86: 'etransport.form.packages.measurementUnit.B86',
          B87: 'etransport.form.packages.measurementUnit.B87',
          B88: 'etransport.form.packages.measurementUnit.B88',
          B89: 'etransport.form.packages.measurementUnit.B89',
          B90: 'etransport.form.packages.measurementUnit.B90',
          B91: 'etransport.form.packages.measurementUnit.B91',
          B92: 'etransport.form.packages.measurementUnit.B92',
          B93: 'etransport.form.packages.measurementUnit.B93',
          B94: 'etransport.form.packages.measurementUnit.B94',
          B95: 'etransport.form.packages.measurementUnit.B95',
          B96: 'etransport.form.packages.measurementUnit.B96',
          B97: 'etransport.form.packages.measurementUnit.B97',
          B98: 'etransport.form.packages.measurementUnit.B98',
          B99: 'etransport.form.packages.measurementUnit.B99',
          BAR: 'etransport.form.packages.measurementUnit.BAR',
          BB: 'etransport.form.packages.measurementUnit.BB',
          BFT: 'etransport.form.packages.measurementUnit.BFT',
          BHP: 'etransport.form.packages.measurementUnit.BHP',
          BIL: 'etransport.form.packages.measurementUnit.BIL',
          BLD: 'etransport.form.packages.measurementUnit.BLD',
          BLL: 'etransport.form.packages.measurementUnit.BLL',
          BP: 'etransport.form.packages.measurementUnit.BP',
          BPM: 'etransport.form.packages.measurementUnit.BPM',
          BQL: 'etransport.form.packages.measurementUnit.BQL',
          BTU: 'etransport.form.packages.measurementUnit.BTU',
          BUA: 'etransport.form.packages.measurementUnit.BUA',
          BUI: 'etransport.form.packages.measurementUnit.BUI',
          C0: 'etransport.form.packages.measurementUnit.C0',
          C10: 'etransport.form.packages.measurementUnit.C10',
          C11: 'etransport.form.packages.measurementUnit.C11',
          C12: 'etransport.form.packages.measurementUnit.C12',
          C13: 'etransport.form.packages.measurementUnit.C13',
          C14: 'etransport.form.packages.measurementUnit.C14',
          C15: 'etransport.form.packages.measurementUnit.C15',
          C16: 'etransport.form.packages.measurementUnit.C16',
          C17: 'etransport.form.packages.measurementUnit.C17',
          C18: 'etransport.form.packages.measurementUnit.C18',
          C19: 'etransport.form.packages.measurementUnit.C19',
          C20: 'etransport.form.packages.measurementUnit.C20',
          C21: 'etransport.form.packages.measurementUnit.C21',
          C22: 'etransport.form.packages.measurementUnit.C22',
          C23: 'etransport.form.packages.measurementUnit.C23',
          C24: 'etransport.form.packages.measurementUnit.C24',
          C25: 'etransport.form.packages.measurementUnit.C25',
          C26: 'etransport.form.packages.measurementUnit.C26',
          C27: 'etransport.form.packages.measurementUnit.C27',
          C28: 'etransport.form.packages.measurementUnit.C28',
          C29: 'etransport.form.packages.measurementUnit.C29',
          C3: 'etransport.form.packages.measurementUnit.C3',
          C30: 'etransport.form.packages.measurementUnit.C30',
          C31: 'etransport.form.packages.measurementUnit.C31',
          C32: 'etransport.form.packages.measurementUnit.C32',
          C33: 'etransport.form.packages.measurementUnit.C33',
          C34: 'etransport.form.packages.measurementUnit.C34',
          C35: 'etransport.form.packages.measurementUnit.C35',
          C36: 'etransport.form.packages.measurementUnit.C36',
          C37: 'etransport.form.packages.measurementUnit.C37',
          C38: 'etransport.form.packages.measurementUnit.C38',
          C39: 'etransport.form.packages.measurementUnit.C39',
          C40: 'etransport.form.packages.measurementUnit.C40',
          C41: 'etransport.form.packages.measurementUnit.C41',
          C42: 'etransport.form.packages.measurementUnit.C42',
          C43: 'etransport.form.packages.measurementUnit.C43',
          C44: 'etransport.form.packages.measurementUnit.C44',
          C45: 'etransport.form.packages.measurementUnit.C45',
          C46: 'etransport.form.packages.measurementUnit.C46',
          C47: 'etransport.form.packages.measurementUnit.C47',
          C48: 'etransport.form.packages.measurementUnit.C48',
          C49: 'etransport.form.packages.measurementUnit.C49',
          C50: 'etransport.form.packages.measurementUnit.C50',
          C51: 'etransport.form.packages.measurementUnit.C51',
          C52: 'etransport.form.packages.measurementUnit.C52',
          C53: 'etransport.form.packages.measurementUnit.C53',
          C54: 'etransport.form.packages.measurementUnit.C54',
          C55: 'etransport.form.packages.measurementUnit.C55',
          C56: 'etransport.form.packages.measurementUnit.C56',
          C57: 'etransport.form.packages.measurementUnit.C57',
          C58: 'etransport.form.packages.measurementUnit.C58',
          C59: 'etransport.form.packages.measurementUnit.C59',
          C60: 'etransport.form.packages.measurementUnit.C60',
          C61: 'etransport.form.packages.measurementUnit.C61',
          C63: 'etransport.form.packages.measurementUnit.C63',
          C64: 'etransport.form.packages.measurementUnit.C64',
          C65: 'etransport.form.packages.measurementUnit.C65',
          C66: 'etransport.form.packages.measurementUnit.C66',
          C67: 'etransport.form.packages.measurementUnit.C67',
          C68: 'etransport.form.packages.measurementUnit.C68',
          C69: 'etransport.form.packages.measurementUnit.C69',
          C7: 'etransport.form.packages.measurementUnit.C7',
          C70: 'etransport.form.packages.measurementUnit.C70',
          C71: 'etransport.form.packages.measurementUnit.C71',
          C72: 'etransport.form.packages.measurementUnit.C72',
          C73: 'etransport.form.packages.measurementUnit.C73',
          C74: 'etransport.form.packages.measurementUnit.C74',
          C75: 'etransport.form.packages.measurementUnit.C75',
          C76: 'etransport.form.packages.measurementUnit.C76',
          C78: 'etransport.form.packages.measurementUnit.C78',
          C79: 'etransport.form.packages.measurementUnit.C79',
          C8: 'etransport.form.packages.measurementUnit.C8',
          C80: 'etransport.form.packages.measurementUnit.C80',
          C81: 'etransport.form.packages.measurementUnit.C81',
          C82: 'etransport.form.packages.measurementUnit.C82',
          C83: 'etransport.form.packages.measurementUnit.C83',
          C84: 'etransport.form.packages.measurementUnit.C84',
          C85: 'etransport.form.packages.measurementUnit.C85',
          C86: 'etransport.form.packages.measurementUnit.C86',
          C87: 'etransport.form.packages.measurementUnit.C87',
          C88: 'etransport.form.packages.measurementUnit.C88',
          C89: 'etransport.form.packages.measurementUnit.C89',
          C9: 'etransport.form.packages.measurementUnit.C9',
          C90: 'etransport.form.packages.measurementUnit.C90',
          C91: 'etransport.form.packages.measurementUnit.C91',
          C92: 'etransport.form.packages.measurementUnit.C92',
          C93: 'etransport.form.packages.measurementUnit.C93',
          C94: 'etransport.form.packages.measurementUnit.C94',
          C95: 'etransport.form.packages.measurementUnit.C95',
          C96: 'etransport.form.packages.measurementUnit.C96',
          C97: 'etransport.form.packages.measurementUnit.C97',
          C99: 'etransport.form.packages.measurementUnit.C99',
          CCT: 'etransport.form.packages.measurementUnit.CCT',
          CDL: 'etransport.form.packages.measurementUnit.CDL',
          CEL: 'etransport.form.packages.measurementUnit.CEL',
          CEN: 'etransport.form.packages.measurementUnit.CEN',
          CG: 'etransport.form.packages.measurementUnit.CG',
          CGM: 'etransport.form.packages.measurementUnit.CGM',
          CKG: 'etransport.form.packages.measurementUnit.CKG',
          CLF: 'etransport.form.packages.measurementUnit.CLF',
          CLT: 'etransport.form.packages.measurementUnit.CLT',
          CMK: 'etransport.form.packages.measurementUnit.CMK',
          CMQ: 'etransport.form.packages.measurementUnit.CMQ',
          CNP: 'etransport.form.packages.measurementUnit.CNP',
          CNT: 'etransport.form.packages.measurementUnit.CNT',
          COU: 'etransport.form.packages.measurementUnit.COU',
          CTG: 'etransport.form.packages.measurementUnit.CTG',
          CTM: 'etransport.form.packages.measurementUnit.CTM',
          CTN: 'etransport.form.packages.measurementUnit.CTN',
          CUR: 'etransport.form.packages.measurementUnit.CUR',
          CWA: 'etransport.form.packages.measurementUnit.CWA',
          CWI: 'etransport.form.packages.measurementUnit.CWI',
          D03: 'etransport.form.packages.measurementUnit.D03',
          D04: 'etransport.form.packages.measurementUnit.D04',
          D1: 'etransport.form.packages.measurementUnit.D1',
          D10: 'etransport.form.packages.measurementUnit.D10',
          D11: 'etransport.form.packages.measurementUnit.D11',
          D12: 'etransport.form.packages.measurementUnit.D12',
          D13: 'etransport.form.packages.measurementUnit.D13',
          D15: 'etransport.form.packages.measurementUnit.D15',
          D16: 'etransport.form.packages.measurementUnit.D16',
          D17: 'etransport.form.packages.measurementUnit.D17',
          D18: 'etransport.form.packages.measurementUnit.D18',
          D19: 'etransport.form.packages.measurementUnit.D19',
          D2: 'etransport.form.packages.measurementUnit.D2',
          D20: 'etransport.form.packages.measurementUnit.D20',
          D21: 'etransport.form.packages.measurementUnit.D21',
          D22: 'etransport.form.packages.measurementUnit.D22',
          D23: 'etransport.form.packages.measurementUnit.D23',
          D24: 'etransport.form.packages.measurementUnit.D24',
          D25: 'etransport.form.packages.measurementUnit.D25',
          D26: 'etransport.form.packages.measurementUnit.D26',
          D27: 'etransport.form.packages.measurementUnit.D27',
          D29: 'etransport.form.packages.measurementUnit.D29',
          D30: 'etransport.form.packages.measurementUnit.D30',
          D31: 'etransport.form.packages.measurementUnit.D31',
          D32: 'etransport.form.packages.measurementUnit.D32',
          D33: 'etransport.form.packages.measurementUnit.D33',
          D34: 'etransport.form.packages.measurementUnit.D34',
          D36: 'etransport.form.packages.measurementUnit.D36',
          D41: 'etransport.form.packages.measurementUnit.D41',
          D42: 'etransport.form.packages.measurementUnit.D42',
          D43: 'etransport.form.packages.measurementUnit.D43',
          D44: 'etransport.form.packages.measurementUnit.D44',
          D45: 'etransport.form.packages.measurementUnit.D45',
          D46: 'etransport.form.packages.measurementUnit.D46',
          D47: 'etransport.form.packages.measurementUnit.D47',
          D48: 'etransport.form.packages.measurementUnit.D48',
          D49: 'etransport.form.packages.measurementUnit.D49',
          D5: 'etransport.form.packages.measurementUnit.D5',
          D50: 'etransport.form.packages.measurementUnit.D50',
          D51: 'etransport.form.packages.measurementUnit.D51',
          D52: 'etransport.form.packages.measurementUnit.D52',
          D53: 'etransport.form.packages.measurementUnit.D53',
          D54: 'etransport.form.packages.measurementUnit.D54',
          D55: 'etransport.form.packages.measurementUnit.D55',
          D56: 'etransport.form.packages.measurementUnit.D56',
          D57: 'etransport.form.packages.measurementUnit.D57',
          D58: 'etransport.form.packages.measurementUnit.D58',
          D59: 'etransport.form.packages.measurementUnit.D59',
          D6: 'etransport.form.packages.measurementUnit.D6',
          D60: 'etransport.form.packages.measurementUnit.D60',
          D61: 'etransport.form.packages.measurementUnit.D61',
          D62: 'etransport.form.packages.measurementUnit.D62',
          D63: 'etransport.form.packages.measurementUnit.D63',
          D65: 'etransport.form.packages.measurementUnit.D65',
          D68: 'etransport.form.packages.measurementUnit.D68',
          D69: 'etransport.form.packages.measurementUnit.D69',
          D73: 'etransport.form.packages.measurementUnit.D73',
          D74: 'etransport.form.packages.measurementUnit.D74',
          D77: 'etransport.form.packages.measurementUnit.D77',
          D78: 'etransport.form.packages.measurementUnit.D78',
          D80: 'etransport.form.packages.measurementUnit.D80',
          D81: 'etransport.form.packages.measurementUnit.D81',
          D82: 'etransport.form.packages.measurementUnit.D82',
          D83: 'etransport.form.packages.measurementUnit.D83',
          D85: 'etransport.form.packages.measurementUnit.D85',
          D86: 'etransport.form.packages.measurementUnit.D86',
          D87: 'etransport.form.packages.measurementUnit.D87',
          D88: 'etransport.form.packages.measurementUnit.D88',
          D89: 'etransport.form.packages.measurementUnit.D89',
          D91: 'etransport.form.packages.measurementUnit.D91',
          D93: 'etransport.form.packages.measurementUnit.D93',
          D94: 'etransport.form.packages.measurementUnit.D94',
          D95: 'etransport.form.packages.measurementUnit.D95',
          DAA: 'etransport.form.packages.measurementUnit.DAA',
          DAD: 'etransport.form.packages.measurementUnit.DAD',
          DAY: 'etransport.form.packages.measurementUnit.DAY',
          DB: 'etransport.form.packages.measurementUnit.DB',
          DD: 'etransport.form.packages.measurementUnit.DD',
          DEC: 'etransport.form.packages.measurementUnit.DEC',
          DG: 'etransport.form.packages.measurementUnit.DG',
          DJ: 'etransport.form.packages.measurementUnit.DJ',
          DLT: 'etransport.form.packages.measurementUnit.DLT',
          DMA: 'etransport.form.packages.measurementUnit.DMA',
          DMK: 'etransport.form.packages.measurementUnit.DMK',
          DMO: 'etransport.form.packages.measurementUnit.DMO',
          DMQ: 'etransport.form.packages.measurementUnit.DMQ',
          DMT: 'etransport.form.packages.measurementUnit.DMT',
          DN: 'etransport.form.packages.measurementUnit.DN',
          DPC: 'etransport.form.packages.measurementUnit.DPC',
          DPR: 'etransport.form.packages.measurementUnit.DPR',
          DPT: 'etransport.form.packages.measurementUnit.DPT',
          DRA: 'etransport.form.packages.measurementUnit.DRA',
          DRI: 'etransport.form.packages.measurementUnit.DRI',
          DRL: 'etransport.form.packages.measurementUnit.DRL',
          DT: 'etransport.form.packages.measurementUnit.DT',
          DTN: 'etransport.form.packages.measurementUnit.DTN',
          DWT: 'etransport.form.packages.measurementUnit.DWT',
          DZP: 'etransport.form.packages.measurementUnit.DZP',
          E01: 'etransport.form.packages.measurementUnit.E01',
          E07: 'etransport.form.packages.measurementUnit.E07',
          E08: 'etransport.form.packages.measurementUnit.E08',
          E09: 'etransport.form.packages.measurementUnit.E09',
          E10: 'etransport.form.packages.measurementUnit.E10',
          E12: 'etransport.form.packages.measurementUnit.E12',
          E14: 'etransport.form.packages.measurementUnit.E14',
          E15: 'etransport.form.packages.measurementUnit.E15',
          E16: 'etransport.form.packages.measurementUnit.E16',
          E17: 'etransport.form.packages.measurementUnit.E17',
          E18: 'etransport.form.packages.measurementUnit.E18',
          E19: 'etransport.form.packages.measurementUnit.E19',
          E20: 'etransport.form.packages.measurementUnit.E20',
          E21: 'etransport.form.packages.measurementUnit.E21',
          E22: 'etransport.form.packages.measurementUnit.E22',
          E23: 'etransport.form.packages.measurementUnit.E23',
          E25: 'etransport.form.packages.measurementUnit.E25',
          E27: 'etransport.form.packages.measurementUnit.E27',
          E28: 'etransport.form.packages.measurementUnit.E28',
          E30: 'etransport.form.packages.measurementUnit.E30',
          E31: 'etransport.form.packages.measurementUnit.E31',
          E32: 'etransport.form.packages.measurementUnit.E32',
          E33: 'etransport.form.packages.measurementUnit.E33',
          E34: 'etransport.form.packages.measurementUnit.E34',
          E35: 'etransport.form.packages.measurementUnit.E35',
          E36: 'etransport.form.packages.measurementUnit.E36',
          E37: 'etransport.form.packages.measurementUnit.E37',
          E38: 'etransport.form.packages.measurementUnit.E38',
          E39: 'etransport.form.packages.measurementUnit.E39',
          E4: 'etransport.form.packages.measurementUnit.E4',
          E40: 'etransport.form.packages.measurementUnit.E40',
          E41: 'etransport.form.packages.measurementUnit.E41',
          E42: 'etransport.form.packages.measurementUnit.E42',
          E43: 'etransport.form.packages.measurementUnit.E43',
          E44: 'etransport.form.packages.measurementUnit.E44',
          E45: 'etransport.form.packages.measurementUnit.E45',
          E46: 'etransport.form.packages.measurementUnit.E46',
          E47: 'etransport.form.packages.measurementUnit.E47',
          E48: 'etransport.form.packages.measurementUnit.E48',
          E49: 'etransport.form.packages.measurementUnit.E49',
          E50: 'etransport.form.packages.measurementUnit.E50',
          E51: 'etransport.form.packages.measurementUnit.E51',
          E52: 'etransport.form.packages.measurementUnit.E52',
          E53: 'etransport.form.packages.measurementUnit.E53',
          E54: 'etransport.form.packages.measurementUnit.E54',
          E55: 'etransport.form.packages.measurementUnit.E55',
          E56: 'etransport.form.packages.measurementUnit.E56',
          E57: 'etransport.form.packages.measurementUnit.E57',
          E58: 'etransport.form.packages.measurementUnit.E58',
          E59: 'etransport.form.packages.measurementUnit.E59',
          E60: 'etransport.form.packages.measurementUnit.E60',
          E61: 'etransport.form.packages.measurementUnit.E61',
          E62: 'etransport.form.packages.measurementUnit.E62',
          E63: 'etransport.form.packages.measurementUnit.E63',
          E64: 'etransport.form.packages.measurementUnit.E64',
          E65: 'etransport.form.packages.measurementUnit.E65',
          E66: 'etransport.form.packages.measurementUnit.E66',
          E67: 'etransport.form.packages.measurementUnit.E67',
          E68: 'etransport.form.packages.measurementUnit.E68',
          E69: 'etransport.form.packages.measurementUnit.E69',
          E70: 'etransport.form.packages.measurementUnit.E70',
          E71: 'etransport.form.packages.measurementUnit.E71',
          E72: 'etransport.form.packages.measurementUnit.E72',
          E73: 'etransport.form.packages.measurementUnit.E73',
          E74: 'etransport.form.packages.measurementUnit.E74',
          E75: 'etransport.form.packages.measurementUnit.E75',
          E76: 'etransport.form.packages.measurementUnit.E76',
          E77: 'etransport.form.packages.measurementUnit.E77',
          E78: 'etransport.form.packages.measurementUnit.E78',
          E79: 'etransport.form.packages.measurementUnit.E79',
          E80: 'etransport.form.packages.measurementUnit.E80',
          E81: 'etransport.form.packages.measurementUnit.E81',
          E82: 'etransport.form.packages.measurementUnit.E82',
          E83: 'etransport.form.packages.measurementUnit.E83',
          E84: 'etransport.form.packages.measurementUnit.E84',
          E85: 'etransport.form.packages.measurementUnit.E85',
          E86: 'etransport.form.packages.measurementUnit.E86',
          E87: 'etransport.form.packages.measurementUnit.E87',
          E88: 'etransport.form.packages.measurementUnit.E88',
          E89: 'etransport.form.packages.measurementUnit.E89',
          E90: 'etransport.form.packages.measurementUnit.E90',
          E91: 'etransport.form.packages.measurementUnit.E91',
          E92: 'etransport.form.packages.measurementUnit.E92',
          E93: 'etransport.form.packages.measurementUnit.E93',
          E94: 'etransport.form.packages.measurementUnit.E94',
          E95: 'etransport.form.packages.measurementUnit.E95',
          E96: 'etransport.form.packages.measurementUnit.E96',
          E97: 'etransport.form.packages.measurementUnit.E97',
          E98: 'etransport.form.packages.measurementUnit.E98',
          E99: 'etransport.form.packages.measurementUnit.E99',
          EB: 'etransport.form.packages.measurementUnit.EB',
          EQ: 'etransport.form.packages.measurementUnit.EQ',
          F01: 'etransport.form.packages.measurementUnit.F01',
          F02: 'etransport.form.packages.measurementUnit.F02',
          F03: 'etransport.form.packages.measurementUnit.F03',
          F04: 'etransport.form.packages.measurementUnit.F04',
          F05: 'etransport.form.packages.measurementUnit.F05',
          F06: 'etransport.form.packages.measurementUnit.F06',
          F07: 'etransport.form.packages.measurementUnit.F07',
          F08: 'etransport.form.packages.measurementUnit.F08',
          F10: 'etransport.form.packages.measurementUnit.F10',
          F11: 'etransport.form.packages.measurementUnit.F11',
          F12: 'etransport.form.packages.measurementUnit.F12',
          F13: 'etransport.form.packages.measurementUnit.F13',
          F14: 'etransport.form.packages.measurementUnit.F14',
          F15: 'etransport.form.packages.measurementUnit.F15',
          F16: 'etransport.form.packages.measurementUnit.F16',
          F17: 'etransport.form.packages.measurementUnit.F17',
          F18: 'etransport.form.packages.measurementUnit.F18',
          F19: 'etransport.form.packages.measurementUnit.F19',
          F20: 'etransport.form.packages.measurementUnit.F20',
          F21: 'etransport.form.packages.measurementUnit.F21',
          F22: 'etransport.form.packages.measurementUnit.F22',
          F23: 'etransport.form.packages.measurementUnit.F23',
          F24: 'etransport.form.packages.measurementUnit.F24',
          F25: 'etransport.form.packages.measurementUnit.F25',
          F26: 'etransport.form.packages.measurementUnit.F26',
          F27: 'etransport.form.packages.measurementUnit.F27',
          F28: 'etransport.form.packages.measurementUnit.F28',
          F29: 'etransport.form.packages.measurementUnit.F29',
          F30: 'etransport.form.packages.measurementUnit.F30',
          F31: 'etransport.form.packages.measurementUnit.F31',
          F32: 'etransport.form.packages.measurementUnit.F32',
          F33: 'etransport.form.packages.measurementUnit.F33',
          F34: 'etransport.form.packages.measurementUnit.F34',
          F35: 'etransport.form.packages.measurementUnit.F35',
          F36: 'etransport.form.packages.measurementUnit.F36',
          F37: 'etransport.form.packages.measurementUnit.F37',
          F38: 'etransport.form.packages.measurementUnit.F38',
          F39: 'etransport.form.packages.measurementUnit.F39',
          F40: 'etransport.form.packages.measurementUnit.F40',
          F41: 'etransport.form.packages.measurementUnit.F41',
          F42: 'etransport.form.packages.measurementUnit.F42',
          F43: 'etransport.form.packages.measurementUnit.F43',
          F44: 'etransport.form.packages.measurementUnit.F44',
          F45: 'etransport.form.packages.measurementUnit.F45',
          F46: 'etransport.form.packages.measurementUnit.F46',
          F47: 'etransport.form.packages.measurementUnit.F47',
          F48: 'etransport.form.packages.measurementUnit.F48',
          F49: 'etransport.form.packages.measurementUnit.F49',
          F50: 'etransport.form.packages.measurementUnit.F50',
          F51: 'etransport.form.packages.measurementUnit.F51',
          F52: 'etransport.form.packages.measurementUnit.F52',
          F53: 'etransport.form.packages.measurementUnit.F53',
          F54: 'etransport.form.packages.measurementUnit.F54',
          F55: 'etransport.form.packages.measurementUnit.F55',
          F56: 'etransport.form.packages.measurementUnit.F56',
          F57: 'etransport.form.packages.measurementUnit.F57',
          F58: 'etransport.form.packages.measurementUnit.F58',
          F59: 'etransport.form.packages.measurementUnit.F59',
          F60: 'etransport.form.packages.measurementUnit.F60',
          F61: 'etransport.form.packages.measurementUnit.F61',
          F62: 'etransport.form.packages.measurementUnit.F62',
          F63: 'etransport.form.packages.measurementUnit.F63',
          F64: 'etransport.form.packages.measurementUnit.F64',
          F65: 'etransport.form.packages.measurementUnit.F65',
          F66: 'etransport.form.packages.measurementUnit.F66',
          F67: 'etransport.form.packages.measurementUnit.F67',
          F68: 'etransport.form.packages.measurementUnit.F68',
          F69: 'etransport.form.packages.measurementUnit.F69',
          F70: 'etransport.form.packages.measurementUnit.F70',
          F71: 'etransport.form.packages.measurementUnit.F71',
          F72: 'etransport.form.packages.measurementUnit.F72',
          F73: 'etransport.form.packages.measurementUnit.F73',
          F74: 'etransport.form.packages.measurementUnit.F74',
          F75: 'etransport.form.packages.measurementUnit.F75',
          F76: 'etransport.form.packages.measurementUnit.F76',
          F77: 'etransport.form.packages.measurementUnit.F77',
          F78: 'etransport.form.packages.measurementUnit.F78',
          F79: 'etransport.form.packages.measurementUnit.F79',
          F80: 'etransport.form.packages.measurementUnit.F80',
          F81: 'etransport.form.packages.measurementUnit.F81',
          F82: 'etransport.form.packages.measurementUnit.F82',
          F83: 'etransport.form.packages.measurementUnit.F83',
          F84: 'etransport.form.packages.measurementUnit.F84',
          F85: 'etransport.form.packages.measurementUnit.F85',
          F86: 'etransport.form.packages.measurementUnit.F86',
          F87: 'etransport.form.packages.measurementUnit.F87',
          F88: 'etransport.form.packages.measurementUnit.F88',
          F89: 'etransport.form.packages.measurementUnit.F89',
          F90: 'etransport.form.packages.measurementUnit.F90',
          F91: 'etransport.form.packages.measurementUnit.F91',
          F92: 'etransport.form.packages.measurementUnit.F92',
          F93: 'etransport.form.packages.measurementUnit.F93',
          F94: 'etransport.form.packages.measurementUnit.F94',
          F95: 'etransport.form.packages.measurementUnit.F95',
          F96: 'etransport.form.packages.measurementUnit.F96',
          F97: 'etransport.form.packages.measurementUnit.F97',
          F98: 'etransport.form.packages.measurementUnit.F98',
          F99: 'etransport.form.packages.measurementUnit.F99',
          FAH: 'etransport.form.packages.measurementUnit.FAH',
          FAR: 'etransport.form.packages.measurementUnit.FAR',
          FBM: 'etransport.form.packages.measurementUnit.FBM',
          FC: 'etransport.form.packages.measurementUnit.FC',
          FF: 'etransport.form.packages.measurementUnit.FF',
          FH: 'etransport.form.packages.measurementUnit.FH',
          FIT: 'etransport.form.packages.measurementUnit.FIT',
          FL: 'etransport.form.packages.measurementUnit.FL',
          FP: 'etransport.form.packages.measurementUnit.FP',
          FR: 'etransport.form.packages.measurementUnit.FR',
          FS: 'etransport.form.packages.measurementUnit.FS',
          FTK: 'etransport.form.packages.measurementUnit.FTK',
          FTQ: 'etransport.form.packages.measurementUnit.FTQ',
          G01: 'etransport.form.packages.measurementUnit.G01',
          G04: 'etransport.form.packages.measurementUnit.G04',
          G05: 'etransport.form.packages.measurementUnit.G05',
          G06: 'etransport.form.packages.measurementUnit.G06',
          G08: 'etransport.form.packages.measurementUnit.G08',
          G09: 'etransport.form.packages.measurementUnit.G09',
          G10: 'etransport.form.packages.measurementUnit.G10',
          G11: 'etransport.form.packages.measurementUnit.G11',
          G12: 'etransport.form.packages.measurementUnit.G12',
          G13: 'etransport.form.packages.measurementUnit.G13',
          G14: 'etransport.form.packages.measurementUnit.G14',
          G15: 'etransport.form.packages.measurementUnit.G15',
          G16: 'etransport.form.packages.measurementUnit.G16',
          G17: 'etransport.form.packages.measurementUnit.G17',
          G18: 'etransport.form.packages.measurementUnit.G18',
          G19: 'etransport.form.packages.measurementUnit.G19',
          G2: 'etransport.form.packages.measurementUnit.G2',
          G20: 'etransport.form.packages.measurementUnit.G20',
          G21: 'etransport.form.packages.measurementUnit.G21',
          G23: 'etransport.form.packages.measurementUnit.G23',
          G24: 'etransport.form.packages.measurementUnit.G24',
          G25: 'etransport.form.packages.measurementUnit.G25',
          G26: 'etransport.form.packages.measurementUnit.G26',
          G27: 'etransport.form.packages.measurementUnit.G27',
          G28: 'etransport.form.packages.measurementUnit.G28',
          G29: 'etransport.form.packages.measurementUnit.G29',
          G3: 'etransport.form.packages.measurementUnit.G3',
          G30: 'etransport.form.packages.measurementUnit.G30',
          G31: 'etransport.form.packages.measurementUnit.G31',
          G32: 'etransport.form.packages.measurementUnit.G32',
          G33: 'etransport.form.packages.measurementUnit.G33',
          G34: 'etransport.form.packages.measurementUnit.G34',
          G35: 'etransport.form.packages.measurementUnit.G35',
          G36: 'etransport.form.packages.measurementUnit.G36',
          G37: 'etransport.form.packages.measurementUnit.G37',
          G38: 'etransport.form.packages.measurementUnit.G38',
          G39: 'etransport.form.packages.measurementUnit.G39',
          G40: 'etransport.form.packages.measurementUnit.G40',
          G41: 'etransport.form.packages.measurementUnit.G41',
          G42: 'etransport.form.packages.measurementUnit.G42',
          G43: 'etransport.form.packages.measurementUnit.G43',
          G44: 'etransport.form.packages.measurementUnit.G44',
          G45: 'etransport.form.packages.measurementUnit.G45',
          G46: 'etransport.form.packages.measurementUnit.G46',
          G47: 'etransport.form.packages.measurementUnit.G47',
          G48: 'etransport.form.packages.measurementUnit.G48',
          G49: 'etransport.form.packages.measurementUnit.G49',
          G50: 'etransport.form.packages.measurementUnit.G50',
          G51: 'etransport.form.packages.measurementUnit.G51',
          G52: 'etransport.form.packages.measurementUnit.G52',
          G53: 'etransport.form.packages.measurementUnit.G53',
          G54: 'etransport.form.packages.measurementUnit.G54',
          G55: 'etransport.form.packages.measurementUnit.G55',
          G56: 'etransport.form.packages.measurementUnit.G56',
          G57: 'etransport.form.packages.measurementUnit.G57',
          G58: 'etransport.form.packages.measurementUnit.G58',
          G59: 'etransport.form.packages.measurementUnit.G59',
          G60: 'etransport.form.packages.measurementUnit.G60',
          G61: 'etransport.form.packages.measurementUnit.G61',
          G62: 'etransport.form.packages.measurementUnit.G62',
          G63: 'etransport.form.packages.measurementUnit.G63',
          G64: 'etransport.form.packages.measurementUnit.G64',
          G65: 'etransport.form.packages.measurementUnit.G65',
          G66: 'etransport.form.packages.measurementUnit.G66',
          G67: 'etransport.form.packages.measurementUnit.G67',
          G68: 'etransport.form.packages.measurementUnit.G68',
          G69: 'etransport.form.packages.measurementUnit.G69',
          G70: 'etransport.form.packages.measurementUnit.G70',
          G71: 'etransport.form.packages.measurementUnit.G71',
          G72: 'etransport.form.packages.measurementUnit.G72',
          G73: 'etransport.form.packages.measurementUnit.G73',
          G74: 'etransport.form.packages.measurementUnit.G74',
          G75: 'etransport.form.packages.measurementUnit.G75',
          G76: 'etransport.form.packages.measurementUnit.G76',
          G77: 'etransport.form.packages.measurementUnit.G77',
          G78: 'etransport.form.packages.measurementUnit.G78',
          G79: 'etransport.form.packages.measurementUnit.G79',
          G80: 'etransport.form.packages.measurementUnit.G80',
          G81: 'etransport.form.packages.measurementUnit.G81',
          G82: 'etransport.form.packages.measurementUnit.G82',
          G83: 'etransport.form.packages.measurementUnit.G83',
          G84: 'etransport.form.packages.measurementUnit.G84',
          G85: 'etransport.form.packages.measurementUnit.G85',
          G86: 'etransport.form.packages.measurementUnit.G86',
          G87: 'etransport.form.packages.measurementUnit.G87',
          G88: 'etransport.form.packages.measurementUnit.G88',
          G89: 'etransport.form.packages.measurementUnit.G89',
          G90: 'etransport.form.packages.measurementUnit.G90',
          G91: 'etransport.form.packages.measurementUnit.G91',
          G92: 'etransport.form.packages.measurementUnit.G92',
          G93: 'etransport.form.packages.measurementUnit.G93',
          G94: 'etransport.form.packages.measurementUnit.G94',
          G95: 'etransport.form.packages.measurementUnit.G95',
          G96: 'etransport.form.packages.measurementUnit.G96',
          G97: 'etransport.form.packages.measurementUnit.G97',
          G98: 'etransport.form.packages.measurementUnit.G98',
          G99: 'etransport.form.packages.measurementUnit.G99',
          GB: 'etransport.form.packages.measurementUnit.GB',
          GBQ: 'etransport.form.packages.measurementUnit.GBQ',
          GDW: 'etransport.form.packages.measurementUnit.GDW',
          GE: 'etransport.form.packages.measurementUnit.GE',
          GF: 'etransport.form.packages.measurementUnit.GF',
          GFI: 'etransport.form.packages.measurementUnit.GFI',
          GGR: 'etransport.form.packages.measurementUnit.GGR',
          GIA: 'etransport.form.packages.measurementUnit.GIA',
          GIC: 'etransport.form.packages.measurementUnit.GIC',
          GII: 'etransport.form.packages.measurementUnit.GII',
          GIP: 'etransport.form.packages.measurementUnit.GIP',
          GJ: 'etransport.form.packages.measurementUnit.GJ',
          GL: 'etransport.form.packages.measurementUnit.GL',
          GLD: 'etransport.form.packages.measurementUnit.GLD',
          GLI: 'etransport.form.packages.measurementUnit.GLI',
          GLL: 'etransport.form.packages.measurementUnit.GLL',
          GM: 'etransport.form.packages.measurementUnit.GM',
          GO: 'etransport.form.packages.measurementUnit.GO',
          GP: 'etransport.form.packages.measurementUnit.GP',
          GQ: 'etransport.form.packages.measurementUnit.GQ',
          GRN: 'etransport.form.packages.measurementUnit.GRN',
          GRO: 'etransport.form.packages.measurementUnit.GRO',
          GV: 'etransport.form.packages.measurementUnit.GV',
          GWH: 'etransport.form.packages.measurementUnit.GWH',
          H03: 'etransport.form.packages.measurementUnit.H03',
          H04: 'etransport.form.packages.measurementUnit.H04',
          H05: 'etransport.form.packages.measurementUnit.H05',
          H06: 'etransport.form.packages.measurementUnit.H06',
          H07: 'etransport.form.packages.measurementUnit.H07',
          H08: 'etransport.form.packages.measurementUnit.H08',
          H09: 'etransport.form.packages.measurementUnit.H09',
          H10: 'etransport.form.packages.measurementUnit.H10',
          H11: 'etransport.form.packages.measurementUnit.H11',
          H12: 'etransport.form.packages.measurementUnit.H12',
          H13: 'etransport.form.packages.measurementUnit.H13',
          H14: 'etransport.form.packages.measurementUnit.H14',
          H15: 'etransport.form.packages.measurementUnit.H15',
          H16: 'etransport.form.packages.measurementUnit.H16',
          H18: 'etransport.form.packages.measurementUnit.H18',
          H19: 'etransport.form.packages.measurementUnit.H19',
          H20: 'etransport.form.packages.measurementUnit.H20',
          H21: 'etransport.form.packages.measurementUnit.H21',
          H22: 'etransport.form.packages.measurementUnit.H22',
          H23: 'etransport.form.packages.measurementUnit.H23',
          H24: 'etransport.form.packages.measurementUnit.H24',
          H25: 'etransport.form.packages.measurementUnit.H25',
          H26: 'etransport.form.packages.measurementUnit.H26',
          H27: 'etransport.form.packages.measurementUnit.H27',
          H28: 'etransport.form.packages.measurementUnit.H28',
          H29: 'etransport.form.packages.measurementUnit.H29',
          H30: 'etransport.form.packages.measurementUnit.H30',
          H31: 'etransport.form.packages.measurementUnit.H31',
          H32: 'etransport.form.packages.measurementUnit.H32',
          H33: 'etransport.form.packages.measurementUnit.H33',
          H34: 'etransport.form.packages.measurementUnit.H34',
          H35: 'etransport.form.packages.measurementUnit.H35',
          H36: 'etransport.form.packages.measurementUnit.H36',
          H37: 'etransport.form.packages.measurementUnit.H37',
          H38: 'etransport.form.packages.measurementUnit.H38',
          H39: 'etransport.form.packages.measurementUnit.H39',
          H40: 'etransport.form.packages.measurementUnit.H40',
          H41: 'etransport.form.packages.measurementUnit.H41',
          H42: 'etransport.form.packages.measurementUnit.H42',
          H43: 'etransport.form.packages.measurementUnit.H43',
          H44: 'etransport.form.packages.measurementUnit.H44',
          H45: 'etransport.form.packages.measurementUnit.H45',
          H46: 'etransport.form.packages.measurementUnit.H46',
          H47: 'etransport.form.packages.measurementUnit.H47',
          H48: 'etransport.form.packages.measurementUnit.H48',
          H49: 'etransport.form.packages.measurementUnit.H49',
          H50: 'etransport.form.packages.measurementUnit.H50',
          H51: 'etransport.form.packages.measurementUnit.H51',
          H52: 'etransport.form.packages.measurementUnit.H52',
          H53: 'etransport.form.packages.measurementUnit.H53',
          H54: 'etransport.form.packages.measurementUnit.H54',
          H55: 'etransport.form.packages.measurementUnit.H55',
          H56: 'etransport.form.packages.measurementUnit.H56',
          H57: 'etransport.form.packages.measurementUnit.H57',
          H58: 'etransport.form.packages.measurementUnit.H58',
          H59: 'etransport.form.packages.measurementUnit.H59',
          H60: 'etransport.form.packages.measurementUnit.H60',
          H61: 'etransport.form.packages.measurementUnit.H61',
          H62: 'etransport.form.packages.measurementUnit.H62',
          H63: 'etransport.form.packages.measurementUnit.H63',
          H64: 'etransport.form.packages.measurementUnit.H64',
          H65: 'etransport.form.packages.measurementUnit.H65',
          H66: 'etransport.form.packages.measurementUnit.H66',
          H67: 'etransport.form.packages.measurementUnit.H67',
          H68: 'etransport.form.packages.measurementUnit.H68',
          H69: 'etransport.form.packages.measurementUnit.H69',
          H70: 'etransport.form.packages.measurementUnit.H70',
          H71: 'etransport.form.packages.measurementUnit.H71',
          H72: 'etransport.form.packages.measurementUnit.H72',
          H73: 'etransport.form.packages.measurementUnit.H73',
          H74: 'etransport.form.packages.measurementUnit.H74',
          H75: 'etransport.form.packages.measurementUnit.H75',
          H76: 'etransport.form.packages.measurementUnit.H76',
          H77: 'etransport.form.packages.measurementUnit.H77',
          H79: 'etransport.form.packages.measurementUnit.H79',
          H80: 'etransport.form.packages.measurementUnit.H80',
          H81: 'etransport.form.packages.measurementUnit.H81',
          H82: 'etransport.form.packages.measurementUnit.H82',
          H83: 'etransport.form.packages.measurementUnit.H83',
          H84: 'etransport.form.packages.measurementUnit.H84',
          H85: 'etransport.form.packages.measurementUnit.H85',
          H88: 'etransport.form.packages.measurementUnit.H88',
          H89: 'etransport.form.packages.measurementUnit.H89',
          H90: 'etransport.form.packages.measurementUnit.H90',
          H91: 'etransport.form.packages.measurementUnit.H91',
          H92: 'etransport.form.packages.measurementUnit.H92',
          H93: 'etransport.form.packages.measurementUnit.H93',
          H94: 'etransport.form.packages.measurementUnit.H94',
          H95: 'etransport.form.packages.measurementUnit.H95',
          H96: 'etransport.form.packages.measurementUnit.H96',
          H98: 'etransport.form.packages.measurementUnit.H98',
          H99: 'etransport.form.packages.measurementUnit.H99',
          HA: 'etransport.form.packages.measurementUnit.HA',
          HBA: 'etransport.form.packages.measurementUnit.HBA',
          HBX: 'etransport.form.packages.measurementUnit.HBX',
          HC: 'etransport.form.packages.measurementUnit.HC',
          HDW: 'etransport.form.packages.measurementUnit.HDW',
          HEA: 'etransport.form.packages.measurementUnit.HEA',
          HGM: 'etransport.form.packages.measurementUnit.HGM',
          HH: 'etransport.form.packages.measurementUnit.HH',
          HIU: 'etransport.form.packages.measurementUnit.HIU',
          HKM: 'etransport.form.packages.measurementUnit.HKM',
          HLT: 'etransport.form.packages.measurementUnit.HLT',
          HM: 'etransport.form.packages.measurementUnit.HM',
          HMQ: 'etransport.form.packages.measurementUnit.HMQ',
          HMT: 'etransport.form.packages.measurementUnit.HMT',
          HPA: 'etransport.form.packages.measurementUnit.HPA',
          HTZ: 'etransport.form.packages.measurementUnit.HTZ',
          HUR: 'etransport.form.packages.measurementUnit.HUR',
          IA: 'etransport.form.packages.measurementUnit.IA',
          IE: 'etransport.form.packages.measurementUnit.IE',
          INK: 'etransport.form.packages.measurementUnit.INK',
          INQ: 'etransport.form.packages.measurementUnit.INQ',
          ISD: 'etransport.form.packages.measurementUnit.ISD',
          IU: 'etransport.form.packages.measurementUnit.IU',
          IUG: 'etransport.form.packages.measurementUnit.IUG',
          IV: 'etransport.form.packages.measurementUnit.IV',
          J10: 'etransport.form.packages.measurementUnit.J10',
          J12: 'etransport.form.packages.measurementUnit.J12',
          J13: 'etransport.form.packages.measurementUnit.J13',
          J14: 'etransport.form.packages.measurementUnit.J14',
          J15: 'etransport.form.packages.measurementUnit.J15',
          J16: 'etransport.form.packages.measurementUnit.J16',
          J17: 'etransport.form.packages.measurementUnit.J17',
          J18: 'etransport.form.packages.measurementUnit.J18',
          J19: 'etransport.form.packages.measurementUnit.J19',
          J2: 'etransport.form.packages.measurementUnit.J2',
          J20: 'etransport.form.packages.measurementUnit.J20',
          J21: 'etransport.form.packages.measurementUnit.J21',
          J22: 'etransport.form.packages.measurementUnit.J22',
          J23: 'etransport.form.packages.measurementUnit.J23',
          J24: 'etransport.form.packages.measurementUnit.J24',
          J25: 'etransport.form.packages.measurementUnit.J25',
          J26: 'etransport.form.packages.measurementUnit.J26',
          J27: 'etransport.form.packages.measurementUnit.J27',
          J28: 'etransport.form.packages.measurementUnit.J28',
          J29: 'etransport.form.packages.measurementUnit.J29',
          J30: 'etransport.form.packages.measurementUnit.J30',
          J31: 'etransport.form.packages.measurementUnit.J31',
          J32: 'etransport.form.packages.measurementUnit.J32',
          J33: 'etransport.form.packages.measurementUnit.J33',
          J34: 'etransport.form.packages.measurementUnit.J34',
          J35: 'etransport.form.packages.measurementUnit.J35',
          J36: 'etransport.form.packages.measurementUnit.J36',
          J38: 'etransport.form.packages.measurementUnit.J38',
          J39: 'etransport.form.packages.measurementUnit.J39',
          J40: 'etransport.form.packages.measurementUnit.J40',
          J41: 'etransport.form.packages.measurementUnit.J41',
          J42: 'etransport.form.packages.measurementUnit.J42',
          J43: 'etransport.form.packages.measurementUnit.J43',
          J44: 'etransport.form.packages.measurementUnit.J44',
          J45: 'etransport.form.packages.measurementUnit.J45',
          J46: 'etransport.form.packages.measurementUnit.J46',
          J47: 'etransport.form.packages.measurementUnit.J47',
          J48: 'etransport.form.packages.measurementUnit.J48',
          J49: 'etransport.form.packages.measurementUnit.J49',
          J50: 'etransport.form.packages.measurementUnit.J50',
          J51: 'etransport.form.packages.measurementUnit.J51',
          J52: 'etransport.form.packages.measurementUnit.J52',
          J53: 'etransport.form.packages.measurementUnit.J53',
          J54: 'etransport.form.packages.measurementUnit.J54',
          J55: 'etransport.form.packages.measurementUnit.J55',
          J56: 'etransport.form.packages.measurementUnit.J56',
          J58: 'etransport.form.packages.measurementUnit.J58',
          J59: 'etransport.form.packages.measurementUnit.J59',
          J60: 'etransport.form.packages.measurementUnit.J60',
          J61: 'etransport.form.packages.measurementUnit.J61',
          J62: 'etransport.form.packages.measurementUnit.J62',
          J63: 'etransport.form.packages.measurementUnit.J63',
          J64: 'etransport.form.packages.measurementUnit.J64',
          J65: 'etransport.form.packages.measurementUnit.J65',
          J66: 'etransport.form.packages.measurementUnit.J66',
          J67: 'etransport.form.packages.measurementUnit.J67',
          J68: 'etransport.form.packages.measurementUnit.J68',
          J69: 'etransport.form.packages.measurementUnit.J69',
          J70: 'etransport.form.packages.measurementUnit.J70',
          J71: 'etransport.form.packages.measurementUnit.J71',
          J72: 'etransport.form.packages.measurementUnit.J72',
          J73: 'etransport.form.packages.measurementUnit.J73',
          J74: 'etransport.form.packages.measurementUnit.J74',
          J75: 'etransport.form.packages.measurementUnit.J75',
          J76: 'etransport.form.packages.measurementUnit.J76',
          J78: 'etransport.form.packages.measurementUnit.J78',
          J79: 'etransport.form.packages.measurementUnit.J79',
          J81: 'etransport.form.packages.measurementUnit.J81',
          J82: 'etransport.form.packages.measurementUnit.J82',
          J83: 'etransport.form.packages.measurementUnit.J83',
          J84: 'etransport.form.packages.measurementUnit.J84',
          J85: 'etransport.form.packages.measurementUnit.J85',
          J87: 'etransport.form.packages.measurementUnit.J87',
          J90: 'etransport.form.packages.measurementUnit.J90',
          J91: 'etransport.form.packages.measurementUnit.J91',
          J92: 'etransport.form.packages.measurementUnit.J92',
          J93: 'etransport.form.packages.measurementUnit.J93',
          J95: 'etransport.form.packages.measurementUnit.J95',
          J96: 'etransport.form.packages.measurementUnit.J96',
          J97: 'etransport.form.packages.measurementUnit.J97',
          J98: 'etransport.form.packages.measurementUnit.J98',
          J99: 'etransport.form.packages.measurementUnit.J99',
          JE: 'etransport.form.packages.measurementUnit.JE',
          JK: 'etransport.form.packages.measurementUnit.JK',
          JM: 'etransport.form.packages.measurementUnit.JM',
          JNT: 'etransport.form.packages.measurementUnit.JNT',
          JOU: 'etransport.form.packages.measurementUnit.JOU',
          JPS: 'etransport.form.packages.measurementUnit.JPS',
          JWL: 'etransport.form.packages.measurementUnit.JWL',
          K1: 'etransport.form.packages.measurementUnit.K1',
          K10: 'etransport.form.packages.measurementUnit.K10',
          K11: 'etransport.form.packages.measurementUnit.K11',
          K12: 'etransport.form.packages.measurementUnit.K12',
          K13: 'etransport.form.packages.measurementUnit.K13',
          K14: 'etransport.form.packages.measurementUnit.K14',
          K15: 'etransport.form.packages.measurementUnit.K15',
          K16: 'etransport.form.packages.measurementUnit.K16',
          K17: 'etransport.form.packages.measurementUnit.K17',
          K18: 'etransport.form.packages.measurementUnit.K18',
          K19: 'etransport.form.packages.measurementUnit.K19',
          K2: 'etransport.form.packages.measurementUnit.K2',
          K20: 'etransport.form.packages.measurementUnit.K20',
          K21: 'etransport.form.packages.measurementUnit.K21',
          K22: 'etransport.form.packages.measurementUnit.K22',
          K23: 'etransport.form.packages.measurementUnit.K23',
          K26: 'etransport.form.packages.measurementUnit.K26',
          K27: 'etransport.form.packages.measurementUnit.K27',
          K28: 'etransport.form.packages.measurementUnit.K28',
          K3: 'etransport.form.packages.measurementUnit.K3',
          K30: 'etransport.form.packages.measurementUnit.K30',
          K31: 'etransport.form.packages.measurementUnit.K31',
          K32: 'etransport.form.packages.measurementUnit.K32',
          K33: 'etransport.form.packages.measurementUnit.K33',
          K34: 'etransport.form.packages.measurementUnit.K34',
          K35: 'etransport.form.packages.measurementUnit.K35',
          K36: 'etransport.form.packages.measurementUnit.K36',
          K37: 'etransport.form.packages.measurementUnit.K37',
          K38: 'etransport.form.packages.measurementUnit.K38',
          K39: 'etransport.form.packages.measurementUnit.K39',
          K40: 'etransport.form.packages.measurementUnit.K40',
          K41: 'etransport.form.packages.measurementUnit.K41',
          K42: 'etransport.form.packages.measurementUnit.K42',
          K43: 'etransport.form.packages.measurementUnit.K43',
          K45: 'etransport.form.packages.measurementUnit.K45',
          K46: 'etransport.form.packages.measurementUnit.K46',
          K47: 'etransport.form.packages.measurementUnit.K47',
          K48: 'etransport.form.packages.measurementUnit.K48',
          K49: 'etransport.form.packages.measurementUnit.K49',
          K50: 'etransport.form.packages.measurementUnit.K50',
          K51: 'etransport.form.packages.measurementUnit.K51',
          K52: 'etransport.form.packages.measurementUnit.K52',
          K53: 'etransport.form.packages.measurementUnit.K53',
          K54: 'etransport.form.packages.measurementUnit.K54',
          K55: 'etransport.form.packages.measurementUnit.K55',
          K58: 'etransport.form.packages.measurementUnit.K58',
          K59: 'etransport.form.packages.measurementUnit.K59',
          K6: 'etransport.form.packages.measurementUnit.K6',
          K60: 'etransport.form.packages.measurementUnit.K60',
          K61: 'etransport.form.packages.measurementUnit.K61',
          K62: 'etransport.form.packages.measurementUnit.K62',
          K63: 'etransport.form.packages.measurementUnit.K63',
          K64: 'etransport.form.packages.measurementUnit.K64',
          K65: 'etransport.form.packages.measurementUnit.K65',
          K66: 'etransport.form.packages.measurementUnit.K66',
          K67: 'etransport.form.packages.measurementUnit.K67',
          K68: 'etransport.form.packages.measurementUnit.K68',
          K69: 'etransport.form.packages.measurementUnit.K69',
          K70: 'etransport.form.packages.measurementUnit.K70',
          K71: 'etransport.form.packages.measurementUnit.K71',
          K73: 'etransport.form.packages.measurementUnit.K73',
          K74: 'etransport.form.packages.measurementUnit.K74',
          K75: 'etransport.form.packages.measurementUnit.K75',
          K76: 'etransport.form.packages.measurementUnit.K76',
          K77: 'etransport.form.packages.measurementUnit.K77',
          K78: 'etransport.form.packages.measurementUnit.K78',
          K79: 'etransport.form.packages.measurementUnit.K79',
          K80: 'etransport.form.packages.measurementUnit.K80',
          K81: 'etransport.form.packages.measurementUnit.K81',
          K82: 'etransport.form.packages.measurementUnit.K82',
          K83: 'etransport.form.packages.measurementUnit.K83',
          K84: 'etransport.form.packages.measurementUnit.K84',
          K85: 'etransport.form.packages.measurementUnit.K85',
          K86: 'etransport.form.packages.measurementUnit.K86',
          K87: 'etransport.form.packages.measurementUnit.K87',
          K88: 'etransport.form.packages.measurementUnit.K88',
          K89: 'etransport.form.packages.measurementUnit.K89',
          K90: 'etransport.form.packages.measurementUnit.K90',
          K91: 'etransport.form.packages.measurementUnit.K91',
          K92: 'etransport.form.packages.measurementUnit.K92',
          K93: 'etransport.form.packages.measurementUnit.K93',
          K94: 'etransport.form.packages.measurementUnit.K94',
          K95: 'etransport.form.packages.measurementUnit.K95',
          K96: 'etransport.form.packages.measurementUnit.K96',
          K97: 'etransport.form.packages.measurementUnit.K97',
          K98: 'etransport.form.packages.measurementUnit.K98',
          K99: 'etransport.form.packages.measurementUnit.K99',
          KA: 'etransport.form.packages.measurementUnit.KA',
          KAT: 'etransport.form.packages.measurementUnit.KAT',
          KB: 'etransport.form.packages.measurementUnit.KB',
          KBA: 'etransport.form.packages.measurementUnit.KBA',
          KCC: 'etransport.form.packages.measurementUnit.KCC',
          KDW: 'etransport.form.packages.measurementUnit.KDW',
          KEL: 'etransport.form.packages.measurementUnit.KEL',
          KGS: 'etransport.form.packages.measurementUnit.KGS',
          KHY: 'etransport.form.packages.measurementUnit.KHY',
          KHZ: 'etransport.form.packages.measurementUnit.KHZ',
          KI: 'etransport.form.packages.measurementUnit.KI',
          KIC: 'etransport.form.packages.measurementUnit.KIC',
          KIP: 'etransport.form.packages.measurementUnit.KIP',
          KJ: 'etransport.form.packages.measurementUnit.KJ',
          KJO: 'etransport.form.packages.measurementUnit.KJO',
          KL: 'etransport.form.packages.measurementUnit.KL',
          KLK: 'etransport.form.packages.measurementUnit.KLK',
          KLX: 'etransport.form.packages.measurementUnit.KLX',
          KMA: 'etransport.form.packages.measurementUnit.KMA',
          KMH: 'etransport.form.packages.measurementUnit.KMH',
          KMK: 'etransport.form.packages.measurementUnit.KMK',
          KMQ: 'etransport.form.packages.measurementUnit.KMQ',
          KNI: 'etransport.form.packages.measurementUnit.KNI',
          KNM: 'etransport.form.packages.measurementUnit.KNM',
          KNS: 'etransport.form.packages.measurementUnit.KNS',
          KNT: 'etransport.form.packages.measurementUnit.KNT',
          KO: 'etransport.form.packages.measurementUnit.KO',
          KPA: 'etransport.form.packages.measurementUnit.KPA',
          KPH: 'etransport.form.packages.measurementUnit.KPH',
          KPO: 'etransport.form.packages.measurementUnit.KPO',
          KPP: 'etransport.form.packages.measurementUnit.KPP',
          KR: 'etransport.form.packages.measurementUnit.KR',
          KSD: 'etransport.form.packages.measurementUnit.KSD',
          KSH: 'etransport.form.packages.measurementUnit.KSH',
          KT: 'etransport.form.packages.measurementUnit.KT',
          KTN: 'etransport.form.packages.measurementUnit.KTN',
          KUR: 'etransport.form.packages.measurementUnit.KUR',
          KVA: 'etransport.form.packages.measurementUnit.KVA',
          KVR: 'etransport.form.packages.measurementUnit.KVR',
          KVT: 'etransport.form.packages.measurementUnit.KVT',
          KW: 'etransport.form.packages.measurementUnit.KW',
          KWH: 'etransport.form.packages.measurementUnit.KWH',
          KWN: 'etransport.form.packages.measurementUnit.KWN',
          KWO: 'etransport.form.packages.measurementUnit.KWO',
          KWS: 'etransport.form.packages.measurementUnit.KWS',
          KWT: 'etransport.form.packages.measurementUnit.KWT',
          KX: 'etransport.form.packages.measurementUnit.KX',
          L10: 'etransport.form.packages.measurementUnit.L10',
          L11: 'etransport.form.packages.measurementUnit.L11',
          L12: 'etransport.form.packages.measurementUnit.L12',
          L13: 'etransport.form.packages.measurementUnit.L13',
          L14: 'etransport.form.packages.measurementUnit.L14',
          L15: 'etransport.form.packages.measurementUnit.L15',
          L16: 'etransport.form.packages.measurementUnit.L16',
          L17: 'etransport.form.packages.measurementUnit.L17',
          L18: 'etransport.form.packages.measurementUnit.L18',
          L19: 'etransport.form.packages.measurementUnit.L19',
          L2: 'etransport.form.packages.measurementUnit.L2',
          L20: 'etransport.form.packages.measurementUnit.L20',
          L21: 'etransport.form.packages.measurementUnit.L21',
          L23: 'etransport.form.packages.measurementUnit.L23',
          L24: 'etransport.form.packages.measurementUnit.L24',
          L25: 'etransport.form.packages.measurementUnit.L25',
          L26: 'etransport.form.packages.measurementUnit.L26',
          L27: 'etransport.form.packages.measurementUnit.L27',
          L28: 'etransport.form.packages.measurementUnit.L28',
          L29: 'etransport.form.packages.measurementUnit.L29',
          L30: 'etransport.form.packages.measurementUnit.L30',
          L31: 'etransport.form.packages.measurementUnit.L31',
          L32: 'etransport.form.packages.measurementUnit.L32',
          L33: 'etransport.form.packages.measurementUnit.L33',
          L34: 'etransport.form.packages.measurementUnit.L34',
          L35: 'etransport.form.packages.measurementUnit.L35',
          L36: 'etransport.form.packages.measurementUnit.L36',
          L37: 'etransport.form.packages.measurementUnit.L37',
          L38: 'etransport.form.packages.measurementUnit.L38',
          L39: 'etransport.form.packages.measurementUnit.L39',
          L40: 'etransport.form.packages.measurementUnit.L40',
          L41: 'etransport.form.packages.measurementUnit.L41',
          L42: 'etransport.form.packages.measurementUnit.L42',
          L43: 'etransport.form.packages.measurementUnit.L43',
          L44: 'etransport.form.packages.measurementUnit.L44',
          L45: 'etransport.form.packages.measurementUnit.L45',
          L46: 'etransport.form.packages.measurementUnit.L46',
          L47: 'etransport.form.packages.measurementUnit.L47',
          L48: 'etransport.form.packages.measurementUnit.L48',
          L49: 'etransport.form.packages.measurementUnit.L49',
          L50: 'etransport.form.packages.measurementUnit.L50',
          L51: 'etransport.form.packages.measurementUnit.L51',
          L52: 'etransport.form.packages.measurementUnit.L52',
          L53: 'etransport.form.packages.measurementUnit.L53',
          L54: 'etransport.form.packages.measurementUnit.L54',
          L55: 'etransport.form.packages.measurementUnit.L55',
          L56: 'etransport.form.packages.measurementUnit.L56',
          L57: 'etransport.form.packages.measurementUnit.L57',
          L58: 'etransport.form.packages.measurementUnit.L58',
          L59: 'etransport.form.packages.measurementUnit.L59',
          L60: 'etransport.form.packages.measurementUnit.L60',
          L63: 'etransport.form.packages.measurementUnit.L63',
          L64: 'etransport.form.packages.measurementUnit.L64',
          L65: 'etransport.form.packages.measurementUnit.L65',
          L66: 'etransport.form.packages.measurementUnit.L66',
          L67: 'etransport.form.packages.measurementUnit.L67',
          L68: 'etransport.form.packages.measurementUnit.L68',
          L69: 'etransport.form.packages.measurementUnit.L69',
          L70: 'etransport.form.packages.measurementUnit.L70',
          L71: 'etransport.form.packages.measurementUnit.L71',
          L72: 'etransport.form.packages.measurementUnit.L72',
          L73: 'etransport.form.packages.measurementUnit.L73',
          L74: 'etransport.form.packages.measurementUnit.L74',
          L75: 'etransport.form.packages.measurementUnit.L75',
          L76: 'etransport.form.packages.measurementUnit.L76',
          L77: 'etransport.form.packages.measurementUnit.L77',
          L78: 'etransport.form.packages.measurementUnit.L78',
          L79: 'etransport.form.packages.measurementUnit.L79',
          L80: 'etransport.form.packages.measurementUnit.L80',
          L81: 'etransport.form.packages.measurementUnit.L81',
          L82: 'etransport.form.packages.measurementUnit.L82',
          L83: 'etransport.form.packages.measurementUnit.L83',
          L84: 'etransport.form.packages.measurementUnit.L84',
          L85: 'etransport.form.packages.measurementUnit.L85',
          L86: 'etransport.form.packages.measurementUnit.L86',
          L87: 'etransport.form.packages.measurementUnit.L87',
          L88: 'etransport.form.packages.measurementUnit.L88',
          L89: 'etransport.form.packages.measurementUnit.L89',
          L90: 'etransport.form.packages.measurementUnit.L90',
          L91: 'etransport.form.packages.measurementUnit.L91',
          L92: 'etransport.form.packages.measurementUnit.L92',
          L93: 'etransport.form.packages.measurementUnit.L93',
          L94: 'etransport.form.packages.measurementUnit.L94',
          L95: 'etransport.form.packages.measurementUnit.L95',
          L96: 'etransport.form.packages.measurementUnit.L96',
          L98: 'etransport.form.packages.measurementUnit.L98',
          L99: 'etransport.form.packages.measurementUnit.L99',
          LA: 'etransport.form.packages.measurementUnit.LA',
          LAC: 'etransport.form.packages.measurementUnit.LAC',
          LBR: 'etransport.form.packages.measurementUnit.LBR',
          LBT: 'etransport.form.packages.measurementUnit.LBT',
          LD: 'etransport.form.packages.measurementUnit.LD',
          LEF: 'etransport.form.packages.measurementUnit.LEF',
          LF: 'etransport.form.packages.measurementUnit.LF',
          LH: 'etransport.form.packages.measurementUnit.LH',
          LK: 'etransport.form.packages.measurementUnit.LK',
          LN: 'etransport.form.packages.measurementUnit.LN',
          LO: 'etransport.form.packages.measurementUnit.LO',
          LP: 'etransport.form.packages.measurementUnit.LP',
          LPA: 'etransport.form.packages.measurementUnit.LPA',
          LR: 'etransport.form.packages.measurementUnit.LR',
          LS: 'etransport.form.packages.measurementUnit.LS',
          LTN: 'etransport.form.packages.measurementUnit.LTN',
          LUB: 'etransport.form.packages.measurementUnit.LUB',
          LUM: 'etransport.form.packages.measurementUnit.LUM',
          LUX: 'etransport.form.packages.measurementUnit.LUX',
          LY: 'etransport.form.packages.measurementUnit.LY',
          M1: 'etransport.form.packages.measurementUnit.M1',
          M10: 'etransport.form.packages.measurementUnit.M10',
          M11: 'etransport.form.packages.measurementUnit.M11',
          M12: 'etransport.form.packages.measurementUnit.M12',
          M13: 'etransport.form.packages.measurementUnit.M13',
          M14: 'etransport.form.packages.measurementUnit.M14',
          M15: 'etransport.form.packages.measurementUnit.M15',
          M16: 'etransport.form.packages.measurementUnit.M16',
          M17: 'etransport.form.packages.measurementUnit.M17',
          M18: 'etransport.form.packages.measurementUnit.M18',
          M19: 'etransport.form.packages.measurementUnit.M19',
          M20: 'etransport.form.packages.measurementUnit.M20',
          M21: 'etransport.form.packages.measurementUnit.M21',
          M22: 'etransport.form.packages.measurementUnit.M22',
          M23: 'etransport.form.packages.measurementUnit.M23',
          M24: 'etransport.form.packages.measurementUnit.M24',
          M25: 'etransport.form.packages.measurementUnit.M25',
          M26: 'etransport.form.packages.measurementUnit.M26',
          M27: 'etransport.form.packages.measurementUnit.M27',
          M29: 'etransport.form.packages.measurementUnit.M29',
          M30: 'etransport.form.packages.measurementUnit.M30',
          M31: 'etransport.form.packages.measurementUnit.M31',
          M32: 'etransport.form.packages.measurementUnit.M32',
          M33: 'etransport.form.packages.measurementUnit.M33',
          M34: 'etransport.form.packages.measurementUnit.M34',
          M35: 'etransport.form.packages.measurementUnit.M35',
          M36: 'etransport.form.packages.measurementUnit.M36',
          M37: 'etransport.form.packages.measurementUnit.M37',
          M38: 'etransport.form.packages.measurementUnit.M38',
          M39: 'etransport.form.packages.measurementUnit.M39',
          M4: 'etransport.form.packages.measurementUnit.M4',
          M40: 'etransport.form.packages.measurementUnit.M40',
          M41: 'etransport.form.packages.measurementUnit.M41',
          M42: 'etransport.form.packages.measurementUnit.M42',
          M43: 'etransport.form.packages.measurementUnit.M43',
          M44: 'etransport.form.packages.measurementUnit.M44',
          M45: 'etransport.form.packages.measurementUnit.M45',
          M46: 'etransport.form.packages.measurementUnit.M46',
          M47: 'etransport.form.packages.measurementUnit.M47',
          M48: 'etransport.form.packages.measurementUnit.M48',
          M49: 'etransport.form.packages.measurementUnit.M49',
          M5: 'etransport.form.packages.measurementUnit.M5',
          M50: 'etransport.form.packages.measurementUnit.M50',
          M51: 'etransport.form.packages.measurementUnit.M51',
          M52: 'etransport.form.packages.measurementUnit.M52',
          M53: 'etransport.form.packages.measurementUnit.M53',
          M55: 'etransport.form.packages.measurementUnit.M55',
          M56: 'etransport.form.packages.measurementUnit.M56',
          M57: 'etransport.form.packages.measurementUnit.M57',
          M58: 'etransport.form.packages.measurementUnit.M58',
          M59: 'etransport.form.packages.measurementUnit.M59',
          M60: 'etransport.form.packages.measurementUnit.M60',
          M61: 'etransport.form.packages.measurementUnit.M61',
          M62: 'etransport.form.packages.measurementUnit.M62',
          M63: 'etransport.form.packages.measurementUnit.M63',
          M64: 'etransport.form.packages.measurementUnit.M64',
          M65: 'etransport.form.packages.measurementUnit.M65',
          M66: 'etransport.form.packages.measurementUnit.M66',
          M67: 'etransport.form.packages.measurementUnit.M67',
          M68: 'etransport.form.packages.measurementUnit.M68',
          M69: 'etransport.form.packages.measurementUnit.M69',
          M7: 'etransport.form.packages.measurementUnit.M7',
          M70: 'etransport.form.packages.measurementUnit.M70',
          M71: 'etransport.form.packages.measurementUnit.M71',
          M72: 'etransport.form.packages.measurementUnit.M72',
          M73: 'etransport.form.packages.measurementUnit.M73',
          M74: 'etransport.form.packages.measurementUnit.M74',
          M75: 'etransport.form.packages.measurementUnit.M75',
          M76: 'etransport.form.packages.measurementUnit.M76',
          M77: 'etransport.form.packages.measurementUnit.M77',
          M78: 'etransport.form.packages.measurementUnit.M78',
          M79: 'etransport.form.packages.measurementUnit.M79',
          M80: 'etransport.form.packages.measurementUnit.M80',
          M81: 'etransport.form.packages.measurementUnit.M81',
          M82: 'etransport.form.packages.measurementUnit.M82',
          M83: 'etransport.form.packages.measurementUnit.M83',
          M84: 'etransport.form.packages.measurementUnit.M84',
          M85: 'etransport.form.packages.measurementUnit.M85',
          M86: 'etransport.form.packages.measurementUnit.M86',
          M87: 'etransport.form.packages.measurementUnit.M87',
          M88: 'etransport.form.packages.measurementUnit.M88',
          M89: 'etransport.form.packages.measurementUnit.M89',
          M9: 'etransport.form.packages.measurementUnit.M9',
          M90: 'etransport.form.packages.measurementUnit.M90',
          M91: 'etransport.form.packages.measurementUnit.M91',
          M92: 'etransport.form.packages.measurementUnit.M92',
          M93: 'etransport.form.packages.measurementUnit.M93',
          M94: 'etransport.form.packages.measurementUnit.M94',
          M95: 'etransport.form.packages.measurementUnit.M95',
          M96: 'etransport.form.packages.measurementUnit.M96',
          M97: 'etransport.form.packages.measurementUnit.M97',
          M98: 'etransport.form.packages.measurementUnit.M98',
          M99: 'etransport.form.packages.measurementUnit.M99',
          MAH: 'etransport.form.packages.measurementUnit.MAH',
          MAL: 'etransport.form.packages.measurementUnit.MAL',
          MAM: 'etransport.form.packages.measurementUnit.MAM',
          MAR: 'etransport.form.packages.measurementUnit.MAR',
          MAW: 'etransport.form.packages.measurementUnit.MAW',
          MBE: 'etransport.form.packages.measurementUnit.MBE',
          MBF: 'etransport.form.packages.measurementUnit.MBF',
          MBR: 'etransport.form.packages.measurementUnit.MBR',
          MC: 'etransport.form.packages.measurementUnit.MC',
          MCU: 'etransport.form.packages.measurementUnit.MCU',
          MD: 'etransport.form.packages.measurementUnit.MD',
          MGM: 'etransport.form.packages.measurementUnit.MGM',
          MHZ: 'etransport.form.packages.measurementUnit.MHZ',
          MIK: 'etransport.form.packages.measurementUnit.MIK',
          MIL: 'etransport.form.packages.measurementUnit.MIL',
          MIN: 'etransport.form.packages.measurementUnit.MIN',
          MIO: 'etransport.form.packages.measurementUnit.MIO',
          MIU: 'etransport.form.packages.measurementUnit.MIU',
          MLD: 'etransport.form.packages.measurementUnit.MLD',
          MLT: 'etransport.form.packages.measurementUnit.MLT',
          MMK: 'etransport.form.packages.measurementUnit.MMK',
          MMQ: 'etransport.form.packages.measurementUnit.MMQ',
          MMT: 'etransport.form.packages.measurementUnit.MMT',
          MND: 'etransport.form.packages.measurementUnit.MND',
          MON: 'etransport.form.packages.measurementUnit.MON',
          MPA: 'etransport.form.packages.measurementUnit.MPA',
          MQH: 'etransport.form.packages.measurementUnit.MQH',
          MQS: 'etransport.form.packages.measurementUnit.MQS',
          MSK: 'etransport.form.packages.measurementUnit.MSK',
          MTS: 'etransport.form.packages.measurementUnit.MTS',
          MVA: 'etransport.form.packages.measurementUnit.MVA',
          MWH: 'etransport.form.packages.measurementUnit.MWH',
          N1: 'etransport.form.packages.measurementUnit.N1',
          N10: 'etransport.form.packages.measurementUnit.N10',
          N11: 'etransport.form.packages.measurementUnit.N11',
          N12: 'etransport.form.packages.measurementUnit.N12',
          N13: 'etransport.form.packages.measurementUnit.N13',
          N14: 'etransport.form.packages.measurementUnit.N14',
          N15: 'etransport.form.packages.measurementUnit.N15',
          N16: 'etransport.form.packages.measurementUnit.N16',
          N17: 'etransport.form.packages.measurementUnit.N17',
          N18: 'etransport.form.packages.measurementUnit.N18',
          N19: 'etransport.form.packages.measurementUnit.N19',
          N20: 'etransport.form.packages.measurementUnit.N20',
          N21: 'etransport.form.packages.measurementUnit.N21',
          N22: 'etransport.form.packages.measurementUnit.N22',
          N23: 'etransport.form.packages.measurementUnit.N23',
          N24: 'etransport.form.packages.measurementUnit.N24',
          N25: 'etransport.form.packages.measurementUnit.N25',
          N26: 'etransport.form.packages.measurementUnit.N26',
          N27: 'etransport.form.packages.measurementUnit.N27',
          N28: 'etransport.form.packages.measurementUnit.N28',
          N29: 'etransport.form.packages.measurementUnit.N29',
          N3: 'etransport.form.packages.measurementUnit.N3',
          N30: 'etransport.form.packages.measurementUnit.N30',
          N31: 'etransport.form.packages.measurementUnit.N31',
          N32: 'etransport.form.packages.measurementUnit.N32',
          N33: 'etransport.form.packages.measurementUnit.N33',
          N34: 'etransport.form.packages.measurementUnit.N34',
          N35: 'etransport.form.packages.measurementUnit.N35',
          N36: 'etransport.form.packages.measurementUnit.N36',
          N37: 'etransport.form.packages.measurementUnit.N37',
          N38: 'etransport.form.packages.measurementUnit.N38',
          N39: 'etransport.form.packages.measurementUnit.N39',
          N40: 'etransport.form.packages.measurementUnit.N40',
          N41: 'etransport.form.packages.measurementUnit.N41',
          N42: 'etransport.form.packages.measurementUnit.N42',
          N43: 'etransport.form.packages.measurementUnit.N43',
          N44: 'etransport.form.packages.measurementUnit.N44',
          N45: 'etransport.form.packages.measurementUnit.N45',
          N46: 'etransport.form.packages.measurementUnit.N46',
          N47: 'etransport.form.packages.measurementUnit.N47',
          N48: 'etransport.form.packages.measurementUnit.N48',
          N49: 'etransport.form.packages.measurementUnit.N49',
          N50: 'etransport.form.packages.measurementUnit.N50',
          N51: 'etransport.form.packages.measurementUnit.N51',
          N52: 'etransport.form.packages.measurementUnit.N52',
          N53: 'etransport.form.packages.measurementUnit.N53',
          N54: 'etransport.form.packages.measurementUnit.N54',
          N55: 'etransport.form.packages.measurementUnit.N55',
          N56: 'etransport.form.packages.measurementUnit.N56',
          N57: 'etransport.form.packages.measurementUnit.N57',
          N58: 'etransport.form.packages.measurementUnit.N58',
          N59: 'etransport.form.packages.measurementUnit.N59',
          N60: 'etransport.form.packages.measurementUnit.N60',
          N61: 'etransport.form.packages.measurementUnit.N61',
          N62: 'etransport.form.packages.measurementUnit.N62',
          N63: 'etransport.form.packages.measurementUnit.N63',
          N64: 'etransport.form.packages.measurementUnit.N64',
          N65: 'etransport.form.packages.measurementUnit.N65',
          N66: 'etransport.form.packages.measurementUnit.N66',
          N67: 'etransport.form.packages.measurementUnit.N67',
          N68: 'etransport.form.packages.measurementUnit.N68',
          N69: 'etransport.form.packages.measurementUnit.N69',
          N70: 'etransport.form.packages.measurementUnit.N70',
          N71: 'etransport.form.packages.measurementUnit.N71',
          N72: 'etransport.form.packages.measurementUnit.N72',
          N73: 'etransport.form.packages.measurementUnit.N73',
          N74: 'etransport.form.packages.measurementUnit.N74',
          N75: 'etransport.form.packages.measurementUnit.N75',
          N76: 'etransport.form.packages.measurementUnit.N76',
          N77: 'etransport.form.packages.measurementUnit.N77',
          N78: 'etransport.form.packages.measurementUnit.N78',
          N79: 'etransport.form.packages.measurementUnit.N79',
          N80: 'etransport.form.packages.measurementUnit.N80',
          N81: 'etransport.form.packages.measurementUnit.N81',
          N82: 'etransport.form.packages.measurementUnit.N82',
          N83: 'etransport.form.packages.measurementUnit.N83',
          N84: 'etransport.form.packages.measurementUnit.N84',
          N85: 'etransport.form.packages.measurementUnit.N85',
          N86: 'etransport.form.packages.measurementUnit.N86',
          N87: 'etransport.form.packages.measurementUnit.N87',
          N88: 'etransport.form.packages.measurementUnit.N88',
          N89: 'etransport.form.packages.measurementUnit.N89',
          N90: 'etransport.form.packages.measurementUnit.N90',
          N91: 'etransport.form.packages.measurementUnit.N91',
          N92: 'etransport.form.packages.measurementUnit.N92',
          N93: 'etransport.form.packages.measurementUnit.N93',
          N94: 'etransport.form.packages.measurementUnit.N94',
          N95: 'etransport.form.packages.measurementUnit.N95',
          N96: 'etransport.form.packages.measurementUnit.N96',
          N97: 'etransport.form.packages.measurementUnit.N97',
          N98: 'etransport.form.packages.measurementUnit.N98',
          N99: 'etransport.form.packages.measurementUnit.N99',
          NA: 'etransport.form.packages.measurementUnit.NA',
          NCL: 'etransport.form.packages.measurementUnit.NCL',
          NEW: 'etransport.form.packages.measurementUnit.NEW',
          NF: 'etransport.form.packages.measurementUnit.NF',
          NIL: 'etransport.form.packages.measurementUnit.NIL',
          NIU: 'etransport.form.packages.measurementUnit.NIU',
          NL: 'etransport.form.packages.measurementUnit.NL',
          NM3: 'etransport.form.packages.measurementUnit.NM3',
          NMI: 'etransport.form.packages.measurementUnit.NMI',
          NMP: 'etransport.form.packages.measurementUnit.NMP',
          NPT: 'etransport.form.packages.measurementUnit.NPT',
          NT: 'etransport.form.packages.measurementUnit.NT',
          NU: 'etransport.form.packages.measurementUnit.NU',
          NX: 'etransport.form.packages.measurementUnit.NX',
          OA: 'etransport.form.packages.measurementUnit.OA',
          ODE: 'etransport.form.packages.measurementUnit.ODE',
          ODG: 'etransport.form.packages.measurementUnit.ODG',
          ODK: 'etransport.form.packages.measurementUnit.ODK',
          ODM: 'etransport.form.packages.measurementUnit.ODM',
          OHM: 'etransport.form.packages.measurementUnit.OHM',
          ON: 'etransport.form.packages.measurementUnit.ON',
          ONZ: 'etransport.form.packages.measurementUnit.ONZ',
          OPM: 'etransport.form.packages.measurementUnit.OPM',
          OT: 'etransport.form.packages.measurementUnit.OT',
          OZA: 'etransport.form.packages.measurementUnit.OZA',
          OZI: 'etransport.form.packages.measurementUnit.OZI',
          P1: 'etransport.form.packages.measurementUnit.P1',
          P10: 'etransport.form.packages.measurementUnit.P10',
          P11: 'etransport.form.packages.measurementUnit.P11',
          P12: 'etransport.form.packages.measurementUnit.P12',
          P13: 'etransport.form.packages.measurementUnit.P13',
          P14: 'etransport.form.packages.measurementUnit.P14',
          P15: 'etransport.form.packages.measurementUnit.P15',
          P16: 'etransport.form.packages.measurementUnit.P16',
          P17: 'etransport.form.packages.measurementUnit.P17',
          P18: 'etransport.form.packages.measurementUnit.P18',
          P19: 'etransport.form.packages.measurementUnit.P19',
          P2: 'etransport.form.packages.measurementUnit.P2',
          P20: 'etransport.form.packages.measurementUnit.P20',
          P21: 'etransport.form.packages.measurementUnit.P21',
          P22: 'etransport.form.packages.measurementUnit.P22',
          P23: 'etransport.form.packages.measurementUnit.P23',
          P24: 'etransport.form.packages.measurementUnit.P24',
          P25: 'etransport.form.packages.measurementUnit.P25',
          P26: 'etransport.form.packages.measurementUnit.P26',
          P27: 'etransport.form.packages.measurementUnit.P27',
          P28: 'etransport.form.packages.measurementUnit.P28',
          P29: 'etransport.form.packages.measurementUnit.P29',
          P30: 'etransport.form.packages.measurementUnit.P30',
          P31: 'etransport.form.packages.measurementUnit.P31',
          P32: 'etransport.form.packages.measurementUnit.P32',
          P33: 'etransport.form.packages.measurementUnit.P33',
          P34: 'etransport.form.packages.measurementUnit.P34',
          P35: 'etransport.form.packages.measurementUnit.P35',
          P36: 'etransport.form.packages.measurementUnit.P36',
          P37: 'etransport.form.packages.measurementUnit.P37',
          P38: 'etransport.form.packages.measurementUnit.P38',
          P39: 'etransport.form.packages.measurementUnit.P39',
          P40: 'etransport.form.packages.measurementUnit.P40',
          P41: 'etransport.form.packages.measurementUnit.P41',
          P42: 'etransport.form.packages.measurementUnit.P42',
          P43: 'etransport.form.packages.measurementUnit.P43',
          P44: 'etransport.form.packages.measurementUnit.P44',
          P45: 'etransport.form.packages.measurementUnit.P45',
          P46: 'etransport.form.packages.measurementUnit.P46',
          P47: 'etransport.form.packages.measurementUnit.P47',
          P48: 'etransport.form.packages.measurementUnit.P48',
          P49: 'etransport.form.packages.measurementUnit.P49',
          P5: 'etransport.form.packages.measurementUnit.P5',
          P50: 'etransport.form.packages.measurementUnit.P50',
          P51: 'etransport.form.packages.measurementUnit.P51',
          P52: 'etransport.form.packages.measurementUnit.P52',
          P53: 'etransport.form.packages.measurementUnit.P53',
          P54: 'etransport.form.packages.measurementUnit.P54',
          P55: 'etransport.form.packages.measurementUnit.P55',
          P56: 'etransport.form.packages.measurementUnit.P56',
          P57: 'etransport.form.packages.measurementUnit.P57',
          P58: 'etransport.form.packages.measurementUnit.P58',
          P59: 'etransport.form.packages.measurementUnit.P59',
          P60: 'etransport.form.packages.measurementUnit.P60',
          P61: 'etransport.form.packages.measurementUnit.P61',
          P62: 'etransport.form.packages.measurementUnit.P62',
          P63: 'etransport.form.packages.measurementUnit.P63',
          P64: 'etransport.form.packages.measurementUnit.P64',
          P65: 'etransport.form.packages.measurementUnit.P65',
          P66: 'etransport.form.packages.measurementUnit.P66',
          P67: 'etransport.form.packages.measurementUnit.P67',
          P68: 'etransport.form.packages.measurementUnit.P68',
          P69: 'etransport.form.packages.measurementUnit.P69',
          P70: 'etransport.form.packages.measurementUnit.P70',
          P71: 'etransport.form.packages.measurementUnit.P71',
          P72: 'etransport.form.packages.measurementUnit.P72',
          P73: 'etransport.form.packages.measurementUnit.P73',
          P74: 'etransport.form.packages.measurementUnit.P74',
          P75: 'etransport.form.packages.measurementUnit.P75',
          P76: 'etransport.form.packages.measurementUnit.P76',
          P77: 'etransport.form.packages.measurementUnit.P77',
          P78: 'etransport.form.packages.measurementUnit.P78',
          P79: 'etransport.form.packages.measurementUnit.P79',
          P80: 'etransport.form.packages.measurementUnit.P80',
          P81: 'etransport.form.packages.measurementUnit.P81',
          P82: 'etransport.form.packages.measurementUnit.P82',
          P83: 'etransport.form.packages.measurementUnit.P83',
          P84: 'etransport.form.packages.measurementUnit.P84',
          P85: 'etransport.form.packages.measurementUnit.P85',
          P86: 'etransport.form.packages.measurementUnit.P86',
          P87: 'etransport.form.packages.measurementUnit.P87',
          P88: 'etransport.form.packages.measurementUnit.P88',
          P89: 'etransport.form.packages.measurementUnit.P89',
          P90: 'etransport.form.packages.measurementUnit.P90',
          P91: 'etransport.form.packages.measurementUnit.P91',
          P92: 'etransport.form.packages.measurementUnit.P92',
          P93: 'etransport.form.packages.measurementUnit.P93',
          P94: 'etransport.form.packages.measurementUnit.P94',
          P95: 'etransport.form.packages.measurementUnit.P95',
          P96: 'etransport.form.packages.measurementUnit.P96',
          P97: 'etransport.form.packages.measurementUnit.P97',
          P98: 'etransport.form.packages.measurementUnit.P98',
          P99: 'etransport.form.packages.measurementUnit.P99',
          PAL: 'etransport.form.packages.measurementUnit.PAL',
          PD: 'etransport.form.packages.measurementUnit.PD',
          PFL: 'etransport.form.packages.measurementUnit.PFL',
          PGL: 'etransport.form.packages.measurementUnit.PGL',
          PI: 'etransport.form.packages.measurementUnit.PI',
          PLA: 'etransport.form.packages.measurementUnit.PLA',
          PO: 'etransport.form.packages.measurementUnit.PO',
          PQ: 'etransport.form.packages.measurementUnit.PQ',
          PR: 'etransport.form.packages.measurementUnit.PR',
          PS: 'etransport.form.packages.measurementUnit.PS',
          PTD: 'etransport.form.packages.measurementUnit.PTD',
          PTI: 'etransport.form.packages.measurementUnit.PTI',
          PTL: 'etransport.form.packages.measurementUnit.PTL',
          PTN: 'etransport.form.packages.measurementUnit.PTN',
          Q10: 'etransport.form.packages.measurementUnit.Q10',
          Q11: 'etransport.form.packages.measurementUnit.Q11',
          Q12: 'etransport.form.packages.measurementUnit.Q12',
          Q13: 'etransport.form.packages.measurementUnit.Q13',
          Q14: 'etransport.form.packages.measurementUnit.Q14',
          Q15: 'etransport.form.packages.measurementUnit.Q15',
          Q16: 'etransport.form.packages.measurementUnit.Q16',
          Q17: 'etransport.form.packages.measurementUnit.Q17',
          Q18: 'etransport.form.packages.measurementUnit.Q18',
          Q19: 'etransport.form.packages.measurementUnit.Q19',
          Q20: 'etransport.form.packages.measurementUnit.Q20',
          Q21: 'etransport.form.packages.measurementUnit.Q21',
          Q22: 'etransport.form.packages.measurementUnit.Q22',
          Q23: 'etransport.form.packages.measurementUnit.Q23',
          Q24: 'etransport.form.packages.measurementUnit.Q24',
          Q25: 'etransport.form.packages.measurementUnit.Q25',
          Q26: 'etransport.form.packages.measurementUnit.Q26',
          Q27: 'etransport.form.packages.measurementUnit.Q27',
          Q28: 'etransport.form.packages.measurementUnit.Q28',
          Q29: 'etransport.form.packages.measurementUnit.Q29',
          Q30: 'etransport.form.packages.measurementUnit.Q30',
          Q31: 'etransport.form.packages.measurementUnit.Q31',
          Q32: 'etransport.form.packages.measurementUnit.Q32',
          Q33: 'etransport.form.packages.measurementUnit.Q33',
          Q34: 'etransport.form.packages.measurementUnit.Q34',
          Q35: 'etransport.form.packages.measurementUnit.Q35',
          Q36: 'etransport.form.packages.measurementUnit.Q36',
          Q37: 'etransport.form.packages.measurementUnit.Q37',
          Q38: 'etransport.form.packages.measurementUnit.Q38',
          Q39: 'etransport.form.packages.measurementUnit.Q39',
          Q40: 'etransport.form.packages.measurementUnit.Q40',
          Q41: 'etransport.form.packages.measurementUnit.Q41',
          Q42: 'etransport.form.packages.measurementUnit.Q42',
          Q3: 'etransport.form.packages.measurementUnit.Q3',
          QA: 'etransport.form.packages.measurementUnit.QA',
          QAN: 'etransport.form.packages.measurementUnit.QAN',
          QB: 'etransport.form.packages.measurementUnit.QB',
          QR: 'etransport.form.packages.measurementUnit.QR',
          QTD: 'etransport.form.packages.measurementUnit.QTD',
          QTI: 'etransport.form.packages.measurementUnit.QTI',
          QTL: 'etransport.form.packages.measurementUnit.QTL',
          QTR: 'etransport.form.packages.measurementUnit.QTR',
          R1: 'etransport.form.packages.measurementUnit.R1',
          R9: 'etransport.form.packages.measurementUnit.R9',
          RH: 'etransport.form.packages.measurementUnit.RH',
          RM: 'etransport.form.packages.measurementUnit.RM',
          ROM: 'etransport.form.packages.measurementUnit.ROM',
          RP: 'etransport.form.packages.measurementUnit.RP',
          RPM: 'etransport.form.packages.measurementUnit.RPM',
          RPS: 'etransport.form.packages.measurementUnit.RPS',
          RT: 'etransport.form.packages.measurementUnit.RT',
          S3: 'etransport.form.packages.measurementUnit.S3',
          S4: 'etransport.form.packages.measurementUnit.S4',
          SAN: 'etransport.form.packages.measurementUnit.SAN',
          SCO: 'etransport.form.packages.measurementUnit.SCO',
          SCR: 'etransport.form.packages.measurementUnit.SCR',
          SEC: 'etransport.form.packages.measurementUnit.SEC',
          SG: 'etransport.form.packages.measurementUnit.SG',
          SIE: 'etransport.form.packages.measurementUnit.SIE',
          SM3: 'etransport.form.packages.measurementUnit.SM3',
          SMI: 'etransport.form.packages.measurementUnit.SMI',
          SQ: 'etransport.form.packages.measurementUnit.SQ',
          SQR: 'etransport.form.packages.measurementUnit.SQR',
          SR: 'etransport.form.packages.measurementUnit.SR',
          STC: 'etransport.form.packages.measurementUnit.STC',
          STI: 'etransport.form.packages.measurementUnit.STI',
          STK: 'etransport.form.packages.measurementUnit.STK',
          STL: 'etransport.form.packages.measurementUnit.STL',
          STN: 'etransport.form.packages.measurementUnit.STN',
          STW: 'etransport.form.packages.measurementUnit.STW',
          SW: 'etransport.form.packages.measurementUnit.SW',
          SX: 'etransport.form.packages.measurementUnit.SX',
          SYR: 'etransport.form.packages.measurementUnit.SYR',
          T0: 'etransport.form.packages.measurementUnit.T0',
          T3: 'etransport.form.packages.measurementUnit.T3',
          TAH: 'etransport.form.packages.measurementUnit.TAH',
          TAN: 'etransport.form.packages.measurementUnit.TAN',
          TI: 'etransport.form.packages.measurementUnit.TI',
          TIC: 'etransport.form.packages.measurementUnit.TIC',
          TIP: 'etransport.form.packages.measurementUnit.TIP',
          TKM: 'etransport.form.packages.measurementUnit.TKM',
          TMS: 'etransport.form.packages.measurementUnit.TMS',
          TP: 'etransport.form.packages.measurementUnit.TP',
          TPI: 'etransport.form.packages.measurementUnit.TPI',
          TPR: 'etransport.form.packages.measurementUnit.TPR',
          TQD: 'etransport.form.packages.measurementUnit.TQD',
          TRL: 'etransport.form.packages.measurementUnit.TRL',
          TST: 'etransport.form.packages.measurementUnit.TST',
          TTS: 'etransport.form.packages.measurementUnit.TTS',
          U1: 'etransport.form.packages.measurementUnit.U1',
          U2: 'etransport.form.packages.measurementUnit.U2',
          UB: 'etransport.form.packages.measurementUnit.UB',
          UC: 'etransport.form.packages.measurementUnit.UC',
          VA: 'etransport.form.packages.measurementUnit.VA',
          VLT: 'etransport.form.packages.measurementUnit.VLT',
          VP: 'etransport.form.packages.measurementUnit.VP',
          W2: 'etransport.form.packages.measurementUnit.W2',
          WA: 'etransport.form.packages.measurementUnit.WA',
          WB: 'etransport.form.packages.measurementUnit.WB',
          WCD: 'etransport.form.packages.measurementUnit.WCD',
          WE: 'etransport.form.packages.measurementUnit.WE',
          WEB: 'etransport.form.packages.measurementUnit.WEB',
          WEE: 'etransport.form.packages.measurementUnit.WEE',
          WG: 'etransport.form.packages.measurementUnit.WG',
          WHR: 'etransport.form.packages.measurementUnit.WHR',
          WM: 'etransport.form.packages.measurementUnit.WM',
          WSD: 'etransport.form.packages.measurementUnit.WSD',
          WTT: 'etransport.form.packages.measurementUnit.WTT',
          X1: 'etransport.form.packages.measurementUnit.X1',
          YDK: 'etransport.form.packages.measurementUnit.YDK',
          YDQ: 'etransport.form.packages.measurementUnit.YDQ',
          YRD: 'etransport.form.packages.measurementUnit.YRD',
          Z11: 'etransport.form.packages.measurementUnit.Z11',
          ZP: 'etransport.form.packages.measurementUnit.ZP',
          ZZ: 'etransport.form.packages.measurementUnit.ZZ',
          X1A: 'etransport.form.packages.measurementUnit.X1A',
          X1B: 'etransport.form.packages.measurementUnit.X1B',
          X1D: 'etransport.form.packages.measurementUnit.X1D',
          X1F: 'etransport.form.packages.measurementUnit.X1F',
          X1G: 'etransport.form.packages.measurementUnit.X1G',
          X1W: 'etransport.form.packages.measurementUnit.X1W',
          X2C: 'etransport.form.packages.measurementUnit.X2C',
          X3A: 'etransport.form.packages.measurementUnit.X3A',
          X3H: 'etransport.form.packages.measurementUnit.X3H',
          X43: 'etransport.form.packages.measurementUnit.X43',
          X44: 'etransport.form.packages.measurementUnit.X44',
          X4A: 'etransport.form.packages.measurementUnit.X4A',
          X4B: 'etransport.form.packages.measurementUnit.X4B',
          X4C: 'etransport.form.packages.measurementUnit.X4C',
          X4D: 'etransport.form.packages.measurementUnit.X4D',
          X4F: 'etransport.form.packages.measurementUnit.X4F',
          X4G: 'etransport.form.packages.measurementUnit.X4G',
          X4H: 'etransport.form.packages.measurementUnit.X4H',
          X5H: 'etransport.form.packages.measurementUnit.X5H',
          X5L: 'etransport.form.packages.measurementUnit.X5L',
          X5M: 'etransport.form.packages.measurementUnit.X5M',
          X6H: 'etransport.form.packages.measurementUnit.X6H',
          X6P: 'etransport.form.packages.measurementUnit.X6P',
          X7A: 'etransport.form.packages.measurementUnit.X7A',
          X7B: 'etransport.form.packages.measurementUnit.X7B',
          X8A: 'etransport.form.packages.measurementUnit.X8A',
          X8B: 'etransport.form.packages.measurementUnit.X8B',
          X8C: 'etransport.form.packages.measurementUnit.X8C',
          XAA: 'etransport.form.packages.measurementUnit.XAA',
          XAB: 'etransport.form.packages.measurementUnit.XAB',
          XAC: 'etransport.form.packages.measurementUnit.XAC',
          XAD: 'etransport.form.packages.measurementUnit.XAD',
          XAE: 'etransport.form.packages.measurementUnit.XAE',
          XAF: 'etransport.form.packages.measurementUnit.XAF',
          XAG: 'etransport.form.packages.measurementUnit.XAG',
          XAH: 'etransport.form.packages.measurementUnit.XAH',
          XAI: 'etransport.form.packages.measurementUnit.XAI',
          XAJ: 'etransport.form.packages.measurementUnit.XAJ',
          XAL: 'etransport.form.packages.measurementUnit.XAL',
          XAM: 'etransport.form.packages.measurementUnit.XAM',
          XAP: 'etransport.form.packages.measurementUnit.XAP',
          XAT: 'etransport.form.packages.measurementUnit.XAT',
          XAV: 'etransport.form.packages.measurementUnit.XAV',
          XB4: 'etransport.form.packages.measurementUnit.XB4',
          XBA: 'etransport.form.packages.measurementUnit.XBA',
          XBB: 'etransport.form.packages.measurementUnit.XBB',
          XBC: 'etransport.form.packages.measurementUnit.XBC',
          XBD: 'etransport.form.packages.measurementUnit.XBD',
          XBE: 'etransport.form.packages.measurementUnit.XBE',
          XBF: 'etransport.form.packages.measurementUnit.XBF',
          XBG: 'etransport.form.packages.measurementUnit.XBG',
          XBH: 'etransport.form.packages.measurementUnit.XBH',
          XBI: 'etransport.form.packages.measurementUnit.XBI',
          XBJ: 'etransport.form.packages.measurementUnit.XBJ',
          XBK: 'etransport.form.packages.measurementUnit.XBK',
          XBL: 'etransport.form.packages.measurementUnit.XBL',
          XBM: 'etransport.form.packages.measurementUnit.XBM',
          XBN: 'etransport.form.packages.measurementUnit.XBN',
          XBO: 'etransport.form.packages.measurementUnit.XBO',
          XBP: 'etransport.form.packages.measurementUnit.XBP',
          XBQ: 'etransport.form.packages.measurementUnit.XBQ',
          XBR: 'etransport.form.packages.measurementUnit.XBR',
          XBS: 'etransport.form.packages.measurementUnit.XBS',
          XBT: 'etransport.form.packages.measurementUnit.XBT',
          XBU: 'etransport.form.packages.measurementUnit.XBU',
          XBV: 'etransport.form.packages.measurementUnit.XBV',
          XBW: 'etransport.form.packages.measurementUnit.XBW',
          XBX: 'etransport.form.packages.measurementUnit.XBX',
          XBY: 'etransport.form.packages.measurementUnit.XBY',
          XBZ: 'etransport.form.packages.measurementUnit.XBZ',
          XCA: 'etransport.form.packages.measurementUnit.XCA',
          XCB: 'etransport.form.packages.measurementUnit.XCB',
          XCC: 'etransport.form.packages.measurementUnit.XCC',
          XCD: 'etransport.form.packages.measurementUnit.XCD',
          XCE: 'etransport.form.packages.measurementUnit.XCE',
          XCF: 'etransport.form.packages.measurementUnit.XCF',
          XCG: 'etransport.form.packages.measurementUnit.XCG',
          XCH: 'etransport.form.packages.measurementUnit.XCH',
          XCI: 'etransport.form.packages.measurementUnit.XCI',
          XCJ: 'etransport.form.packages.measurementUnit.XCJ',
          XCK: 'etransport.form.packages.measurementUnit.XCK',
          XCL: 'etransport.form.packages.measurementUnit.XCL',
          XCM: 'etransport.form.packages.measurementUnit.XCM',
          XCN: 'etransport.form.packages.measurementUnit.XCN',
          XCO: 'etransport.form.packages.measurementUnit.XCO',
          XCP: 'etransport.form.packages.measurementUnit.XCP',
          XCQ: 'etransport.form.packages.measurementUnit.XCQ',
          XCR: 'etransport.form.packages.measurementUnit.XCR',
          XCS: 'etransport.form.packages.measurementUnit.XCS',
          XCT: 'etransport.form.packages.measurementUnit.XCT',
          XCU: 'etransport.form.packages.measurementUnit.XCU',
          XCV: 'etransport.form.packages.measurementUnit.XCV',
          XCW: 'etransport.form.packages.measurementUnit.XCW',
          XCX: 'etransport.form.packages.measurementUnit.XCX',
          XCZ: 'etransport.form.packages.measurementUnit.XCZ',
          XDA: 'etransport.form.packages.measurementUnit.XDA',
          XDB: 'etransport.form.packages.measurementUnit.XDB',
          XDC: 'etransport.form.packages.measurementUnit.XDC',
          XDG: 'etransport.form.packages.measurementUnit.XDG',
          XDH: 'etransport.form.packages.measurementUnit.XDH',
          XDI: 'etransport.form.packages.measurementUnit.XDI',
          XDJ: 'etransport.form.packages.measurementUnit.XDJ',
          XDK: 'etransport.form.packages.measurementUnit.XDK',
          XDL: 'etransport.form.packages.measurementUnit.XDL',
          XDM: 'etransport.form.packages.measurementUnit.XDM',
          XDN: 'etransport.form.packages.measurementUnit.XDN',
          XDP: 'etransport.form.packages.measurementUnit.XDP',
          XDR: 'etransport.form.packages.measurementUnit.XDR',
          XDS: 'etransport.form.packages.measurementUnit.XDS',
          XDT: 'etransport.form.packages.measurementUnit.XDT',
          XDU: 'etransport.form.packages.measurementUnit.XDU',
          XDV: 'etransport.form.packages.measurementUnit.XDV',
          XDW: 'etransport.form.packages.measurementUnit.XDW',
          XDX: 'etransport.form.packages.measurementUnit.XDX',
          XDY: 'etransport.form.packages.measurementUnit.XDY',
          XEC: 'etransport.form.packages.measurementUnit.XEC',
          XED: 'etransport.form.packages.measurementUnit.XED',
          XEE: 'etransport.form.packages.measurementUnit.XEE',
          XEF: 'etransport.form.packages.measurementUnit.XEF',
          XEG: 'etransport.form.packages.measurementUnit.XEG',
          XEH: 'etransport.form.packages.measurementUnit.XEH',
          XEI: 'etransport.form.packages.measurementUnit.XEI',
          XEN: 'etransport.form.packages.measurementUnit.XEN',
          XFB: 'etransport.form.packages.measurementUnit.XFB',
          XFC: 'etransport.form.packages.measurementUnit.XFC',
          XFD: 'etransport.form.packages.measurementUnit.XFD',
          XFE: 'etransport.form.packages.measurementUnit.XFE',
          XFI: 'etransport.form.packages.measurementUnit.XFI',
          XFL: 'etransport.form.packages.measurementUnit.XFL',
          XFO: 'etransport.form.packages.measurementUnit.XFO',
          XFP: 'etransport.form.packages.measurementUnit.XFP',
          XFR: 'etransport.form.packages.measurementUnit.XFR',
          XFT: 'etransport.form.packages.measurementUnit.XFT',
          XFW: 'etransport.form.packages.measurementUnit.XFW',
          XFX: 'etransport.form.packages.measurementUnit.XFX',
          XGB: 'etransport.form.packages.measurementUnit.XGB',
          XGI: 'etransport.form.packages.measurementUnit.XGI',
          XGL: 'etransport.form.packages.measurementUnit.XGL',
          XGR: 'etransport.form.packages.measurementUnit.XGR',
          XGU: 'etransport.form.packages.measurementUnit.XGU',
          XGY: 'etransport.form.packages.measurementUnit.XGY',
          XGZ: 'etransport.form.packages.measurementUnit.XGZ',
          XHA: 'etransport.form.packages.measurementUnit.XHA',
          XHB: 'etransport.form.packages.measurementUnit.XHB',
          XHC: 'etransport.form.packages.measurementUnit.XHC',
          XHG: 'etransport.form.packages.measurementUnit.XHG',
          XHN: 'etransport.form.packages.measurementUnit.XHN',
          XHR: 'etransport.form.packages.measurementUnit.XHR',
          XIA: 'etransport.form.packages.measurementUnit.XIA',
          XIB: 'etransport.form.packages.measurementUnit.XIB',
          XIC: 'etransport.form.packages.measurementUnit.XIC',
          XID: 'etransport.form.packages.measurementUnit.XID',
          XIE: 'etransport.form.packages.measurementUnit.XIE',
          XIF: 'etransport.form.packages.measurementUnit.XIF',
          XIG: 'etransport.form.packages.measurementUnit.XIG',
          XIH: 'etransport.form.packages.measurementUnit.XIH',
          XIK: 'etransport.form.packages.measurementUnit.XIK',
          XIL: 'etransport.form.packages.measurementUnit.XIL',
          XIN: 'etransport.form.packages.measurementUnit.XIN',
          XIZ: 'etransport.form.packages.measurementUnit.XIZ',
          XJB: 'etransport.form.packages.measurementUnit.XJB',
          XJC: 'etransport.form.packages.measurementUnit.XJC',
          XJG: 'etransport.form.packages.measurementUnit.XJG',
          XJR: 'etransport.form.packages.measurementUnit.XJR',
          XJT: 'etransport.form.packages.measurementUnit.XJT',
          XJY: 'etransport.form.packages.measurementUnit.XJY',
          XKG: 'etransport.form.packages.measurementUnit.XKG',
          XKI: 'etransport.form.packages.measurementUnit.XKI',
          XLE: 'etransport.form.packages.measurementUnit.XLE',
          XLG: 'etransport.form.packages.measurementUnit.XLG',
          XLT: 'etransport.form.packages.measurementUnit.XLT',
          XLU: 'etransport.form.packages.measurementUnit.XLU',
          XLV: 'etransport.form.packages.measurementUnit.XLV',
          XLZ: 'etransport.form.packages.measurementUnit.XLZ',
          XMA: 'etransport.form.packages.measurementUnit.XMA',
          XMB: 'etransport.form.packages.measurementUnit.XMB',
          XMC: 'etransport.form.packages.measurementUnit.XMC',
          XMR: 'etransport.form.packages.measurementUnit.XMR',
          XMS: 'etransport.form.packages.measurementUnit.XMS',
          XMT: 'etransport.form.packages.measurementUnit.XMT',
          XMW: 'etransport.form.packages.measurementUnit.XMW',
          XMX: 'etransport.form.packages.measurementUnit.XMX',
          XNA: 'etransport.form.packages.measurementUnit.XNA',
          XNE: 'etransport.form.packages.measurementUnit.XNE',
          XNF: 'etransport.form.packages.measurementUnit.XNF',
          XNG: 'etransport.form.packages.measurementUnit.XNG',
          XNS: 'etransport.form.packages.measurementUnit.XNS',
          XNT: 'etransport.form.packages.measurementUnit.XNT',
          XNU: 'etransport.form.packages.measurementUnit.XNU',
          XNV: 'etransport.form.packages.measurementUnit.XNV',
          XOA: 'etransport.form.packages.measurementUnit.XOA',
          XOB: 'etransport.form.packages.measurementUnit.XOB',
          XOC: 'etransport.form.packages.measurementUnit.XOC',
          XOD: 'etransport.form.packages.measurementUnit.XOD',
          XOE: 'etransport.form.packages.measurementUnit.XOE',
          XOF: 'etransport.form.packages.measurementUnit.XOF',
          XOK: 'etransport.form.packages.measurementUnit.XOK',
          XOT: 'etransport.form.packages.measurementUnit.XOT',
          XOU: 'etransport.form.packages.measurementUnit.XOU',
          XP2: 'etransport.form.packages.measurementUnit.XP2',
          XPA: 'etransport.form.packages.measurementUnit.XPA',
          XPC: 'etransport.form.packages.measurementUnit.XPC',
          XPD: 'etransport.form.packages.measurementUnit.XPD',
          XPE: 'etransport.form.packages.measurementUnit.XPE',
          XPF: 'etransport.form.packages.measurementUnit.XPF',
          XPG: 'etransport.form.packages.measurementUnit.XPG',
          XPH: 'etransport.form.packages.measurementUnit.XPH',
          XPI: 'etransport.form.packages.measurementUnit.XPI',
          XPJ: 'etransport.form.packages.measurementUnit.XPJ',
          XPK: 'etransport.form.packages.measurementUnit.XPK',
          XPL: 'etransport.form.packages.measurementUnit.XPL',
          XPN: 'etransport.form.packages.measurementUnit.XPN',
          XPO: 'etransport.form.packages.measurementUnit.XPO',
          XPR: 'etransport.form.packages.measurementUnit.XPR',
          XPT: 'etransport.form.packages.measurementUnit.XPT',
          XPU: 'etransport.form.packages.measurementUnit.XPU',
          XPV: 'etransport.form.packages.measurementUnit.XPV',
          XPX: 'etransport.form.packages.measurementUnit.XPX',
          XPY: 'etransport.form.packages.measurementUnit.XPY',
          XPZ: 'etransport.form.packages.measurementUnit.XPZ',
          XQA: 'etransport.form.packages.measurementUnit.XQA',
          XQB: 'etransport.form.packages.measurementUnit.XQB',
          XQC: 'etransport.form.packages.measurementUnit.XQC',
          XQD: 'etransport.form.packages.measurementUnit.XQD',
          XQF: 'etransport.form.packages.measurementUnit.XQF',
          XQG: 'etransport.form.packages.measurementUnit.XQG',
          XQH: 'etransport.form.packages.measurementUnit.XQH',
          XQJ: 'etransport.form.packages.measurementUnit.XQJ',
          XQK: 'etransport.form.packages.measurementUnit.XQK',
          XQL: 'etransport.form.packages.measurementUnit.XQL',
          XQM: 'etransport.form.packages.measurementUnit.XQM',
          XQN: 'etransport.form.packages.measurementUnit.XQN',
          XQP: 'etransport.form.packages.measurementUnit.XQP',
          XQQ: 'etransport.form.packages.measurementUnit.XQQ',
          XQR: 'etransport.form.packages.measurementUnit.XQR',
          XQS: 'etransport.form.packages.measurementUnit.XQS',
          XRD: 'etransport.form.packages.measurementUnit.XRD',
          XRG: 'etransport.form.packages.measurementUnit.XRG',
          XRJ: 'etransport.form.packages.measurementUnit.XRJ',
          XRK: 'etransport.form.packages.measurementUnit.XRK',
          XRL: 'etransport.form.packages.measurementUnit.XRL',
          XRO: 'etransport.form.packages.measurementUnit.XRO',
          XRT: 'etransport.form.packages.measurementUnit.XRT',
          XRZ: 'etransport.form.packages.measurementUnit.XRZ',
          XSA: 'etransport.form.packages.measurementUnit.XSA',
          XSB: 'etransport.form.packages.measurementUnit.XSB',
          XSC: 'etransport.form.packages.measurementUnit.XSC',
          XSD: 'etransport.form.packages.measurementUnit.XSD',
          XSE: 'etransport.form.packages.measurementUnit.XSE',
          XSH: 'etransport.form.packages.measurementUnit.XSH',
          XSI: 'etransport.form.packages.measurementUnit.XSI',
          XSK: 'etransport.form.packages.measurementUnit.XSK',
          XSL: 'etransport.form.packages.measurementUnit.XSL',
          XSM: 'etransport.form.packages.measurementUnit.XSM',
          XSO: 'etransport.form.packages.measurementUnit.XSO',
          XSP: 'etransport.form.packages.measurementUnit.XSP',
          XSS: 'etransport.form.packages.measurementUnit.XSS',
          XST: 'etransport.form.packages.measurementUnit.XST',
          XSU: 'etransport.form.packages.measurementUnit.XSU',
          XSV: 'etransport.form.packages.measurementUnit.XSV',
          XSW: 'etransport.form.packages.measurementUnit.XSW',
          XSY: 'etransport.form.packages.measurementUnit.XSY',
          XSZ: 'etransport.form.packages.measurementUnit.XSZ',
          XT1: 'etransport.form.packages.measurementUnit.XT1',
          XTB: 'etransport.form.packages.measurementUnit.XTB',
          XTC: 'etransport.form.packages.measurementUnit.XTC',
          XTD: 'etransport.form.packages.measurementUnit.XTD',
          XTE: 'etransport.form.packages.measurementUnit.XTE',
          XTG: 'etransport.form.packages.measurementUnit.XTG',
          XTI: 'etransport.form.packages.measurementUnit.XTI',
          XTK: 'etransport.form.packages.measurementUnit.XTK',
          XTL: 'etransport.form.packages.measurementUnit.XTL',
          XTN: 'etransport.form.packages.measurementUnit.XTN',
          XTO: 'etransport.form.packages.measurementUnit.XTO',
          XTR: 'etransport.form.packages.measurementUnit.XTR',
          XTS: 'etransport.form.packages.measurementUnit.XTS',
          XTT: 'etransport.form.packages.measurementUnit.XTT',
          XTU: 'etransport.form.packages.measurementUnit.XTU',
          XTV: 'etransport.form.packages.measurementUnit.XTV',
          XTW: 'etransport.form.packages.measurementUnit.XTW',
          XTZ: 'etransport.form.packages.measurementUnit.XTZ',
          XUC: 'etransport.form.packages.measurementUnit.XUC',
          XUN: 'etransport.form.packages.measurementUnit.XUN',
          XVA: 'etransport.form.packages.measurementUnit.XVA',
          XVG: 'etransport.form.packages.measurementUnit.XVG',
          XVI: 'etransport.form.packages.measurementUnit.XVI',
          XVK: 'etransport.form.packages.measurementUnit.XVK',
          XVL: 'etransport.form.packages.measurementUnit.XVL',
          XVO: 'etransport.form.packages.measurementUnit.XVO',
          XVP: 'etransport.form.packages.measurementUnit.XVP',
          XVQ: 'etransport.form.packages.measurementUnit.XVQ',
          XVN: 'etransport.form.packages.measurementUnit.XVN',
          XVR: 'etransport.form.packages.measurementUnit.XVR',
          XVS: 'etransport.form.packages.measurementUnit.XVS',
          XVY: 'etransport.form.packages.measurementUnit.XVY',
          XWA: 'etransport.form.packages.measurementUnit.XWA',
          XWB: 'etransport.form.packages.measurementUnit.XWB',
          XWC: 'etransport.form.packages.measurementUnit.XWC',
          XWD: 'etransport.form.packages.measurementUnit.XWD',
          XWF: 'etransport.form.packages.measurementUnit.XWF',
          XWG: 'etransport.form.packages.measurementUnit.XWG',
          XWH: 'etransport.form.packages.measurementUnit.XWH',
          XWJ: 'etransport.form.packages.measurementUnit.XWJ',
          XWK: 'etransport.form.packages.measurementUnit.XWK',
          XWL: 'etransport.form.packages.measurementUnit.XWL',
          XWM: 'etransport.form.packages.measurementUnit.XWM',
          XWN: 'etransport.form.packages.measurementUnit.XWN',
          XWP: 'etransport.form.packages.measurementUnit.XWP',
          XWQ: 'etransport.form.packages.measurementUnit.XWQ',
          XWR: 'etransport.form.packages.measurementUnit.XWR',
          XWS: 'etransport.form.packages.measurementUnit.XWS',
          XWT: 'etransport.form.packages.measurementUnit.XWT',
          XWU: 'etransport.form.packages.measurementUnit.XWU',
          XWV: 'etransport.form.packages.measurementUnit.XWV',
          XWW: 'etransport.form.packages.measurementUnit.XWW',
          XWX: 'etransport.form.packages.measurementUnit.XWX',
          XWY: 'etransport.form.packages.measurementUnit.XWY',
          XWZ: 'etransport.form.packages.measurementUnit.XWZ',
          XXA: 'etransport.form.packages.measurementUnit.XXA',
          XXB: 'etransport.form.packages.measurementUnit.XXB',
          XXC: 'etransport.form.packages.measurementUnit.XXC',
          XXD: 'etransport.form.packages.measurementUnit.XXD',
          XXF: 'etransport.form.packages.measurementUnit.XXF',
          XXG: 'etransport.form.packages.measurementUnit.XXG',
          XXH: 'etransport.form.packages.measurementUnit.XXH',
          XXJ: 'etransport.form.packages.measurementUnit.XXJ',
          XXK: 'etransport.form.packages.measurementUnit.XXK',
          XYA: 'etransport.form.packages.measurementUnit.XYA',
          XYB: 'etransport.form.packages.measurementUnit.XYB',
          XYC: 'etransport.form.packages.measurementUnit.XYC',
          XYD: 'etransport.form.packages.measurementUnit.XYD',
          XYF: 'etransport.form.packages.measurementUnit.XYF',
          XYG: 'etransport.form.packages.measurementUnit.XYG',
          XYH: 'etransport.form.packages.measurementUnit.XYH',
          XYJ: 'etransport.form.packages.measurementUnit.XYJ',
          XYK: 'etransport.form.packages.measurementUnit.XYK',
          XYL: 'etransport.form.packages.measurementUnit.XYL',
          XYM: 'etransport.form.packages.measurementUnit.XYM',
          XYN: 'etransport.form.packages.measurementUnit.XYN',
          XYP: 'etransport.form.packages.measurementUnit.XYP',
          XYQ: 'etransport.form.packages.measurementUnit.XYQ',
          XYR: 'etransport.form.packages.measurementUnit.XYR',
          XYS: 'etransport.form.packages.measurementUnit.XYS',
          XYT: 'etransport.form.packages.measurementUnit.XYT',
          XYV: 'etransport.form.packages.measurementUnit.XYV',
          XYW: 'etransport.form.packages.measurementUnit.XYW',
          XYX: 'etransport.form.packages.measurementUnit.XYX',
          XYY: 'etransport.form.packages.measurementUnit.XYY',
          XYZ: 'etransport.form.packages.measurementUnit.XYZ',
          XZA: 'etransport.form.packages.measurementUnit.XZA',
          XZB: 'etransport.form.packages.measurementUnit.XZB',
          XZC: 'etransport.form.packages.measurementUnit.XZC',
          XZD: 'etransport.form.packages.measurementUnit.XZD',
          XZF: 'etransport.form.packages.measurementUnit.XZF',
          XZG: 'etransport.form.packages.measurementUnit.XZG',
          XZH: 'etransport.form.packages.measurementUnit.XZH',
          XZJ: 'etransport.form.packages.measurementUnit.XZJ',
          XZK: 'etransport.form.packages.measurementUnit.XZK',
          XZL: 'etransport.form.packages.measurementUnit.XZL',
          XZM: 'etransport.form.packages.measurementUnit.XZM',
          XZN: 'etransport.form.packages.measurementUnit.XZN',
          XZP: 'etransport.form.packages.measurementUnit.XZP',
          XZQ: 'etransport.form.packages.measurementUnit.XZQ',
          XZR: 'etransport.form.packages.measurementUnit.XZR',
          XZS: 'etransport.form.packages.measurementUnit.XZS',
          XZT: 'etransport.form.packages.measurementUnit.XZT',
          XZU: 'etransport.form.packages.measurementUnit.XZU',
          XZV: 'etransport.form.packages.measurementUnit.XZV',
          XZW: 'etransport.form.packages.measurementUnit.XZW',
          XZX: 'etransport.form.packages.measurementUnit.XZX',
          XZY: 'etransport.form.packages.measurementUnit.XZY',
          XZZ: 'etransport.form.packages.measurementUnit.XZZ',
          DBM: 'etransport.form.packages.measurementUnit.DBM',
          DBW: 'etransport.form.packages.measurementUnit.DBW',
          FNU: 'etransport.form.packages.measurementUnit.FNU',
          HAD: 'etransport.form.packages.measurementUnit.HAD',
          HMO: 'etransport.form.packages.measurementUnit.HMO',
          HWE: 'etransport.form.packages.measurementUnit.HWE',
          KWY: 'etransport.form.packages.measurementUnit.KWY',
          MKD: 'etransport.form.packages.measurementUnit.MKD',
          MKM: 'etransport.form.packages.measurementUnit.MKM',
          MKW: 'etransport.form.packages.measurementUnit.MKW',
          MNJ: 'etransport.form.packages.measurementUnit.MNJ',
          MQD: 'etransport.form.packages.measurementUnit.MQD',
          MQM: 'etransport.form.packages.measurementUnit.MQM',
          MQW: 'etransport.form.packages.measurementUnit.MQW',
          MRD: 'etransport.form.packages.measurementUnit.MRD',
          MRM: 'etransport.form.packages.measurementUnit.MRM',
          MRW: 'etransport.form.packages.measurementUnit.MRW',
          MTZ: 'etransport.form.packages.measurementUnit.MTZ',
          NTU: 'etransport.form.packages.measurementUnit.NTU',
          Z9: 'etransport.form.packages.measurementUnit.Z9',
          XO1: 'etransport.form.packages.measurementUnit.XO1',
          XO2: 'etransport.form.packages.measurementUnit.XO2',
          XO3: 'etransport.form.packages.measurementUnit.XO3',
          XO4: 'etransport.form.packages.measurementUnit.XO4',
          XO5: 'etransport.form.packages.measurementUnit.XO5',
          XO6: 'etransport.form.packages.measurementUnit.XO6',
          XO7: 'etransport.form.packages.measurementUnit.XO7',
          XO8: 'etransport.form.packages.measurementUnit.XO8',
          XO9: 'etransport.form.packages.measurementUnit.XO9',
          XOG: 'etransport.form.packages.measurementUnit.XOG',
          XOH: 'etransport.form.packages.measurementUnit.XOH',
          XOI: 'etransport.form.packages.measurementUnit.XOI',
          XOJ: 'etransport.form.packages.measurementUnit.XOJ',
          XOL: 'etransport.form.packages.measurementUnit.XOL',
          XOM: 'etransport.form.packages.measurementUnit.XOM',
          XON: 'etransport.form.packages.measurementUnit.XON',
          XOP: 'etransport.form.packages.measurementUnit.XOP',
          XOQ: 'etransport.form.packages.measurementUnit.XOQ',
          XOR: 'etransport.form.packages.measurementUnit.XOR',
          XOS: 'etransport.form.packages.measurementUnit.XOS',
          XOV: 'etransport.form.packages.measurementUnit.XOV',
          XOW: 'etransport.form.packages.measurementUnit.XOW',
          XOX: 'etransport.form.packages.measurementUnit.XOX',
          XOY: 'etransport.form.packages.measurementUnit.XOY',
          XOZ: 'etransport.form.packages.measurementUnit.XOZ',
          XP1: 'etransport.form.packages.measurementUnit.XP1',
          XP3: 'etransport.form.packages.measurementUnit.XP3',
          XP4: 'etransport.form.packages.measurementUnit.XP4',
          XSX: 'etransport.form.packages.measurementUnit.XSX',
          XME: 'etransport.form.packages.measurementUnit.XME',
          XPB: 'etransport.form.packages.measurementUnit.XPB',
          XTY: 'etransport.form.packages.measurementUnit.XTY',
          XCY: 'etransport.form.packages.measurementUnit.XCY',
          C62: 'etransport.form.packages.measurementUnit.C62',
          EA: 'etransport.form.packages.measurementUnit.EA',
          CMT: 'etransport.form.packages.measurementUnit.CMT',
          H87: 'etransport.form.packages.measurementUnit.H87',
          INH: 'etransport.form.packages.measurementUnit.INH',
          KGM: 'etransport.form.packages.measurementUnit.KGM',
          KMT: 'etransport.form.packages.measurementUnit.KMT',
          LTR: 'etransport.form.packages.measurementUnit.LTR',
          MTK: 'etransport.form.packages.measurementUnit.MTK',
          MTQ: 'etransport.form.packages.measurementUnit.MTQ',
          MTR: 'etransport.form.packages.measurementUnit.MTR',
          TNE: 'etransport.form.packages.measurementUnit.TNE',
          GRM: 'etransport.form.packages.measurementUnit.GRM',
          LM: 'etransport.form.packages.measurementUnit.LM',
          DZN: 'etransport.form.packages.measurementUnit.DZN',
          SET: 'etransport.form.packages.measurementUnit.SET',
          FOT: 'etransport.form.packages.measurementUnit.FOT',
          J57: 'etransport.form.packages.measurementUnit.J57',
          PF: 'etransport.form.packages.measurementUnit.PF',
          NAR: 'etransport.form.packages.measurementUnit.NAR',
          XPP: 'etransport.form.packages.measurementUnit.XPP',
        },
        errors: {
          requiredOperationPurpose: 'etransport.form.packages.errors.requiredOperationPurpose',
          requiredUnitMeasurement: 'etransport.form.packages.errors.requiredUnitMeasurement',
          requiredCargoName: 'etransport.form.packages.errors.requiredCargoName',
          requiredQuantity: 'etransport.form.packages.errors.requiredQuantity',
          requiredGrossWeight: 'etransport.form.packages.errors.requiredGrossWeight',
          maxLength8: 'etransport.form.packages.errors.maxLength8',
          maxLength200: 'etransport.form.packages.errors.maxLength200',
          requiredNetWeight: 'etransport.form.packages.errors.requiredNetWeight',
          requiredUnitPrice: 'etransport.form.packages.errors.requiredUnitPrice',
          requiredCombinedNomenclature: 'etransport.form.packages.errors.requiredTariffCode',
          maxlengthCombinedNomenclature: 'etransport.form.packages.errors.maxlengthCombinedNomenclature',
        },
        secondaryCurrencyCode: 'etransport.form.packages.secondaryCurrencyCode',
      },
      legalEntityInfoMessage: 'etransport.form.legalEntityInfoMessage',
      legalEntityErrorMessage: 'etransport.form.legalEntityErrorMessage',
    },
    authorization: {
      title: 'etransport.authorization.title',
      addAuthorization: 'etransport.authorization.addAuthorization',
      addAuthorizationTooltip: 'etransport.authorization.addAuthorizationTooltip',
      token: 'etransport.authorization.token',
      authorizedBy: 'etransport.authorization.authorizedBy',
      authorizedAt: 'etransport.authorization.authorizedAt',
      validTo: 'etransport.authorization.validTo',
      processAuthorization: 'etransport.authorization.processAuthorization',
      authorizationSuccess: 'etransport.authorization.authorizationSuccess',
      authorizationError: 'etransport.authorization.authorizationError',
    },
    list: {
      title: 'etransport.list.title',
      createdBy: 'etransport.list.createdBy',
      externalReference: 'etransport.list.externalReference',
      uit: 'etransport.list.uit',
      uploadIndex: 'etransport.list.uploadIndex',
      shipmentDate: 'etransport.list.shipmentDate',
      validUntil: 'etransport.list.validUntil',
      operationType: 'etransport.list.operationType',
      commercialPartner: 'etransport.list.commercialPartner',
      shipmentOrganizerName: 'etransport.list.shipmentOrganizerName',
      address: 'etransport.list.address',
      licensePlate: 'etransport.list.licensePlate',
      startLocation: 'etransport.list.startLocation',
      endLocation: 'etransport.list.endLocation',
      orderNumber: 'etransport.list.orderNumber',
      order: 'etransport.list.order',
      status: 'etransport.list.status',
      confirmationType: 'etransport.list.confirmationType',
      latestActionType: 'etransport.list.latestActionType',
      collaborationStatus: 'etransport.list.collaborationStatus',
      actionStatus: 'etransport.list.actionStatus',
      uploadStatus: 'etransport.list.uploadStatus',
      checkStatus: 'etransport.list.checkStatus',
      anafMessage: 'etransport.list.anafMessage',
      resetFilters: 'etransport.list.resetFilters',
      uitUnchecked: 'etransport.list.uitUnchecked',
      uitValid: 'etransport.list.uitValid',
      uitInvalid: 'etransport.list.uitInvalid',
      import: 'etransport.list.import',
      personalizedImport: 'etransport.list.personalizedImport',
      downloadTemplate: 'etransport.list.downloadTemplate',
      modifiedVehicleTooltip: 'etransport.list.modifiedVehicleTooltip',
      totalNetWeight: 'etransport.list.totalNetWeight',
      totalGrossWeight: 'etransport.list.totalGrossWeight',
      totalValue: 'etransport.list.totalValue',
      bulkSendSuccessfulMessage: 'etransport.list.bulkSendSuccessfulMessage',
      bulkCheckSuccessfulMessage: 'etransport.list.bulkCheckSuccessfulMessage',
      verifyData: 'etransport.list.verifyData',
      selectedETransports: 'etransport.list.selectedETransports',
      selectMessage: 'etransport.list.selectMessage',
      sendETransports: 'etransport.list.sendETransports',
      checkETransports: 'etransport.list.checkETransports',
      predefinedNotices: {
        UNSEND: 'etransport.list.predefinedNotices.UNSEND',
        UNVERIFIED: 'etransport.list.predefinedNotices.UNVERIFIED',
      },
      actionCheckStatuses: {
        UNCHECKED: 'etransport.list.actionCheckStatuses.UNCHECKED',
        PENDING: 'etransport.list.actionCheckStatuses.PENDING',
        COMMUNICATION_ERROR: 'etransport.list.actionCheckStatuses.COMMUNICATION_ERROR',
        ERROR: 'etransport.list.actionCheckStatuses.ERROR',
        NOT_OK: 'etransport.list.actionCheckStatuses.NOT_OK',
        OK: 'etransport.list.actionCheckStatuses.OK',
      },
      checkStatuses: {
        UNCHECKED: 'etransport.list.checkStatuses.UNCHECKED',
        PENDING: 'etransport.list.checkStatuses.PENDING',
        COMMUNICATION_ERROR: 'etransport.list.checkStatuses.COMMUNICATION_ERROR',
        AUTHORIZATION_ERROR: 'etransport.list.checkStatuses.AUTHORIZATION_ERROR',
        ERROR: 'etransport.list.checkStatuses.ERROR',
        NOT_OK: 'etransport.list.checkStatuses.NOT_OK',
        OK: 'etransport.list.checkStatuses.OK',
      },
      uploadStatuses: {
        UNSENT: 'etransport.list.uploadStatuses.UNSENT',
        CONVERSION_ERROR: 'etransport.list.uploadStatuses.CONVERSION_ERROR',
        COMMUNICATION_ERROR: 'etransport.list.uploadStatuses.COMMUNICATION_ERROR',
        ERROR: 'etransport.list.uploadStatuses.ERROR',
        UPLOAD_SUCCESS: 'etransport.list.uploadStatuses.UPLOAD_SUCCESS',
        AUTHORIZATION_ERROR: 'etransport.list.uploadStatuses.AUTHORIZATION_ERROR',
        CANCEL_SUCCESS: 'etransport.list.uploadStatuses.CANCEL_SUCCESS',
        null: 'etransport.list.uploadStatuses.null',
      },
      actionTypes: {
        CANCEL: 'etransport.list.actionTypes.CANCEL',
        MODIF_VEHICLE: 'etransport.list.actionTypes.MODIF_VEHICLE',
        CONFIRMATION: 'etransport.list.actionTypes.CONFIRMATION',
      },
      checkActionStatus: 'etransport.list.checkActionStatus',
      uploadAction: 'etransport.list.uploadAction',
      collaborationSent: 'etransport.list.collaborationSent',
      collaborationPartiallyCompleted: 'etransport.list.collaborationPartiallyCompleted',
      collaborationCompleted: 'etransport.list.collaborationCompleted',
    },
    confirmETransportTitle: 'etransport.confirmETransportTitle',
    commercialDataTitle: 'etransport.commercialDataTitle',
    shipmentDataTitle: 'etransport.shipmentDataTitle',
    dataUpdateSuccess: 'etransport.dataUpdateSuccess',
    contactSuggestion: 'etransport.contactSuggestion',
    shipmentOrganizer: {
      list: {
        title: 'etransport.shipmentOrganizer.list.title',
        uit: 'etransport.shipmentOrganizer.list.uit',
        declaringCompanyCode: 'etransport.shipmentOrganizer.list.declaringCompanyCode',
        declaringCompanyName: 'etransport.shipmentOrganizer.list.declaringCompanyName',
        declaringCompanyReference: 'etransport.shipmentOrganizer.list.declaringCompanyReference',
        shipmentDate: 'etransport.shipmentOrganizer.list.shipmentDate',
        validUntil: 'etransport.shipmentOrganizer.list.validUntil',
        shipmentOrganizerCode: 'etransport.shipmentOrganizer.list.shipmentOrganizerCode',
        shipmentOrganizerName: 'etransport.shipmentOrganizer.list.shipmentOrganizerName',
        licensePlates: 'etransport.shipmentOrganizer.list.licensePlates',
        startLocation: 'etransport.shipmentOrganizer.list.startLocation',
        endLocation: 'etransport.shipmentOrganizer.list.endLocation',
        documents: 'etransport.shipmentOrganizer.list.documents',
      },
      anafCommunicationError: 'etransport.shipmentOrganizer.anafCommunicationError',
    },
    errors: {
      ETransportNotificationNotUploadReadyException: 'etransport.errors.ETransportNotificationNotUploadReadyException',
    },
  },
  efactura: {
    messages: {
      pageTitle: 'efactura.messages.pageTitle',
      title: 'efactura.messages.title',
      serial: 'efactura.messages.serial',
      cui: 'efactura.messages.cui',
      id: 'efactura.messages.id',
      idRequest: 'efactura.messages.idRequest',
      createdAt: 'efactura.messages.createdAt',
      cif: 'efactura.messages.cif',
      details: 'efactura.messages.details',
      type: 'efactura.messages.type',
      emptyMessage: 'efactura.messages.emptyMessage',
      searchDaysMessage: 'efactura.messages.searchDaysMessage',
    },
    assignToCost: 'efactura.assignToCost',
    assignToOrder: 'efactura.assignToOrder',
    assignInvoiceNotAvailable: 'efactura.assignInvoiceNotAvailable',
    invoiceSent: 'efactura.invoiceSent',
    title: 'efactura.title',
    supplierName: 'efactura.supplierName',
    partnerName: 'efactura.partnerName',
    partnerCif: 'efactura.partnerCif',
    supplierCif: 'efactura.supplierCif',
    uploadedAt: 'efactura.uploadedAt',
    uploadId: 'efactura.uploadId',
    downloadId: 'efactura.downloadId',
    invoiceSeriesNumber: 'efactura.invoiceSeriesNumber',
    invoiceDate: 'efactura.invoiceDate',
    maturityDate: 'efactura.maturityDate',
    amount: 'efactura.amount',
    amountInclTax: 'efactura.amountInclTax',
    currency: 'efactura.currency',
    details: 'efactura.details',
    type: 'efactura.type',
    errorMessage: 'efactura.errorMessage',
    assignedToInvoice: 'efactura.assignedToInvoice',
    assignedToCost: 'efactura.assignedToCost',
    zipFileUuid: 'efactura.zipFileUuid',
    pdfFileUuid: 'efactura.pdfFileUuid',
    officeAddressStateCountryMessage: 'efactura.officeAddressStateCountryMessage',
    officeAddressBucharestMessage: 'efactura.officeAddressBucharestMessage',
    downloadZip: 'efactura.downloadZip',
    downloadPdf: 'efactura.downloadPdf',
    seeInvoiceDetails: 'efactura.seeInvoiceDetails',
    invoiceNotSystemGenerated: 'efactura.invoiceNotSystemGenerated',
    import: {
      selectAnafInvoice: 'efactura.import.selectAnafInvoice',
      dialogTitle: 'efactura.import.dialogTitle',
      importButton: 'efactura.import.importButton',
      selectAnafInvoiceSeries: 'efactura.import.selectAnafInvoiceSeries',
      externalInvoice: {
        selectCustomer: 'efactura.import.externalInvoice.selectCustomer',
        selectSp: 'efactura.import.externalInvoice.selectSp',
      },
    },
  },
  'user-preferences': {
    filters: {
      addFilterName: 'user-preferences.filters.addFilterName',
      filterName: 'user-preferences.filters.filterName',
      confirmDeletionHeader: 'user-preferences.filters.confirmDeletionHeader',
      confirmDeletionMessage: 'user-preferences.filters.confirmDeletionMessage',
      savedFilters: 'user-preferences.filters.savedFilters',
      applyFilterTooltip: 'user-preferences.filters.applyFilterTooltip',
      deleteSearchTooltip: 'user-preferences.filters.deleteSearchTooltip',
      markAsDefaultTooltip: 'user-preferences.filters.markAsDefaultTooltip',
      saveSearch: 'user-preferences.filters.saveSearch',
      resetSearch: 'user-preferences.filters.resetSearch',
    },
    defaultOption: 'user-preferences.defaultOption',
    noDataMessage: 'user-preferences.noDataMessage',
    saveSuccessMessage: 'user-preferences.saveSuccessMessage',
    deleteSuccessMessage: 'user-preferences.deleteSuccessMessage',
  },
  'company-user': {
    title: 'company-user.title',
    list: {
      username: 'company-user.username',
      company: 'company-user.company',
      email: 'company-user.email',
      phone: 'company-user.phone',
      'last-login': 'company-user.last-login',
      createdAt: 'company-user.createdAt',
      activeTo: 'company-user.activeTo',
      indefinitely: 'company-user.list.indefinitely',
    },
  },
  httpErrors: {
    connectionError: 'httpErrors.connectionError',
    connectionErrorMessage: 'httpErrors.connectionErrorMessage',
    timeoutError: 'httpErrors.timeoutError',
    timeoutErrorDetail: 'httpErrors.timeoutErrorDetail',
  },
  'gps-tracking': {
    title: 'gps-tracking.title',
    monitoringInterval: 'gps-tracking.monitoringInterval',
    interval: {
      startDate: 'gps-tracking.interval.startDate',
      endDate: 'gps-tracking.interval.endDate',
    },
    tooltip: 'gps-tracking.tooltip',
  },
  'self-signup-cards': {
    'authorization-token': {
      title: 'self-signup-cards.authorization-token.title',
      done: 'self-signup-cards.authorization-token.done',
      'not-done': 'self-signup-cards.authorization-token.not-done',
      'go-to-authorize-token': 'self-signup-cards.authorization-token.go-to-authorize-token',
      'add-authorize-token': 'self-signup-cards.authorization-token.add-authorize-token',
      expiringSoon: 'self-signup-cards.authorization-token.expiringSoon',
      expiringSoonMessage: 'self-signup-cards.authorization-token.expiringSoonMessage',
    },
    'terms-and-conditions': {
      title: 'self-signup-cards.terms-and-conditions.title',
      'general-terms-and-conditions-with': {
        service_provider: 'self-signup-cards.terms-and-conditions.general-terms-and-conditions-with.service_provider',
        customer: 'self-signup-cards.terms-and-conditions.general-terms-and-conditions-with.customer',
      },
      'terms-and-conditions-with': {
        service_provider: 'self-signup-cards.terms-and-conditions.terms-and-conditions-with.service_provider',
        customer: 'self-signup-cards.terms-and-conditions.terms-and-conditions-with.customer',
      },
      'go-to-terms-and-conditions': 'self-signup-cards.terms-and-conditions.go-to-terms-and-conditions',
      'platform-terms-and-conditions': 'self-signup-cards.terms-and-conditions.platform-terms-and-conditions',
    },
    'addresses-and-bank-accounts': {
      title: 'self-signup-cards.addresses-and-bank-accounts.title',
      'missing-office-address': 'self-signup-cards.addresses-and-bank-accounts.missing-office-address',
      'office-address': 'self-signup-cards.addresses-and-bank-accounts.edit-office-address',
      'fiscal-residence-address': 'self-signup-cards.addresses-and-bank-accounts.edit-fiscal-residence-address',
      'missing-fiscal-residence-address':
        'self-signup-cards.addresses-and-bank-accounts.missing-fiscal-residence-address',
      'active-bank-accounts': 'self-signup-cards.addresses-and-bank-accounts.active-bank-accounts',
      add: 'self-signup-cards.addresses-and-bank-accounts.add',
      edit: 'self-signup-cards.addresses-and-bank-accounts.edit',
      'active-bank-account': 'self-signup-cards.addresses-and-bank-accounts.active-bank-account',
      'go-to-bank-accounts': 'self-signup-cards.addresses-and-bank-accounts.go-to-bank-accounts',
    },
    tariffs: {
      title: 'self-signup-cards.tariffs.title',
      'tariff-contracts': 'self-signup-cards.tariffs.tariff-contracts',
      'tariff-contract': 'self-signup-cards.tariffs.tariff-contract',
      'add-tariff-contract': 'self-signup-cards.tariffs.add-tariff-contract',
    },
    'employees-and-contacts': {
      title: 'self-signup-cards.employees-and-contacts.title',
      employee: 'self-signup-cards.employees-and-contacts.employee',
      employees: 'self-signup-cards.employees-and-contacts.employees',
      contact: 'self-signup-cards.employees-and-contacts.contact',
      contacts: 'self-signup-cards.employees-and-contacts.contacts',
      'add-employee': 'self-signup-cards.employees-and-contacts.add-employee',
      'add-contact': 'self-signup-cards.employees-and-contacts.add-contact',
    },
    customers: {
      title: 'self-signup-cards.customers.title',
      customer: 'self-signup-cards.customers.customer',
      customers: 'self-signup-cards.customers.customers',
      'add-customer': 'self-signup-cards.customers.add-customer',
    },
    'service-providers': {
      title: 'self-signup-cards.service-providers.title',
      'service-provider': 'self-signup-cards.service-providers.service-provider',
      'service-providers': 'self-signup-cards.service-providers.service-providers',
      'add-service-provider': 'self-signup-cards.service-providers.add-service-provider',
    },
    fleet: {
      title: 'self-signup-cards.fleet.title',
      driver: 'self-signup-cards.fleet.driver',
      drivers: 'self-signup-cards.fleet.drivers',
      vehicle: 'self-signup-cards.fleet.vehicle',
      vehicles: 'self-signup-cards.fleet.vehicles',
      'add-driver': 'self-signup-cards.fleet.add-driver',
      'add-vehicle': 'self-signup-cards.fleet.add-vehicle',
    },
    'util-links': {
      title: 'self-signup-cards.util-links.title',
      'received-invoices': 'self-signup-cards.util-links.received-invoices',
      dashboard: 'self-signup-cards.util-links.dashboard',
      reports: 'self-signup-cards.util-links.reports',
      workflows: 'self-signup-cards.util-links.workflows',
      'roles-configuration': 'self-signup-cards.util-links.roles-configuration',
    },
  },
  eTransportActions: {
    title: 'eTransportActions.title',
    list: {
      uit: 'eTransportActions.list.uit',
      uploadIndex: 'eTransportActions.list.uploadIndex',
      createdAt: 'eTransportActions.list.createdAt',
      actionType: 'eTransportActions.list.actionType',
      anafMessage: 'eTransportActions.list.anafMessage',
      createdBy: 'eTransportActions.list.createdBy',
      checkStatus: 'eTransportActions.list.checkStatus',
      uploadStatus: 'eTransportActions.list.uploadStatus',
      licensePlates: 'eTransportActions.list.licensePlates',
      observations: 'eTransportActions.list.observations',
      vehicleModificationDate: 'eTransportActions.list.vehicleModificationDate',
    },
  },
  timesheet: {
    title: 'timesheet.title',
    driver: 'timesheet.driver',
    date: 'timesheet.data',
    type: 'timesheet.type',
    dailyAllownace: 'timesheet.dailyAllowance',
    weekendSupplement: 'timesheet.weekendSupplement',
    dayOfTheWeek: 'timesheet.dayOfTheWeek',
    country: 'timesheet.country',
    monthAndYear: 'timesheet.monthAndYear',
  },
  namedLocation: {
    addNamedLocation: 'namedLocation.addNamedLocation',
    location: 'namedLocation.location',
    namedLocation: 'namedLocation.namedLocation',
    locationSolutions: 'namedLocation.locationSolutions',
    lockFilters: 'namedLocation.lockFilters',
    unlockFilters: 'namedLocation.unlockFilters',
    details: 'namedLocation.details',
    name: 'namedLocation.name',
    locations: 'namedLocation.locations',
    territoryLocationOne: 'namedLocation.territoryLocationOne',
    territoryLocationMultiple: 'namedLocation.territoryLocationMultiple',
    selectLocation: 'namedLocation.selectLocation',
    multipleSelectionSummary: 'namedLocation.multipleSelectionSummary',
    labelTitle: 'namedLocation.labelTitle',
    cost: 'namedLocation.cost',
    addLegalEntity: 'namedLocation.addLegalEntity',
    duplicateCheckpoint: 'namedLocation.duplicateCheckpoint',
    label: 'namedLocation.label',
    code: 'namedLocation.code',
    shipmentSeries: 'namedLocation.shipmentSeries',
    orderNumber: 'namedLocation.orderNumber',
    deliveryTimeWindowEnd: 'namedLocation.deliveryTimeWindowEnd',
    statusMixed: 'namedLocation.statusMixed',
    statusInTransit: 'namedLocation.statusInTransit',
    statusInWarehouse: 'namedLocation.statusInWarehouse',
    statusFailed: 'namedLocation.statusFailed',
    delete: 'namedLocation.delete',
    packageStatus: 'namedLocation.packageStatus',
    filterTags: 'namedLocation.filterTags',
    deleteConfirmationMessageTitle: 'namedLocation.deleteConfirmationMessageTitle',
    deleteConfirmationMessage: 'namedLocation.deleteConfirmationMessage',
    operatingCompanyName: 'namedLocation.operatingCompanyName',
    schedule: 'namedLocation.schedule',
    specialConditions: 'namedLocation.specialConditions',
    address: 'namedLocation.address',
    companies: 'namedLocation.companies',
    owner: 'namedLocation.owner',
    operatingCompany: 'namedLocation.operatingCompany',
    operator: 'namedLocation.operator',
    timeIntervalAndAddress: 'namedLocation.timeIntervalAndAddress',
    publicContacts: 'namedLocation.publicContacts',
    partnerContacts: 'namedLocation.partnerContacts',
    addNewContact: 'namedLocation.addNewContact',
    updateContacts: 'namedLocation.updateContacts',
    updateNamedLocationSpecialConditions: 'namedLocation.updateNamedLocationSpecialConditions',
    updateInfo: 'namedLocation.updateInfo',
    saveChanges: 'namedLocation.saveChanges',
    manage: 'namedLocation.manage',
    emptyPublicContactsMessage: 'namedLocation.emptyPublicContactsMessage',
    emptyPartnerContactsMessage: 'namedLocation.emptyPartnerContactsMessage',
    emptySpecialConditionsMessage: 'namedLocation.emptySpecialConditionsMessage',
    emptyScheduleMessage: 'namedLocation.emptyScheduleMessage',
    selectDays: 'namedLocation.selectDays',
    selectedDays: 'namedLocation.selectedDays',
    shipmentDays: 'namedLocation.shipmentDays',
    start: 'namedLocation.start',
    end: 'namedLocation.end',
    maxPackage: 'namedLocation.maxPackage',
    startingLocation: 'namedLocation.startingLocation',
    destination: 'namedLocation.destination',
    destinations: 'namedLocation.destinations',
    disabledDestinationsMessage: 'namedLocation.disabledDestinationsMessage',
    timeWarning: 'namedLocation.timeWarning',
    nextDayWarning: 'namedLocation.nextDayWarning',
    addDestination: 'namedLocation.addDestination',
    routesOrganisation: 'namedLocation.routesOrganisation',
    emptyLocationMessage: 'namedLocation.emptyLocationMessage',
    generalInfo: 'namedLocation.generalInfo',
    sendOrder: 'namedLocation.sendOrder',
    sendOrderTooltip: 'namedLocation.sendOrderTooltip',
    createTask: 'namedLocation.createTask',
    createTaskTooltip: 'namedLocation.createTaskTooltip',
    deleteDraggedShipments: 'namedLocation.deleteDraggedShipments',
    dragAndDropHere: 'namedLocation.dragAndDropHere',
    dragAndDropForAdhocTemplate: 'namedLocation.dragAndDropForAdhocTemplate',
    emptyShipmentsMessage: 'namedLocation.emptyShipmentsMessage',
    emptyRoutedOrderTemplatesMessage: 'namedLocation.emptyRoutedOrderTemplatesMessage',
    timezone: 'namedLocation.timezone',
    scheduleTimezoneInfo: 'namedLocation.scheduleTimezoneInfo',
    handoverPlaceholder: 'namedLocation.handoverPlaceholder',
    search: 'namedLocation.search',
    company: 'namedLocation.company',
    searchAddressSuggestion: 'namedLocation.searchAddressSuggestion',
    emptyNamedLocationContacts: 'namedLocation.emptyNamedLocationContacts',
    emptyLocationsSuggestion: 'namedLocation.emptyLocationsSuggestion',
    isClaimedTooltip: 'namedLocation.isClaimedTooltip',
    operatedBy: 'namedLocation.operatedBy',
    cannotEditAddress: 'namedLocation.cannotEditAddress',
    employees: 'namedLocation.employees',
    emptyEmployees: 'namedLocation.emptyEmployees',
    updateEmployees: 'namedLocation.updateEmployees',
    notClaimedForUpdatingEmployees: 'namedLocation.notClaimedForUpdatingEmployees',
    savedFilters: 'namedLocation.savedFilters',
    saveFilters: 'namedLocation.saveFilters',
    routes: 'namedLocation.routes',
    shipments: 'namedLocation.shipments',
    preferencesSaveError: 'namedLocation.preferencesSaveError',
    activeFilters: 'namedLocation.activeFilters',
    labelRequired: 'namedLocation.labelRequired',
    adhocTemplateLabel: 'namedLocation.adhocTemplateLabel',
    goToDispatcherShipments: 'namedLocation.goToDispatcherShipments',
    errors: {
      patternCode: 'namedLocation.errors.patternCode',
      requiredLabel: 'namedLocation.errors.requiredLabel',
      requiredOperator: 'namedLocation.errors.requiredOperator',
      fillAllSpecialConditions: 'namedLocation.errors.fillAllSpecialConditions',
      operatorNotInPlatform: 'namedLocation.errors.operatorNotInPlatform',
      requiredIntervals: 'namedLocation.errors.requiredIntervals',
      startBeforePrecedent: 'namedLocation.errors.startBeforePrecedent',
      endAfterStart: 'namedLocation.errors.endAfterStart',
      requiredCost: 'namedLocation.errors.requiredCost',
    },
    utils: {
      filterActive: 'namedLocation.utils.filterActive',
      filtersActive: 'namedLocation.utils.filtersActive',
    },
    ownershipRequest: {
      header: 'namedLocation.ownershipRequest.header',
      title: 'namedLocation.ownershipRequest.title',
      createdAt: 'namedLocation.ownershipRequest.createdAt',
      namedLocationLabel: 'namedLocation.ownershipRequest.namedLocationLabel',
      message: 'namedLocation.ownershipRequest.message',
      statusHeader: 'namedLocation.ownershipRequest.statusHeader',
      phoneNumber: 'namedLocation.ownershipRequest.phoneNumber',
      email: 'namedLocation.ownershipRequest.email',
      userName: 'namedLocation.ownershipRequest.userName',
      addRequest: 'namedLocation.ownershipRequest.addRequest',
      phoneNotValidatedWarning: 'namedLocation.ownershipRequest.phoneNotValidatedWarning',
      delete: 'namedLocation.ownershipRequest.delete',
      deleteConfirmationMessage: 'namedLocation.ownershipRequest.deleteConfirmationMessage',
      status: {
        ACCEPTED: 'namedLocation.ownershipRequest.status.ACCEPTED',
        PENDING: 'namedLocation.ownershipRequest.status.PENDING',
        CANCELED: 'namedLocation.ownershipRequest.status.CANCELED',
        REJECTED: 'namedLocation.ownershipRequest.status.REJECTED',
      },
      attachments: 'namedLocation.ownershipRequest.attachments',
      errors: {
        requiredMessage: 'namedLocation.ownershipRequest.errors.requiredMessage',
      },
    },
  },
  operationalTerritory: {
    territories: 'operationalTerritory.territories',
    territory: 'operationalTerritory.territory',
    addOperationalTerritory: 'operationalTerritory.addOperationalTerritory',
    editOperationalTerritory: 'operationalTerritory.editOperationalTerritory',
    label: 'operationalTerritory.label',
    validFrom: 'operationalTerritory.validFrom',
    validTo: 'operationalTerritory.validTo',
    locationSelectionMessage: 'operationalTerritory.locationSelectionMessage',
    centralNamedLocationLabel: 'operationalTerritory.centralNamedLocationLabel',
    centralNamedLocationSelectionMessage: 'operationalTerritory.centralNamedLocationSelectionMessage',
    centralNamedLocationHighlightMessage: 'operationalTerritory.centralNamedLocationHighlightMessage',
    partners: 'operationalTerritory.partners',
    partnerSelectionMessage: 'operationalTerritory.partnerSelectionMessage',
    seeTerritoryLocations: 'operationalTerritory.seeTerritoryLocations',
    selectTerritory: 'operationalTerritory.selectTerritory',
    invalidate: 'operationalTerritory.invalidate',
    errors: {
      requiredLabel: 'operationalTerritory.errors.requiredLabel',
      requiredPartners: 'operationalTerritory.errors.requiredPartners',
      requiredNamedLocations: 'operationalTerritory.errors.requiredNamedLocations',
      requiredCentralNamedLocation: 'operationalTerritory.errors.requiredCentralNamedLocation',
      requiredValidFrom: 'operationalTerritory.errors.requiredValidFrom',
      requiredValidTo: 'operationalTerritory.errors.requiredValidTo',
      validToValidTo: 'operationalTerritory.errors.validToValidTo',
    },
    details: 'operationalTerritory.details',
  },
  routedOrder: {
    addRoutedOrderTemplate: 'routedOrder.addRoutedOrderTemplate',
    editRoutedOrderTemplate: 'routedOrder.editRoutedOrderTemplate',
    chronologicalTimeInfoMessage: 'routedOrder.chronologicalTimeInfoMessage',
    deleteTemplateMessage: 'routedOrder.deleteTemplateMessage',
    deleteTemplate: 'routedOrder.deleteTemplate',
    shipmentRemoved: 'routedOrder.shipmentRemoved',
    shipmentMergeError: 'routedOrder.shipmentMergeError',
    shipmentSplitError: 'routedOrder.shipmentSplitError',
  },
  externalMappings: {
    externalReferences: 'externalMappings.externalReferences',
    locations: 'externalMappings.locations',
    packages: 'externalMappings.packages',
    standardPackage: 'externalMappings.standardPackage',
    legalEntities: 'externalMappings.legalEntities',
    addReference: 'externalMappings.addReference',
    addForLocation: 'externalMappings.addForLocation',
    editForLocation: 'externalMappings.editForLocation',
    addForPackage: 'externalMappings.addForPackage',
    editForPackage: 'externalMappings.editForPackage',
    addForLegalEntity: 'externalMappings.addForLegalEntity',
    editForLegalEntity: 'externalMappings.editForLegalEntity',
    hubLocations: 'externalMappings.hubLocations',
    addForHubLocation: 'externalMappings.addForHubLocation',
    editForHubLocation: 'externalMappings.editForHubLocation',
    showAll: 'externalMappings.showAll',
    showOnlyValid: 'externalMappings.showOnlyValid',
    list: {
      externalRefType: 'externalMappings.list.externalRefType',
      externalRefId: 'externalMappings.list.externalRefId',
      namedLocationLabel: 'externalMappings.list.namedLocationLabel',
      standardPackageDimensionName: 'externalMappings.list.standardPackageDimensionName',
      companyName: 'externalMappings.list.companyName',
      uniqueIdentificationNumber: 'externalMappings.list.uniqueIdentificationNumber',
      validFrom: 'externalMappings.list.validFrom',
      validTo: 'externalMappings.list.validTo',
    },
    errors: {
      requiredExternalReferenceType: 'externalMappings.errors.requiredExternalReferenceType',
      requiredExternalReferenceId: 'externalMappings.errors.requiredExternalReferenceId',
      requiredNamedLocation: 'externalMappings.errors.requiredNamedLocation',
      requiredStandardPackage: 'externalMappings.errors.requiredStandardPackage',
      requiredPartner: 'externalMappings.errors.requiredPartner',
      missingNamedLocation: 'externalMappings.errors.missingNamedLocation',
      missingStandardPackage: 'externalMappings.errors.missingStandardPackage',
      missingLegalEntity: 'externalMappings.errors.missingLegalEntity',
      missingNamedLocationHub: 'externalMappings.errors.missingNamedLocationHub',
      missingUnknown: 'externalMappings.errors.missingUnknown',
      NOMENCLATURE_UNKNOWN: 'externalMappings.errors.NOMENCLATURE_UNKNOWN',
      NOMENCLATURE_MISSING_VALUE: 'externalMappings.errors.NOMENCLATURE_MISSING_VALUE',
      ContractTariffItemNotMatchedConverterException:
        'externalMappings.errors.ContractTariffItemNotMatchedConverterException',
      ContractTariffItemWithDifferentCurrenciesConverterException:
        'externalMappings.errors.ContractTariffItemWithDifferentCurrenciesConverterException',
      NamedLocationWithoutContactConverterException:
        'externalMappings.errors.NamedLocationWithoutContactConverterException',
      NamedLocationHubWithoutContactConverterException:
        'externalMappings.errors.NamedLocationHubWithoutContactConverterException',
    },
  },
  unedifact: {
    edifactImports: 'unedifact.edifactImports',
    edifactImport: 'unedifact.edifactImport',
    import: 'unedifact.import',
    createdAt: 'unedifact.createdAt',
    createdBy: 'unedifact.createdBy',
    fileName: 'unedifact.fileName',
    interchangeDate: 'unedifact.interchangeDate',
    licensePlate: 'unedifact.licensePlate',
    externalReferenceNumber: 'unedifact.externalReferenceNumber',
    controlRef: 'unedifact.controlRef',
    externalReferenceType: 'unedifact.externalReferenceType',
    orderNumber: 'unedifact.orderNumber',
    fileUploadedSummary: 'unedifact.fileUploadedSummary',
    fileUploadedDetails: 'unedifact.fileUploadedDetails',
    fileUploadedContainsErrors: 'unedifact.fileUploadedContainsErrors',
    importDetails: 'unedifact.importDetails',
    downloadFile: 'unedifact.downloadFile',
    generalInformations: 'unedifact.generalInformations',
    senderID: 'unedifact.senderID',
    recipientID: 'unedifact.recipientID',
    navigateToOrder: 'unedifact.navigateToOrder',
    importContains: 'unedifact.importContains',
    shipments: 'unedifact.shipments',
    importProblems: 'unedifact.importProblems',
    collapseAll: 'unedifact.collapseAll',
    expandAll: 'unedifact.expandAll',
    errors: 'unedifact.errors',
    warnings: 'unedifact.warnings',
    add: 'unedifact.add',
    relinkTitle: 'unedifact.relinkTitle',
    relinkConfirmationMessage: 'unedifact.relinkConfirmationMessage',
    relink: 'unedifact.relink',
  },
  nomenclature: {
    unitMeasurementLabel: 'nomenclature.unitMeasurementLabel',
    unitMeasurementCode: 'nomenclature.unitMeasurementCode',
    customLabel: 'nomenclature.customLabel',
    productName: 'nomenclature.productName',
    productPrice: 'nomenclature.productPrice',
    currencyCode: 'nomenclature.currencyCode',
    tariffCode: 'nomenclature.tariffCode',
    netWeight: 'nomenclature.netWeight',
    grossWeight: 'nomenclature.grossWeight',
    deleteMessage: 'nomenclature.deleteMessage',
    errors: {
      requiredCustomLabel: 'nomenclature.errors.requiredCustomLabel',
      requiredProductName: 'nomenclature.errors.requiredProductName',
      requiredProductPrice: 'nomenclature.errors.requiredProductPrice',
      requiredTariffCode: 'nomenclature.errors.requiredTariffCode',
      requiredNetWeight: 'nomenclature.errors.requiredNetWeight',
      requiredGrossWeight: 'nomenclature.errors.requiredGrossWeight',
      requiredUnitMeasurement: 'nomenclature.errors.requiredUnitMeasurement',
      requiredCurrencyCode: 'nomenclature.errors.requiredCurrencyCode',
      existsCustomLabel: 'nomenclature.errors.existsCustomLabel',
      maxlengthTariffCode: 'nomenclature.errors.maxlengthTariffCode',
      greaterThanGrossWeight: 'nomenclature.errors.greaterThanGrossWeight',
      greaterThanNetWeight: 'nomenclature.errors.greaterThanNetWeight',
    },
  },
  selectableEmployeeList: {
    employees: 'selectableEmployeeList.employees',
    selected: 'selectableEmployeeList.selected',
    search: 'selectableEmployeeList.search',
  },
};

type IsBranch<T> =
  // Is T an object?
  T extends { [k: string]: any }
    ? // T is an object. Is it also an array?
      T extends any[]
      ? // T is an object, but also is an array. This is a leaf.
        never
      : // T is an object, but is not also an array. This is a branch.
        T
    : // T is not an object. This is a leaf.
      never;

// Recursively process each key.
// If it is a branch, process its keys and return the Partial of that branch.
// If it is a leaf, replace with the value type.
type ModifyShapeType<S, T> = S extends IsBranch<S> ? { [k in keyof S]: ModifyShapeType<S[k], T> } : T;

export type TranslationInterface = ModifyShapeType<
  typeof translationSchema,
  string | null | ((...args: any[]) => unknown)
>;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
// const extractSchemaFromLanguage  = (obj: string | [], path: unknown, caca: unknown) => {
//     Object.keys(obj).forEach((key) => {
//         if (obj[key] && typeof obj[key] === 'object') {
//             return extractSchemaFromLanguage(obj[key], path + "" + key, caca[key]={})
//         }
//         else {
//             caca[key] = path + "" + key
//         }
//     })
// }
